webpackJsonp([1],{

/***/ 0:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	///<reference path="../typings/index.d.ts" />
	///<reference path="../node_modules/immutable/dist/immutable.d.ts" />
	
	Object.defineProperty(exports, "__esModule", { value: true });
	// Modifies the browser environment to support ES5/ES6 features.
	__webpack_require__(675);
	var $_ = __webpack_require__(10);
	// jQuery detects that it's inside Webpack and doesn't assign to
	// global $/jQuery, but some plugins need it there while they load :\
	//noinspection JSUnusedAssignment
	window.jQuery = window.$ = $_;
	// Not a CommonJS or AMD module, but attaches to global $ so must be loaded before we do $.noConflict()
	__webpack_require__(957);
	__webpack_require__(1213);
	__webpack_require__(989);
	__webpack_require__(987);
	__webpack_require__(986);
	__webpack_require__(670);
	__webpack_require__(992);
	__webpack_require__(984);
	__webpack_require__(866);
	//i do this instead of just using an import above, so that this will be lowest priority
	//we need some kind of jqueryui theming
	if (!window.hasOwnProperty("dont_define_jqueryui")) {
	    var css = document.createElement('link');
	    css.setAttribute('rel', 'alternative stylesheet');
	    css.setAttribute('type', 'text/css');
	    css.title = "jquery-ui-defaults";
	    css.href = '/sb/static/lib/themes/base/minified/jquery-ui.min.css';
	    document.head.insertBefore(css, document.head.firstChild);
	}
	$_.noConflict(true);
	var analytics_ = __webpack_require__(535);
	var contacts_ = __webpack_require__(564);
	var common_ = __webpack_require__(134);
	var paymentgateway_ = __webpack_require__(285);
	var orders2_ = __webpack_require__(653);
	var community2_ = __webpack_require__(557);
	var membership3_ = __webpack_require__(621);
	var events2_ = __webpack_require__(589);
	var compliancetracker_ = __webpack_require__(558);
	var news2_ = __webpack_require__(644);
	var knowledge2_ = __webpack_require__(594);
	var spareFields_ = __webpack_require__(562);
	var memory_ = __webpack_require__(636);
	var wentworthadvantage_ = __webpack_require__(534);
	var swfuploader_ = __webpack_require__(182);
	var modal = __webpack_require__(135);
	var FormButtons = __webpack_require__(266);
	var SearchDirectory = __webpack_require__(664);
	var html_input_multi_checkbox_1 = __webpack_require__(595);
	var subscriptionmanager_ = __webpack_require__(669);
	var emailmanager_ = __webpack_require__(585);
	var communications_ = __webpack_require__(548);
	var recaptcha_ = __webpack_require__(604);
	var controlcentre_ = __webpack_require__(583);
	var ivt;
	(function (ivt) {
	    var ao = void 0;
	    (function (ao) {
	        ao.analytics = analytics_;
	        ao.contacts = contacts_;
	        ao.common = common_;
	        ao.community2 = community2_;
	        ao.knowledge2 = knowledge2_;
	        ao.memory = memory_;
	        ao.spareFields = spareFields_;
	        ao.membership3 = membership3_;
	        ao.events2 = events2_;
	        ao.news2 = news2_;
	        ao.compliancetracker = compliancetracker_;
	        ao.paymentgateway = paymentgateway_;
	        ao.orders2 = orders2_;
	        ao.swfuploader = swfuploader_.swfuploadercalljs;
	        ao.wentworthadvantage = wentworthadvantage_;
	        ao.legacy = { modal: modal, html: { inputMultiCheckbox: html_input_multi_checkbox_1.MulticheckboxCallJs }, form_buttons: FormButtons.form_buttons, close: function close() {
	                return self.close();
	            } };
	        ao.searchdirectory = SearchDirectory;
	        ao.subscriptionmanager = subscriptionmanager_;
	        ao.emailmanager = emailmanager_;
	        ao.communications = communications_;
	        ao.recaptcha = recaptcha_;
	        ao.controlcentre = controlcentre_;
	    })(ao = ivt.ao || (ivt.ao = {}));
	    ivt.jQuery = $_;
	})(ivt || (ivt = {}));
	// Grab the "ivt" namespace and merge it into the window, since there is no built-in way
	// in TypeScript to create a global variable from within a module. :(
	//noinspection JSUnusedAssignment
	$_.extend(true, window, { ivt: ivt });

/***/ },

/***/ 4:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var R = __webpack_require__(62);
	exports.formatInt = function (a) {
	    return exports.formatFloat(a, 0);
	};
	exports.formatFloat = function (a, len) {
	    return a.toLocaleString('en-AU', { minimumFractionDigits: len, maximumFractionDigits: len });
	};
	exports.sumReducer = function (a, b) {
	    return a + b;
	};
	exports.sum = function (a) {
	    return a.reduce(function (a, b) {
	        return a + b;
	    }, 0);
	};
	exports.isNumeric = function (number) {
	    return number === "" + Number.parseInt(number);
	};
	exports.dateToTimestamp = function (d) {
	    return d !== null ? Math.floor(d.getTime() / 1000) : 0;
	};
	exports.curryFunc = function (f) {
	    return function (t1) {
	        return function (t2) {
	            return f(t1, t2);
	        };
	    };
	};
	exports.substring = function (len, s) {
	    return s.substr(0, len);
	};
	exports.just = exports.curryFunc(exports.substring);
	exports.just3 = exports.just(3);
	exports.mapSubtract = function (source, exclusions) {
	    return source.filter(function (v, k) {
	        return !!k && !exclusions.has(k);
	    });
	};
	exports.mapKeys = function (map) {
	    return map.map(function (v, k) {
	        return String(k);
	    }).toArray();
	};
	exports.mapNonNull = function (t, f, def) {
	    return t == null ? def : f(t);
	};
	exports.mapClass = function (t, constructor, f, def) {
	    return t instanceof constructor ? f(t) : def;
	};
	function curriedCompose(applyAfter) {
	    function takeMethodToApplyFirst(f) {
	        return R.compose(applyAfter, f);
	    }
	    return takeMethodToApplyFirst;
	}
	exports.curriedCompose = curriedCompose;
	function unzip(val) {
	    return val.reduce(function (acc, v) {
	        return [acc[0].concat([v[0]]), acc[1].concat([v[1]])];
	    }, [[], []]);
	}
	exports.unzip = unzip;
	exports.compareStringsNumerically = function (string1, string2) {
	    var cat1Id = parseInt(string1);
	    var cat2Id = parseInt(string2);
	    if (isNaN(cat1Id) || isNaN(cat2Id)) throw new Error("expected two numerical strings, got " + string1 + " and " + string2);
	    return compare(cat1Id, cat2Id);
	};
	exports.compareStringsAlphabetically = function (string1, string2) {
	    return compare(string1, string2);
	};
	var compare = function compare(item1, item2) {
	    if (item1 < item2) {
	        return -1;
	    } else if (item1 > item2) {
	        return 1;
	    } else {
	        return 0;
	    }
	};
	/**
	 * Combines multiple different strings together, ignoring values of null or zero length.
	 */
	exports.joinStrings = function (names) {
	    var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : " ";
	    return names.filter(function (name) {
	        return name != null && name.length > 0;
	    }).join(separator);
	};
	exports.splitStringByLengths = function (str, groupLengths) {
	    var extractGroup = function extractGroup(groupLength, i) {
	        var start = R.sum(groupLengths.slice(0, i));
	        return str.substr(start, groupLength);
	    };
	    return groupLengths.map(extractGroup).filter(R.identity);
	};
	exports.debug = function (a) {
	    var _console;
	
	    for (var _len = arguments.length, b = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        b[_key - 1] = arguments[_key];
	    }
	
	    return (_console = console).log.apply(_console, [a].concat(b)), a;
	};
	/**
	 * Intended to assist in the filtering of JS bugsnag errors in future
	 */
	
	var IVTError = function (_Error) {
	    _inherits(IVTError, _Error);
	
	    function IVTError() {
	        _classCallCheck(this, IVTError);
	
	        return _possibleConstructorReturn(this, (IVTError.__proto__ || Object.getPrototypeOf(IVTError)).apply(this, arguments));
	    }
	
	    return IVTError;
	}(Error);
	
	exports.IVTError = IVTError;
	exports.removeNulls = function (aa) {
	    var result = [];
	    aa.forEach(function (a) {
	        if (a != null) result.push(a);
	    });
	    return result;
	};
	exports.getElementByIdOrThrow = function (document, id) {
	    var element = document.getElementById(id);
	    if (element === null) {
	        throw new Error("couldn't find element with id " + id);
	    }
	    return element;
	};
	exports.callIfRightType = function (narrower) {
	    return function (f, def) {
	        return function (s) {
	            return narrower(s) ? f(s) : def;
	        };
	    };
	};
	exports.callIfRightTypeUndef = function (narrower) {
	    return function (f) {
	        return exports.callIfRightType(narrower)(f, undefined);
	    };
	};
	/**
	 * `makeReducer` is like `callIfRightType`, except that the f takes two parameters.
	 * The first parameter is the default return value, and it is the second parameter that is checked for specialisation.
	 */
	exports.makeReducer = function (narrower, reducer, initialState) {
	    return function () {
	        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	        var action = arguments[1];
	        return narrower(action) ? reducer(state, action) : state;
	    };
	};
	exports.callOrVoid = function (narrower) {
	    return function (f) {
	        return exports.callIfRightType(narrower)(f, undefined);
	    };
	};
	exports.getKeys = function (o) {
	    return Array.from(Object.keys(o));
	};
	exports.mapObjectKeys = function (o, f) {
	    return exports.getKeys(o).map(f);
	};
	exports.mapValues = function (o, f) {
	    return exports.getKeys(o).map(function (key) {
	        return f(o[key], key);
	    });
	};
	exports.filterObjectArray = function (data, key, test) {
	    return data.filter(function (d) {
	        return d[key] == test;
	    });
	};
	//values must be in both `a` and `b`. Uses `default` if not found in `b`.
	//sorry folks, i need a type annotation in this function so I can't make it legible. typescript could've done with a better syntax
	exports.mergeArraysByValue = function (merge, areMergeable, defaultB) {
	    return function (values, callbacks) {
	        return values.reduce(function (acc, v) {
	            var callback = callbacks.find(areMergeable(v)) || defaultB;
	            return callback ? acc.concat([merge(v, callback)]) : acc;
	        }, []);
	    };
	};
	exports.pad = function (len, padding) {
	    return function (strToPad) {
	        return strToPad.length < len ? padding.repeat(len - strToPad.length) + strToPad : strToPad;
	    };
	};
	exports.twoDigitNumber = function (num) {
	    return exports.pad(2, '0')(num.toString());
	};
	exports.dateToYYYYMMDD = function (date) {
	    return date.getFullYear() + "-" + exports.twoDigitNumber(date.getMonth() + 1) + "-" + exports.twoDigitNumber(date.getDate());
	};
	exports.concat = function (start, end) {
	    return start.concat(end);
	};
	exports.flatten = function (as) {
	    return as.reduce(exports.concat, []);
	};
	exports.unique = function (withDupes) {
	    return Array.from(new Set(withDupes));
	};
	exports.compose = function (f, g) {
	    return function (a) {
	        return g(f(a));
	    };
	};
	exports.withDefault = function (f, def) {
	    return function (a, b) {
	        return f(a === undefined ? def : a, b) || def;
	    };
	};
	exports.dataFromSerial = function (id, map, def, searchKey, key) {
	    var data = map.find(function (m) {
	        return m[searchKey] == id;
	    });
	    return data ? data[key] : def + " no. " + id;
	};
	exports.secsToHMS = function (input) {
	    return [input / 3600, input % 3600 / 60, input % 60].map(function (a) {
	        return exports.twoDigitNumber(Math.floor(a));
	    }).join(':');
	};
	exports.objToList = function (map, obj) {
	    var list = [];
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	        for (var _iterator = Object.keys(obj)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var key = _step.value;
	
	            list.push(map(obj[key]));
	        }
	    } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	    } finally {
	        try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	                _iterator.return();
	            }
	        } finally {
	            if (_didIteratorError) {
	                throw _iteratorError;
	            }
	        }
	    }
	
	    return list;
	};
	exports.findInObj = function (predicate, obj) {
	    return exports.objToList(function (t) {
	        return t;
	    }, obj).find(predicate);
	};
	exports.reduceToObj = function (key, value, data) {
	    var accumulator = {};
	    return data.reduce(function (acc, v) {
	        acc[key(v)] = value(v);
	        return acc;
	    }, accumulator);
	};
	exports.mapObj = function (map, obj) {
	    //to begin, we lie. i deeply apologise but i have not yet determined an alternative
	    var ret = {};
	    var _iteratorNormalCompletion2 = true;
	    var _didIteratorError2 = false;
	    var _iteratorError2 = undefined;
	
	    try {
	        for (var _iterator2 = Object.keys(obj)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	            var key = _step2.value;
	
	            ret[key] = map(obj[key]);
	        }
	    } catch (err) {
	        _didIteratorError2 = true;
	        _iteratorError2 = err;
	    } finally {
	        try {
	            if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                _iterator2.return();
	            }
	        } finally {
	            if (_didIteratorError2) {
	                throw _iteratorError2;
	            }
	        }
	    }
	
	    return ret;
	};
	exports.reduceObj = function (reduce, obj, accumulator) {
	    var _iteratorNormalCompletion3 = true;
	    var _didIteratorError3 = false;
	    var _iteratorError3 = undefined;
	
	    try {
	        for (var _iterator3 = Object.keys(obj)[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	            var key = _step3.value;
	
	            accumulator = reduce(key, obj[key], accumulator);
	        }
	    } catch (err) {
	        _didIteratorError3 = true;
	        _iteratorError3 = err;
	    } finally {
	        try {
	            if (!_iteratorNormalCompletion3 && _iterator3.return) {
	                _iterator3.return();
	            }
	        } finally {
	            if (_didIteratorError3) {
	                throw _iteratorError3;
	            }
	        }
	    }
	
	    return accumulator;
	};
	exports.mapObjEither = function (map, obj) {
	    //to begin, we lie. i deeply apologise but i have not yet determined an alternative
	    var ret = {};
	    var _iteratorNormalCompletion4 = true;
	    var _didIteratorError4 = false;
	    var _iteratorError4 = undefined;
	
	    try {
	        for (var _iterator4 = Object.keys(obj)[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
	            var key = _step4.value;
	
	            var val = map(obj[key]);
	            if (val.type == "error") {
	                return val;
	            } else {
	                ret[key] = val.success;
	            }
	        }
	    } catch (err) {
	        _didIteratorError4 = true;
	        _iteratorError4 = err;
	    } finally {
	        try {
	            if (!_iteratorNormalCompletion4 && _iterator4.return) {
	                _iterator4.return();
	            }
	        } finally {
	            if (_didIteratorError4) {
	                throw _iteratorError4;
	            }
	        }
	    }
	
	    return { type: 'success', success: ret };
	};
	var tryParseInt = function tryParseInt(s) {
	    var n = Number.parseInt(s);
	    return isNaN(n) ? { type: 'error', error: s } : { type: 'success', success: n };
	};
	exports.toInts = function (obj) {
	    var v = exports.mapObjEither(tryParseInt, obj);
	    return v.type == "success" ? v.success : null;
	};
	exports.maybeToInts = function (obj) {
	    var v = exports.mapObjEither(function (a) {
	        return a !== null ? tryParseInt(a) : { type: "success", success: null };
	    }, obj);
	    return v.type == "success" ? v.success : null;
	};
	exports.range = function (first, last) {
	    var range = function range(l, r) {
	        return new Array(r - l + 1).fill(null).map(function (v, k) {
	            return k + l;
	        });
	    };
	    return last > first ? range(first, last) : range(last, first);
	};
	exports.max = function (a, b) {
	    return a > b ? a : b;
	};
	exports.min = function (a, b) {
	    return a < b ? a : b;
	};
	var unkeys = function unkeys(keys) {
	    var a = {};
	    var _iteratorNormalCompletion5 = true;
	    var _didIteratorError5 = false;
	    var _iteratorError5 = undefined;
	
	    try {
	        for (var _iterator5 = keys[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
	            var key = _step5.value;
	
	            a[key] = [];
	        }
	        //we cast the type because we had to construct it over time.
	    } catch (err) {
	        _didIteratorError5 = true;
	        _iteratorError5 = err;
	    } finally {
	        try {
	            if (!_iteratorNormalCompletion5 && _iterator5.return) {
	                _iterator5.return();
	            }
	        } finally {
	            if (_didIteratorError5) {
	                throw _iteratorError5;
	            }
	        }
	    }
	
	    return a;
	};
	exports.zipObj = function (as, keys) {
	    var merge = function merge(acc, curr) {
	        var _iteratorNormalCompletion6 = true;
	        var _didIteratorError6 = false;
	        var _iteratorError6 = undefined;
	
	        try {
	            for (var _iterator6 = keys[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
	                var key = _step6.value;
	
	                acc[key].push(curr[key]);
	            }
	        } catch (err) {
	            _didIteratorError6 = true;
	            _iteratorError6 = err;
	        } finally {
	            try {
	                if (!_iteratorNormalCompletion6 && _iterator6.return) {
	                    _iterator6.return();
	                }
	            } finally {
	                if (_didIteratorError6) {
	                    throw _iteratorError6;
	                }
	            }
	        }
	
	        return acc;
	    };
	    return as.reduce(merge, unkeys(keys));
	};
	exports.toString = function (a) {
	    return "" + a;
	};
	exports.toStrings = function (as) {
	    return as.map(exports.toString);
	};
	exports.concatenate = regeneratorRuntime.mark(function _callee(a, b) {
	    var _iteratorNormalCompletion7, _didIteratorError7, _iteratorError7, _iterator7, _step7, one, _iteratorNormalCompletion8, _didIteratorError8, _iteratorError8, _iterator8, _step8, _one;
	
	    return regeneratorRuntime.wrap(function _callee$(_context) {
	        while (1) {
	            switch (_context.prev = _context.next) {
	                case 0:
	                    _iteratorNormalCompletion7 = true;
	                    _didIteratorError7 = false;
	                    _iteratorError7 = undefined;
	                    _context.prev = 3;
	                    _iterator7 = a[Symbol.iterator]();
	
	                case 5:
	                    if (_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done) {
	                        _context.next = 12;
	                        break;
	                    }
	
	                    one = _step7.value;
	                    _context.next = 9;
	                    return one;
	
	                case 9:
	                    _iteratorNormalCompletion7 = true;
	                    _context.next = 5;
	                    break;
	
	                case 12:
	                    _context.next = 18;
	                    break;
	
	                case 14:
	                    _context.prev = 14;
	                    _context.t0 = _context["catch"](3);
	                    _didIteratorError7 = true;
	                    _iteratorError7 = _context.t0;
	
	                case 18:
	                    _context.prev = 18;
	                    _context.prev = 19;
	
	                    if (!_iteratorNormalCompletion7 && _iterator7.return) {
	                        _iterator7.return();
	                    }
	
	                case 21:
	                    _context.prev = 21;
	
	                    if (!_didIteratorError7) {
	                        _context.next = 24;
	                        break;
	                    }
	
	                    throw _iteratorError7;
	
	                case 24:
	                    return _context.finish(21);
	
	                case 25:
	                    return _context.finish(18);
	
	                case 26:
	                    _iteratorNormalCompletion8 = true;
	                    _didIteratorError8 = false;
	                    _iteratorError8 = undefined;
	                    _context.prev = 29;
	                    _iterator8 = b[Symbol.iterator]();
	
	                case 31:
	                    if (_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done) {
	                        _context.next = 38;
	                        break;
	                    }
	
	                    _one = _step8.value;
	                    _context.next = 35;
	                    return _one;
	
	                case 35:
	                    _iteratorNormalCompletion8 = true;
	                    _context.next = 31;
	                    break;
	
	                case 38:
	                    _context.next = 44;
	                    break;
	
	                case 40:
	                    _context.prev = 40;
	                    _context.t1 = _context["catch"](29);
	                    _didIteratorError8 = true;
	                    _iteratorError8 = _context.t1;
	
	                case 44:
	                    _context.prev = 44;
	                    _context.prev = 45;
	
	                    if (!_iteratorNormalCompletion8 && _iterator8.return) {
	                        _iterator8.return();
	                    }
	
	                case 47:
	                    _context.prev = 47;
	
	                    if (!_didIteratorError8) {
	                        _context.next = 50;
	                        break;
	                    }
	
	                    throw _iteratorError8;
	
	                case 50:
	                    return _context.finish(47);
	
	                case 51:
	                    return _context.finish(44);
	
	                case 52:
	                case "end":
	                    return _context.stop();
	            }
	        }
	    }, _callee, this, [[3, 14, 18, 26], [19,, 21, 25], [29, 40, 44, 52], [45,, 47, 51]]);
	});
	exports.group = regeneratorRuntime.mark(function _callee2(source, length) {
	    var res, _iteratorNormalCompletion9, _didIteratorError9, _iteratorError9, _iterator9, _step9, one;
	
	    return regeneratorRuntime.wrap(function _callee2$(_context2) {
	        while (1) {
	            switch (_context2.prev = _context2.next) {
	                case 0:
	                    res = [];
	                    _iteratorNormalCompletion9 = true;
	                    _didIteratorError9 = false;
	                    _iteratorError9 = undefined;
	                    _context2.prev = 4;
	                    _iterator9 = source[Symbol.iterator]();
	
	                case 6:
	                    if (_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done) {
	                        _context2.next = 16;
	                        break;
	                    }
	
	                    one = _step9.value;
	
	                    res.push(one);
	
	                    if (!(res.length >= length)) {
	                        _context2.next = 13;
	                        break;
	                    }
	
	                    _context2.next = 12;
	                    return res;
	
	                case 12:
	                    res = [];
	
	                case 13:
	                    _iteratorNormalCompletion9 = true;
	                    _context2.next = 6;
	                    break;
	
	                case 16:
	                    _context2.next = 22;
	                    break;
	
	                case 18:
	                    _context2.prev = 18;
	                    _context2.t0 = _context2["catch"](4);
	                    _didIteratorError9 = true;
	                    _iteratorError9 = _context2.t0;
	
	                case 22:
	                    _context2.prev = 22;
	                    _context2.prev = 23;
	
	                    if (!_iteratorNormalCompletion9 && _iterator9.return) {
	                        _iterator9.return();
	                    }
	
	                case 25:
	                    _context2.prev = 25;
	
	                    if (!_didIteratorError9) {
	                        _context2.next = 28;
	                        break;
	                    }
	
	                    throw _iteratorError9;
	
	                case 28:
	                    return _context2.finish(25);
	
	                case 29:
	                    return _context2.finish(22);
	
	                case 30:
	                    while (res.length < length) {
	                        res.push(undefined);
	                    }
	                    _context2.next = 33;
	                    return res;
	
	                case 33:
	                case "end":
	                    return _context2.stop();
	            }
	        }
	    }, _callee2, this, [[4, 18, 22, 30], [23,, 25, 29]]);
	});

/***/ },

/***/ 12:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var ajax_1 = __webpack_require__(111);
	
	var CommandMock = function () {
	    function CommandMock(value) {
	        _classCallCheck(this, CommandMock);
	
	        this.value = value;
	    }
	
	    _createClass(CommandMock, [{
	        key: "runGet",
	        value: function runGet(command, params) {
	            return Promise.resolve(this.value);
	        }
	    }, {
	        key: "runPost",
	        value: function runPost(command, params) {
	            return Promise.resolve(this.value);
	        }
	    }]);
	
	    return CommandMock;
	}();
	
	exports.CommandMock = CommandMock;
	
	var CommandPosterMock = function () {
	    function CommandPosterMock(value) {
	        _classCallCheck(this, CommandPosterMock);
	
	        this.value = value;
	    }
	
	    _createClass(CommandPosterMock, [{
	        key: "runPost",
	        value: function runPost(command, params) {
	            return Promise.resolve(this.value);
	        }
	    }]);
	
	    return CommandPosterMock;
	}();
	
	exports.CommandPosterMock = CommandPosterMock;
	
	var CommandPosterRejecterMock = function () {
	    function CommandPosterRejecterMock(reason) {
	        _classCallCheck(this, CommandPosterRejecterMock);
	
	        this.reason = reason;
	    }
	
	    _createClass(CommandPosterRejecterMock, [{
	        key: "runPost",
	        value: function runPost(command, params) {
	            return Promise.reject(this.reason);
	        }
	    }]);
	
	    return CommandPosterRejecterMock;
	}();
	
	exports.CommandPosterRejecterMock = CommandPosterRejecterMock;
	
	var CommandCaller = function () {
	    function CommandCaller(ajaxPageUrl) {
	        _classCallCheck(this, CommandCaller);
	
	        this.ajaxRequest = new ajax_1.AjaxRequest(ajaxPageUrl);
	    }
	
	    _createClass(CommandCaller, [{
	        key: "runGet",
	        value: function runGet(command) {
	            var _this = this;
	
	            var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	            var data = {
	                command: command,
	                noheaders: 1,
	                param: JSON.stringify(params)
	            };
	            return this.ajaxRequest.runGet(data).then(function (r) {
	                return _this.handleResponse(r);
	            });
	        }
	    }, {
	        key: "runPost",
	        value: function runPost(command, params) {
	            var _this2 = this;
	
	            var GET_params = { command: command, noheaders: 1 };
	            var form = { param: JSON.stringify(params) };
	            return this.ajaxRequest.postForm(form, GET_params).then(function (r) {
	                return _this2.handleResponse(r);
	            });
	        }
	    }, {
	        key: "handleResponse",
	        value: function handleResponse(r) {
	            return new Promise(function (resolve, reject) {
	                return new CommandResultHandler(resolve, reject).handleResult(r);
	            });
	        }
	    }]);
	
	    return CommandCaller;
	}();
	
	exports.CommandCaller = CommandCaller;
	
	var CommandResultHandler = function () {
	    function CommandResultHandler(resolver, rejecter) {
	        _classCallCheck(this, CommandResultHandler);
	
	        this.resolver = resolver;
	        this.rejecter = rejecter;
	    }
	
	    _createClass(CommandResultHandler, [{
	        key: "handleResult",
	        value: function handleResult(result) {
	            if (result.error !== null) {
	                this.handleError(result.error); // Not sure how to make this type safe
	            } else {
	                this.resolver(result.response); // Not sure how to make this type safe
	            }
	        }
	    }, {
	        key: "handleError",
	        value: function handleError(error) {
	            var message = error.title + "\n\n" + error.message;
	            alert(message);
	            this.rejecter(message);
	        }
	    }]);

	    return CommandResultHandler;
	}();

/***/ },

/***/ 34:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(3);
	var sizeToClassName = function sizeToClassName(size) {
	    switch (size) {
	        case "tiny":
	            return "sbTextInputTiny";
	        case "medium":
	            return "sbTextInputMedium";
	    }
	};
	
	var Input = function (_React$Component) {
	    _inherits(Input, _React$Component);
	
	    function Input(p, context) {
	        _classCallCheck(this, Input);
	
	        var _this = _possibleConstructorReturn(this, (Input.__proto__ || Object.getPrototypeOf(Input)).call(this, p, context));
	
	        _this.state = { isFocused: false };
	        return _this;
	    }
	
	    _createClass(Input, [{
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var classNames = [this.state.isFocused ? "sbTextInputOn" : "sbTextInputOff", sizeToClassName(this.props.size || "medium")];
	            var style = Object.assign(this.props.invalid ? { border: "solid red 2px" } : {}, this.props.style || {});
	            var numericProps = this.props.numeric ? Object.assign({}, this.props.numeric, { type: 'number' }) : {};
	            return React.createElement("input", Object.assign({}, numericProps, { className: classNames.join(" "), disabled: this.props.disabled, onChange: function onChange(event) {
	                    event.stopPropagation();
	                    if (_this2.props.onChange) {
	                        _this2.props.onChange(event.currentTarget.value);
	                    }
	                }, onFocus: function onFocus() {
	                    return _this2.setState({ isFocused: true });
	                }, onBlur: function onBlur() {
	                    return _this2.setState({ isFocused: false });
	                }, value: this.props.value, name: this.props.name, maxLength: this.props.maxlength, style: style }));
	        }
	    }]);
	
	    return Input;
	}(React.Component);
	
	exports.Input = Input;
	exports.AlwaysPost = function (props) {
	    return React.createElement("input", { hidden: true, readOnly: true, name: props.name, value: props.value });
	};

/***/ },

/***/ 39:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(3);
	var BoxImpl = function BoxImpl(props) {
	    return React.createElement("select", { onChange: props.onChange, onFocus: props.onFocus, onMouseOver: props.onMouseOver, onKeyDown: props.onKeyDown, value: props.value, name: props.name, className: "sbSelect", disabled: typeof props.enabled !== 'undefined' && !props.enabled, style: Object.assign({}, props.style, props.invalid ? { border: "solid red 2px" } : undefined), multiple: props.multiple }, props.children);
	};
	exports.SingleBox = function (props) {
	    return React.createElement(BoxImpl, Object.assign({}, props, { onChange: function onChange(event) {
	            event.stopPropagation();
	            if (props.onChange) {
	                props.onChange(event.currentTarget.value);
	            }
	        }, multiple: false }));
	};
	exports.MultiBox = function (props) {
	    return React.createElement(BoxImpl, Object.assign({}, props, { onChange: function onChange(event) {
	            event.stopPropagation();
	            if (props.onChange) {
	                var selectedOptions = Array.prototype.filter.call(event.currentTarget.options, function (o) {
	                    return o.selected;
	                }).map(function (o) {
	                    return o.value;
	                });
	                props.onChange(selectedOptions);
	            }
	        } }));
	};
	exports.FlexiBox = function (props) {
	    //despite the types, you can't send an array to a single select
	    var value = props.multiple ? props.value : props.value[0];
	    return React.createElement(BoxImpl, Object.assign({}, props, { value: value, onChange: function onChange(event) {
	            event.stopPropagation();
	            if (props.onChange) {
	                var selectedOptions = Array.prototype.filter.call(event.currentTarget.options, function (o) {
	                    return o.selected;
	                }).map(function (o) {
	                    return o.value;
	                });
	                props.onChange(selectedOptions);
	            }
	        } }));
	};

/***/ },

/***/ 55:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) {
	            try {
	                step(generator.next(value));
	            } catch (e) {
	                reject(e);
	            }
	        }
	        function rejected(value) {
	            try {
	                step(generator["throw"](value));
	            } catch (e) {
	                reject(e);
	            }
	        }
	        function step(result) {
	            result.done ? resolve(result.value) : new P(function (resolve) {
	                resolve(result.value);
	            }).then(fulfilled, rejected);
	        }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(3);
	var Button = __webpack_require__(138);
	
	var Form = function (_React$Component) {
	    _inherits(Form, _React$Component);
	
	    function Form() {
	        _classCallCheck(this, Form);
	
	        return _possibleConstructorReturn(this, (Form.__proto__ || Object.getPrototypeOf(Form)).apply(this, arguments));
	    }
	
	    _createClass(Form, [{
	        key: "getChildContext",
	        value: function getChildContext() {
	            return { theme: this.props.theme || "admin" };
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var leftButtons = [];
	            var rightButtons = [];
	            if (this.props.hasCancel) {
	                leftButtons.push(React.createElement(CancelButton, { key: "cancel", onClick: this.props.onCancel }));
	            }
	            var hasSave = this.props.hasSave;
	            if (hasSave !== false) {
	                var label = typeof hasSave === "string" ? hasSave : undefined;
	                rightButtons.push(React.createElement(SaveButton, { key: "save", label: label, isInProgress: this.props.isSubmitting }));
	            }
	            var onSaveReturn = this.props.onSaveReturn;
	            if (onSaveReturn !== undefined) {
	                var saveReturnLabel = this.props.saveReturnLabel;
	                rightButtons.push(React.createElement(SaveButton, { key: "saveReturn", label: saveReturnLabel !== undefined ? saveReturnLabel : 'Save / Return', onClick: onSaveReturn, isInProgress: this.props.isSubmitting }));
	            }
	            var rightButtonsName = rightButtons.length > 1 ? "sbFormButtonsRight" : "sbFormButtonRight";
	            var onSubmit = function onSubmit(e) {
	                // prevent the form from actually submitting
	                e.preventDefault();
	                e.stopPropagation();
	                _this2.props.onSubmit();
	            };
	            return React.createElement("form", { className: "sbForm", onSubmit: onSubmit }, this.props.children, React.createElement("table", { style: { width: "100%" }, className: "sbFormButtonsOuter" }, React.createElement("tbody", null, React.createElement("tr", null, React.createElement("td", { className: "sbFormButtonsLeft" }, leftButtons), React.createElement("td", { className: rightButtonsName, style: { textAlign: "right", nowrap: "nowrap" } }, this.props.isSubmitting && React.createElement("span", null, React.createElement("img", { className: "loadingImage", src: "/sb/static/images/loadergif.gif" })), rightButtons)))));
	        }
	    }]);
	
	    return Form;
	}(React.Component);
	
	Form.childContextTypes = {
	    theme: React.PropTypes.string.isRequired
	};
	exports.Form = Form;
	exports.saveReturnCallback = function (dispatch, save, returnUrl) {
	    return function (dispatch, getState) {
	        return __awaiter(undefined, void 0, void 0, regeneratorRuntime.mark(function _callee() {
	            return regeneratorRuntime.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            _context.next = 2;
	                            return save(dispatch, getState);
	
	                        case 2:
	                            window.location.assign(returnUrl);
	
	                        case 3:
	                        case "end":
	                            return _context.stop();
	                    }
	                }
	            }, _callee, this);
	        }));
	    };
	};
	
	var ManagedForm = function (_React$Component2) {
	    _inherits(ManagedForm, _React$Component2);
	
	    function ManagedForm(props, context) {
	        _classCallCheck(this, ManagedForm);
	
	        var _this3 = _possibleConstructorReturn(this, (ManagedForm.__proto__ || Object.getPrototypeOf(ManagedForm)).call(this, props, context));
	
	        _this3.state = {
	            isInProgress: false
	        };
	        return _this3;
	    }
	
	    _createClass(ManagedForm, [{
	        key: "render",
	        value: function render() {
	            var _this4 = this;
	
	            var onSubmit = function onSubmit() {
	                _this4.setState({ isInProgress: true });
	                var onDone = function onDone() {
	                    _this4.setState({ isInProgress: false });
	                };
	                // Notifying the user of the rejected promise should have been done by this.props.onSubmit()
	                // We just need to set isInProgress back to false
	                _this4.props.onSubmit().then(onDone, onDone);
	            };
	            return React.createElement(Form, { isSubmitting: this.state.isInProgress, onSubmit: onSubmit, hasSave: this.props.hasSave, hasCancel: this.props.hasCancel, onCancel: this.props.onCancel }, this.props.children);
	        }
	    }]);
	
	    return ManagedForm;
	}(React.Component);
	
	exports.ManagedForm = ManagedForm;
	
	var Heading = function (_React$Component3) {
	    _inherits(Heading, _React$Component3);
	
	    function Heading() {
	        _classCallCheck(this, Heading);
	
	        return _possibleConstructorReturn(this, (Heading.__proto__ || Object.getPrototypeOf(Heading)).apply(this, arguments));
	    }
	
	    _createClass(Heading, [{
	        key: "render",
	        value: function render() {
	            return React.createElement("h2", { className: "sbHeading" }, this.props.children);
	        }
	    }]);
	
	    return Heading;
	}(React.Component);
	
	exports.Heading = Heading;
	var buttonClasses = "sbFormButton sbRoundedEdges";
	var CancelButton = function CancelButton(props) {
	    return React.createElement(Button.Button, { className: buttonClasses, onClick: props.onClick }, "Cancel");
	};
	var SaveButton = function SaveButton(props) {
	    var label = props.label || "Save";
	    var classProps = { className: buttonClasses };
	    var disabledProps = props.isInProgress ? { disabled: props.isInProgress } : {};
	    var typeProps = props.onClick ? {
	        type: 0 /* button */
	        , onClick: props.onClick
	    } : {
	        type: 1 /* submit */
	    };
	    return React.createElement("span", null, React.createElement(Button.Button, Object.assign({}, classProps, typeProps, disabledProps), label));
	};

/***/ },

/***/ 92:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(3);
	exports.Checkbox = function (props) {
	    var box = unlabelledBox({
	        name: props.name,
	        value: props.value,
	        checked: props.checked,
	        disabled: props.disabled,
	        onChange: props.onChange
	    });
	    return props.label == undefined ? box : React.createElement("label", { className: "sbCheckboxLabel" }, box, props.label);
	};
	var unlabelledBox = function unlabelledBox(props) {
	    return React.createElement("input", { type: "checkbox", name: props.name, value: props.value, checked: props.checked, disabled: props.disabled, onChange: function onChange(event) {
	            event.stopPropagation();
	            if (props.onChange) {
	                props.onChange(event.currentTarget.checked);
	            }
	        }, className: "sbRadioButton" });
	};

/***/ },

/***/ 93:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Uses jquery datepicker
	 */
	var React = __webpack_require__(3);
	var $ = __webpack_require__(10);
	var button_1 = __webpack_require__(138);
	
	var DatePicker = function (_React$Component) {
	    _inherits(DatePicker, _React$Component);
	
	    function DatePicker() {
	        _classCallCheck(this, DatePicker);
	
	        var _this = _possibleConstructorReturn(this, (DatePicker.__proto__ || Object.getPrototypeOf(DatePicker)).apply(this, arguments));
	
	        _this.inputElement = null;
	        return _this;
	    }
	
	    _createClass(DatePicker, [{
	        key: "_destroyDatePicker",
	        value: function _destroyDatePicker() {
	            if (this.inputElement) {
	                $(this.inputElement).datepicker('destroy');
	            }
	        }
	    }, {
	        key: "_initDatePicker",
	        value: function _initDatePicker() {
	            var _self = this;
	            var element = _self.inputElement;
	            if (element) {
	                var options = {
	                    duration: 0,
	                    changeMonth: true,
	                    changeYear: true,
	                    showOn: 'both',
	                    yearRange: '1900:c+50',
	                    buttonImageOnly: true,
	                    buttonText: 'Select Date',
	                    dateFormat: 'dd/mm/yy',
	                    onClose: function onClose(text, inst) {
	                        if (_self.props.onChange) {
	                            _self.props.onChange(text, $(element).datepicker('getDate'));
	                        }
	                    }
	                };
	                var newProps = Object.assign(options, this.props);
	                $(element).datepicker(newProps);
	                if (this.props.date !== undefined) {
	                    $(element).datepicker('setDate', this.props.date);
	                }
	            }
	        }
	    }, {
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            this._initDatePicker();
	        }
	    }, {
	        key: "componentWillReceiveProps",
	        value: function componentWillReceiveProps(props) {
	            var _self = this;
	            var element = _self.inputElement;
	            if (element) {
	                var $element = $(element);
	                $element.datepicker(props.disabled ? 'disable' : 'enable');
	                if (props.date === undefined || props.date === null) {
	                    $element.datepicker('setDate', null);
	                }
	            }
	        }
	    }, {
	        key: "componentWillUnmount",
	        value: function componentWillUnmount() {
	            this._destroyDatePicker();
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            return React.createElement("span", null, React.createElement("input", { type: "text", ref: function ref(inputElement) {
	                    _this2.inputElement = inputElement;
	                }, style: this.props.invalid ? { border: "solid red 2px" } : undefined, disabled: this.props.disabled, readOnly: this.props.readonly }), this.props.hasClearButton && React.createElement(button_1.Button, { onClick: function onClick() {
	                    if (_this2.props.hasClearButton) {
	                        _this2.props.hasClearButton();
	                    }
	                } }, "Clear"));
	        }
	    }]);
	
	    return DatePicker;
	}(React.Component);
	
	exports.DatePicker = DatePicker;

/***/ },

/***/ 94:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(3);
	var utils_1 = __webpack_require__(4);
	exports.Alignment = { left: "left", center: "center", right: "right" };
	
	var FixedDataGrid = function (_React$Component) {
	    _inherits(FixedDataGrid, _React$Component);
	
	    function FixedDataGrid() {
	        _classCallCheck(this, FixedDataGrid);
	
	        return _possibleConstructorReturn(this, (FixedDataGrid.__proto__ || Object.getPrototypeOf(FixedDataGrid)).apply(this, arguments));
	    }
	
	    _createClass(FixedDataGrid, [{
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var fields = Object.keys(this.props.heading).filter(function (k) {
	                return _this2.props.rowClick !== k;
	            });
	            var makeRow = function makeRow(row, index) {
	                var customStyles = {};
	                var customProps = {};
	                if (_this2.props.highlight !== undefined && _this2.props.highlight(row)) {
	                    customStyles['backgroundColor'] = _this2.props.highlightColor !== undefined ? _this2.props.highlightColor : '#b5d6ed';
	                }
	                var rowClick = _this2.props.rowClick;
	                if (rowClick && row[rowClick] && typeof row[rowClick] == 'function') {
	                    customStyles['cursor'] = 'pointer';
	                    customProps['onClick'] = row[rowClick];
	                }
	                return React.createElement("tr", { className: index % 2 == 0 ? "row0" : "row1", key: "row" + index }, fields.map(function (field) {
	                    if (field == _this2.props.rowClick) return undefined;
	                    var fieldData = row[field];
	                    if (typeof fieldData == 'function') return undefined;
	                    var data = fieldData; // we have exhausted the alternatives
	                    var alignment = data.alignment || "center";
	                    return React.createElement("td", Object.assign({}, customProps, { style: Object.assign({}, customStyles, { textAlign: alignment, minWidth: data.minWidth }), key: "field" + field + "row" + index }), data != null ? data.node : null);
	                }));
	            };
	            var width = this.props.widths == "leave undefined" ? undefined : "50px";
	            var headings = fields.map(function (field) {
	                return React.createElement("th", { style: { width: width, textAlign: _this2.props.headingAlignments ? _this2.props.headingAlignments[field] : "center" }, key: "heading-" + field }, _this2.props.heading[field]);
	            });
	            var rows = this.props.data.map(makeRow);
	            return React.createElement("div", { className: "dataGridPanel sbRoundedEdges", style: { width: "100%" } }, React.createElement("table", { className: "dataGrid sbRoundedEdges tablesorter", cellSpacing: "0", cellPadding: "2", style: { width: "100%", visibility: "visible" } }, React.createElement("thead", null, React.createElement("tr", { className: "dataGridTitlebar sbRoundedEdges", style: { height: "30px" } }, headings)), React.createElement("tbody", null, rows), this.props.footer && React.createElement("tfoot", null, this.props.footer)));
	        }
	    }]);
	
	    return FixedDataGrid;
	}(React.Component);
	
	exports.FixedDataGrid = FixedDataGrid;
	var makeLimits = function makeLimits(limit, length) {
	    var limits = [10, 20, 50, 100];
	    if (limit && limits.indexOf(limit) < 0) {
	        limits.push(limit);
	    }
	    return limits.filter(function (l) {
	        return l < length;
	    });
	};
	var findFirstRow = function findFirstRow(limit, rowToShow, length) {
	    // we must start at at least the first row
	    rowToShow = utils_1.max(0, rowToShow);
	    console.log(rowToShow);
	    //we can't have more pages than are available
	    rowToShow = utils_1.min(rowToShow, length);
	    console.log(rowToShow);
	    //we want to start at an integral number of pages considering the length
	    var page = Math.ceil(rowToShow / limit);
	    console.log(page);
	    //we're trying to find the first row. Why one less the ceiling? 10/10 = 1, but we need to start at 0.
	    page = page - 1;
	    console.log(page);
	    return page * limit;
	};
	
	var PaginatedDataGrid = function (_React$Component2) {
	    _inherits(PaginatedDataGrid, _React$Component2);
	
	    function PaginatedDataGrid() {
	        _classCallCheck(this, PaginatedDataGrid);
	
	        return _possibleConstructorReturn(this, (PaginatedDataGrid.__proto__ || Object.getPrototypeOf(PaginatedDataGrid)).apply(this, arguments));
	    }
	
	    _createClass(PaginatedDataGrid, [{
	        key: "render",
	        value: function render() {
	            var props = this.props;
	            var numRowsTotal = props.data.length;
	            var numColumns = Object.keys(props.heading).length;
	            var hasLimit = props.limit !== null && numRowsTotal > 0;
	            var limits = makeLimits(props.limit, numRowsTotal);
	            var pages = hasLimit ? utils_1.range(1, props.limit ? Math.ceil(numRowsTotal / props.limit) : 1) : [];
	            var onChangeLimit = function onChangeLimit(e) {
	                var newLimit = Number.parseInt(e.currentTarget.value);
	                props.setLimit(isNaN(newLimit) ? null : newLimit);
	            };
	            var onChangePage = function onChangePage(e) {
	                var newPage = Number.parseInt(e.currentTarget.value);
	                props.setPage(isNaN(newPage) || !props.limit ? 1 : (newPage - 1) * props.limit + 1);
	            };
	            var footer = React.createElement("tr", null, React.createElement("td", { style: { textAlign: "center" }, colSpan: utils_1.max(numColumns / (hasLimit ? 2 : 1), 1) }, "Show rows: ", React.createElement("select", { onChange: onChangeLimit }, limits.map(function (l) {
	                return React.createElement("option", { value: l, key: l }, l);
	            }), React.createElement("option", { value: "all" }, "All"))), hasLimit && React.createElement("td", { style: { textAlign: "center" }, colSpan: utils_1.max(numColumns / 2, 1) }, "Show page: ", React.createElement("select", { onChange: onChangePage }, pages.map(function (p) {
	                return React.createElement("option", { value: p, key: p }, p);
	            }))));
	            var sliced = props.limit ? function (offset) {
	                return props.data.slice(offset, offset + props.limit);
	            }(findFirstRow(props.limit, props.page, numRowsTotal)) : props.data;
	            return React.createElement("div", null, React.createElement(FixedDataGrid, { heading: props.heading, data: sliced, footer: footer }));
	        }
	    }]);
	
	    return PaginatedDataGrid;
	}(React.Component);
	
	exports.PaginatedDataGrid = PaginatedDataGrid;

/***/ },

/***/ 95:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(3);
	var ReactModal = __webpack_require__(1159);
	
	var Modal = function (_React$Component) {
	    _inherits(Modal, _React$Component);
	
	    function Modal() {
	        _classCallCheck(this, Modal);
	
	        return _possibleConstructorReturn(this, (Modal.__proto__ || Object.getPrototypeOf(Modal)).apply(this, arguments));
	    }
	
	    _createClass(Modal, [{
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            ReactModal.setAppElement(document.body);
	            var style = {
	                content: {
	                    border: "none",
	                    background: "none"
	                }
	            };
	            return React.createElement("div", null, React.createElement(ReactModal, { contentLabel: this.props.title, style: style, isOpen: this.props.isOpen, onRequestClose: function onRequestClose() {
	                    return _this2.props.onRequestClose();
	                } }, React.createElement("div", { className: "ui-dialog ui-widget ui-widget-content ui-corner-all ui-front", style: this.props.style }, React.createElement("div", { className: "ui-dialog-titlebar ui-widget-header ui-corner-all ui-helper-clearfix" }, React.createElement("span", { className: "ui-dialog-title" }, this.props.title), React.createElement("button", { type: "button", className: "ui-button ui-widget ui-state-default ui-corner-all ui-button-icon-only ui-dialog-titlebar-close", onClick: function onClick() {
	                    return _this2.props.onRequestClose();
	                } }, React.createElement("span", { className: "ui-button-icon-primary ui-icon ui-icon-closethick" }))), React.createElement("div", { className: "ui-dialog-content ui-widget-content" }, this.props.children))));
	        }
	    }]);
	
	    return Modal;
	}(React.Component);
	
	exports.Modal = Modal;
	exports.centeredModalProps = function (minWidth) {
	    var style = {
	        top: '50%',
	        left: '50%',
	        right: 'auto',
	        bottom: 'auto',
	        marginRight: '-50%',
	        transform: 'translate(-50%, -50%)',
	        maxWidth: '1000px',
	        maxHeight: '500px',
	        overflow: "scroll"
	    };
	    return Object.assign({}, style, minWidth !== undefined ? { minWidth: minWidth } : {});
	};

/***/ },

/***/ 110:
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.isColumn = function (value) {
	    return value === '1' || value === '2' || value === '3';
	};
	exports.toColumn = function (column) {
	    var c = column.toString();
	    if (exports.isColumn(c)) {
	        return c;
	    }
	    return '1';
	};
	exports.restrictColumn = function (lastColumn) {
	    var maxColumn = parseInt(lastColumn);
	    return function (a) {
	        return parseInt(a.column) > maxColumn ? Object.assign({}, a, { column: lastColumn }) : a;
	    };
	};
	exports.sortByColumnAndPriority = function (a, b) {
	    return a.column === b.column ? a.priority - b.priority : parseInt(a.column) - parseInt(b.column);
	};

/***/ },

/***/ 111:
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var http = __webpack_require__(1204);
	var url = __webpack_require__(530);
	var querystring = __webpack_require__(467);
	var lodash_1 = __webpack_require__(125);
	
	var AjaxRequest = function () {
	    function AjaxRequest(ajaxPageUrl) {
	        _classCallCheck(this, AjaxRequest);
	
	        this.url = new UrlPortFixer(url.parse(ajaxPageUrl, true));
	    }
	
	    _createClass(AjaxRequest, [{
	        key: "postForm",
	        value: function postForm(form) {
	            var GET_data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	            return this.runPost('application/x-www-form-urlencoded', querystring.stringify(form), GET_data);
	        }
	    }, {
	        key: "runPost",
	        value: function runPost(contentType, POST_body) {
	            var GET_data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	            // TODO Convert this to use the Node.js/Webpack "http" module instead of XMLHttpRequest
	            // The reason it uses XMLHttpRequest is because there was some request format incompatibility with PHP's
	            // request parser that Tristan didn't have time to figure out.
	            var req = new XMLHttpRequest();
	            var url3 = this.url.urlWithPortAsString(GET_data);
	            req.open('POST', url.format(url3));
	            req.setRequestHeader('Content-Type', contentType);
	            req.setRequestHeader('Content-Length', POST_body == null ? '0' : Buffer.byteLength(POST_body).toString());
	            return new Promise(function (resolve, reject) {
	                var finalizer = new AjaxRequestFinalizer(resolve, reject);
	                req.onreadystatechange = function () {
	                    return finalizer.handleReadyStateChange(req);
	                };
	                if (POST_body == null) {
	                    req.send();
	                } else {
	                    req.send(POST_body);
	                }
	            });
	        }
	    }, {
	        key: "runGet",
	        value: function runGet(params) {
	            var req = lodash_1.merge({ method: "GET" }, this.url.urlWithPortAsNumber(params));
	            return new Promise(function (resolve, reject) {
	                var finalizer = new AjaxRequestFinalizer(resolve, reject);
	                var client = http.request(req);
	                client.on('abort', function () {
	                    return finalizer.handleError({ statusNumber: -1, reason: 'aborted by user' });
	                });
	                client.on('response', function (message) {
	                    return finalizer.handleIncomingMessage(message);
	                });
	                client.end();
	            });
	        }
	    }]);
	
	    return AjaxRequest;
	}();
	
	exports.AjaxRequest = AjaxRequest;
	
	var AjaxRequestFinalizer = function () {
	    function AjaxRequestFinalizer(resolve, reject) {
	        _classCallCheck(this, AjaxRequestFinalizer);
	
	        this.resolve = resolve;
	        this.reject = reject;
	    }
	
	    _createClass(AjaxRequestFinalizer, [{
	        key: "handleError",
	        value: function handleError(reason) {
	            this.reject(Object.assign({ source: "AjaxRequestFinalizer" }, reason));
	        }
	    }, {
	        key: "handleReadyStateChange",
	        value: function handleReadyStateChange(req) {
	            if (req.readyState !== XMLHttpRequest.DONE) {
	                return;
	            } else if (req.status !== 200) {
	                this.handleError({ statusNumber: req.status, reason: req.statusText });
	            } else {
	                this.handleSuccess(req.responseText);
	            }
	        }
	    }, {
	        key: "handleIncomingMessage",
	        value: function handleIncomingMessage(message) {
	            var _this = this;
	
	            var data = '';
	            message.on('data', function (chunk) {
	                return data += chunk;
	            });
	            message.on('end', function () {
	                return _this.finalize(data, message.statusCode, message.statusMessage);
	            });
	        }
	    }, {
	        key: "finalize",
	        value: function finalize(data, statusNumber, statusMessage) {
	            if (statusNumber === 200) {
	                this.handleSuccess(data);
	            } else {
	                this.handleError({ statusNumber: statusNumber, reason: statusMessage });
	            }
	        }
	    }, {
	        key: "handleSuccess",
	        value: function handleSuccess(data) {
	            try {
	                this.resolve(JSON.parse(data));
	            } catch (e) {
	                this.reject(e);
	            }
	        }
	    }]);
	
	    return AjaxRequestFinalizer;
	}();
	
	var UrlPortFixer = function () {
	    function UrlPortFixer(url_) {
	        _classCallCheck(this, UrlPortFixer);
	
	        this.url_ = url_;
	    }
	
	    _createClass(UrlPortFixer, [{
	        key: "urlNoPort",
	        value: function urlNoPort(GET_params) {
	            var search = querystring.stringify(lodash_1.merge({}, this.url_.query, GET_params));
	            return {
	                protocol: this.url_.protocol,
	                hostname: this.url_.hostname,
	                pathname: this.url_.pathname,
	                search: search,
	                path: this.url_.pathname + '?' + search
	            };
	        }
	    }, {
	        key: "urlWithPortAsNumber",
	        value: function urlWithPortAsNumber(GET_params) {
	            return lodash_1.merge({ port: this.url_.port ? parseInt(this.url_.port) : null }, this.urlNoPort(GET_params));
	        }
	    }, {
	        key: "urlWithPortAsString",
	        value: function urlWithPortAsString(GET_params) {
	            return lodash_1.merge({ port: this.url_.port ? this.url_.port : null }, this.urlNoPort(GET_params));
	        }
	    }]);

	    return UrlPortFixer;
	}();
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(50).Buffer))

/***/ },

/***/ 112:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(3);
	var getClasses = function getClasses(c) {
	    return c.theme && c.theme == "frontend" ? classNames.frontend : classNames.admin;
	};
	var classNames = {
	    frontend: {
	        heading: 'sbFieldGroupHeading',
	        group: 'sbFieldGroup',
	        item: 'sbFieldLi',
	        label: 'sbFieldLabel',
	        content: 'sbFieldContent'
	    },
	    admin: {
	        heading: 'sbFieldGroupHeading sbRoundedEdges',
	        group: 'sbFieldGroupFieldset sbRoundedEdges',
	        item: 'sbFormItem clearfix',
	        label: 'sbFormItemLabel',
	        content: 'sbFormItemContent'
	    }
	};
	
	var Group = function (_React$Component) {
	    _inherits(Group, _React$Component);
	
	    function Group() {
	        _classCallCheck(this, Group);
	
	        return _possibleConstructorReturn(this, (Group.__proto__ || Object.getPrototypeOf(Group)).apply(this, arguments));
	    }
	
	    _createClass(Group, [{
	        key: "render",
	        value: function render() {
	            var style = {
	                width: this.props.width ? this.props.width : undefined,
	                height: this.props.height ? this.props.height : undefined,
	                display: this.props.isVisible ? "none" : undefined
	            };
	            var classes = getClasses(this.context || {});
	            var heading = this.props.heading ? React.createElement("div", { className: classes.heading }, this.props.heading) : null;
	            return React.createElement("fieldset", { className: classes.group, style: style }, heading, React.createElement("ol", { className: "sbFieldGroupOl" }, this.props.children));
	        }
	    }]);
	
	    return Group;
	}(React.Component);
	
	Group.contextTypes = {
	    theme: React.PropTypes.string
	};
	exports.Group = Group;
	
	var Item = function (_React$Component2) {
	    _inherits(Item, _React$Component2);
	
	    function Item() {
	        _classCallCheck(this, Item);
	
	        var _this2 = _possibleConstructorReturn(this, (Item.__proto__ || Object.getPrototypeOf(Item)).apply(this, arguments));
	
	        _this2.context = {};
	        return _this2;
	    }
	
	    _createClass(Item, [{
	        key: "render",
	        value: function render() {
	            var classes = getClasses(this.context);
	            var label = this.props.label ? React.createElement("label", { className: classes.label, htmlFor: this.props.id }, this.props.isRequired ? "*\xA0" : "", this.props.label) : null;
	            return React.createElement("li", { className: classes.item }, label, React.createElement("div", { className: classes.content }, this.props.children));
	        }
	    }]);
	
	    return Item;
	}(React.Component);
	
	Item.contextTypes = {
	    theme: React.PropTypes.string
	};
	exports.Item = Item;

/***/ },

/***/ 113:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(3);
	
	var FileOrFolderComponent = function (_React$Component) {
	    _inherits(FileOrFolderComponent, _React$Component);
	
	    function FileOrFolderComponent() {
	        _classCallCheck(this, FileOrFolderComponent);
	
	        return _possibleConstructorReturn(this, (FileOrFolderComponent.__proto__ || Object.getPrototypeOf(FileOrFolderComponent)).apply(this, arguments));
	    }
	
	    _createClass(FileOrFolderComponent, [{
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var deleteCallback = this.props.deleteCallback;
	
	            var deleteButton = deleteCallback === undefined || this.props.deleteIconPath === undefined ? null : React.createElement("span", { className: "delete" }, React.createElement("a", { href: "#", onClick: function onClick(event) {
	                    deleteCallback(_this2.props.file.id);event.preventDefault();
	                } }, React.createElement("img", { src: this.props.deleteIconPath })));
	            var type = this.type();
	            return React.createElement("li", { className: type + "-details details" }, React.createElement("span", { className: type + " item" }, React.createElement("span", { className: type + "-icon icon" }, this.icon()), React.createElement("span", { className: type + "-label label" }, this.title(), this.titleSuffix())), deleteButton);
	        }
	    }, {
	        key: "icon",
	        value: function icon() {
	            return this.maybeLink(React.createElement("img", { src: this.props.file.iconPath }));
	        }
	    }, {
	        key: "title",
	        value: function title() {
	            return this.maybeLink(React.createElement("span", null, this.props.file.title));
	        }
	    }, {
	        key: "maybeLink",
	        value: function maybeLink(child) {
	            var link = this.props.file.link;
	            return link != null ? React.createElement("a", { href: link }, child) : child;
	        }
	    }, {
	        key: "titleSuffix",
	        value: function titleSuffix() {
	            return null;
	        }
	    }]);
	
	    return FileOrFolderComponent;
	}(React.Component);
	
	var FileComponent = function (_FileOrFolderComponen) {
	    _inherits(FileComponent, _FileOrFolderComponen);
	
	    function FileComponent() {
	        _classCallCheck(this, FileComponent);
	
	        return _possibleConstructorReturn(this, (FileComponent.__proto__ || Object.getPrototypeOf(FileComponent)).apply(this, arguments));
	    }
	
	    _createClass(FileComponent, [{
	        key: "titleSuffix",
	        value: function titleSuffix() {
	            return React.createElement("span", null, ' (', this.props.file.size, ')');
	        }
	    }, {
	        key: "type",
	        value: function type() {
	            return 'file';
	        }
	    }]);
	
	    return FileComponent;
	}(FileOrFolderComponent);
	
	exports.FileComponent = FileComponent;
	
	var FolderComponent = function (_FileOrFolderComponen2) {
	    _inherits(FolderComponent, _FileOrFolderComponen2);
	
	    function FolderComponent() {
	        _classCallCheck(this, FolderComponent);
	
	        return _possibleConstructorReturn(this, (FolderComponent.__proto__ || Object.getPrototypeOf(FolderComponent)).apply(this, arguments));
	    }
	
	    _createClass(FolderComponent, [{
	        key: "type",
	        value: function type() {
	            return 'folder';
	        }
	    }]);
	
	    return FolderComponent;
	}(FileOrFolderComponent);
	
	exports.FolderComponent = FolderComponent;
	
	var RecursiveFolderTree = function (_React$Component2) {
	    _inherits(RecursiveFolderTree, _React$Component2);
	
	    function RecursiveFolderTree() {
	        _classCallCheck(this, RecursiveFolderTree);
	
	        return _possibleConstructorReturn(this, (RecursiveFolderTree.__proto__ || Object.getPrototypeOf(RecursiveFolderTree)).apply(this, arguments));
	    }
	
	    _createClass(RecursiveFolderTree, [{
	        key: "render",
	        value: function render() {
	            var _this6 = this;
	
	            var children = this.props.allPotentialChildren.filter(function (child) {
	                return child.parent_serial == _this6.props.parentId;
	            });
	            var otherItems = children.map(function (item) {
	                var key = "category-tree-entry-" + item.id;
	                return item.is_directory ? React.createElement(CategoryRow, { key: key, category: item, directoryIconPath: _this6.props.directoryIconPath, allPotentialChildren: _this6.props.allPotentialChildren }) : React.createElement(FileComponent, { key: key, file: item });
	            });
	            return React.createElement("ul", { className: "child-list item-list" }, otherItems);
	        }
	    }]);
	
	    return RecursiveFolderTree;
	}(React.Component);
	
	exports.RecursiveFolderTree = RecursiveFolderTree;
	
	var CategoryRow = function (_React$Component3) {
	    _inherits(CategoryRow, _React$Component3);
	
	    function CategoryRow() {
	        _classCallCheck(this, CategoryRow);
	
	        return _possibleConstructorReturn(this, (CategoryRow.__proto__ || Object.getPrototypeOf(CategoryRow)).apply(this, arguments));
	    }
	
	    _createClass(CategoryRow, [{
	        key: "render",
	        value: function render() {
	            return React.createElement("li", { className: "category-details details" }, React.createElement("div", null, React.createElement("span", { className: "category item" }, React.createElement("span", { className: "category-icon icon" }, React.createElement("img", { src: this.props.directoryIconPath })), React.createElement("span", { className: "category-label label" }, this.props.category.title))), React.createElement(RecursiveFolderTree, { parentId: this.props.category.id, directoryIconPath: this.props.directoryIconPath, allPotentialChildren: this.props.allPotentialChildren }));
	        }
	    }]);
	
	    return CategoryRow;
	}(React.Component);

/***/ },

/***/ 134:
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.redirect = function (props) {
	    window.location.assign(props.pageUrl);
	};

/***/ },

/***/ 135:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var $ = __webpack_require__(10);
	
	var Dimension = function Dimension(width, height) {
	    _classCallCheck(this, Dimension);
	
	    this.height = height;
	    this.width = width;
	};
	
	exports.Dimension = Dimension;
	exports.renderModal = function (name, title, contentsHtml, dimension, appendCb, onApplyChanges) {
	    var modal = $('<div id="' + name + '">');
	    appendCb(modal.get(0));
	    modal.html(contentsHtml);
	    modal.find('[name="backButton"]').click(function () {
	        return modal.dialog('close');
	    });
	    modal.find('[name="saveSubmit"]').click(onApplyChanges);
	    modal.dialog({
	        height: dimension.height,
	        width: dimension.width,
	        title: title,
	        autoOpen: false
	    });
	    return modal;
	};
	exports.showDialog = function (id, title, content, width) {
	    // The following functions prevent our dialogs from auto focusing the first element they can find, which
	    // can cause unintuitive behaviour for users in some cases (especially with date pickers). The dialog
	    // prototype is put back in its default state when the dialog is closed.
	    var focusTabbable = $.ui.dialog.prototype._focusTabbable;
	    var removeAutoFocus = function removeAutoFocus() {
	        $.ui.dialog.prototype._focusTabbable = function () {};
	    };
	    var addAutoFocus = function addAutoFocus() {
	        $.ui.dialog.prototype._focusTabbable = focusTabbable;
	    };
	    //noinspection JSJQueryEfficiency
	    if ($('#' + id).length) return;
	    $('body').append('<div id="' + id + '">' + content + '</div>');
	    removeAutoFocus();
	    //noinspection JSJQueryEfficiency
	    var div = $('#' + id);
	    div.dialog({
	        autoOpen: false,
	        modal: true,
	        height: 'auto',
	        width: width,
	        title: title,
	        close: function close() {
	            addAutoFocus();$(this).remove();
	        }
	    });
	    div.dialog("open");
	};
	exports.hideDialog = function (id) {
	    $('#' + id).dialog("destroy").remove();
	};

/***/ },

/***/ 136:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(3);
	exports.HelpButton = function (props) {
	        return React.createElement("a", { href: "#", title: props.message, onClick: function onClick(event) {
	                        event.preventDefault();
	                        alert(props.message);
	                } }, React.createElement("img", { src: "/sb/static/images/help.png", style: { verticalAlign: "middle" }, alt: "Help" }));
	};
	//# sourceMappingURL=help button.js.map

/***/ },

/***/ 137:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(3);
	var react_chartjs_2_1 = __webpack_require__(468);
	var chart_data_1 = __webpack_require__(180);
	var utils_1 = __webpack_require__(4);
	var fixed_data_grid_1 = __webpack_require__(94);
	var ramda_1 = __webpack_require__(62);
	var axisLabel = function axisLabel(id, map) {
	    return utils_1.dataFromSerial(id, map, "Axis Data", 'value', 'label');
	};
	exports.RenderGraph = function (props) {
	    var chartData = props.chartData;
	    switch (chartData.renderAs) {
	        case "line":
	        case "bar":
	            return React.createElement(exports.RenderMultiGraph, { chartData: chartData, borderColors: props.borderColors, fillColors: props.fillColors, axis: props.axis, removeEmptyAxes: props.removeEmptyAxes, keys: props.keys });
	        case "pie":
	            return React.createElement(RenderPieGraph, { chartData: chartData, borderColors: props.borderColors, fillColors: props.fillColors, axis: props.axis });
	    }
	};
	exports.RenderMultiGraph = function (props) {
	    var d = props.chartData.data || [];
	    var datasets = extractDatasets(props.borderColors, props.fillColors, props.removeEmptyAxes ? chart_data_1.getActualData(d) : d, props.axis);
	    var labels = utils_1.unique((props.chartData.data || []).map(function (d) {
	        return d.key;
	    }));
	    var chartData = props.chartData;
	    switch (chartData.renderAs) {
	        case "line":
	            return React.createElement(exports.RenderLineGraph, { datasets: datasets, labels: labels });
	        case "bar":
	            return React.createElement(exports.RenderBarGraph, { datasets: datasets, labels: labels });
	    }
	};
	var labelsFromInstantReportData = function labelsFromInstantReportData(data, types) {
	    //first we convert the data from an object into an array of tuples
	    var asTuples = utils_1.mapValues(data.data || {}, function (v, k) {
	        return [v, k];
	    });
	    // then we remove the types with zero answers
	    var withoutBlanks = asTuples.filter(function (_ref) {
	        var _ref2 = _slicedToArray(_ref, 1),
	            v = _ref2[0];
	
	        return v > 0;
	    });
	    //then we get the labels
	    return withoutBlanks.map(function (_ref3) {
	        var _ref4 = _slicedToArray(_ref3, 2),
	            v = _ref4[0],
	            k = _ref4[1];
	
	        return axisLabel(k, types);
	    });
	};
	var RenderPieGraph = function RenderPieGraph(props) {
	    return React.createElement(react_chartjs_2_1.Pie, { data: {
	            labels: labelsFromInstantReportData(props.chartData, props.axis),
	            datasets: [{ backgroundColor: props.fillColors, borderColor: props.borderColors, data: utils_1.mapValues(props.chartData.data || {}, function (v) {
	                    return v;
	                }).filter(function (v) {
	                    return v > 0;
	                }) }]
	        } });
	};
	exports.RenderBarGraph = function (props) {
	    return React.createElement(react_chartjs_2_1.Bar, { options: {
	            scales: {
	                xAxes: [{ stacked: true }],
	                yAxes: [{ stacked: true }]
	            }, legend: { display: props.datasets.length <= 30 }
	        }, data: {
	            labels: props.labels,
	            datasets: props.datasets
	        } });
	};
	exports.RenderLineGraph = function (props) {
	    return React.createElement(react_chartjs_2_1.Line, { options: { legend: { display: props.datasets.length <= 30 } }, data: {
	            labels: props.labels,
	            datasets: props.datasets.map(function (d) {
	                return Object.assign({}, d, { fill: false, lineTension: 0 });
	            })
	        } });
	};
	var extractDatasets = function extractDatasets(borderColors, fillColors, d, axis) {
	    return chart_data_1.getIds(d).map(function (id, n) {
	        return {
	            label: axisLabel(id, axis),
	            backgroundColor: fillColors[n],
	            borderColor: borderColors[n],
	            borderSkipped: "right",
	            data: chart_data_1.getDataById(d, id).map(function (d) {
	                return d.value;
	            })
	        };
	    });
	};
	exports.RenderSelectMode = function (props) {
	    return React.createElement("span", null, ramda_1.intersperse(' | ', props.modes.map(function (mode) {
	        return props.mode == mode ? React.createElement("b", { key: mode }, mode) : React.createElement("a", { key: mode, style: { fontWeight: 'normal' }, href: "javascript:void 0", onClick: function onClick() {
	                return props.setMode(mode), false;
	            } }, mode);
	    })));
	};
	var RenderMultiTable = function RenderMultiTable(props) {
	    var chartData = props.chartData.data || [];
	    var filteredData = chart_data_1.getIds(props.removeEmptyAxes ? chart_data_1.getActualData(chartData) : chartData);
	    var headingFixed = utils_1.reduceToObj(function (key) {
	        return "i_" + key.id;
	    }, function (key) {
	        return key.label;
	    }, props.keys);
	    var headingVar = utils_1.reduceToObj(function (id) {
	        return "i_" + id;
	    }, function (id) {
	        return axisLabel(id, props.axis);
	    }, filteredData);
	    var heading = Object.assign({}, headingFixed, headingVar);
	    var makeKeyCells = function makeKeyCells(key) {
	        return utils_1.reduceToObj(function (k) {
	            return "i_" + k.id;
	        }, function () {
	            return { node: key };
	        }, props.keys);
	    };
	    var makeDataCells = function makeDataCells(key) {
	        return utils_1.reduceToObj(function (data) {
	            return "i_" + data.id;
	        }, function (data) {
	            return { node: data.value };
	        }, chart_data_1.getDataByKey(chartData, key));
	    };
	    var makeRow = function makeRow(key) {
	        return Object.assign({}, makeKeyCells(key), makeDataCells(key));
	    };
	    var rows = chart_data_1.getKeys(chartData);
	    var data = rows.map(makeRow);
	    return React.createElement(fixed_data_grid_1.FixedDataGrid, { heading: heading, data: data });
	};
	var headingSingle = { "Type": "Membership Type", "Count": "Membership Count" };
	
	var SingleTable = function (_fixed_data_grid_1$Fi) {
	    _inherits(SingleTable, _fixed_data_grid_1$Fi);
	
	    function SingleTable() {
	        _classCallCheck(this, SingleTable);
	
	        return _possibleConstructorReturn(this, (SingleTable.__proto__ || Object.getPrototypeOf(SingleTable)).apply(this, arguments));
	    }
	
	    return SingleTable;
	}(fixed_data_grid_1.FixedDataGrid);
	
	var RenderSingleTable = function RenderSingleTable(props) {
	    var data = utils_1.mapValues(props.chartData.data || {}, function (count, type) {
	        return { "Type": { node: axisLabel(type, props.axis) }, "Count": { node: count + "" } };
	    });
	    return React.createElement(SingleTable, { heading: headingSingle, data: data });
	};
	var RenderTable = function RenderTable(props) {
	    var chartData = props.chartData;
	    if (!chartData) {
	        return React.createElement("div", null, "No data");
	    }
	    switch (chartData.renderAs) {
	        case "line":
	        case "bar":
	            return React.createElement(RenderMultiTable, { chartData: chartData, borderColors: props.borderColors, fillColors: props.fillColors, axis: props.axis, removeEmptyAxes: props.removeEmptyAxes, keys: props.keys });
	        case "pie":
	            return React.createElement(RenderSingleTable, { chartData: chartData, borderColors: props.borderColors, fillColors: props.fillColors, axis: props.axis });
	    }
	};
	exports.standardModes = {
	    Graph: exports.RenderGraph,
	    Table: RenderTable
	};

/***/ },

/***/ 138:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(3);
	var buttonTypeToString = function buttonTypeToString(type) {
	    switch (type) {
	        case 0 /* button */:
	            return "button";
	        case 1 /* submit */:
	            return "submit";
	        case 2 /* reset */:
	            return "reset";
	    }
	};
	
	var Button = function (_React$Component) {
	    _inherits(Button, _React$Component);
	
	    function Button() {
	        _classCallCheck(this, Button);
	
	        return _possibleConstructorReturn(this, (Button.__proto__ || Object.getPrototypeOf(Button)).apply(this, arguments));
	    }
	
	    _createClass(Button, [{
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var className = this.props.disabled ? "sbButtonOff" : "sbButton";
	            if (this.props.className) {
	                className += ' ' + this.props.className;
	            }
	            var type = buttonTypeToString(this.props.type || 0 /* button */);
	            var icon = this.props.icon && React.createElement("img", { style: { paddingRight: "1ex", verticalAlign: "bottom" }, src: this.props.icon });
	            var style = this.props.emoji ? { position: "relative", filter: this.props.disabled && "grayscale(100%)" } : undefined;
	            var children = this.props.emoji ? React.createElement("span", { style: { marginLeft: "2em" } }, this.props.children) : this.props.children;
	            var emoji = this.props.emoji && React.createElement("span", { style: { position: "absolute", fontSize: "150%" } }, this.props.emoji);
	            return React.createElement("button", { type: type, onClick: function onClick(event) {
	                    event.stopPropagation();
	                    if (_this2.props.onClick) {
	                        _this2.props.onClick();
	                    }
	                }, disabled: this.props.disabled, className: className, style: style }, icon, emoji, children);
	        }
	    }]);
	
	    return Button;
	}(React.Component);
	
	exports.Button = Button;

/***/ },

/***/ 139:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(3);
	var utils_1 = __webpack_require__(4);
	exports.Notification = function (props) {
	  return React.createElement("div", { className: utils_1.joinStrings(['ui-corner-all', 'notify-widget', props.type]) }, props.children);
	};

/***/ },

/***/ 140:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var $ = __webpack_require__(10);
	var Visa = {
	    name: "Visa",
	    code: 'vis',
	    pattern: /^4/,
	    structure: [4, 4, 4, 4],
	    cvv: 3
	};
	var MasterCard = {
	    name: "MasterCard",
	    code: 'mcd',
	    pattern: /^5[012345]/,
	    structure: [4, 4, 4, 4],
	    cvv: 3
	};
	var DinersClub = {
	    name: "DinersClub",
	    code: 'diner',
	    pattern: /^3(0[0123459]|6|8|9)/,
	    structure: [4, 6, 4, 0],
	    cvv: 3
	};
	var Amex = {
	    name: "AmEx",
	    code: 'amex',
	    pattern: /^3[47]/,
	    structure: [4, 6, 5, 0],
	    cvv: 4
	};
	var putCursorAtEnd = function putCursorAtEnd(query) {
	    return query.each(function () {
	        var that = this;
	        if (that instanceof HTMLInputElement) {
	            $(that).focus();
	            if (that.setSelectionRange) {
	                var len = $(that).val().length * 2;
	                that.setSelectionRange(len, len);
	            } else {
	                $(that).val($(that).val());
	            }
	            that.scrollTop = 999999;
	        }
	    });
	};
	exports.checkCreditCard = function (cardnumber, cardname) {
	    // Array to hold the permitted card characteristics
	    var cards = [];
	    // Define the cards we support. You may add addtional card types as follows.
	    //  Name:         As in the selection box of the form - must be same as user's
	    //  Length:       List of possible valid lengths of the card number for the card
	    //  prefixes:     List of possible prefixes for the card
	    //  checkdigit:   Boolean to say whether there is a check digit
	    cards[0] = { name: "Visa",
	        length: "13,16",
	        prefixes: "4",
	        checkdigit: true };
	    cards[1] = { name: "MasterCard",
	        length: "16",
	        prefixes: "51,52,53,54,55",
	        checkdigit: true };
	    cards[2] = { name: "DinersClub",
	        length: "14,16",
	        prefixes: "36,38,54,55",
	        checkdigit: true };
	    cards[3] = { name: "CarteBlanche",
	        length: "14",
	        prefixes: "300,301,302,303,304,305",
	        checkdigit: true };
	    cards[4] = { name: "AmEx",
	        length: "15",
	        prefixes: "34,37",
	        checkdigit: true };
	    cards[5] = { name: "Discover",
	        length: "16",
	        prefixes: "6011,622,64,65",
	        checkdigit: true };
	    cards[6] = { name: "JCB",
	        length: "16",
	        prefixes: "35",
	        checkdigit: true };
	    cards[7] = { name: "enRoute",
	        length: "15",
	        prefixes: "2014,2149",
	        checkdigit: true };
	    cards[8] = { name: "Solo",
	        length: "16,18,19",
	        prefixes: "6334,6767",
	        checkdigit: true };
	    cards[9] = { name: "Switch",
	        length: "16,18,19",
	        prefixes: "4903,4905,4911,4936,564182,633110,6333,6759",
	        checkdigit: true };
	    cards[10] = { name: "Maestro",
	        length: "12,13,14,15,16,18,19",
	        prefixes: "5018,5020,5038,6304,6759,6761,6762,6763",
	        checkdigit: true };
	    cards[11] = { name: "VisaElectron",
	        length: "16",
	        prefixes: "4026,417500,4508,4844,4913,4917",
	        checkdigit: true };
	    cards[12] = { name: "LaserCard",
	        length: "16,17,18,19",
	        prefixes: "6304,6706,6771,6709",
	        checkdigit: true };
	    // Establish card type
	    var cardType = -1;
	    for (var i = 0; i < cards.length; i++) {
	        // See if it is this card (ignoring the case of the string)
	        if (cardname.toLowerCase() == cards[i].name.toLowerCase()) {
	            cardType = i;
	            break;
	        }
	    }
	    // If card type not found, report an error
	    if (cardType == -1) {
	        window.ccErrorNo = 0;
	        return false;
	    }
	    // Ensure that the user has provided a credit card number
	    if (cardnumber.length == 0) {
	        window.ccErrorNo = 1;
	        return false;
	    }
	    // Now remove any spaces from the credit card number
	    cardnumber = cardnumber.replace(/\s/g, "");
	    // Check that the number is numeric
	    var cardNo = cardnumber;
	    var cardexp = /^[0-9]{13,19}$/;
	    if (!cardexp.exec(cardNo)) {
	        window.ccErrorNo = 2;
	        return false;
	    }
	    // Now check the modulus 10 check digit - if required
	    if (cards[cardType].checkdigit) {
	        var checksum = 0; // running checksum total
	        var j = 1; // takes value of 1 or 2
	        // Process each digit one by one starting at the right
	        var calc;
	        for (i = cardNo.length - 1; i >= 0; i--) {
	            // Extract the next digit and multiply by 1 or 2 on alternative digits.
	            calc = Number(cardNo.charAt(i)) * j;
	            // If the result is in two digits add 1 to the checksum total
	            if (calc > 9) {
	                checksum = checksum + 1;
	                calc = calc - 10;
	            }
	            // Add the units element to the checksum total
	            checksum = checksum + calc;
	            // Switch the value of j
	            if (j == 1) {
	                j = 2;
	            } else {
	                j = 1;
	            }
	        }
	        // All done - if checksum is divisible by 10, it is a valid modulus 10.
	        // If not, report an error.
	        if (checksum % 10 != 0) {
	            window.ccErrorNo = 3;
	            return false;
	        }
	    }
	    // Check it's not a spam number
	    if (cardNo == '5490997771092064') {
	        window.ccErrorNo = 5;
	        return false;
	    }
	    // The following are the card-specific checks we undertake.
	    var LengthValid = false;
	    var PrefixValid = false;
	    // We use these for holding the valid lengths and prefixes of a card type
	    var lengths = [];
	    // Load an array with the valid prefixes for this card
	    var prefix = cards[cardType].prefixes.split(",");
	    // Now see if any of them match what we have in the card number
	    for (i = 0; i < prefix.length; i++) {
	        var exp = new RegExp("^" + prefix[i]);
	        if (exp.test(cardNo)) PrefixValid = true;
	    }
	    // If it isn't a valid prefix there's no point at looking at the length
	    if (!PrefixValid) {
	        window.ccErrorNo = 3;
	        return false;
	    }
	    // See if the length is valid for this card
	    lengths = cards[cardType].length.split(",").map(function (n) {
	        return Number.parseInt(n);
	    });
	    for (j = 0; j < lengths.length; j++) {
	        if (cardNo.length == lengths[j]) LengthValid = true;
	    }
	    // See if all is OK by seeing if the length was valid. We only check the length if all else was
	    // hunky dory.
	    if (!LengthValid) {
	        window.ccErrorNo = 4;
	        return false;
	    }
	    // The credit card is in the required format.
	    return true;
	};
	var initialiseCreditCardGroupFields = function initialiseCreditCardGroupFields(oldtype, type) {
	    var full = $("[name='CreditCardNumberFull']");
	    var current = 0;
	    var fulltext = full.val().replace(/[^0-9]/, "");
	    var breakUpNumbers = function breakUpNumbers() {
	        for (var i = 0; i < 4; i++) {
	            var group = $("[name='CreditCardNumberGroup[" + i + "]']");
	            var text = fulltext.slice(current, current + type.structure[i]);
	            group.val(text);
	            current += type.structure[i];
	        }
	    };
	    var focusNextGroup = function focusNextGroup() {
	        for (var i = 0; i < 4; i++) {
	            var group = $("[name='CreditCardNumberGroup[" + i + "]']");
	            if (group.val().length != group.prop('maxlength')) {
	                group.focus();
	                putCursorAtEnd(group);
	                break;
	            }
	        }
	    };
	    breakUpNumbers();
	    focusNextGroup();
	    callChangeTypeCallback(oldtype, type);
	};
	var setCardType = function setCardType(oldtype, type) {
	    var full = $("[name='CreditCardNumberFull']");
	    var showAllCreditCardIcons = function showAllCreditCardIcons() {
	        full.css('display', 'inline');
	        full.focus();
	        $("[name^='CreditCardNumberGroup']").css('display', 'none');
	        $("[name|='cc-full']").css('display', 'inline');
	        $("[name|='cc-grey']").css('display', 'none');
	    };
	    var hightlightSelectedTypeIcon = function hightlightSelectedTypeIcon(type) {
	        full.css('display', 'none');
	        $("[name|='cc-full']").css('display', 'none');
	        $("[name|='cc-grey']").css('display', 'inline');
	        $("[name='cc-grey-" + type.code + "']").css('display', 'none');
	        $("[name='cc-full-" + type.code + "']").css('display', 'inline');
	    };
	    var layoutGroupTextBoxes = function layoutGroupTextBoxes(type) {
	        for (var i = 0; i < 4; i++) {
	            var group = $("[name='CreditCardNumberGroup[" + i + "]']");
	            group.css('display', type.structure[i] > 0 ? 'inline' : 'none');
	            group.prop('maxlength', type.structure[i]);
	            group.width(0.75 + type.structure[i] * 0.75 + "em");
	        }
	    };
	    full.data('oldType', type);
	    if (type == null) {
	        showAllCreditCardIcons();
	    } else {
	        hightlightSelectedTypeIcon(type);
	        layoutGroupTextBoxes(type);
	        if (oldtype != type) initialiseCreditCardGroupFields(oldtype, type);
	    }
	};
	var collateCreditCardNumber = function collateCreditCardNumber() {
	    var full = $("[name='CreditCardNumberFull']");
	    if (full.css('display') == 'none') {
	        var string = '';
	        for (var i = 0; i < 4; i++) {
	            var group = $("[name='CreditCardNumberGroup[" + i + "]']");
	            if (group.css('display') != 'none') string += group.val();
	        }
	        full.val(string);
	    }
	};
	var detectType = function detectType(cardNumber) {
	    for (var i = 0; i < exports.types.length; i++) {
	        if (exports.types[i].pattern.test(cardNumber)) return exports.types[i];
	    }return null;
	};
	var move = function move(source, direction) {
	    var destination = source.data(direction);
	    if (destination == undefined) return true;
	    if (destination.css('display') != 'none') {
	        destination.focus();
	        return false;
	    }
	    return true;
	};
	var moveToPrevious = function moveToPrevious(source) {
	    move(source, 'previous');
	    return true;
	};
	var moveToNext = function moveToNext(source) {
	    if (source.val().length >= source.prop('maxlength')) return move(source, 'next');
	    return true;
	};
	var callChangeTypeCallback = function callChangeTypeCallback() {};
	exports.types = [Visa, MasterCard, DinersClub, Amex]; /* todo checkme */
	exports.setTypes = function (newTypes) {
	    exports.types = newTypes;
	};
	//noinspection JSUnusedGlobalSymbols
	exports.setChangeTypeCallback = function (callback) {
	    callChangeTypeCallback = callback;
	};
	exports.blur = function (event) {
	    var target = $(event.target);
	    target.data('oldLength', target.val().length);
	};
	exports.keydown = function (event) {
	    var target = $(event.target);
	    target.data('oldLength', target.val().length);
	    if ([37, 38].indexOf(event.which) !== -1 && target.caret() == 0 || 8 == event.which && target.val().length == 0) return moveToPrevious(target);else if ([40, 39, 35].indexOf(event.which) !== -1 && target.caret() == target.val().length) return move(target, 'next');
	    return true;
	};
	exports.creditCardType = function () {
	    collateCreditCardNumber();
	    var full = $("[name='CreditCardNumberFull']");
	    var type = detectType(full.val());
	    var oldType = full.data('oldType');
	    return { old: oldType, new_: type };
	};
	exports.keyup = function (event) {
	    var type = exports.creditCardType();
	    setCardType(type.old, type.new_);
	    var target = $(event.target);
	    var data = target.data('oldLength');
	    if (typeof data == 'undefined' || target.val().length > data) moveToNext(target);
	};
	//noinspection JSUnusedGlobalSymbols
	exports.isCreditCardValid = function () {
	    var type = exports.creditCardType();
	    return type.new_ != null && exports.checkCreditCard($("[name='CreditCardNumberFull']").val(), type.new_.name);
	};
	//noinspection JSUnusedGlobalSymbols
	exports.isCreditCardCvvValid = function () {
	    var params = exports.getCreditCardParams();
	    return params.cvv.length == exports.requiredCvvDigits();
	};
	exports.requiredCvvDigits = function () {
	    var type = exports.creditCardType();
	    return type.new_ != null && type.new_.cvv != null ? type.new_.cvv : 3;
	};
	//noinspection JSUnusedGlobalSymbols
	exports.isCreditCardExpiryValid = function () {
	    var params = exports.getCreditCardParams();
	    var date = new Date();
	    var currentYear = date.getFullYear();
	    var currentMonth = date.getMonth() + 1;
	    var suppliedYear = Number.parseInt(params.year);
	    return suppliedYear > currentYear || suppliedYear == currentYear && Number.parseInt(params.month) >= currentMonth;
	};
	exports.getCreditCardParams = function () {
	    var type = exports.creditCardType().new_;
	    return {
	        method: "CreditCard",
	        cardType: type == null ? 'unknown' : type.code,
	        number: $("[name='CreditCardNumberFull']").val(),
	        month: $("[name='CreditCardExpiryMonth']").val(),
	        year: $("[name='CreditCardExpiryYear']").val(),
	        name: $("[name='CreditCardCardholderName']").val(),
	        cvv: $("[name='CreditCardNumberCVV']").val()
	    };
	};
	exports.ccErrors = [];
	exports.ccErrors[0] = "Unknown card type";
	exports.ccErrors[1] = "No card number provided";
	exports.ccErrors[2] = "Credit card number is in invalid format";
	exports.ccErrors[3] = "Credit card number is invalid";
	exports.ccErrors[4] = "Credit card number has an inappropriate number of digits";
	exports.ccErrors[5] = "Warning! This credit card number is associated with a scam attempt";

/***/ },

/***/ 178:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var utils_1 = __webpack_require__(4);
	var data_1 = __webpack_require__(262);
	exports.maxPrioritiesFromLayout = function (layout) {
	    var articleTemplates = utils_1.objToList(function (a) {
	        return a;
	    }, layout);
	    return exports.maxPrioritiesFromList(articleTemplates);
	};
	exports.maxPrioritiesFromList = function (articleTemplates) {
	    var priorities = {
	        '1': 0,
	        '2': 0,
	        '3': 0
	    };
	    articleTemplates.forEach(function (a) {
	        priorities[a.column] = priorities[a.column] + 1;
	    });
	    return priorities;
	};
	exports.layoutFromTemplates = function (articleTemplates, columns) {
	    var sortedArticleTemplates = articleTemplates.sort(function (a, b) {
	        return a.column === b.column ? a.priority - b.priority : a.column - b.column;
	    });
	    var priorities = { '1': 1, '2': 1, '3': 1 };
	    var hydrate = data_1.hydrateTemplateWithRestrictedColumn(columns);
	    return utils_1.reduceToObj(function (a) {
	        return a.id.toString();
	    }, function (a) {
	        var hydrated = hydrate(a);
	        return Object.assign({}, hydrated, { priority: priorities[hydrated.column]++ });
	    }, sortedArticleTemplates);
	};

/***/ },

/***/ 179:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var reducer_1 = __webpack_require__(605);
	exports.reducer = reducer_1.reducer;
	var lib_1 = __webpack_require__(181);
	exports.makeReportApp = lib_1.makeReportApp;

/***/ },

/***/ 180:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var utils_1 = __webpack_require__(4);
	exports.flattenReportChartData = function (data) {
	  return utils_1.flatten(utils_1.mapValues(data, function (row, key) {
	    return utils_1.mapValues(row, function (value, id) {
	      return { id: id, key: key, value: value };
	    });
	  })).sort(function (a, b) {
	    return utils_1.compareStringsAlphabetically(a.key, b.key);
	  });
	};
	exports.getActualData = function (data) {
	  return data.filter(function (d1) {
	    return d1.value != 0 || data.some(function (d2) {
	      return d1.id == d2.id && d2.value != 0;
	    });
	  });
	};
	exports.getIds = function (data) {
	  return utils_1.unique(data.map(function (d) {
	    return d.id;
	  }));
	};
	exports.getKeys = function (data) {
	  return utils_1.unique(data.map(function (d) {
	    return d.key;
	  })).sort();
	};
	exports.getDataById = function (data, id) {
	  return utils_1.filterObjectArray(data, 'id', id);
	};
	exports.getDataByKey = function (data, key) {
	  return utils_1.filterObjectArray(data, 'key', key);
	};

/***/ },

/***/ 181:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var utils_1 = __webpack_require__(4);
	var react_redux_1 = __webpack_require__(23);
	var lib1_1 = __webpack_require__(270);
	exports.mapDispatchToProps = function (dispatch_, ownProps) {
	    var wrap = function wrap(action) {
	        return {
	            type: "report action",
	            action: action
	        };
	    };
	    var dispatchAction = utils_1.compose(wrap, dispatch_);
	    return {
	        setDisplay: function setDisplay(mode) {
	            return dispatchAction({ type: "set display mode", mode: mode });
	        },
	        runReport: function runReport() {
	            return dispatch_(ownProps.runReport(dispatchAction));
	        },
	        onSetReportType: function onSetReportType(reportType) {
	            return dispatchAction({ type: "set report type", value: reportType });
	        },
	        filterCallbacks: {
	            onSetCheckbox: function onSetCheckbox(filter, value) {
	                return dispatchAction({ type: "set filter checkbox", filter: filter, value: value });
	            },
	            onUnsetCheckbox: function onUnsetCheckbox(filter, value) {
	                return dispatchAction({ type: "unset filter checkbox", filter: filter, value: value });
	            },
	            onSelect: function onSelect(s, f) {
	                return dispatchAction({
	                    type: "set filter",
	                    filter: f,
	                    filterData: { type: "select box", selected: s }
	                });
	            },
	            onSetFromDate: function onSetFromDate(d, f) {
	                return dispatchAction({
	                    type: "set filter",
	                    filter: f,
	                    filterData: { type: "date range", fromDate: d }
	                });
	            },
	            onSetToDate: function onSetToDate(d, f) {
	                return dispatchAction({
	                    type: "set filter",
	                    filter: f,
	                    filterData: { type: "date range", toDate: d }
	                });
	            }
	        }
	    };
	};
	exports.mapStateToProps = function (state, ownProps) {
	    return {
	        title: ownProps.title,
	        displayMode: state.displayMode,
	        displayModes: ownProps.modes,
	        chartData: state.reportData,
	        reportType: state.reportType,
	        reportTypes: ownProps.reportTypes,
	        filters: ownProps.filters,
	        filterState: state.filters,
	        axes: ownProps.axes
	    };
	};
	exports.makeReportApp = function () {
	    return react_redux_1.connect(function (reportState, ownProps) {
	        return exports.mapStateToProps(reportState, ownProps);
	    }, function (dispatcher, ownProps) {
	        return exports.mapDispatchToProps(dispatcher, ownProps);
	    })(lib1_1.Report);
	};

/***/ },

/***/ 182:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) {
	            try {
	                step(generator.next(value));
	            } catch (e) {
	                reject(e);
	            }
	        }
	        function rejected(value) {
	            try {
	                step(generator["throw"](value));
	            } catch (e) {
	                reject(e);
	            }
	        }
	        function step(result) {
	            result.done ? resolve(result.value) : new P(function (resolve) {
	                resolve(result.value);
	            }).then(fulfilled, rejected);
	        }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var fileprogress_1 = __webpack_require__(275);
	var extensions_1 = __webpack_require__(602);
	var handler = __webpack_require__(612);
	var swfUploaderFile = function swfUploaderFile(file, id) {
	    return {
	        id: id.toString(),
	        name: file.name
	    };
	};
	//it seems there's some sort of global state in this. it isn't worth removing it; we should remove swfuploader
	//still, till then, here's our static counter:
	var _uploaderCount = 1;
	/** @returns {Promise<XHRPromiseFulfilled>} It doesn't care why it finished. It merely promises that it finished. */
	var xhrToPromise = function xhrToPromise(xhr, go) {
	    var promise = new Promise(function (resolve) {
	        xhr.onreadystatechange = function (event) {
	            if (xhr.readyState == 4) resolve({ xhr: xhr, event: event });
	        };
	    });
	    go(xhr);
	    return promise;
	};
	var _cancelUpload = function _cancelUpload(f) {
	    switch (f.state) {
	        case "uploading":
	            f.xhr.abort();
	    }
	    return { file: f.file, swfFile: f.swfFile, index: f.index, state: "done (whether successfully or not)" };
	};
	var yieldNextPending = function yieldNextPending(set) {
	    return set.find(function (s) {
	        return s.state == "pending";
	    });
	};
	/**
	 * in order to use this method, the php still needs to make sure the header javascript
	 * is added, because i really don't have the time to deal with that for code that is
	 * probably going to be thrown away in a few months anyway.
	 *
	 * @see \SwfUploadWrapper->render() the top thereof.
	 */
	exports.swfuploader = function (replace, params) {
	    if (!handler.done) {
	        return;
	    }
	    var uploaderCount = String(_uploaderCount++);
	    window.ivt = window.ivt || {};
	    window.ivt.sbhtml = window.ivt.sbhtml || {};
	    window.ivt.sbhtml.swfUploaders = window.ivt.sbhtml.swfUploaders || {};
	    var node = document.createElement('div');
	    replace(node);
	    var outerDiv = document.createElement('div');
	    outerDiv.className = 'swfUploadOuterDiv';
	    node.appendChild(outerDiv);
	    var fileUpload = document.createElement('input');
	    fileUpload.multiple = params.queueLimit != 1;
	    fileUpload.type = "file";
	    var filetypes = extensions_1.makeAcceptFromExtensions(params.fileTypes);
	    fileUpload.accept = filetypes.join(', ');
	    outerDiv.appendChild(fileUpload);
	    var cancelButton = document.createElement('button');
	    cancelButton.id = 'btnCancel' + uploaderCount;
	    cancelButton.type = 'button';
	    cancelButton.className = 'swfUploadCancel';
	    cancelButton.style.display = params.showCancelButton ? 'block' : 'none';
	    cancelButton.innerHTML = 'Cancel All Uploads';
	    cancelButton.disabled = true;
	    outerDiv.appendChild(cancelButton);
	    var swfUploaderDiv = document.createElement('div');
	    swfUploaderDiv.id = 'fsUploadProgress' + uploaderCount;
	    swfUploaderDiv.className = 'swfUploadFieldset swfUploadflash';
	    node.appendChild(swfUploaderDiv);
	    if (params.showQueue) {
	        var progressSpan = document.createElement('span');
	        progressSpan.id = 'swfUploadProgressLegend' + uploaderCount;
	        progressSpan.innerHTML = 'Upload Queue';
	        swfUploaderDiv.appendChild(progressSpan);
	    }
	    var statusDiv = null;
	    if (params.showUploadTotal) {
	        statusDiv = document.createElement('div');
	        statusDiv.innerHTML = '0 Files Uploaded';
	        node.appendChild(statusDiv);
	    }
	    var cancelled = false;
	    var swfUploader = {
	        file_size_limit: params.maxSize + " MB",
	        file_types: params.fileTypes,
	        file_types_description: params.fileTypesDescription,
	        file_upload_limit: params.maxSize,
	        file_queue_limit: params.queueLimit,
	        custom_settings: {
	            progressTarget: swfUploaderDiv.id,
	            cancelButtonId: cancelButton.id
	        },
	        button_width: "61",
	        button_height: "22",
	        button_placeholder_id: fileUpload.id,
	        // The event handler functions are defined in handlers.js
	        file_queued_handler: fileQueued,
	        file_queue_error_handler: fileQueueError,
	        upload_start_handler: uploadStart,
	        upload_progress_handler: uploadProgress,
	        upload_error_handler: uploadError,
	        getStats: function getStats() {
	            return { files_queued: fileSet.filter(function (s) {
	                    return s.state == "pending";
	                }).length };
	        },
	        cancelUpload: function cancelUpload(fileId) {
	            return fileSet.map(function (f) {
	                return f.index == fileId ? _cancelUpload(f) : f;
	            });
	        },
	        cancelQueue: function cancelQueue() {
	            return fileSet.map(_cancelUpload);
	        },
	        updateUploadUrl: function updateUploadUrl(url) {
	            params.uploadUrl = url;
	        },
	        upload_success_handler: function upload_success_handler(file, serverData, response) {
	            var progress = new fileprogress_1.FileProgress(file, swfUploaderDiv.id);
	            progress.setComplete();
	            progress.setStatus("Complete.");
	            progress.toggleCancel(false);
	            if (params.uploadCallback) {
	                params.uploadCallback.call(this, file, serverData, response);
	            }
	        },
	        upload_complete_handler: function upload_complete_handler(File) {
	            cancelButton.disabled = true;
	            if (params.uploadComplete) params.uploadComplete.call(this, File);
	        },
	        queue_complete_handler: function queue_complete_handler(numFilesUploaded) {
	            if (params.showUploadedTotal && statusDiv != null) statusDiv.innerHTML = numFilesUploaded + " file" + (numFilesUploaded === 1 ? "" : "s") + " uploaded.";
	            if (params.queueComplete) params.queueComplete.call(this);
	        }
	    };
	    var fileIdCount = 0;
	    var fileSet = [];
	    if (params.id) {
	        window.ivt.sbhtml.swfUploaders[params.id] = swfUploader;
	    }
	    fileUpload.onchange = function () {
	        if (fileUpload && fileUpload.files) {
	            // first, we validate
	            // `fileUpload.files` is a FileList, not an Array. consequently we manually iterate. But i want some isolation, so i do a async iife
	            for (var i = 0; i < fileUpload.files.length; i++) {
	                var _file = fileUpload.files[i];
	                var swfFile = swfUploaderFile(_file, fileIdCount++);
	                var maxSize = Number.parseFloat(params.maxSize);
	                if (maxSize && _file.size > maxSize * 1000000) {
	                    swfUploader.file_queue_error_handler(swfFile, exports.SWFUpload.QUEUE_ERROR.FILE_EXCEEDS_SIZE_LIMIT, "The file " + _file.name + " cannot be uploaded because it is too large. Files must be less than  " + maxSize + " MB, but this file is " + _file.size / 1000000 + " MB");
	                } else if (!extensions_1.matchesGlob(_file.name, params.fileTypes)) {
	                    swfUploader.file_queue_error_handler(swfFile, exports.SWFUpload.QUEUE_ERROR.INVALID_FILETYPE, "The file " + _file.name + " cannot be uploaded because it is of type " + _file.type + ". Please select a file of type " + filetypes.join(', '));
	                }
	                swfUploader.file_queued_handler(swfFile);
	                fileSet.push({ file: _file, swfFile: swfFile, index: "UploadFileDataEle" + fileIdCount, state: "pending" });
	            }
	            // then we upload.
	            ;
	            (function () {
	                return __awaiter(undefined, void 0, void 0, regeneratorRuntime.mark(function _callee() {
	                    var _this = this;
	
	                    var go, _loop, fileState, _ret;
	
	                    return regeneratorRuntime.wrap(function _callee$(_context2) {
	                        while (1) {
	                            switch (_context2.prev = _context2.next) {
	                                case 0:
	                                    cancelButton.disabled = false;
	
	                                    go = function go(fd) {
	                                        return function (xhr) {
	                                            xhr.open('POST', params.uploadUrl);
	                                            xhr.send(fd);
	                                        };
	                                    };
	
	                                    _loop = regeneratorRuntime.mark(function _loop(fileState) {
	                                        var xhr, file, fd, filename, r;
	                                        return regeneratorRuntime.wrap(function _loop$(_context) {
	                                            while (1) {
	                                                switch (_context.prev = _context.next) {
	                                                    case 0:
	                                                        xhr = new XMLHttpRequest();
	                                                        file = fileState.file;
	                                                        fd = new FormData();
	                                                        filename = file.name;
	
	                                                        fd.append("Filedata", file);
	                                                        _context.next = 7;
	                                                        return xhrToPromise(xhr, go(fd));
	
	                                                    case 7:
	                                                        r = _context.sent;
	
	                                                        swfUploader.upload_start_handler(fileState.swfFile);
	                                                        cancelButton.onclick = function () {
	                                                            cancelled = true;xhr.abort();
	                                                        };
	                                                        fileState.state = "done (whether successfully or not)";
	
	                                                        if (!(r.xhr.status == 200)) {
	                                                            _context.next = 17;
	                                                            break;
	                                                        }
	
	                                                        swfUploader.upload_complete_handler(fileState.swfFile);
	                                                        swfUploader.upload_success_handler(fileState.swfFile, r.event.target.responseText, '');
	                                                        return _context.abrupt("return", "continue");
	
	                                                    case 17:
	                                                        if (r.xhr.status <= 0) {
	                                                            swfUploader.upload_error_handler(fileState.swfFile, exports.SWFUpload.UPLOAD_ERROR.FILE_CANCELLED, "An error occurred uploading file no. " + fileState.index + ", " + filename + ". No further files have been uploaded.");
	                                                        } else {
	                                                            swfUploader.upload_error_handler(fileState.swfFile, exports.SWFUpload.UPLOAD_ERROR.HTTP_ERROR, "An error occurred uploading file no. " + fileState.index + ", " + filename + ". No further files have been uploaded.");
	                                                        }
	
	                                                    case 18:
	                                                        cancelButton.onclick = function () {};
	                                                        cancelButton.disabled = true;
	                                                        return _context.abrupt("return", {
	                                                            v: void 0
	                                                        });
	
	                                                    case 21:
	                                                    case "end":
	                                                        return _context.stop();
	                                                }
	                                            }
	                                        }, _loop, _this);
	                                    });
	                                    fileState = yieldNextPending(fileSet);
	
	                                case 4:
	                                    if (!fileState) {
	                                        _context2.next = 16;
	                                        break;
	                                    }
	
	                                    return _context2.delegateYield(_loop(fileState), "t0", 6);
	
	                                case 6:
	                                    _ret = _context2.t0;
	                                    _context2.t1 = _ret;
	                                    _context2.next = _context2.t1 === "continue" ? 10 : 11;
	                                    break;
	
	                                case 10:
	                                    return _context2.abrupt("continue", 13);
	
	                                case 11:
	                                    if (!((typeof _ret === "undefined" ? "undefined" : _typeof(_ret)) === "object")) {
	                                        _context2.next = 13;
	                                        break;
	                                    }
	
	                                    return _context2.abrupt("return", _ret.v);
	
	                                case 13:
	                                    fileState = yieldNextPending(fileSet);
	                                    _context2.next = 4;
	                                    break;
	
	                                case 16:
	                                    swfUploader.queue_complete_handler(fileSet.length);
	                                    fileUpload.value = '';
	
	                                case 18:
	                                case "end":
	                                    return _context2.stop();
	                            }
	                        }
	                    }, _callee, this);
	                }));
	            })();
	        }
	        var file = fileUpload && fileUpload.files ? fileUpload.files[0] : null;
	        if (!file) return;
	    };
	    cancelButton.onclick = function () {
	        return swfUploader.cancelQueue();
	    };
	};
	exports.swfuploadercalljs = function (replace, params) {
	    var ts_params = {
	        showCancelButton: params.showCancelButton,
	        showQueue: params.showQueue,
	        showUploadTotal: params.showUploadTotal,
	        uploadUrl: params.uploadUrl,
	        maxSize: "1",
	        fileTypes: params.fileTypes,
	        fileTypesDescription: params.fileTypesDescription,
	        queueLimit: params.queueLimit,
	        uploadCallback: new Function("file", "serverData", "response", params.uploadCallback),
	        uploadComplete: new Function("file", params.uploadComplete),
	        queueComplete: new Function(params.queueComplete),
	        showUploadedTotal: params.showUploadedTotal,
	        id: params.id
	    };
	    exports.swfuploader(replace, ts_params);
	};
	exports.SWFUpload = {
	    QUEUE_ERROR: {
	        QUEUE_LIMIT_EXCEEDED: -100,
	        FILE_EXCEEDS_SIZE_LIMIT: -110,
	        ZERO_BYTE_FILE: -120,
	        INVALID_FILETYPE: -130
	    },
	    UPLOAD_ERROR: {
	        HTTP_ERROR: -200,
	        MISSING_UPLOAD_URL: -210,
	        IO_ERROR: -220,
	        SECURITY_ERROR: -230,
	        UPLOAD_LIMIT_EXCEEDED: -240,
	        UPLOAD_FAILED: -250,
	        SPECIFIED_FILE_ID_NOT_FOUND: -260,
	        FILE_VALIDATION_FAILED: -270,
	        FILE_CANCELLED: -280,
	        UPLOAD_STOPPED: -290
	    },
	    FILE_STATUS: {
	        QUEUED: -1,
	        IN_PROGRESS: -2,
	        ERROR: -3,
	        COMPLETE: -4,
	        CANCELLED: -5
	    }
	};

/***/ },

/***/ 183:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var Immutable = __webpack_require__(103);
	
	var Preferences = function () {
	    function Preferences(personId, _categoryIds) {
	        _classCallCheck(this, Preferences);
	
	        this.personId = personId;
	        this._categoryIds = _categoryIds;
	    }
	
	    _createClass(Preferences, [{
	        key: "isCategorySelected",
	        value: function isCategorySelected(category) {
	            return this._categoryIds.has(category.getNumericId());
	        }
	    }, {
	        key: "categoryIds",
	        get: function get() {
	            return this._categoryIds;
	        }
	    }], [{
	        key: "fromObject",
	        value: function fromObject(object) {
	            return new Preferences(object.person, object.categoryIds == null ? Immutable.Set() : Immutable.Set(object.categoryIds));
	        }
	    }]);
	
	    return Preferences;
	}();
	
	exports.Preferences = Preferences;
	
	var Category = function () {
	    function Category() {
	        _classCallCheck(this, Category);
	
	        this.categorySerial = 0;
	        this.parentSerial = 0;
	        this.title = '';
	        this.urlTitle = '';
	        this.thumbPath = '';
	        this.isLinked = false;
	        this.children = [];
	    }
	
	    _createClass(Category, [{
	        key: "isPreferredCategories",
	        value: function isPreferredCategories() {
	            return this.categorySerial == Category.PREFERRED_SERIAL;
	        }
	    }, {
	        key: "getId",
	        value: function getId() {
	            return this.categorySerial.toString();
	        }
	    }, {
	        key: "getLabel",
	        value: function getLabel() {
	            return this.title;
	        }
	    }, {
	        key: "getNumericId",
	        value: function getNumericId() {
	            return this.categorySerial;
	        }
	    }], [{
	        key: "flattenTree",
	        value: function flattenTree(categories) {
	            var sideEffectingFlattener = function sideEffectingFlattener(categories, flatteningCategories) {
	                return categories.forEach(function (category) {
	                    flatteningCategories.push(category);
	                    sideEffectingFlattener(category.children, flatteningCategories);
	                });
	            };
	            var cats = [];
	            sideEffectingFlattener(categories, cats);
	            return cats;
	        }
	    }, {
	        key: "fromObjects",
	        value: function fromObjects(objects) {
	            return objects.map(function (object) {
	                var category = new Category();
	                category.categorySerial = +object.categorySerial;
	                category.parentSerial = +object.parentSerial;
	                category.title = '' + object.title;
	                category.urlTitle = '' + object.urlTitle;
	                category.thumbPath = '' + object.thumbPath;
	                category.isLinked = !!object.isLinked;
	                category.children = object.children === null ? [] : Category.fromObjects(object.children);
	                return category;
	            });
	        }
	    }, {
	        key: "PREFERRED",
	        get: function get() {
	            if (Category.preferred == null) {
	                Category.preferred = new Category();
	                Category.preferred.categorySerial = Category.PREFERRED_SERIAL;
	                Category.preferred.title = "My Preferences";
	                Category.preferred.children = [];
	                Category.preferred.urlTitle = "";
	                Category.preferred.thumbPath = "";
	                Category.preferred.isLinked = false;
	            }
	            return Category.preferred;
	        }
	    }, {
	        key: "UNCATEGORISED",
	        get: function get() {
	            if (Category.uncategorised == null) {
	                Category.uncategorised = new Category();
	                Category.uncategorised.categorySerial = Category.UNCATEGORISED_SERIAL;
	                Category.uncategorised.title = "Uncategorised";
	                Category.uncategorised.children = [];
	                Category.uncategorised.urlTitle = "";
	                Category.uncategorised.thumbPath = "";
	                Category.uncategorised.isLinked = false;
	            }
	            return Category.uncategorised;
	        }
	    }]);
	
	    return Category;
	}();
	
	Category.PREFERRED_SERIAL = -1;
	Category.preferred = null;
	Category.UNCATEGORISED_SERIAL = -2;
	Category.uncategorised = null;
	exports.Category = Category;

/***/ },

/***/ 261:
/***/ function(module, exports) {

	"use strict";
	/**
	 * This cookie function is derived from lib/jquery-ui/js/jquery.cookie.js
	 *
	 * It is not anticipated to be used in new codes, but perhaps it will be.
	 *
	 * Note that the original cookie function was intended for use both as a reader and a writer, but
	 * (a) this makes the using programmer's intent harder to determine;
	 * (b) it makes the implementation harder to read
	 * (c) it was not necessary for implementing the code i was working on.
	 *
	 * If you discover a usage of $.cookie(a) i.e. which is functioning as a getter,
	 * do feel free to consult the original function but please implement it separately.
	 */
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var defineCookieExpiryString = function defineCookieExpiryString(expires) {
	    if (!expires) {
	        return '';
	    }
	    var date = new Date();
	    date.setTime(date.getTime() + expires * 24 * 60 * 60 * 1000);
	    return '; expires=' + date.toUTCString();
	};
	exports.setCookie = function (name, value, path, expiry) {
	    if (value === null) {
	        value = '';
	        expiry = -1;
	    }
	    var pathStr = path && '; path=' + path;
	    var secureStr = '; secure';
	    document.cookie = name + "=" + encodeURIComponent(value) + defineCookieExpiryString(expiry) + pathStr + secureStr;
	};
	// this has been migrated across from analytics_html.php to maintain backwards compatibility.
	exports.Get_Cookie = function (name) {
	    var start = document.cookie.indexOf(name + "=");
	    var len = start + name.length + 1;
	    if (!start && name != document.cookie.substring(0, name.length)) {
	        return null;
	    }
	    if (start == -1) return null;
	    var end = document.cookie.indexOf(";", len);
	    if (end == -1) end = document.cookie.length;
	    return unescape(document.cookie.substring(len, end));
	};

/***/ },

/***/ 262:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var R = __webpack_require__(62);
	var data_1 = __webpack_require__(110);
	var hydrateTemplate = function hydrateTemplate(a) {
	    var column = data_1.toColumn(a.column);
	    return {
	        id: a.id.toString(),
	        title: a.title,
	        column: column,
	        priority: a.priority
	    };
	};
	exports.hydrateTemplateWithRestrictedColumn = function (lastColumn) {
	    return R.pipe(hydrateTemplate, data_1.restrictColumn(lastColumn));
	};
	exports.templatesFromPHPTemplates = function (articleTemplates, lastColumn) {
	    return articleTemplates.map(exports.hydrateTemplateWithRestrictedColumn(lastColumn)).sort(data_1.sortByColumnAndPriority);
	};

/***/ },

/***/ 263:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(3);
	var ReactDOM = __webpack_require__(6);
	var Public_1 = __webpack_require__(630);
	var Admin_1 = __webpack_require__(281);
	exports.adminSpareFieldMemoryWidgetCallJs = function (replace, params) {
	    var node = document.createElement('div');
	    replace(node);
	    exports.renderAdminFile(params.fieldName, params.memoryParams, params.file, node, 'Link a File');
	};
	//noinspection JSUnusedGlobalSymbols
	exports.renderAdminFilesFolders = function (fieldName, memoryParams, files, folders, parentNode) {
	    ReactDOM.render(React.createElement(Admin_1.FilesFoldersWidget, { fieldName: fieldName, memoryParams: memoryParams, files: files, folders: folders }), parentNode);
	};
	//noinspection JSUnusedGlobalSymbols
	exports.renderAdminFile = function (fieldName, memoryParams, file, parentNode, buttonLabel, selectedCallback, deleteCallback) {
	    ReactDOM.render(React.createElement(Admin_1.FileWidget, { fieldName: fieldName, memoryParams: memoryParams, selected: file, buttonLabel: buttonLabel, selectedCallback: selectedCallback, deleteCallback: deleteCallback }), parentNode);
	};
	exports.renderAdminFolder = function (fieldName, memoryParams, folder, parentNode, buttonLabel, selectedCallback, deleteCallback) {
	    ReactDOM.render(React.createElement(Admin_1.FolderWidget, { fieldName: fieldName, memoryParams: memoryParams, selected: folder, buttonLabel: buttonLabel, selectedCallback: selectedCallback, deleteCallback: deleteCallback }), parentNode);
	};
	//noinspection JSUnusedGlobalSymbols
	exports.renderPublicFile = function (memoryParams, file, parentNode) {
	    ReactDOM.render(React.createElement(Public_1.FileWidget, { memoryParams: memoryParams, file: file }), parentNode);
	};
	//noinspection JSUnusedGlobalSymbols
	exports.renderPublicFilesFolders = function (memoryParams, files, folders, parentNode) {
	    ReactDOM.render(React.createElement(Public_1.FilesFoldersWidget, { memoryParams: memoryParams, files: files, folders: folders }), parentNode);
	};

/***/ },

/***/ 264:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) {
	            try {
	                step(generator.next(value));
	            } catch (e) {
	                reject(e);
	            }
	        }
	        function rejected(value) {
	            try {
	                step(generator["throw"](value));
	            } catch (e) {
	                reject(e);
	            }
	        }
	        function step(result) {
	            result.done ? resolve(result.value) : new P(function (resolve) {
	                resolve(result.value);
	            }).then(fulfilled, rejected);
	        }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var ReactRedux = __webpack_require__(23);
	var employmentHistoryView_1 = __webpack_require__(567);
	var Actions = __webpack_require__(565);
	var commands_1 = __webpack_require__(12);
	var $ = __webpack_require__(10);
	var dateFormat = 'dd/mm/yy';
	exports.parseDate = function (dateStr) {
	    return $.datepicker.parseDate(dateFormat, dateStr);
	};
	exports.formatDate = function (date) {
	    return $.datepicker.formatDate(dateFormat, date);
	};
	// state is the current store's state
	// ownProps are those explicit properties passed to the react component
	// This could also return a function rather than object containing properties. This function will take the store's state and must return props object
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	    return {
	        id: state.id,
	        userId: state.userId,
	        startDate: exports.parseDate(state.startDate),
	        endDate: exports.parseDate(state.endDate),
	        companyName: state.companyName,
	        companyId: state.companyId,
	        positionTitle: state.positionTitle,
	        isSaving: state.isSaving,
	        companies: ownProps.companies,
	        labels: ownProps.fieldLabels,
	        datePickerProps: ownProps.datePickerProps,
	        errorFields: state.errorFields,
	        errorMsgs: state.serverErrors
	    };
	};
	var validateDate = function validateDate(dateStr) {
	    try {
	        var date = exports.parseDate(dateStr);
	        var isValid = date != null;
	        return isValid ? { valid: true, date: date } : { valid: false };
	    } catch (e) {
	        return { valid: false };
	    }
	};
	var doFieldValidation = function doFieldValidation(state) {
	    var errorFields = [];
	    if (!state.companyName || !state.companyName.trim()) {
	        errorFields.push('companyName');
	    }
	    var startDateValidity = validateDate(state.startDate);
	    var endDateValidity = validateDate(state.endDate);
	    if (!startDateValidity.valid) {
	        errorFields.push('startDate');
	    }
	    if (!endDateValidity.valid) {
	        errorFields.push('endDate');
	    }
	    if (startDateValidity.valid && endDateValidity.valid && startDateValidity.date.getTime() > endDateValidity.date.getTime()) {
	        errorFields.push('startDate');
	        errorFields.push('endDate');
	    }
	    return errorFields;
	};
	/*
	 * The onSave() returns an AsyncAction.
	 * There are two definitions of IDispatch - one which accepts simple js object, the other accepts a thunk (some object)
	 */
	exports.onSave = function (commandCaller, onClose) {
	    return function (dispatch, getState) {
	        return __awaiter(undefined, void 0, void 0, regeneratorRuntime.mark(function _callee() {
	            var errorFields, state, response;
	            return regeneratorRuntime.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            errorFields = doFieldValidation(getState());
	
	                            if (!(errorFields.length > 0)) {
	                                _context.next = 4;
	                                break;
	                            }
	
	                            dispatch(Actions.actionCreator.field.validateFailure(errorFields));
	                            return _context.abrupt("return");
	
	                        case 4:
	                            dispatch(Actions.actionCreator.server.save());
	                            state = getState();
	                            _context.prev = 6;
	                            _context.next = 9;
	                            return commandCaller.runPost('saveEmploymentHistoryPosition', {
	                                id: state.id,
	                                userId: state.userId,
	                                startDate: state.startDate,
	                                endDate: state.endDate,
	                                companyName: state.companyName.trim(),
	                                companyId: state.companyId,
	                                positionTitle: state.positionTitle.trim()
	                            });
	
	                        case 9:
	                            response = _context.sent;
	
	                            if (response.serverErrors.length > 0) {
	                                dispatch(Actions.actionCreator.server.saveFailure(response.serverErrors));
	                            } else {
	                                state.id === 0 ? dispatch(Actions.actionCreator.server.saveAddSuccess(response.id)) : dispatch(Actions.actionCreator.server.saveUpdateSuccess());
	                                onClose();
	                            }
	                            _context.next = 15;
	                            break;
	
	                        case 13:
	                            _context.prev = 13;
	                            _context.t0 = _context["catch"](6);
	
	                        case 15:
	                            return _context.abrupt("return");
	
	                        case 16:
	                        case "end":
	                            return _context.stop();
	                    }
	                }
	            }, _callee, this, [[6, 13]]);
	        }));
	    };
	};
	var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
	    return {
	        startDateChanged: function startDateChanged(text, date) {
	            return dispatch(Actions.actionCreator.field.startDateChanged(text, date));
	        },
	        endDateChanged: function endDateChanged(text, date) {
	            return dispatch(Actions.actionCreator.field.endDateChanged(text, date));
	        },
	        companyNameChanged: function companyNameChanged(newName) {
	            return dispatch(Actions.actionCreator.field.changeCompanyName(newName));
	        },
	        companyIdChanged: function companyIdChanged(selectorId, newCompany) {
	            return dispatch(Actions.actionCreator.field.changeCompanyId(selectorId, newCompany));
	        },
	        positionTitleChanged: function positionTitleChanged(newTitle) {
	            return dispatch(Actions.actionCreator.field.changePositionTitle(newTitle));
	        },
	        onClose: function onClose() {
	            return ownProps.onClose();
	        },
	        onSave: function onSave() {
	            return dispatch(exports.onSave(new commands_1.CommandCaller(ownProps.ajaxPageUrl), ownProps.onClose));
	        }
	    };
	};
	exports.EmploymentHistoryContainer = ReactRedux.connect(mapStateToProps, mapDispatchToProps)(employmentHistoryView_1.EmploymentHistoryPositionView);

/***/ },

/***/ 265:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(3);
	var ReactDOM = __webpack_require__(6);
	/**
	 * This component takes a Template and a set of placeholders.
	 * The template is evaluated, resulting in a string that contains HTML and then added to the DOM using dangerouslySetInnerHTML.
	 * Subclasses are able to override placeholdersToReactify() and return an object literal like so:
	 *
	 *  {
	 *      Placeholder1 : <FirstComponentToUse myProp={blah} />,
	 *      Placeholder2 : <OtherComponent yourProp={sneh} />
	 *  }
	 *
	 * Each of the keys in that object literal will be used.
	 */
	
	var TemplateableComponent = function (_React$Component) {
	    _inherits(TemplateableComponent, _React$Component);
	
	    function TemplateableComponent() {
	        _classCallCheck(this, TemplateableComponent);
	
	        return _possibleConstructorReturn(this, (TemplateableComponent.__proto__ || Object.getPrototypeOf(TemplateableComponent)).apply(this, arguments));
	    }
	
	    _createClass(TemplateableComponent, [{
	        key: "getStaticPlaceholders",
	        value: function getStaticPlaceholders() {
	            return {};
	        }
	    }, {
	        key: "getPlaceholders",
	        value: function getPlaceholders() {
	            var placeholders = {};
	            Object.assign(placeholders, this.props.placeholders, this.getStaticPlaceholders());
	            var toReactify = this.renderPlaceholders();
	            var reactifiedPlaceholderNames = Object.keys(toReactify);
	            for (var i = 0; i < reactifiedPlaceholderNames.length; i++) {
	                var placeholder = reactifiedPlaceholderNames[i];
	                if (toReactify[placeholder]) {
	                    placeholders[placeholder] = "<span class=\"reactified-" + placeholder + "\" />";
	                }
	            }
	            return placeholders;
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var evaluatedTemplate = this.props.template.evaluate(this.getPlaceholders());
	            return React.createElement("span", { dangerouslySetInnerHTML: { __html: evaluatedTemplate } });
	        }
	    }, {
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            this.renderPlaceholdersIntoTemplate();
	        }
	    }, {
	        key: "componentDidUpdate",
	        value: function componentDidUpdate() {
	            this.renderPlaceholdersIntoTemplate();
	        }
	    }, {
	        key: "renderPlaceholdersIntoTemplate",
	        value: function renderPlaceholdersIntoTemplate() {
	            var node = ReactDOM.findDOMNode(this);
	            var placeholders = this.renderPlaceholders();
	            var placeholderNames = Object.keys(placeholders);
	            for (var i = 0; i < placeholderNames.length; i++) {
	                var placeholder = placeholderNames[i];
	                if (placeholders.hasOwnProperty(placeholder)) {
	                    var nodesToAttachTo = node.getElementsByClassName("reactified-" + placeholder);
	                    if (nodesToAttachTo.length > 1) {
	                        throw new Error("Found " + nodesToAttachTo.length + " nodes for " + placeholder + " placeholder, but expected 0 or 1.");
	                    } else if (nodesToAttachTo.length == 1) {
	                        var placeholder2 = placeholders[placeholder];
	                        if (placeholder2 != null) {
	                            ReactDOM.render(placeholder2, nodesToAttachTo[0]);
	                        }
	                    }
	                }
	            }
	            this.placeholdersDidRender(node);
	        }
	        /**
	         * If you need to attach event listeners to rendered placeholders, this is the place to do it.
	         */
	
	    }, {
	        key: "placeholdersDidRender",
	        value: function placeholdersDidRender(node) {}
	    }]);
	
	    return TemplateableComponent;
	}(React.Component);
	
	exports.TemplateableComponent = TemplateableComponent;
	/**
	 * Simple class to evaluate a template given a set of placeholders.
	 */
	
	var TemplateComponent = function (_TemplateableComponen) {
	    _inherits(TemplateComponent, _TemplateableComponen);
	
	    function TemplateComponent() {
	        _classCallCheck(this, TemplateComponent);
	
	        return _possibleConstructorReturn(this, (TemplateComponent.__proto__ || Object.getPrototypeOf(TemplateComponent)).apply(this, arguments));
	    }
	
	    _createClass(TemplateComponent, [{
	        key: "renderPlaceholders",
	        value: function renderPlaceholders() {
	            return {};
	        }
	    }]);
	
	    return TemplateComponent;
	}(TemplateableComponent);
	
	exports.TemplateComponent = TemplateComponent;

/***/ },

/***/ 266:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(3);
	var ReactDOM = __webpack_require__(6);
	exports.form_buttons = function (replace, params) {
	    var div = document.createElement('div');
	    div.id = params.form + "_buttons";
	    replace(div);
	    var enableCancel = params.enableCancel === null || params.enableCancel === undefined ? true : params.enableCancel;
	    var p = Object.assign({}, params);
	    ReactDOM.render(React.createElement(exports.FormButtons, Object.assign({}, params, { enableCancel: enableCancel, cancel: params.cancel ? function () {
	            eval(params.cancel);
	        } : undefined, single: params.single == 1 || params.single == "1" })), div);
	};
	exports.FormButtons = function (params) {
	    return React.createElement("table", { style: { width: "100%", border: "0" }, cellPadding: 0, cellSpacing: 0 }, React.createElement("tbody", null, React.createElement("tr", null, params.enableCancel && React.createElement("td", null, React.createElement("input", { type: "button", name: "cancel", value: params.cancel_label, className: "submit", onClick: params.cancel })), React.createElement("td", { style: { textAlign: "right" } }, React.createElement("input", { type: "submit", name: "submit_page", value: params.save_label, className: "submit" }), !params.single && React.createElement("input", { type: "submit", name: "submit_page", value: "Save / Return", className: "submit", onClick: function onClick() {
	            document.forms.namedItem(params.form)['command'].value = params.command_value;
	        } })))));
	};

/***/ },

/***/ 267:
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.isCategoryManagerAction = function (a) {
	    return a.type == "category manager action";
	};

/***/ },

/***/ 268:
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.cardTypeToUserString = function (type) {
	    switch (type) {
	        case "vis":
	            return 'Visa';
	        case "mcd":
	            return 'MasterCard';
	        case "diner":
	            return 'Diners';
	        case "amex":
	            return 'American Express';
	    }
	    throw "unknown card type " + type;
	};
	exports.accountTypeToUserString = function (type) {
	    switch (type) {
	        case "bank":
	            return "Bank account";
	        default:
	            return exports.cardTypeToUserString(type /*fixme ts2: remove this cast*/);
	    }
	};
	exports.renderCurrencyName = function (code) {
	    switch (code) {
	        case 'aud':
	            return 'Australian dollars';
	        case 'nzd':
	            return 'New Zealand dollars';
	        case 'pgk':
	            return 'kina';
	    }
	    throw "unknown currency code " + code;
	};

/***/ },

/***/ 269:
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var months = ["jan", "feb", "mar", "apr", "may", "jun", "jul", "aug", "sep", "oct", "nov", "dec"];
	exports.monthToJsMonthNumber = function (m) {
	    return months.indexOf(m);
	};
	exports.monthToNumber = function (m) {
	    return exports.monthToJsMonthNumber(m) + 1;
	};
	exports.numberToMaybeMonth = function (i) {
	    return months[i - 1];
	};
	exports.stringToMaybeMonth = function (s) {
	    return months.find(function (a) {
	        return a === s;
	    });
	};
	exports.monthToUserString = function (m) {
	    switch (m) {
	        case 'jan':
	            return 'January';
	        case 'feb':
	            return 'February';
	        case 'mar':
	            return 'March';
	        case 'apr':
	            return 'April';
	        case 'may':
	            return 'May';
	        case 'jun':
	            return 'June';
	        case 'jul':
	            return 'July';
	        case 'aug':
	            return 'August';
	        case 'sep':
	            return 'September';
	        case 'oct':
	            return 'October';
	        case 'nov':
	            return 'November';
	        case 'dec':
	            return 'December';
	    }
	    throw "invalid month " + m;
	};

/***/ },

/***/ 270:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(3);
	var datePicker_1 = __webpack_require__(93);
	var utils_1 = __webpack_require__(4);
	var lib2_1 = __webpack_require__(271);
	var graph_renderer_1 = __webpack_require__(137);
	var colors = ["#a6cee3", "#1f78b4", "#b2df8a", "#33a02c", "#fb9a99", "#e31a1c", "#fdbf6f", "#ff7f00", "#cab2d6", "#6a3d9a", "#ffff99", "#b15928"];
	var filter = {
	    margin: "5px",
	    padding: "5px",
	    backgroundColor: "#DEDEDE"
	};
	var makeReportTypeOption = function makeReportTypeOption(s, id) {
	    return React.createElement("option", { key: id, value: id }, s.label);
	};
	exports.Report = function (props) {
	    var fillColors = colors.slice();
	    var borderColors = colors.slice();
	    for (var i = 0; i < colors.length; i++) {
	        for (var j = 0; j < colors.length; j++) {
	            if (colors[i] != colors[j]) {
	                borderColors.push(colors[i]);
	                fillColors.push(colors[j]);
	            }
	        }
	    }
	    // noinspection JSUnusedLocalSymbols
	    var ChartRenderer = props.displayModes[props.displayMode];
	    var report = props.reportTypes[props.reportType];
	    var chart = props.chartData ? React.createElement(ChartRenderer, { borderColors: borderColors, fillColors: fillColors, axis: props.axes[report.axis], chartData: props.chartData, removeEmptyAxes: report.removeEmptyAxes, keys: report.keys }) : React.createElement("div", null, "No data");
	    var filters = Object.keys(props.filters).filter(function (f) {
	        return !props.filters[f].isHidden;
	    }).map(function (f) {
	        return [props.filters[f], f];
	    });
	    var hasFilters = filters.length > 0;
	    var width = hasFilters ? 260 : 10;
	    var display = !hasFilters ? { display: 'none' } : {};
	    var reportTypeOnChange = function reportTypeOnChange(e) {
	        var newReportType = e.currentTarget.value;
	        var newReport = props.reportTypes[newReportType];
	        if (newReport.displayModes.indexOf(props.displayMode) < 0) {
	            props.setDisplay(newReport.defaultDisplayMode);
	        }
	        props.onSetReportType(newReportType);
	        props.runReport();
	    };
	    return React.createElement("div", { style: { overflow: "auto" } }, React.createElement("h1", null, props.title), React.createElement("div", { style: Object.assign({ float: "right", width: width }, display) }, React.createElement("div", null, filters.map(function (_ref) {
	        var _ref2 = _slicedToArray(_ref, 2),
	            a = _ref2[0],
	            n = _ref2[1];
	
	        return React.createElement("div", { key: n, style: filter }, React.createElement(RenderFilter, { id: n, data: lib2_1.addCallbacks(a, props.filterCallbacks, props.filterState[n]), enabled: lib2_1.filterIsEnabled(n, report), key: n }));
	    })), React.createElement("button", { onClick: props.runReport }, "Run report")), React.createElement("div", { style: { marginRight: width + 10 } }, React.createElement("div", null, React.createElement("select", { style: { width: "25%" }, value: props.reportType, onChange: reportTypeOnChange }, utils_1.mapValues(props.reportTypes, makeReportTypeOption)), React.createElement("span", { style: { paddingLeft: "1em" } }, React.createElement(graph_renderer_1.RenderSelectMode, { modes: report.displayModes, mode: props.displayMode, setMode: props.setDisplay })), React.createElement("h2", { style: { textTransform: "uppercase", float: "right" } }, report.label)), React.createElement("div", { style: { height: "100%", width: "100%" } }, chart)));
	};
	var RenderFilter = function RenderFilter(props) {
	    var f = props.data;
	    switch (f.type) {
	        case "select box":
	            return React.createElement("select", { disabled: !props.enabled, style: { width: "100%" }, value: f.selected, onChange: function onChange(e) {
	                    return f.onSelect(e.currentTarget.value, props.id);
	                } }, utils_1.mapValues(f.options, function (a, b) {
	                return React.createElement("option", { key: b, value: b }, a);
	            }));
	        case "date range":
	            var renderDate = function renderDate(d, onchange, invalid) {
	                return props.enabled ? React.createElement("span", null, React.createElement(datePicker_1.DatePicker, { disabled: !props.enabled, onChange: onchange, date: d, readonly: !props.enabled, invalid: invalid })) : React.createElement("input", { disabled: !props.enabled, value: d.getDate() + "/" + (d.getMonth() + 1) + "/" + d.getFullYear() });
	            };
	            return React.createElement("dl", null, React.createElement("dt", null, "From"), React.createElement("dd", null, renderDate(f.fromDate, function (s, d) {
	                return f.onSetFromDate(d, props.id);
	            }, f.fromDate > f.toDate)), React.createElement("dt", null, "To"), React.createElement("dd", null, renderDate(f.toDate, function (s, d) {
	                return f.onSetToDate(d, props.id);
	            }, f.toDate > new Date())));
	        case "checkbox":
	            return React.createElement(CheckboxFilter, { id: props.id, enabled: props.enabled, onSetFilter: f.onSetCheckbox, onUnsetFilter: f.onUnset, label: f.label, options: f.group, checked: f.checked });
	    }
	};
	var CheckboxFilter = function CheckboxFilter(props) {
	    return React.createElement("div", { style: filter }, React.createElement("dl", { style: props.enabled ? {} : { opacity: 75 } }, React.createElement("dt", null, props.label), React.createElement("dd", { style: { margin: 0 } }, React.createElement("ul", { style: { height: "7em", overflow: "auto", border: "solid black 1px", backgroundColor: props.enabled ? "white" : "lightgray", opacity: props.enabled ? 100 : 75 } }, props.options.map(renderCheckbox(props))))));
	};
	var renderCheckbox = function renderCheckbox(props) {
	    return function (e) {
	        var checked = props.checked.indexOf(e.value) >= 0;
	        return React.createElement("li", { key: e.value }, React.createElement("label", null, React.createElement("input", { disabled: !props.enabled, type: "checkbox", value: e.value, onChange: function onChange() {
	                return (checked ? props.onUnsetFilter : props.onSetFilter)(props.id, e.value);
	            }, checked: checked }), e.label));
	    };
	};

/***/ },

/***/ 271:
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.addCallbacks = function (p, callbacks, filterState) {
	    switch (p.type) {
	        case "checkbox":
	            return Object.assign({}, p, { onSetCheckbox: callbacks.onSetCheckbox, onUnset: callbacks.onUnsetCheckbox, checked: filterState.type == 'checkbox' ? filterState.checked : [] });
	        case "select box":
	            return Object.assign({}, p, { onSelect: callbacks.onSelect, selected: filterState.type == 'select box' ? filterState.selected : p.selectedDefault });
	        case "date range":
	            return Object.assign({}, p, { onSetFromDate: callbacks.onSetFromDate, onSetToDate: callbacks.onSetToDate, fromDate: filterState.type == 'date range' ? filterState.fromDate : new Date(), toDate: filterState.type == 'date range' ? filterState.toDate : new Date() });
	    }
	};
	exports.dateFromFilter = function (filter, key) {
	    return filter.type == "date range" ? filter[key] : new Date();
	};
	exports.filterIsEnabled = function (filterId, report) {
	    return report.filters.indexOf(filterId) >= 0;
	};

/***/ },

/***/ 272:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(3);
	var react_select_1 = __webpack_require__(1173);
	__webpack_require__(1214);
	
	var ReactSelectNumber = function (_react_select_1$defau) {
	    _inherits(ReactSelectNumber, _react_select_1$defau);
	
	    function ReactSelectNumber() {
	        _classCallCheck(this, ReactSelectNumber);
	
	        return _possibleConstructorReturn(this, (ReactSelectNumber.__proto__ || Object.getPrototypeOf(ReactSelectNumber)).apply(this, arguments));
	    }
	
	    return ReactSelectNumber;
	}(react_select_1.default);
	
	exports.Chosen = function (props) {
	    return React.createElement(ReactSelectNumber, Object.assign({}, props));
	};
	exports.onChangeHandler = function (h) {
	    return function (selectedOptions) {
	        if (exports.isOptions(selectedOptions)) {
	            var validSelectedOptions = exports.validateOptions(selectedOptions);
	            h(validSelectedOptions.map(function (o) {
	                return o.value;
	            }));
	        }
	    };
	};
	exports.isOptions = function (o) {
	    return o !== null && Array.isArray(o);
	};
	exports.validateOptions = function (os) {
	    return os.filter(function (o) {
	        return o.value !== undefined;
	    });
	};

/***/ },

/***/ 273:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(3);
	exports.SectionHeading = function (props) {
	  return React.createElement("h3", { className: "sbSectionHeading" }, props.title);
	};

/***/ },

/***/ 274:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(3);
	exports.Textarea = function (props) {
	    return React.createElement("textarea", { name: props.name, disabled: props.disabled, onChange: function onChange(event) {
	            event.stopPropagation();
	            if (props.onChange) {
	                props.onChange(event.currentTarget.value);
	            }
	        }, className: "sbTextAreaOff" + (props.className ? ' ' + props.className : ''), value: props.value, style: props.style || {} });
	};

/***/ },

/***/ 275:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/*
	    A simple class for displaying file information and progress
	    Note: This is a demonstration only and not part of SWFUpload.
	    Note: Some have had problems adapting this class in IE7. It may not be suitable for your application.
	*/
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var utils_1 = __webpack_require__(4);
	
	var FileProgress = function () {
	    function FileProgress(file, targetID) {
	        var _this = this;
	
	        _classCallCheck(this, FileProgress);
	
	        this.fileProgressID = file.id;
	        this.opacity = 100;
	        this.height = 0;
	        this.fileProgressWrapper = document.getElementById(this.fileProgressID);
	        if (!this.fileProgressWrapper || !(this.fileProgressWrapper.firstChild instanceof HTMLElement)) {
	            this.fileProgressWrapper = document.createElement("div");
	            this.fileProgressWrapper.className = "progressWrapper";
	            this.fileProgressWrapper.id = this.fileProgressID;
	            this.fileProgressElement = document.createElement("div");
	            this.fileProgressElement.className = "progressContainer";
	            var progressCancel = document.createElement("a");
	            progressCancel.className = "progressCancel";
	            progressCancel.href = "#";
	            progressCancel.style.visibility = "hidden";
	            progressCancel.appendChild(document.createTextNode(" "));
	            var progressText = document.createElement("div");
	            progressText.className = "progressName";
	            progressText.appendChild(document.createTextNode(file.name));
	            var progressBar = document.createElement("div");
	            progressBar.className = "progressBarInProgress";
	            var progressStatus = document.createElement("div");
	            progressStatus.className = "progressBarStatus";
	            progressStatus.innerHTML = "&nbsp;";
	            this.fileProgressElement.appendChild(progressCancel);
	            this.fileProgressElement.appendChild(progressText);
	            this.fileProgressElement.appendChild(progressStatus);
	            this.fileProgressElement.appendChild(progressBar);
	            this.fileProgressWrapper.appendChild(this.fileProgressElement);
	            utils_1.mapNonNull(document.getElementById(targetID), function (e) {
	                return _this.fileProgressWrapper && e.appendChild(_this.fileProgressWrapper);
	            });
	        } else {
	            this.fileProgressElement = this.fileProgressWrapper.firstChild;
	        }
	        this.height = this.fileProgressWrapper.offsetHeight;
	    }
	
	    _createClass(FileProgress, [{
	        key: "setProgress",
	        value: function setProgress(percentage) {
	            this.fileProgressElement.className = "progressContainer greenprogress";
	            utils_1.mapClass(this.fileProgressElement.childNodes[3], HTMLElement, function (e) {
	                e.className = "progressBarInProgress";e.style.width = percentage + "%";
	            });
	        }
	    }, {
	        key: "setComplete",
	        value: function setComplete() {
	            var _this2 = this;
	
	            this.fileProgressElement.className = "progressContainer blueprogress";
	            utils_1.mapClass(this.fileProgressElement.childNodes[3], HTMLElement, function (e) {
	                e.className = "progressBarComplete";e.style.width = "";
	            });
	            setTimeout(function () {
	                return _this2.disappear();
	            }, 10000);
	        }
	    }, {
	        key: "setError",
	        value: function setError() {
	            var _this3 = this;
	
	            this.fileProgressElement.className = "progressContainer redprogress";
	            utils_1.mapClass(this.fileProgressElement.childNodes[3], HTMLElement, function (e) {
	                e.className = "progressBarError";e.style.width = "";
	            });
	            setTimeout(function () {
	                return _this3.disappear();
	            }, 5000);
	        }
	    }, {
	        key: "setCancelled",
	        value: function setCancelled() {
	            var _this4 = this;
	
	            this.fileProgressElement.className = "progressContainer";
	            utils_1.mapClass(this.fileProgressElement.childNodes[3], HTMLElement, function (e) {
	                e.className = "progressBarError";e.style.width = "";
	            });
	            setTimeout(function () {
	                return _this4.disappear();
	            }, 2000);
	        }
	    }, {
	        key: "setStatus",
	        value: function setStatus(status) {
	            utils_1.mapClass(this.fileProgressElement.childNodes[2], HTMLElement, function (e) {
	                return e.innerText = status;
	            });
	        }
	    }, {
	        key: "toggleCancel",
	        value: function toggleCancel(show, swfUploadInstance) {
	            var _this5 = this;
	
	            utils_1.mapClass(this.fileProgressElement.childNodes[0], HTMLElement, function (e) {
	                e.style.visibility = show ? "visible" : "hidden";
	                if (swfUploadInstance) {
	                    (function () {
	                        var fileID = _this5.fileProgressID;
	                        e.onclick = function () {
	                            swfUploadInstance.cancelUpload(fileID);
	                            return false;
	                        };
	                    })();
	                }
	            });
	        }
	    }, {
	        key: "disappear",
	        value: function disappear() {
	            var _this6 = this;
	
	            var reduceOpacityBy = 15;
	            var reduceHeightBy = 4;
	            var rate = 30; // 15 fps
	            var fileProgressWrapper = this.fileProgressWrapper;
	            if (this.opacity > 0) {
	                this.opacity -= reduceOpacityBy;
	                if (this.opacity < 0) {
	                    this.opacity = 0;
	                }
	                if (fileProgressWrapper) {
	                    if (fileProgressWrapper.filters) {
	                        try {
	                            fileProgressWrapper.filters.item("DXImageTransform.Microsoft.Alpha").opacity = this.opacity;
	                        } catch (e) {
	                            // If it is not set initially, the browser will throw an error.  This will set it if it is not set yet.
	                            fileProgressWrapper.style.filter = "progid:DXImageTransform.Microsoft.Alpha(opacity=" + this.opacity + ")";
	                        }
	                    } else {
	                        fileProgressWrapper.style.opacity = (this.opacity / 100).toString();
	                    }
	                }
	            }
	            if (this.height > 0) {
	                this.height -= reduceHeightBy;
	                if (this.height < 0) {
	                    this.height = 0;
	                }
	                fileProgressWrapper.style.height = this.height + "px";
	            }
	            if (this.height > 0 || this.opacity > 0) {
	                setTimeout(function () {
	                    return _this6.disappear();
	                }, rate);
	            } else {
	                fileProgressWrapper.style.display = "none";
	            }
	        }
	    }]);
	
	    return FileProgress;
	}();
	
	exports.FileProgress = FileProgress;

/***/ },

/***/ 276:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(3);
	var select_1 = __webpack_require__(39);
	var help_button_1 = __webpack_require__(136);
	exports.ProrataPeriodInput = function (props) {
	    return props.value === null ? React.createElement(CantProrata, null) : React.createElement(select_1.SingleBox, { value: props.value, onChange: function onChange(value) {
	            return props.onChange(value);
	        }, name: props.name }, React.createElement("option", { value: "none" }, "No Pro-rata"), React.createElement("option", { value: "daily" }, "Daily"), React.createElement("option", { value: "weekly" }, "Weekly"), React.createElement("option", { value: "monthly" }, "Monthly"), React.createElement("option", { value: "quarterly" }, "Quarterly"), React.createElement("option", { value: "6 monthly" }, "Six monthly"), React.createElement("option", { value: "annually" }, "Annually"));
	};
	var CantProrata = function CantProrata() {
	    return React.createElement("div", null, React.createElement("span", null, "N/A"), React.createElement(help_button_1.HelpButton, { message: "Only membership types with fixed expiry dates can specify pro-rata periods." }));
	};

/***/ },

/***/ 277:
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.noFormFieldsWithPrices = function (formType) {
	    var type = formType == "signup" ? "signup" : "renewal";
	    return "No " + type + " form fields exist with prices.";
	};
	exports.currentlyConfiguredViaStandardCostItem = function (annualCostTitle) {
	    return "The pro-rata period for this field is currently configured via the " + annualCostTitle + " Cost Item above.";
	};
	exports.noFormFieldsWithPrices_requiresConfiguration = function (type) {
	    return exports.noFormFieldsWithPrices(type) + " Configure a field with prices so it can be selected for this cost item.";
	};
	exports.cantUseFieldsDueToAutoRenewal = "Can't configure form field pricing for this pricing option, as it makes use of auto renewal.";

/***/ },

/***/ 278:
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var signupId = "signupCost";
	var renewId = "renewCost";
	exports.isSignupCost = function (costItem) {
	  return costItem.id == signupId;
	};
	exports.isRenewCost = function (costItem) {
	  return costItem.id == renewId;
	};
	exports.isAnnual = function (costItem) {
	  return exports.isSignupCost(costItem) || exports.isRenewCost(costItem);
	};

/***/ },

/***/ 279:
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Find an item with the correct ID and return a copy of it with the new properties assigned.
	 * @param action The action specifies which item it wants to operate on.
	 * @param item The item to compare, to see if it needs to be modified or not.
	 * @param newProperties The new properties to assign to item if it does match.
	 */
	var modifyItemIfMatches = function modifyItemIfMatches(action, item, newProperties) {
	    return item.field.id === action.fieldId && item.formType == action.formType ? Object.assign({}, item, newProperties) : item;
	};
	var updateProrataPeriodIfMatches = function updateProrataPeriodIfMatches(action) {
	    return function (item) {
	        return modifyItemIfMatches(action, item, { prorataPeriod: action.to });
	    };
	};
	exports.fieldCostItems = function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	    var action = arguments[1];
	
	    switch (action.type) {
	        case "set prorata period":
	            return state.map(updateProrataPeriodIfMatches(action));
	    }
	    // This has stay here because this reducer is used with Redux's combineReducers() function, which means
	    // we may be passed actions other than FieldCostItemAppAction.
	    return state;
	};
	exports.ChangeActions = {
	    prorataPeriod: function prorataPeriod(fieldCostItem, _prorataPeriod) {
	        return {
	            type: "set prorata period",
	            fieldId: fieldCostItem.field.id,
	            formType: fieldCostItem.formType,
	            to: _prorataPeriod
	        };
	    }
	};

/***/ },

/***/ 280:
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * If the item has an ID which matches the action, return the result of makeNewItem, otherwise return the item unchanged.
	 */
	var ifMatches = function ifMatches(action, item, makeNewItem) {
	    return item.id === action.id ? makeNewItem(item) : item;
	};
	/**
	 * If the item is the one specified by the action, then create a copy of the item, then update the property requested
	 * by the action to the new value specified by the action.
	 * @see ifMatches
	 */
	var modifyItemIfMatches = function modifyItemIfMatches(action, item, newProperties) {
	    return ifMatches(action, item, function (item) {
	        return Object.assign({}, item, newProperties);
	    });
	};
	var updatePriceIfMatches = function updatePriceIfMatches(action) {
	    return function (item) {
	        return modifyItemIfMatches(action, item, { price: action.to });
	    };
	};
	var updateInfoformFieldIfMatches = function updateInfoformFieldIfMatches(action) {
	    return function (item) {
	        return modifyItemIfMatches(action, item, { infoformField: action.to });
	    };
	};
	var changeModeToPriceIfMatches = function changeModeToPriceIfMatches(action) {
	    return function (item) {
	        return ifMatches(action, item, function (item) {
	            return Object.assign({}, item, { mode: "price", infoformField: 0 });
	        });
	    };
	};
	var changeModeToInfoformFieldIfMatches = function changeModeToInfoformFieldIfMatches(action) {
	    return function (item) {
	        return ifMatches(action, item, function (item) {
	            return Object.assign({}, item, { mode: "infoform field", infoformField: action.defaultField.id });
	        });
	    };
	};
	var updateGstStatusIfMatches = function updateGstStatusIfMatches(action) {
	    return function (item) {
	        return modifyItemIfMatches(action, item, { gstStatus: action.to });
	    };
	};
	var updateGlCodeIfMatches = function updateGlCodeIfMatches(action) {
	    return function (item) {
	        return modifyItemIfMatches(action, item, { glCode: action.to });
	    };
	};
	var updateJobCodeIfMatches = function updateJobCodeIfMatches(action) {
	    return function (item) {
	        return modifyItemIfMatches(action, item, { jobCode: action.to });
	    };
	};
	var updateAccountNumberIfMatches = function updateAccountNumberIfMatches(action) {
	    return function (item) {
	        return modifyItemIfMatches(action, item, { accountNumber: action.to });
	    };
	};
	var updateProrataPeriodIfMatches = function updateProrataPeriodIfMatches(action) {
	    return function (item) {
	        return modifyItemIfMatches(action, item, { prorataPeriod: action.to });
	    };
	};
	exports.items = function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	    var action = arguments[1];
	
	    switch (action.type) {
	        case "set price":
	            return state.map(updatePriceIfMatches(action));
	        case "set infoform field":
	            return state.map(updateInfoformFieldIfMatches(action));
	        case "set mode to price":
	            return state.map(changeModeToPriceIfMatches(action));
	        case "set mode to infoform field":
	            return state.map(changeModeToInfoformFieldIfMatches(action));
	        case "set gst status":
	            return state.map(updateGstStatusIfMatches(action));
	        case "set gl code":
	            return state.map(updateGlCodeIfMatches(action));
	        case "set job code":
	            return state.map(updateJobCodeIfMatches(action));
	        case "set account number":
	            return state.map(updateAccountNumberIfMatches(action));
	        case "set prorata period":
	            return state.map(updateProrataPeriodIfMatches(action));
	    }
	    return state;
	};
	exports.ChangeActions = {
	    price: function price(id, _price) {
	        return {
	            type: "set price",
	            id: id,
	            to: _price
	        };
	    },
	    priceField: function priceField(id, field) {
	        return {
	            type: "set infoform field",
	            id: id,
	            to: field.id
	        };
	    },
	    modeToPrice: function modeToPrice(id) {
	        return {
	            type: "set mode to price",
	            id: id
	        };
	    },
	    modeToInfoformField: function modeToInfoformField(id, defaultField) {
	        return {
	            type: "set mode to infoform field",
	            id: id,
	            defaultField: defaultField
	        };
	    },
	    gstStatus: function gstStatus(id, _gstStatus) {
	        return {
	            type: "set gst status",
	            id: id,
	            to: _gstStatus
	        };
	    },
	    prorataPeriod: function prorataPeriod(id, _prorataPeriod) {
	        return {
	            type: "set prorata period",
	            id: id,
	            to: _prorataPeriod
	        };
	    },
	    itemCode: function itemCode(id, _itemCode) {
	        return {
	            type: "set gl code",
	            id: id,
	            to: _itemCode
	        };
	    },
	    jobCode: function jobCode(id, _jobCode) {
	        return {
	            type: "set job code",
	            id: id,
	            to: _jobCode
	        };
	    },
	    accountNumber: function accountNumber(id, _accountNumber) {
	        return {
	            type: "set account number",
	            id: id,
	            to: _accountNumber
	        };
	    }
	};

/***/ },

/***/ 281:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	///<reference path="Types.ts"/>
	var React = __webpack_require__(3);
	var Component_1 = __webpack_require__(113);
	var Component_2 = __webpack_require__(113);
	var Component_3 = __webpack_require__(113);
	var panel_1 = __webpack_require__(608);
	var PopoutWindow = __webpack_require__(1160);
	var commands_1 = __webpack_require__(12);
	
	var AdminWidget = function (_React$Component) {
	    _inherits(AdminWidget, _React$Component);
	
	    function AdminWidget() {
	        _classCallCheck(this, AdminWidget);
	
	        return _possibleConstructorReturn(this, (AdminWidget.__proto__ || Object.getPrototypeOf(AdminWidget)).apply(this, arguments));
	    }
	
	    _createClass(AdminWidget, [{
	        key: "fileSelected",
	        value: function fileSelected(id, memoryInstance) {}
	    }, {
	        key: "folderSelected",
	        value: function folderSelected(id, memoryInstance) {}
	    }, {
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            return React.createElement("div", { className: "memory-module selected-items" }, React.createElement(SelectButton, { buttonLabel: this.buttonLabel(), memoryPageUrl: this.props.memoryParams.location, windowHeight: this.props.memoryParams.windowHeight, windowWidth: this.props.memoryParams.windowWidth, openDialogCallback: function openDialogCallback() {
	                    return _this2.onDialogOpen();
	                } }), this.renderData(), this.state.showSelectionDialog ? this.selectionDialog() : null);
	        }
	    }, {
	        key: "onDialogClose",
	        value: function onDialogClose() {
	            this.setState(function (prevState) {
	                prevState.showSelectionDialog = false;
	                return prevState;
	            });
	        }
	    }, {
	        key: "onDialogOpen",
	        value: function onDialogOpen() {
	            this.setState(function (prevState) {
	                prevState.showSelectionDialog = true;
	                return prevState;
	            });
	        }
	    }]);
	
	    return AdminWidget;
	}(React.Component);
	
	var FileOrFolderWidget = function (_AdminWidget) {
	    _inherits(FileOrFolderWidget, _AdminWidget);
	
	    function FileOrFolderWidget(props, context) {
	        _classCallCheck(this, FileOrFolderWidget);
	
	        var _this3 = _possibleConstructorReturn(this, (FileOrFolderWidget.__proto__ || Object.getPrototypeOf(FileOrFolderWidget)).call(this, props, context));
	
	        _this3.state = {
	            selected: _this3.props.selected,
	            showSelectionDialog: false
	        };
	        return _this3;
	    }
	
	    _createClass(FileOrFolderWidget, [{
	        key: "renderData",
	        value: function renderData() {
	            var value = this.state.selected ? this.state.selected.id : 0;
	            return React.createElement("div", null, React.createElement("input", { type: "hidden", name: this.props.fieldName, value: value.toString() }), this.state.selected == null ? null : this.renderSelectedItem(this.state.selected));
	        }
	    }, {
	        key: "selected",
	        value: function selected(id, memoryInstance) {
	            var _this4 = this;
	
	            if (this.props.selectedCallback == null || !this.props.selectedCallback(id, memoryInstance)) {
	                new commands_1.CommandCaller(this.props.memoryParams.ajaxPageUrl).runGet(this.command(), [id]).then(function (items) {
	                    if (items != null && items.length > 0) {
	                        _this4.setState({ selected: items[0], showSelectionDialog: false });
	                    }
	                });
	            }
	        }
	    }, {
	        key: "deleted",
	        value: function deleted(id) {
	            if (this.props.deleteCallback == null || !this.props.deleteCallback(id)) {
	                this.setState({ selected: null, showSelectionDialog: false });
	            }
	            return true;
	        }
	    }]);
	
	    return FileOrFolderWidget;
	}(AdminWidget);
	
	var FileWidget = function (_FileOrFolderWidget) {
	    _inherits(FileWidget, _FileOrFolderWidget);
	
	    function FileWidget() {
	        _classCallCheck(this, FileWidget);
	
	        return _possibleConstructorReturn(this, (FileWidget.__proto__ || Object.getPrototypeOf(FileWidget)).apply(this, arguments));
	    }
	
	    _createClass(FileWidget, [{
	        key: "command",
	        value: function command() {
	            return 'get file details';
	        }
	    }, {
	        key: "buttonLabel",
	        value: function buttonLabel() {
	            return this.props.buttonLabel == null ? 'Link a File' : this.props.buttonLabel;
	        }
	    }, {
	        key: "renderSelectedItem",
	        value: function renderSelectedItem(selected) {
	            var _this6 = this;
	
	            return React.createElement(Component_1.FileComponent, { file: selected, deleteIconPath: this.props.memoryParams.deleteIconPath, deleteCallback: function deleteCallback(id) {
	                    return _this6.deleted(id);
	                } });
	        }
	        //noinspection JSMethodCanBeStatic,JSUnusedGlobalSymbols
	
	    }, {
	        key: "selectionDialog",
	        value: function selectionDialog() {
	            var _this7 = this;
	
	            return React.createElement(FileSelectionDialog, { memoryPageUrl: this.props.memoryParams.ajaxPageUrl, closeDialogCallback: function closeDialogCallback() {
	                    return _this7.onDialogClose();
	                }, fileSelectedCallback: function fileSelectedCallback(id, memoryInstance) {
	                    return _this7.selected(id, memoryInstance);
	                } });
	        }
	    }]);
	
	    return FileWidget;
	}(FileOrFolderWidget);
	
	exports.FileWidget = FileWidget;
	
	var FolderWidget = function (_FileOrFolderWidget2) {
	    _inherits(FolderWidget, _FileOrFolderWidget2);
	
	    function FolderWidget() {
	        _classCallCheck(this, FolderWidget);
	
	        return _possibleConstructorReturn(this, (FolderWidget.__proto__ || Object.getPrototypeOf(FolderWidget)).apply(this, arguments));
	    }
	
	    _createClass(FolderWidget, [{
	        key: "command",
	        value: function command() {
	            return 'get folder details';
	        }
	    }, {
	        key: "buttonLabel",
	        value: function buttonLabel() {
	            return this.props.buttonLabel == null ? 'Link a Folder' : this.props.buttonLabel;
	        }
	    }, {
	        key: "renderSelectedItem",
	        value: function renderSelectedItem(selected) {
	            var _this9 = this;
	
	            return React.createElement(Component_2.FolderComponent, { file: selected, deleteIconPath: this.props.memoryParams.deleteIconPath, deleteCallback: function deleteCallback(id) {
	                    return _this9.deleted(id);
	                } });
	        }
	        //noinspection JSMethodCanBeStatic,JSUnusedGlobalSymbols
	
	    }, {
	        key: "selectionDialog",
	        value: function selectionDialog() {
	            var _this10 = this;
	
	            return React.createElement(FolderSelectionDialog, { memoryPageUrl: this.props.memoryParams.ajaxPageUrl, closeDialogCallback: function closeDialogCallback() {
	                    return _this10.onDialogClose();
	                }, categorySelectedCallback: function categorySelectedCallback(id, memoryInstance) {
	                    return _this10.selected(id, memoryInstance);
	                } });
	        }
	    }]);
	
	    return FolderWidget;
	}(FileOrFolderWidget);
	
	exports.FolderWidget = FolderWidget;
	
	var SelectedItems = function () {
	    function SelectedItems(items, memoryParams, selectedCallback, deletedCallback) {
	        _classCallCheck(this, SelectedItems);
	
	        this.items = items;
	        this.memoryParams = memoryParams;
	        this.selectedCallback = selectedCallback;
	        this.deletedCallback = deletedCallback;
	    }
	
	    _createClass(SelectedItems, [{
	        key: "has",
	        value: function has(id) {
	            var _this11 = this;
	
	            return this.items != null && this.items.findIndex(function (item) {
	                return _this11.getId(item) == id;
	            }) != -1;
	        }
	        // If the UI must be updated in response to selecting the specified item, then the promise will be resolved.
	
	    }, {
	        key: "select",
	        value: function select(id, memoryInstance) {
	            var _this12 = this;
	
	            return new Promise(function (resolve) {
	                if (_this12.has(id)) {
	                    resolve({});
	                    return;
	                }
	                if (_this12.selectedCallback == null || !_this12.selectedCallback(id, memoryInstance)) {
	                    _this12.loadData(id).then(function (items) {
	                        if (items != null && items.length > 0) {
	                            _this12.items.push(items[0]);
	                            resolve({});
	                        }
	                    });
	                }
	            });
	        }
	    }, {
	        key: "commands",
	        value: function commands() {
	            return new commands_1.CommandCaller(this.memoryParams.ajaxPageUrl);
	        }
	        // If the UI must be updated in response to selecting the specified item, then the promise will be resolved.
	
	    }, {
	        key: "deleted",
	        value: function deleted(id) {
	            var _this13 = this;
	
	            return new Promise(function (resolve) {
	                if (_this13.deletedCallback == null || !_this13.deletedCallback(id)) {
	                    var index = _this13.items.findIndex(function (file) {
	                        return _this13.getId(file) == id;
	                    });
	                    _this13.items.splice(index, 1);
	                    resolve({});
	                }
	            });
	        }
	    }, {
	        key: "getItems",
	        value: function getItems() {
	            return this.items;
	        }
	    }]);
	
	    return SelectedItems;
	}();
	
	var SelectedFiles = function (_SelectedItems) {
	    _inherits(SelectedFiles, _SelectedItems);
	
	    function SelectedFiles() {
	        _classCallCheck(this, SelectedFiles);
	
	        return _possibleConstructorReturn(this, (SelectedFiles.__proto__ || Object.getPrototypeOf(SelectedFiles)).apply(this, arguments));
	    }
	
	    _createClass(SelectedFiles, [{
	        key: "getId",
	        value: function getId(fromItem) {
	            return fromItem.id;
	        }
	    }, {
	        key: "loadData",
	        value: function loadData(id) {
	            return this.commands().runGet('get file details', [id]);
	        }
	    }]);
	
	    return SelectedFiles;
	}(SelectedItems);
	
	var SelectedFolders = function (_SelectedItems2) {
	    _inherits(SelectedFolders, _SelectedItems2);
	
	    function SelectedFolders() {
	        _classCallCheck(this, SelectedFolders);
	
	        return _possibleConstructorReturn(this, (SelectedFolders.__proto__ || Object.getPrototypeOf(SelectedFolders)).apply(this, arguments));
	    }
	
	    _createClass(SelectedFolders, [{
	        key: "getId",
	        value: function getId(fromItem) {
	            return fromItem.folderId;
	        }
	    }, {
	        key: "loadData",
	        value: function loadData(id) {
	            return this.commands().runGet('get folder hierarchy details', [id]);
	        }
	    }]);
	
	    return SelectedFolders;
	}(SelectedItems);
	
	var FilesFoldersWidget = function (_AdminWidget2) {
	    _inherits(FilesFoldersWidget, _AdminWidget2);
	
	    function FilesFoldersWidget(props, context) {
	        _classCallCheck(this, FilesFoldersWidget);
	
	        var _this16 = _possibleConstructorReturn(this, (FilesFoldersWidget.__proto__ || Object.getPrototypeOf(FilesFoldersWidget)).call(this, props, context));
	
	        _this16.files = new SelectedFiles(props.files, props.memoryParams, props.fileSelectedCallback, props.fileDeletedCallback);
	        _this16.folders = new SelectedFolders(props.folders, props.memoryParams, props.folderSelectedCallback, props.folderDeletedCallback);
	        _this16.state = {
	            files: _this16.props.files,
	            folders: _this16.props.folders,
	            showSelectionDialog: false
	        };
	        return _this16;
	    }
	
	    _createClass(FilesFoldersWidget, [{
	        key: "selectionDialog",
	        value: function selectionDialog() {
	            var _this17 = this;
	
	            return React.createElement(FileFolderSelectionDialog, { memoryPageUrl: this.props.memoryParams.ajaxPageUrl, closeDialogCallback: function closeDialogCallback() {
	                    return _this17.onDialogClose();
	                }, fileSelectedCallback: function fileSelectedCallback(id, memoryInstance) {
	                    return _this17.fileSelected(id, memoryInstance);
	                }, categorySelectedCallback: function categorySelectedCallback(id, memoryInstance) {
	                    return _this17.folderSelected(id, memoryInstance);
	                } });
	        }
	    }, {
	        key: "buttonLabel",
	        value: function buttonLabel() {
	            return 'Link a File or Folder';
	        }
	    }, {
	        key: "fileSelected",
	        value: function fileSelected(id, memoryInstance) {
	            var _this18 = this;
	
	            this.files.select(id, memoryInstance).then(function () {
	                return _this18.refreshState();
	            });
	        }
	        //noinspection JSUnusedGlobalSymbols
	
	    }, {
	        key: "folderSelected",
	        value: function folderSelected(id, memoryInstance) {
	            var _this19 = this;
	
	            this.folders.select(id, memoryInstance).then(function () {
	                return _this19.refreshState();
	            });
	        }
	    }, {
	        key: "refreshState",
	        value: function refreshState() {
	            this.setState({
	                files: this.files.getItems(),
	                folders: this.folders.getItems(),
	                showSelectionDialog: this.state.showSelectionDialog
	            });
	        }
	    }, {
	        key: "hiddenInputsFor",
	        value: function hiddenInputsFor(fieldName, ids) {
	            var _this20 = this;
	
	            return ids.map(function (id) {
	                var inputName = _this20.props.fieldName + "[" + fieldName + "][]";
	                return React.createElement("input", { key: "input-for-" + fieldName + "-" + id, type: "hidden", name: inputName, value: id.toString() });
	            });
	        }
	    }, {
	        key: "renderData",
	        value: function renderData() {
	            var _this21 = this;
	
	            return React.createElement("div", null, this.hiddenInputsFor('fileIds', this.state.files.map(function (file) {
	                return file.id;
	            })), this.hiddenInputsFor('folderIds', this.state.folders.map(function (folder) {
	                return folder.folderId;
	            })), React.createElement(FileList, { files: this.state.files, deleteIconPath: this.props.memoryParams.deleteIconPath, deleteCallback: function deleteCallback(id) {
	                    return _this21.files.deleted(id).then(function () {
	                        return _this21.refreshState();
	                    });
	                } }), React.createElement(FolderHierarchyList, { folders: this.state.folders, deleteIconPath: this.props.memoryParams.deleteIconPath, directoryIconPath: this.props.memoryParams.directoryIconPath, deleteCallback: function deleteCallback(id) {
	                    return _this21.folders.deleted(id).then(function () {
	                        return _this21.refreshState();
	                    });
	                } }));
	        }
	    }]);
	
	    return FilesFoldersWidget;
	}(AdminWidget);
	
	exports.FilesFoldersWidget = FilesFoldersWidget;
	
	var FileList = function (_React$Component2) {
	    _inherits(FileList, _React$Component2);
	
	    function FileList() {
	        _classCallCheck(this, FileList);
	
	        return _possibleConstructorReturn(this, (FileList.__proto__ || Object.getPrototypeOf(FileList)).apply(this, arguments));
	    }
	
	    _createClass(FileList, [{
	        key: "render",
	        value: function render() {
	            var _this23 = this;
	
	            if (this.props.files == null || this.props.files.length === 0) {
	                return null;
	            }
	            return React.createElement(panel_1.Panel, { title: "Individual Files" }, React.createElement("ul", { className: "file-list item-list" }, this.props.files.map(function (file) {
	                return React.createElement(Component_1.FileComponent, { key: "memory-file-" + file.id, file: file, deleteIconPath: _this23.props.deleteIconPath, deleteCallback: function deleteCallback(id) {
	                        return _this23.props.deleteCallback(id);
	                    } });
	            })));
	        }
	    }]);
	
	    return FileList;
	}(React.Component);
	
	var FolderHierarchyList = function (_React$Component3) {
	    _inherits(FolderHierarchyList, _React$Component3);
	
	    function FolderHierarchyList() {
	        _classCallCheck(this, FolderHierarchyList);
	
	        return _possibleConstructorReturn(this, (FolderHierarchyList.__proto__ || Object.getPrototypeOf(FolderHierarchyList)).apply(this, arguments));
	    }
	
	    _createClass(FolderHierarchyList, [{
	        key: "render",
	        value: function render() {
	            var _this25 = this;
	
	            if (this.props.folders == null || this.props.folders.length === 0) {
	                return null;
	            }
	            return React.createElement("ul", { className: "category-list" }, this.props.folders.map(function (folder) {
	                return React.createElement(CategoryDisplay, { key: "category-" + folder.folderId, category: folder, deleteIconPath: _this25.props.deleteIconPath, directoryIconPath: _this25.props.directoryIconPath, deleteCallback: function deleteCallback(id) {
	                        return _this25.props.deleteCallback(id);
	                    } });
	            }));
	        }
	    }]);
	
	    return FolderHierarchyList;
	}(React.Component);
	
	var CategoryDisplay = function (_React$Component4) {
	    _inherits(CategoryDisplay, _React$Component4);
	
	    function CategoryDisplay() {
	        _classCallCheck(this, CategoryDisplay);
	
	        return _possibleConstructorReturn(this, (CategoryDisplay.__proto__ || Object.getPrototypeOf(CategoryDisplay)).apply(this, arguments));
	    }
	
	    _createClass(CategoryDisplay, [{
	        key: "render",
	        value: function render() {
	            var _this27 = this;
	
	            var deleteCallback = this.props.deleteCallback;
	
	            var onDelete = deleteCallback === undefined ? undefined : function () {
	                return deleteCallback(_this27.props.category.folderId);
	            };
	            return React.createElement(panel_1.Panel, { title: this.props.category.name, iconPath: this.props.directoryIconPath, rightIconPath: this.props.deleteIconPath, rightIconClick: onDelete }, React.createElement(Component_3.RecursiveFolderTree, { parentId: this.props.category.folderId, directoryIconPath: this.props.directoryIconPath, allPotentialChildren: this.props.category.hierarchy }));
	        }
	    }]);
	
	    return CategoryDisplay;
	}(React.Component);
	
	var SelectButton = function (_React$Component5) {
	    _inherits(SelectButton, _React$Component5);
	
	    function SelectButton() {
	        _classCallCheck(this, SelectButton);
	
	        return _possibleConstructorReturn(this, (SelectButton.__proto__ || Object.getPrototypeOf(SelectButton)).apply(this, arguments));
	    }
	
	    _createClass(SelectButton, [{
	        key: "render",
	        value: function render() {
	            return React.createElement("div", null, React.createElement("input", { type: "hidden", name: "memory_category_selected", id: "memory_category_selected", value: "" }), React.createElement("input", { type: "hidden", name: "memory_file_selected", id: "memory_file_selected", value: "" }), React.createElement("input", { type: "hidden", name: "memory_instance", id: "memory_instance", value: "" }), React.createElement("input", { type: "button", name: "repository", value: this.props.buttonLabel, className: "submit", onClick: this.props.openDialogCallback }));
	        }
	    }]);
	
	    return SelectButton;
	}(React.Component);
	
	var SelectionDialog = function (_React$Component6) {
	    _inherits(SelectionDialog, _React$Component6);
	
	    function SelectionDialog(props, context) {
	        _classCallCheck(this, SelectionDialog);
	
	        var _this29 = _possibleConstructorReturn(this, (SelectionDialog.__proto__ || Object.getPrototypeOf(SelectionDialog)).call(this, props, context));
	
	        _this29.onMessage = function (event) {
	            if (event.data.hasOwnProperty('eventType')) {
	                if (event.data.eventType == "categorySelected") {
	                    _this29.props.categorySelectedCallback(parseInt(event.data.folderId), event.data.memoryInstance);
	                } else if (event.data.eventType == 'fileSelected') {
	                    _this29.props.fileSelectedCallback(parseInt(event.data.fileId), event.data.memoryInstance);
	                }
	                var ref = _this29.windowRef;
	                ref && ref.closeWindow();
	            }
	        };
	        _this29.cancelClick = function () {
	            var ref = _this29.windowRef;
	            ref && ref.closeWindow();
	        };
	        return _this29;
	    }
	
	    _createClass(SelectionDialog, [{
	        key: "componentWillMount",
	        value: function componentWillMount() {
	            window.addEventListener("message", this.onMessage);
	        }
	    }, {
	        key: "componentWillUnmount",
	        value: function componentWillUnmount() {
	            window.removeEventListener("message", this.onMessage);
	        }
	    }, {
	        key: "command",
	        value: function command() {
	            if (this.canSelectFiles() && !this.canSelectFolders()) {
	                return 'memory_select_file';
	            } else if (!this.canSelectFiles() && this.canSelectFolders()) {
	                return 'memory_select_folder';
	            } else {
	                return 'category_select';
	            }
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this30 = this;
	
	            var url = this.props.memoryPageUrl + "/command/" + this.command();
	            return React.createElement(PopoutWindow, { ref: function ref(_ref) {
	                    return _this30.windowRef = _ref;
	                }, title: "Select a document or folder", url: url, onClosing: function onClosing() {
	                    return _this30.props.closeDialogCallback();
	                } }, React.createElement("div", { style: { padding: '2em' } }, React.createElement("div", null, "Loading list of files/folders..."), React.createElement("a", { href: "#", onClick: this.cancelClick }, "Cancel")));
	        }
	    }]);
	
	    return SelectionDialog;
	}(React.Component);
	
	var FileSelectionDialog = function (_SelectionDialog) {
	    _inherits(FileSelectionDialog, _SelectionDialog);
	
	    function FileSelectionDialog() {
	        _classCallCheck(this, FileSelectionDialog);
	
	        return _possibleConstructorReturn(this, (FileSelectionDialog.__proto__ || Object.getPrototypeOf(FileSelectionDialog)).apply(this, arguments));
	    }
	
	    _createClass(FileSelectionDialog, [{
	        key: "canSelectFolders",
	        value: function canSelectFolders() {
	            return false;
	        }
	    }, {
	        key: "canSelectFiles",
	        value: function canSelectFiles() {
	            return true;
	        }
	    }]);
	
	    return FileSelectionDialog;
	}(SelectionDialog);
	
	var FolderSelectionDialog = function (_SelectionDialog2) {
	    _inherits(FolderSelectionDialog, _SelectionDialog2);
	
	    function FolderSelectionDialog() {
	        _classCallCheck(this, FolderSelectionDialog);
	
	        return _possibleConstructorReturn(this, (FolderSelectionDialog.__proto__ || Object.getPrototypeOf(FolderSelectionDialog)).apply(this, arguments));
	    }
	
	    _createClass(FolderSelectionDialog, [{
	        key: "canSelectFolders",
	        value: function canSelectFolders() {
	            return true;
	        }
	    }, {
	        key: "canSelectFiles",
	        value: function canSelectFiles() {
	            return false;
	        }
	    }]);
	
	    return FolderSelectionDialog;
	}(SelectionDialog);
	
	var FileFolderSelectionDialog = function (_SelectionDialog3) {
	    _inherits(FileFolderSelectionDialog, _SelectionDialog3);
	
	    function FileFolderSelectionDialog() {
	        _classCallCheck(this, FileFolderSelectionDialog);
	
	        return _possibleConstructorReturn(this, (FileFolderSelectionDialog.__proto__ || Object.getPrototypeOf(FileFolderSelectionDialog)).apply(this, arguments));
	    }
	
	    _createClass(FileFolderSelectionDialog, [{
	        key: "canSelectFolders",
	        value: function canSelectFolders() {
	            return true;
	        }
	    }, {
	        key: "canSelectFiles",
	        value: function canSelectFiles() {
	            return true;
	        }
	    }]);
	
	    return FileFolderSelectionDialog;
	}(SelectionDialog);

/***/ },

/***/ 282:
/***/ function(module, exports) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	
	var KeywordFilter = function KeywordFilter() {
	    _classCallCheck(this, KeywordFilter);
	
	    this.isExpanded = false;
	    this.id = '';
	    this.name = '';
	};
	
	exports.KeywordFilter = KeywordFilter;
	
	var FieldFilter = function () {
	    _createClass(FieldFilter, null, [{
	        key: "fromObjects",
	        value: function fromObjects(objects) {
	            return objects.map(function (object) {
	                return new FieldFilter(object);
	            });
	        }
	    }]);
	
	    function FieldFilter(object) {
	        _classCallCheck(this, FieldFilter);
	
	        this.values = FieldOptionValue.fromObjects(object.values);
	        this.id = object.id;
	        this.name = object.name;
	    }
	
	    _createClass(FieldFilter, [{
	        key: "autoCloseOnSelection",
	        value: function autoCloseOnSelection() {
	            return true;
	        }
	    }]);
	
	    return FieldFilter;
	}();
	
	exports.FieldFilter = FieldFilter;
	
	var CategoryFilter = function () {
	    function CategoryFilter(values) {
	        _classCallCheck(this, CategoryFilter);
	
	        this.values = values;
	        this.id = "categoryFilter";
	        this.name = "Category";
	    }
	
	    _createClass(CategoryFilter, [{
	        key: "autoCloseOnSelection",
	        value: function autoCloseOnSelection() {
	            return false;
	        }
	    }]);
	
	    return CategoryFilter;
	}();
	
	exports.CategoryFilter = CategoryFilter;
	
	var ArchiveFilter = function () {
	    function ArchiveFilter() {
	        _classCallCheck(this, ArchiveFilter);
	
	        this.values = [ArchivedStatus.CURRENT, ArchivedStatus.ALL];
	        this.id = "archiveFilter";
	        this.name = "Archive";
	    }
	    /**
	     * Because we only allow selections (and not deselections) of options in this filter, it is a bit confusing to
	     * instantly close the filter after selecting, and very jarring to the eye. Thus, lets leave it open.
	     * @returns {boolean}
	     */
	
	
	    _createClass(ArchiveFilter, [{
	        key: "autoCloseOnSelection",
	        value: function autoCloseOnSelection() {
	            return false;
	        }
	    }]);
	
	    return ArchiveFilter;
	}();
	
	exports.ArchiveFilter = ArchiveFilter;
	
	var ArchivedStatus = function () {
	    function ArchivedStatus(id, label) {
	        _classCallCheck(this, ArchivedStatus);
	
	        this.id = id;
	        this.label = label;
	    }
	
	    _createClass(ArchivedStatus, [{
	        key: "getId",
	        value: function getId() {
	            return this.id;
	        }
	    }, {
	        key: "getLabel",
	        value: function getLabel() {
	            return this.label;
	        }
	    }], [{
	        key: "CURRENT",
	        get: function get() {
	            return ArchivedStatus.current;
	        }
	    }, {
	        key: "ALL",
	        get: function get() {
	            return ArchivedStatus.all;
	        }
	    }]);
	
	    return ArchivedStatus;
	}();
	
	ArchivedStatus.current = new ArchivedStatus("current", "Current");
	ArchivedStatus.all = new ArchivedStatus("all", "All");
	exports.ArchivedStatus = ArchivedStatus;
	
	var FieldOptionValue = function () {
	    function FieldOptionValue() {
	        _classCallCheck(this, FieldOptionValue);
	
	        this.id = '';
	        this.label = '';
	    }
	
	    _createClass(FieldOptionValue, [{
	        key: "getId",
	        value: function getId() {
	            return this.id;
	        }
	    }, {
	        key: "getLabel",
	        value: function getLabel() {
	            return this.label;
	        }
	    }], [{
	        key: "fromObjects",
	        value: function fromObjects(objects) {
	            return objects.map(function (object) {
	                var value = new FieldOptionValue();
	                value.id = object.id;
	                value.label = object.label;
	                return value;
	            });
	        }
	    }]);
	
	    return FieldOptionValue;
	}();
	
	exports.FieldOptionValue = FieldOptionValue;
	
	var FilterSelectionState = function () {
	    function FilterSelectionState() {
	        _classCallCheck(this, FilterSelectionState);
	
	        this.map = new Map();
	    }
	
	    _createClass(FilterSelectionState, [{
	        key: "clearSelected",
	        value: function clearSelected(filter) {
	            var _this = this;
	
	            this.getSelected(filter).forEach(function (value) {
	                _this.setSelected(filter, value, false);
	            });
	        }
	        // For now only supports selecting one item, but it wasn't clear in the original spec, so this should be relatively
	        // trivial to support multiple selections (though the semantics of the server side querying will be less trivial)
	
	    }, {
	        key: "setSelected",
	        value: function setSelected(filter, value, isSelected) {
	            var valueSet = new Set();
	            if (isSelected) {
	                valueSet.add(value);
	            }
	            this.map.set(filter, valueSet);
	        }
	    }, {
	        key: "getSelected",
	        value: function getSelected(filter) {
	            var set = this.map.get(filter);
	            if (set === undefined) {
	                set = new Set();
	                this.map.set(filter, set);
	            }
	            return set;
	        }
	    }, {
	        key: "serialize",
	        value: function serialize() {
	            var selected = {};
	            var _iteratorNormalCompletion = true;
	            var _didIteratorError = false;
	            var _iteratorError = undefined;
	
	            try {
	                for (var _iterator = this.map.keys()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                    var filter = _step.value;
	
	                    selected[filter.id] = this.serializeFilter(filter);
	                }
	            } catch (err) {
	                _didIteratorError = true;
	                _iteratorError = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion && _iterator.return) {
	                        _iterator.return();
	                    }
	                } finally {
	                    if (_didIteratorError) {
	                        throw _iteratorError;
	                    }
	                }
	            }
	
	            return selected;
	        }
	    }, {
	        key: "serializeFilter",
	        value: function serializeFilter(filter) {
	            return Array.from(this.getSelected(filter)).map(function (value) {
	                return value.getId();
	            });
	        }
	    }]);
	
	    return FilterSelectionState;
	}();
	
	exports.FilterSelectionState = FilterSelectionState;

/***/ },

/***/ 283:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) {
	            try {
	                step(generator.next(value));
	            } catch (e) {
	                reject(e);
	            }
	        }
	        function rejected(value) {
	            try {
	                step(generator["throw"](value));
	            } catch (e) {
	                reject(e);
	            }
	        }
	        function step(result) {
	            result.done ? resolve(result.value) : new P(function (resolve) {
	                resolve(result.value);
	            }).then(fulfilled, rejected);
	        }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var commands_1 = __webpack_require__(12);
	var $ = __webpack_require__(10);
	function sendDetailsToSelf(ajaxPageUrl, articleId) {
	    return __awaiter(this, void 0, void 0, regeneratorRuntime.mark(function _callee() {
	        var command, response;
	        return regeneratorRuntime.wrap(function _callee$(_context) {
	            while (1) {
	                switch (_context.prev = _context.next) {
	                    case 0:
	                        command = new commands_1.CommandCaller(ajaxPageUrl);
	                        _context.next = 3;
	                        return command.runPost('email details to current user', { articleId: articleId });
	
	                    case 3:
	                        response = _context.sent;
	
	                        alert(response.message);
	
	                    case 5:
	                    case "end":
	                        return _context.stop();
	                }
	            }
	        }, _callee, this);
	    }));
	}
	exports.sendDetailsToSelf = sendDetailsToSelf;
	function initElementsWithDataAttributes(ajaxPageUrl, nodeToSearch) {
	    var attribute = 'data-email-details-to-current-user';
	    var selector = "[" + attribute + "]";
	    var foundNodes = nodeToSearch != null ? $(nodeToSearch).find(selector) : $(selector);
	    foundNodes.each(function (i, element) {
	        return element.onclick = function (event) {
	            event.preventDefault();
	            var articleId = $(element).attr(attribute);
	            sendDetailsToSelf(ajaxPageUrl, parseInt(articleId));
	        };
	    });
	}
	exports.initElementsWithDataAttributes = initElementsWithDataAttributes;
	//# sourceMappingURL=email details to myself.js.map

/***/ },

/***/ 284:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var creditCard = __webpack_require__(140);
	var getDirectDebitParams = function getDirectDebitParams() {
	    return {
	        method: "DirectDebit",
	        accountName: window.ivt.jQuery("[name='directEntryAccountName']").val(),
	        accountNumber: window.ivt.jQuery("[name='directEntryAccountNumber']").val(),
	        bsb: window.ivt.jQuery("[name='directEntryBSB1']").val() + window.ivt.jQuery("[name='directEntryBSB2']").val()
	    };
	};
	var addValidationRules = function addValidationRules(paymentMethod) {
	    window.ivt.jQuery(".required").removeClass("required");
	    window.ivt.jQuery("#" + paymentMethod).find("input:visible").addClass("required");
	};
	var checkFormForErrors = function checkFormForErrors(paymentMethod, form) {
	    var isCreditCardPayment = paymentMethod == "CreditCard";
	    addValidationRules(paymentMethod);
	    form.validate();
	    var paymentError = function paymentError(error) {
	        return { method: 'error', title: 'Invalid Payment Information', error: error };
	    };
	    if (!form.valid()) {
	        return paymentError("Please ensure all " + (isCreditCardPayment ? "credit card" : "direct debit") + " fields are filled out");
	    }
	    if (isCreditCardPayment && !creditCard.isCreditCardValid()) {
	        return paymentError("The credit card number you have entered is not valid");
	    }
	    if (isCreditCardPayment && !creditCard.isCreditCardCvvValid()) {
	        return paymentError("The credit card CVV you have entered is not valid. It should be " + creditCard.requiredCvvDigits() + " digits long");
	    }
	    if (isCreditCardPayment && !creditCard.isCreditCardExpiryValid()) {
	        return paymentError("Please enter a current expiry date");
	    }
	    return undefined;
	};
	exports.getFormValues = function (form) {
	    var paymentMethod = window.ivt.jQuery('[name=method]').val();
	    var errors = checkFormForErrors(paymentMethod, form);
	    if (errors) {
	        return errors;
	    }
	    return paymentMethod == "CreditCard" ? creditCard.getCreditCardParams() : getDirectDebitParams();
	};

/***/ },

/***/ 285:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var Commands = __webpack_require__(12);
	var EWay = __webpack_require__(657);
	var PaymentMethodsTabs = __webpack_require__(284);
	var ScheduledPayments = __webpack_require__(659);
	var creditcard = __webpack_require__(140);
	var ReusablePayer = __webpack_require__(658);
	
	var EwayTools = function () {
	    function EwayTools(ajaxPageUrl) {
	        _classCallCheck(this, EwayTools);
	
	        this.caller = new Commands.CommandCaller(ajaxPageUrl);
	    }
	
	    _createClass(EwayTools, [{
	        key: "requestAccessCode",
	        value: function requestAccessCode(creditCardType) {
	            return this.caller.runPost('eway.request access code', {
	                cardType: creditCardType
	            });
	        }
	    }, {
	        key: "submitPayment",
	        value: function submitPayment(ewayRequestResult, params) {
	            return EWay.processEway({
	                Name: params.name,
	                Number: params.number,
	                Month: params.month,
	                Year: params.year,
	                CVV: params.cvv,
	                FormActionURL: ewayRequestResult.FormActionURL,
	                AccessCode: ewayRequestResult.AccessCode
	            }).then(function (ewayResult) {
	                if (ewayResult.Is3DSecure) {
	                    window.location.replace(ewayResult.RedirectUrl);
	                }
	                return ewayResult;
	            });
	        }
	    }, {
	        key: "submitSuccess",
	        value: function submitSuccess(ewayResult) {
	            return this.caller.runPost('eway.submit success', {
	                code: ewayResult.AccessCode
	            }).then(function (result) {
	                window.location.assign(result.nextPage);
	            });
	        }
	    }]);
	
	    return EwayTools;
	}();
	//noinspection JSUnusedGlobalSymbols
	
	
	exports.submitEwayPayment = function (div, ajaxPageUrl) {
	    var eway = new EwayTools(ajaxPageUrl);
	    var params = creditcard.getCreditCardParams();
	    div.block({ message: "Please wait while we attempt to process your payment..." });
	    var handleError = function handleError(str) {
	        return function (e) {
	            console.log(e, "the error message", str);
	            window.alert("An error has occurred");
	            div.unblock();
	        };
	    };
	    if (params.cardType === "unknown") {
	        handleError("unknown card")("The credit card number you have entered is unknown or not supported");
	        return;
	    }
	    var withAccessCode = function withAccessCode(result) {
	        if (typeof result.Code !== "undefined") {
	            eway.submitPayment(result.Code, params).then(function (r) {
	                return eway.submitSuccess(r).catch(handleError("eway submit success"));
	            }, handleError("eway sbumit payment"));
	        } else if (typeof result.Continue !== "undefined") {
	            window.location.assign(result.Continue);
	        } else {
	            handleError("with access code")("There was a system error processing your order. It is safe to resubmit.");
	        }
	    };
	    eway.requestAccessCode(params.cardType).then(withAccessCode, handleError("request access code"));
	};
	exports.paymentMethodsTabs = PaymentMethodsTabs;
	exports.scheduledPayments = ScheduledPayments;
	exports.creditCard = creditcard;
	exports.reusablePayer = ReusablePayer;

/***/ },

/***/ 286:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var ReactRedux = __webpack_require__(23);
	var commands_1 = __webpack_require__(12);
	var actions_1 = __webpack_require__(666);
	var presentation_1 = __webpack_require__(667);
	exports.subscriptionAppInitialState = {
	    name: '',
	    optional: true,
	    reason: '',
	    isSaving: false
	};
	var subscriptionAppMapStateToProps = function subscriptionAppMapStateToProps(store, ownProps) {
	    return {
	        name: store.name,
	        optional: store.optional,
	        reason: store.reason,
	        isSaving: store.isSaving,
	        errorFields: store.errorFields
	    };
	};
	var subscriptionAppMapDispatchToProps = function subscriptionAppMapDispatchToProps(dispatch, ownProps) {
	    return {
	        nameOnChange: function nameOnChange(newName) {
	            return dispatch(actions_1.actionCreators.field.changeNameAction(newName));
	        },
	        optionalOnChange: function optionalOnChange(newOptional) {
	            return dispatch(actions_1.actionCreators.field.changeOptionalAction(newOptional));
	        },
	        reasonOnChange: function reasonOnChange(newReason) {
	            return dispatch(actions_1.actionCreators.field.changeReasonAction(newReason));
	        },
	        onClose: ownProps.onClose,
	        onSave: function onSave() {
	            return dispatch(actions_1.onSave(new commands_1.CommandCaller(ownProps.ajaxPageUrl), ownProps.onClose));
	        }
	    };
	};
	exports.SubscriptionAppContainer = ReactRedux.connect(subscriptionAppMapStateToProps, subscriptionAppMapDispatchToProps)(presentation_1.SubscriptionApp);

/***/ },

/***/ 531:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) {
	            try {
	                step(generator.next(value));
	            } catch (e) {
	                reject(e);
	            }
	        }
	        function rejected(value) {
	            try {
	                step(generator["throw"](value));
	            } catch (e) {
	                reject(e);
	            }
	        }
	        function step(result) {
	            result.done ? resolve(result.value) : new P(function (resolve) {
	                resolve(result.value);
	            }).then(fulfilled, rejected);
	        }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var react_redux_1 = __webpack_require__(23);
	var redux_thunk_1 = __webpack_require__(33);
	var presentation_1 = __webpack_require__(532);
	var redux_1 = __webpack_require__(22);
	var commands_1 = __webpack_require__(12);
	exports.createStoreFromParams = function (params) {
	    return redux_1.createStore(exports.reducer, { settings: params.settings, isSaving: false, publicUrl: params.publicUrl }, redux_1.applyMiddleware(redux_thunk_1.default));
	};
	var defaultSettings = {
	    id: 0,
	    instance: null,
	    username: "",
	    password: ""
	};
	var defaultState = {
	    isSaving: false,
	    settings: defaultSettings,
	    publicUrl: ""
	};
	exports.settingsReducer = function () {
	    var s = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultSettings;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case 'change username':
	            return { username: action.to, id: s.id, instance: s.instance, password: s.password };
	        case 'change password':
	            return { password: action.to, id: s.id, instance: s.instance, username: s.username };
	    }
	};
	exports.saveReducer = function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case "saving settings":
	            return { settings: state.settings, publicUrl: state.publicUrl, isSaving: true };
	        case "settings saved":
	            return {
	                isSaving: false,
	                publicUrl: state.publicUrl,
	                settings: action.settings
	            };
	        case "saving settings failed":
	            return { settings: state.settings, publicUrl: state.publicUrl, isSaving: false };
	    }
	};
	exports.reducer = function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
	    var action = arguments[1];
	
	    switch (action.type) {
	        // Unwrap the action because inside it will be another action that says specifically what setting has changed and how.
	        case "settings changed":
	            return Object.assign({}, state, { settings: exports.settingsReducer(state.settings, action.action) });
	        // Async save settings actions redirected through here.
	        case "save info":
	            return exports.saveReducer(state, action.action);
	        default:
	            return state;
	    }
	};
	var wrapSettingsChangeAction = function wrapSettingsChangeAction(action) {
	    return {
	        type: "settings changed",
	        action: action
	    };
	};
	var wrapSaveAction = function wrapSaveAction(action) {
	    return {
	        type: "save info",
	        action: action
	    };
	};
	exports.actionCreators = {
	    settings: {
	        usernameChange: function usernameChange(username) {
	            return wrapSettingsChangeAction({ type: "change username", to: username });
	        },
	        passwordChange: function passwordChange(password) {
	            return wrapSettingsChangeAction({ type: "change password", to: password });
	        }
	    },
	    save: {
	        saveStart: function saveStart() {
	            return wrapSaveAction({ type: "saving settings" });
	        },
	        saveFailure: function saveFailure() {
	            return wrapSaveAction({ type: "saving settings failed" });
	        },
	        saveSuccess: function saveSuccess(settings) {
	            return wrapSaveAction({ type: "settings saved", settings: settings });
	        }
	    },
	    saveSettings: function saveSettings(commandCaller, settings) {
	        return function (dispatch) {
	            return __awaiter(undefined, void 0, void 0, regeneratorRuntime.mark(function _callee() {
	                var result;
	                return regeneratorRuntime.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                dispatch(exports.actionCreators.save.saveStart());
	                                _context.prev = 1;
	                                _context.next = 4;
	                                return commandCaller.runPost("save.settings", settings);
	
	                            case 4:
	                                result = _context.sent;
	
	                                dispatch(exports.actionCreators.save.saveSuccess(result));
	                                _context.next = 11;
	                                break;
	
	                            case 8:
	                                _context.prev = 8;
	                                _context.t0 = _context["catch"](1);
	
	                                dispatch(exports.actionCreators.save.saveFailure());
	
	                            case 11:
	                            case "end":
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this, [[1, 8]]);
	            }));
	        };
	    }
	};
	var mapStateToProps = function mapStateToProps(state) {
	    return state;
	};
	var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
	    return {
	        onUsernameChange: function onUsernameChange(username) {
	            return dispatch(exports.actionCreators.settings.usernameChange(username));
	        },
	        onPasswordChange: function onPasswordChange(password) {
	            return dispatch(exports.actionCreators.settings.passwordChange(password));
	        },
	        onSave: function onSave(settings) {
	            return dispatch(exports.actionCreators.saveSettings(new commands_1.CommandCaller(ownProps.ajaxUrl), settings));
	        }
	    };
	};
	exports.SettingsFormContainer = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(presentation_1.SettingsForm);

/***/ },

/***/ 532:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(3);
	var form_1 = __webpack_require__(55);
	var field_1 = __webpack_require__(112);
	var input_1 = __webpack_require__(34);
	var notification_1 = __webpack_require__(139);
	exports.SettingsForm = function (props) {
	    return React.createElement(form_1.Form, { onSubmit: function onSubmit() {
	            return props.onSave(props.settings);
	        }, hasSave: true, isSubmitting: props.isSaving }, React.createElement(field_1.Group, { heading: "Settings" }, React.createElement("div", { style: { maxWidth: "400px" } }, React.createElement(notification_1.Notification, { type: "info" }, "By providing a username and password for the single sign on process with ", React.createElement("a", { href: "http://myadvantage.com.au/" }, "Wentworth Advantage"), ", members will be able to view Wentworth Advantage content in AO, without first having to first log in by navigating to ", React.createElement("a", { href: props.publicUrl }, "this link"), ".")), React.createElement(field_1.Item, { label: "Username" }, React.createElement(input_1.Input, { value: props.settings.username, onChange: function onChange(value) {
	            return props.onUsernameChange(value);
	        } })), React.createElement(field_1.Item, { label: "Password" }, React.createElement(input_1.Input, { value: props.settings.password, onChange: function onChange(value) {
	            return props.onPasswordChange(value);
	        } }))));
	};

/***/ },

/***/ 533:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(3);
	var ReactDOM = __webpack_require__(6);
	var app_1 = __webpack_require__(531);
	exports.settingsForm = function (replace, params) {
	    var store = app_1.createStoreFromParams(params);
	    var div = document.createElement('div');
	    replace(div);
	    ReactDOM.render(React.createElement(app_1.SettingsFormContainer, { ajaxUrl: params.ajaxUrl, store: store }), div);
	};

/***/ },

/***/ 534:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var settings_form_1 = __webpack_require__(533);
	exports.settingsForm = settings_form_1.settingsForm;

/***/ },

/***/ 535:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var Dashboard = __webpack_require__(536);
	exports.dashboardCallJs = Dashboard.dashboardCallJs;

/***/ },

/***/ 536:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(3);
	var ReactDOM = __webpack_require__(6);
	var redux_1 = __webpack_require__(22);
	var redux_thunk_1 = __webpack_require__(33);
	var react_redux_1 = __webpack_require__(23);
	var utils_1 = __webpack_require__(4);
	var cookie_1 = __webpack_require__(261);
	var presentation_1 = __webpack_require__(539);
	var action_1 = __webpack_require__(537);
	var reducer_1 = __webpack_require__(540);
	var app_1 = __webpack_require__(538);
	var hydrateParams = function hydrateParams(plain) {
	    return {
	        fromDate: plain.fromDate ? new Date(1000 * plain.fromDate) : null,
	        toDate: plain.toDate ? new Date(1000 * plain.toDate) : null
	    };
	};
	exports.dashboardCallJs = function (replacer, params) {
	    var usefulParams = hydrateParams(params);
	    var today = new Date();
	    var lastYear = new Date();
	    lastYear.setFullYear(today.getFullYear() - 1);
	    var initialState = {
	        activeTab: "traffic sources",
	        loading: "done",
	        fromDate: usefulParams.fromDate || lastYear,
	        toDate: usefulParams.toDate || today,
	        includesNewVisitors: false,
	        includesReturningVisitors: false,
	        visits: [],
	        times: [],
	        overviewing: undefined,
	        keywords: {},
	        sources: null,
	        tabs: {
	            "traffic sources": {
	                data: [],
	                typePlaceholder: { i: 0, medium: '', avgTimeOnSite: 0, visits: 0, source: '', highlight: false },
	                pagination: { label: 'traffic sources', limit: 10, page: 1 }
	            },
	            "keywords": {
	                data: [],
	                typePlaceholder: { i: 0, avgTime: 0, highlight: false, keyword: '', visitsTotal: '' },
	                pagination: { label: 'keywords', limit: 10, page: 1 }
	            },
	            "content": {
	                data: [],
	                typePlaceholder: { i: 0, time: 0, pageviewsTotal: 0, url: '', greytitle: '', maintitle: '', visitsTotal: '' },
	                pagination: { label: 'content', limit: 10, page: 1 }
	            },
	            "event detail": {
	                data: [],
	                typePlaceholder: { i: 0, time: 0, pageviewsTotal: 0, url: '', greytitle: '', maintitle: '', visitsTotal: '' },
	                pagination: { label: 'event detail', limit: 10, page: 1 }
	            },
	            "ecommerce": {
	                data: [],
	                typePlaceholder: { i: 0, uniquePurchasesTotal: 0, itemRevenueTotal: 0, productName: '' },
	                pagination: { label: 'ecommerce', limit: 10, page: 1 }
	            }
	        }
	    };
	    var store = redux_1.createStore(utils_1.makeReducer(action_1.isDashboardAction, reducer_1.reducer, initialState), redux_1.applyMiddleware(redux_thunk_1.default));
	    var DashboardApp = react_redux_1.connect(app_1.mapStateToProps, app_1.mapDispatchToProps)(presentation_1.Dashboard);
	    var props = {
	        visitsColor: params.visitsColor,
	        returningVisitsColor: params.returningVisitsColor,
	        newVisitsColor: params.newVisitsColor,
	        pageviewsColor: params.pageviewsColor,
	        directColor: params.directColor,
	        referringColor: params.referringColor,
	        searchColor: params.searchColor,
	        otherColor: params.otherColor,
	        getDashboardDataURI: params.getDashboardDataURI,
	        getKeywordsURI: params.getKeywordsURI,
	        hasEventTracking: params.hasEventTracking,
	        hasEcommerceTracking: params.hasEcommerceTracking,
	        cookieName: cookieName,
	        store: store
	    };
	    var div = document.createElement("div");
	    replacer(div);
	    ReactDOM.render(React.createElement(DashboardApp, Object.assign({}, props)), div);
	    var dispatchers = app_1.mapDispatchToProps(store.dispatch, props);
	    var segmentsCookie = cookie_1.Get_Cookie(cookieName);
	    switch (segmentsCookie) {
	        case 'newvisits':
	            dispatchers.setNewVisitors(true);
	            break;
	        case 'segments':
	            dispatchers.setNewVisitors(true);
	            dispatchers.setReturningVisitors(true);
	            break;
	        case 'returnvisits':
	            dispatchers.setReturningVisitors(true);
	            break;
	    }
	    dispatchers.updateVisitsData();
	};
	var cookieName = 'segments_values';

/***/ },

/***/ 537:
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.isDashboardAction = function (a) {
	  return a.hasOwnProperty("dashboard") && a.dashboard === true;
	};

/***/ },

/***/ 538:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) {
	            try {
	                step(generator.next(value));
	            } catch (e) {
	                reject(e);
	            }
	        }
	        function rejected(value) {
	            try {
	                step(generator["throw"](value));
	            } catch (e) {
	                reject(e);
	            }
	        }
	        function step(result) {
	            result.done ? resolve(result.value) : new P(function (resolve) {
	                resolve(result.value);
	            }).then(fulfilled, rejected);
	        }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var commands_1 = __webpack_require__(12);
	var utils_1 = __webpack_require__(4);
	var cookie_1 = __webpack_require__(261);
	exports.mapStateToProps = function (s, props) {
	    var visits = s.visits || [];
	    var analytics = utils_1.zipObj(visits, ['visits', 'newVisits', 'ShortDate', 'pageviews']);
	    var times = utils_1.zipObj(s.times || [], ['visits', 'newVisits', 'timeTotal']);
	    var returningVisits = visits.map(function (v) {
	        return v.visits - v.newVisits;
	    });
	    var totalTime = times.timeTotal.reduce(utils_1.sumReducer, 0);
	    // the original code has two ways of calculating the total visits. i have not proven if they are the same or different, but maintained it.
	    var totalVisits1 = times.visits.reduce(utils_1.sumReducer, 0);
	    var totalVisits2 = analytics.visits.reduce(utils_1.sumReducer, 0);
	    var totalPageviews = analytics.pageviews.reduce(utils_1.sumReducer, 0);
	    return Object.assign({}, s, { visits: analytics.visits, pageviews: analytics.pageviews, newVisits: analytics.newVisits, visitsColor: props.visitsColor, newVisitsColor: props.newVisitsColor, returningVisitsColor: props.returningVisitsColor, pageviewsColor: props.pageviewsColor, directColor: props.directColor, searchColor: props.searchColor, otherColor: props.otherColor, referringColor: props.referringColor, hasEventTracking: props.hasEventTracking, hasEcommerceTracking: props.hasEcommerceTracking, totalVisits: totalVisits2, totalNewVisits: analytics.newVisits.reduce(utils_1.sumReducer, 0), totalPageviews: totalPageviews,
	        returningVisits: returningVisits, averageTimeOnSite: totalVisits1 ? totalTime / totalVisits1 : 0, totalReturningVisits: returningVisits.reduce(utils_1.sumReducer, 0), labels: analytics.ShortDate, pagesPerVisit: totalVisits2 ? totalPageviews / totalVisits2 : 0, overviewing: s.overviewing !== void 0 && s.visits ? s.visits[s.overviewing] : undefined, keywords: s.overviewing !== void 0 && s.keywords[s.overviewing] ? s.keywords[s.overviewing] : { type: "loading" } });
	};
	exports.mapDispatchToProps = function (dispatch, props) {
	    return {
	        switchTab: function switchTab(tab) {
	            return dispatch({ dashboard: true, type: "switch tab", tab: tab });
	        },
	        paginationCallbacks: function paginationCallbacks(on) {
	            return {
	                setLimit: function setLimit(limit) {
	                    return dispatch({ dashboard: true, type: "set limit", limit: limit, on: on });
	                },
	                setPage: function setPage(page) {
	                    return dispatch({ dashboard: true, type: "set page", page: page, on: on });
	                }
	            };
	        },
	        setNewVisitors: function setNewVisitors(to) {
	            return dispatch({ dashboard: true, type: "set new visitors checked", to: to });
	        },
	        setReturningVisitors: function setReturningVisitors(to) {
	            return dispatch({ dashboard: true, type: "set returning visitors checked", to: to });
	        },
	        setFromDate: function setFromDate(date) {
	            return dispatch({ dashboard: true, type: "set from date", date: date });
	        },
	        setToDate: function setToDate(date) {
	            return dispatch({ dashboard: true, type: "set to date", date: date });
	        },
	        onRequestCloseOverview: function onRequestCloseOverview() {
	            return dispatch({ dashboard: true, type: "close overview" });
	        },
	        showDayById: function showDayById(dayId) {
	            return dispatch(function (dispatch_, getState) {
	                return __awaiter(undefined, void 0, void 0, regeneratorRuntime.mark(function _callee() {
	                    var s, result, resultMapped, _result;
	
	                    return regeneratorRuntime.wrap(function _callee$(_context) {
	                        while (1) {
	                            switch (_context.prev = _context.next) {
	                                case 0:
	                                    dispatch({ dashboard: true, type: "open overview for day by id", dayId: dayId });
	                                    s = getState();
	
	                                    if (!(s.keywords[dayId] && s.keywords[dayId].type == "has result" || !s.visits || !s.visits[dayId])) {
	                                        _context.next = 4;
	                                        break;
	                                    }
	
	                                    return _context.abrupt("return");
	
	                                case 4:
	                                    _context.prev = 4;
	                                    _context.next = 7;
	                                    return new commands_1.CommandCaller(props.getKeywordsURI).runPost('', {
	                                        date: s.visits[dayId].date
	                                    });
	
	                                case 7:
	                                    result = _context.sent;
	                                    resultMapped = utils_1.mapValues(result, function (a) {
	                                        var timeTotal = Number.parseFloat(a.timeTotal);
	                                        var visitsTotal = Number.parseInt(a.visitsTotal);
	                                        return {
	                                            bouncesTotal: Number.parseFloat(a.bouncesTotal),
	                                            keyword: a.keyword,
	                                            timeTotal: timeTotal,
	                                            uniquePageViewsTotal: Number.parseInt(a.uniquePageViewsTotal),
	                                            visitsTotal: visitsTotal,
	                                            averageTime: utils_1.secsToHMS(timeTotal / visitsTotal)
	                                        };
	                                    });
	
	                                    dispatch({ dashboard: true, type: "add to keyword cache", dayId: dayId, result: { type: "has result", result: resultMapped } });
	                                    _context.next = 17;
	                                    break;
	
	                                case 12:
	                                    _context.prev = 12;
	                                    _context.t0 = _context["catch"](4);
	                                    _result = {
	                                        type: "error",
	                                        error: "Unexpected error",
	                                        cause: "Loading the results"
	                                    };
	
	                                    dispatch({ dashboard: true, type: "add to keyword cache", dayId: dayId, result: _result });
	                                    console.log(_context.t0);
	
	                                case 17:
	                                case "end":
	                                    return _context.stop();
	                            }
	                        }
	                    }, _callee, this, [[4, 12]]);
	                }));
	            });
	        },
	        updateVisitsData: function updateVisitsData() {
	            return dispatch(function (dispatch_, getState) {
	                return __awaiter(undefined, void 0, void 0, regeneratorRuntime.mark(function _callee2() {
	                    var state, result;
	                    return regeneratorRuntime.wrap(function _callee2$(_context2) {
	                        while (1) {
	                            switch (_context2.prev = _context2.next) {
	                                case 0:
	                                    dispatch({ dashboard: true, type: "start obtaining dashboard data" });
	                                    state = getState();
	
	                                    if (state.includesNewVisitors && state.includesReturningVisitors) {
	                                        cookie_1.setCookie(props.cookieName, 'segments', '/', 30);
	                                    } else if (state.includesNewVisitors) {
	                                        cookie_1.setCookie(props.cookieName, 'newvisits', '/', 30);
	                                    } else if (state.includesReturningVisitors) {
	                                        cookie_1.setCookie(props.cookieName, 'returnvisits', '/', 30);
	                                    } else {
	                                        cookie_1.setCookie(props.cookieName, '', '/', 30);
	                                    }
	                                    _context2.prev = 3;
	                                    _context2.next = 6;
	                                    return new commands_1.CommandCaller(props.getDashboardDataURI).runPost('', {
	                                        fromDate: utils_1.dateToYYYYMMDD(state.fromDate),
	                                        toDate: utils_1.dateToYYYYMMDD(state.toDate)
	                                    });
	
	                                case 6:
	                                    result = _context2.sent;
	
	                                    dispatch({
	                                        dashboard: true,
	                                        type: "finished obtaining dashboard data",
	                                        data: {
	                                            ecommerce: result.ecommerce,
	                                            eventDetail: result.eventDetail,
	                                            contentDetail: result.contentDetail,
	                                            sourcesDetail: result.sourcesDetail,
	                                            keywordsDetail: result.keywordsDetail,
	                                            times: result.times.map(function (e) {
	                                                return {
	                                                    visits: Number.parseInt(e.visitsTotal),
	                                                    newVisits: Number.parseInt(e.newVisitsTotal),
	                                                    timeTotal: Number.parseInt(e.timeTotal)
	                                                };
	                                            }),
	                                            sources: result.sources && utils_1.maybeToInts(result.sources),
	                                            visits: result.visits.map(function (e) {
	                                                return Object.assign({}, e, { newVisits: Number.parseInt(e.newVisits), pageviews: Number.parseInt(e.pageviews), visits: Number.parseInt(e.visits) });
	                                            })
	                                        }
	                                    });
	                                    _context2.next = 14;
	                                    break;
	
	                                case 10:
	                                    _context2.prev = 10;
	                                    _context2.t0 = _context2["catch"](3);
	
	                                    dispatch({ dashboard: true, type: "aborted obtaining dashboard data" });
	                                    console.log(_context2.t0);
	
	                                case 14:
	                                case "end":
	                                    return _context2.stop();
	                            }
	                        }
	                    }, _callee2, this, [[3, 10]]);
	                }));
	            });
	        }
	    };
	};

/***/ },

/***/ 539:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(3);
	var utils_1 = __webpack_require__(4);
	var tabs_1 = __webpack_require__(611);
	var fixed_data_grid_1 = __webpack_require__(94);
	var modal_1 = __webpack_require__(95);
	var datePicker_1 = __webpack_require__(93);
	var help_button_1 = __webpack_require__(136);
	var react_chartjs_2_1 = __webpack_require__(468);
	exports.ApplyButton = function (props) {
	    return React.createElement("button", { type: "button", onClick: props.updateVisitsData }, "Apply");
	};
	var Keywords = function Keywords(p) {
	    return React.createElement("table", { className: "adminlist tablelist tablesorter", id: "topkeywords2", style: {
	            width: "100%",
	            border: 0
	        }, cellSpacing: 0, cellPadding: 5 }, React.createElement("thead", null, React.createElement("tr", null, React.createElement("th", null), React.createElement("th", { style: { width: "50%", textAlign: "left" } }, "Keyword"), React.createElement("th", { style: { width: "20%", textAlign: "right" } }, "Visits"), React.createElement("th", { style: { width: "30%", textAlign: "right" } }, "Avg. Time On Site"))), React.createElement("tbody", null, p.keywords.result.map(function (k, i) {
	        return React.createElement("tr", { key: i }, React.createElement("td", { style: { textAlign: "right" } }, i + 1, "."), React.createElement("td", { style: { width: "50%" } }, k.keyword), React.createElement("td", { style: { color: "#000", width: "20%", textAlign: "right" } }, k.visitsTotal), React.createElement("td", { style: { color: "#000", width: "30%", align: "right" } }, k.averageTime));
	    })));
	};
	var OverviewModal = function OverviewModal(p) {
	    var keywords = p.keywords;
	    var keywordsWidget = void 0;
	    switch (keywords.type) {
	        case "has result":
	            keywordsWidget = React.createElement(Keywords, Object.assign({}, p, { keywords: keywords }));
	            break;
	        case "loading":
	            keywordsWidget = React.createElement("img", { src: "/sb/static/images/loadergif.gif" });
	            break;
	        case "error":
	            keywordsWidget = React.createElement("p", null, "There was an error loading the top keywords data. Make sure your internet connection works, then try again. Try reloading the page. If the problem persists, consider reporting SB494A to AO tech support.");
	            break;
	    }
	    return React.createElement(modal_1.Modal, { style: {
	            width: 800,
	            height: 340
	        }, isOpen: true, title: "Overview of " + p.day.PopupDate, onRequestClose: p.onRequestCloseModal }, React.createElement("div", { id: "single" }, React.createElement("span", { style: {
	            color: p.visitsColor,
	            fontSize: "20px",
	            fontWeight: "bold"
	        } }, "Visits: ", p.day.visits), React.createElement("br", null), React.createElement("span", { style: { color: p.newVisitsColor } }, "New Visitors: ", p.day.newVisits), React.createElement("br", null), React.createElement("span", { style: { color: p.returningVisitsColor } }, "Returning Visitors: ", p.day.visits - p.day.newVisits), React.createElement("br", null), React.createElement("span", { style: { color: p.pageviewsColor } }, "Pageviews: ", p.day.pageviews), React.createElement("br", null), React.createElement("br", null), React.createElement("h3", { style: { margin: "0 0 5px", color: "#036" } }, "Top 5 Keywords"), keywordsWidget));
	};
	exports.Dashboard = function (p) {
	    return React.createElement("div", null, p.overviewing && React.createElement(OverviewModal, { visitsColor: p.visitsColor, returningVisitsColor: p.returningVisitsColor, newVisitsColor: p.newVisitsColor, pageviewsColor: p.pageviewsColor, day: p.overviewing, keywords: p.keywords, onRequestCloseModal: p.onRequestCloseOverview }), React.createElement("table", { cellSpacing: 0, cellPadding: 0, style: { borderBottom: "1px solid #ccc", width: 1000 } }, React.createElement("tbody", null, React.createElement("tr", null, React.createElement("td", null, React.createElement("h2", { className: "sbHeading" }, "Dashboard")), React.createElement("td", null, React.createElement("table", { style: { marginLeft: 'auto' } }, React.createElement("tbody", null, React.createElement("tr", null, React.createElement("td", null, p.loading == "loading" && React.createElement("img", { src: "/sb/static/images/loadergif.gif" }), p.loading == "failed" && React.createElement("img", { src: "/sb/static/images/icons/cross.gif" }), React.createElement("strong", null, "Segments:")), React.createElement("td", null, React.createElement("form", { style: { margin: 0 } }, React.createElement("label", { className: "checkbox", style: { color: "#666666" } }, React.createElement("input", { onChange: function onChange(e) {
	            return p.setNewVisitors(e.currentTarget.checked);
	        }, checked: p.includesNewVisitors, value: "1", type: "checkbox" }), "New Visitors"), React.createElement("label", { className: "checkbox", style: { color: "#666666" } }, React.createElement("input", { onChange: function onChange(e) {
	            return p.setReturningVisitors(e.currentTarget.checked);
	        }, checked: p.includesReturningVisitors, value: "2", type: "checkbox" }), "Returning Visitors"), React.createElement(exports.ApplyButton, Object.assign({}, p)))), React.createElement("td", { style: { paddingLeft: 20 } }, React.createElement("form", { style: { margin: 0 } }, React.createElement(datePicker_1.DatePicker, { onChange: function onChange(e, d) {
	            return p.setFromDate(d);
	        }, date: p.fromDate, readonly: false, invalid: false }), React.createElement(datePicker_1.DatePicker, { onChange: function onChange(e, d) {
	            return p.setToDate(d);
	        }, date: p.toDate, readonly: false, invalid: false }), React.createElement(exports.ApplyButton, Object.assign({}, p))))))))))), React.createElement("table", { cellSpacing: 0, cellPadding: 0, style: { width: "100%", border: 0 } }, React.createElement("tbody", null, React.createElement("tr", null, React.createElement("td", null, React.createElement("div", { id: "charts2" }, React.createElement("div", { id: "visitsDiv2", style: { width: 1000, height: 230 } }, React.createElement(react_chartjs_2_1.Line, { options: { maintainAspectRatio: false, legend: { position: 'bottom' }, title: { display: true, text: "Visits for all visitors" } }, onElementsClick: function onElementsClick(e) {
	            return e[0] && p.showDayById(e[0]._index);
	        }, data: { labels: p.labels, datasets: utils_1.removeNulls([{ data: p.visits, label: "Visits", borderColor: p.visitsColor, fill: false }, p.includesNewVisitors ? { data: p.newVisits, borderColor: p.newVisitsColor, fill: false, label: "New Visitors" } : undefined, p.includesReturningVisitors ? { data: p.returningVisits, borderColor: p.returningVisitsColor, fill: false, label: "Returning Visitors" } : undefined]) } }))))))), React.createElement("table", { style: { width: 1000, border: 0 }, cellSpacing: "0", cellPadding: "0" }, React.createElement("tbody", null, React.createElement("tr", { style: { height: 20 } }, React.createElement("td", { style: { height: 20 } })), React.createElement("tr", null, React.createElement("td", null, React.createElement("h2", { className: "sbHeading" }, "Site Usage"), React.createElement("table", { className: "ui-corner-all ui-widget-content", style: { width: "100%", background: "#eeeeee" }, cellSpacing: "0", cellPadding: "0" }, React.createElement("tbody", null, React.createElement("tr", null, React.createElement("td", null, React.createElement("table", { cellSpacing: "0", cellPadding: "0", style: { border: 0 } }, React.createElement("tbody", null, React.createElement("tr", null, React.createElement("td", { style: { padding: "10px 0 10px 15px" } }, React.createElement("h4", { style: { margin: 0 } }, "Visits: ", utils_1.formatInt(p.totalVisits), " ", React.createElement(help_button_1.HelpButton, { message: "The number of visits to your site." }), "\t\t\t\t\t\t\t\t\t")), React.createElement("td", { style: { padding: "10px 0 10px 15px" } }, React.createElement("h4", { style: { margin: 0, color: p.newVisitsColor } }, "New Visitors: ", utils_1.formatInt(p.totalNewVisits), " ", React.createElement(help_button_1.HelpButton, { message: "The number of new visitors to your site." }), "\t\t\t\t\t\t\t\t\t")), React.createElement("td", { style: { padding: "10px 0 10px 15px" } }, React.createElement("h4", { style: { margin: 0, color: p.returningVisitsColor } }, "Returning Visitors: ", utils_1.formatInt(p.totalReturningVisits), " ", React.createElement(help_button_1.HelpButton, { message: "The number of returning visitors to your site." }), "\t\t\t\t\t\t\t\t")), React.createElement("td", { style: { padding: "10px 0 10px 15px" } }, React.createElement("h4", { style: { margin: 0, color: p.pageviewsColor } }, "Pageviews: ", utils_1.formatInt(p.totalPageviews), " ", React.createElement(help_button_1.HelpButton, { message: "The total number of pages viewed. Repeated views of a single page are counted." }), "\t\t\t\t\t\t\t\t")), React.createElement("td", { style: { padding: "10px 0 10px 15px" } }, React.createElement("h4", { style: { margin: 0, color: "#000" } }, "Avg. Time on Site: ", utils_1.secsToHMS(p.averageTimeOnSite), " ", React.createElement(help_button_1.HelpButton, { message: "The average duration of a visit to your site." }), "\t\t\t\t\t\t\t\t")), React.createElement("td", { style: { padding: "10px 0 10px 15px" } }, React.createElement("h4", { style: { margin: 0, color: "#f00" } }, React.createElement("span", { style: { color: "#999", fontSize: "11px", fontStyle: "normal" } }, "Pages Per Visit:"), " ", utils_1.formatFloat(p.pagesPerVisit, 2), " ", React.createElement(help_button_1.HelpButton, { message: "The average number of pages viewed during a visit to your site. Repeated views of a single page are counted." }), "\t\t\t\t\t\t\t\t"))))))))), React.createElement("div", { id: "helpdialog" }, React.createElement("div", { className: "helpmessage" })))))), React.createElement("table", null, React.createElement("tbody", null, React.createElement("tr", { style: { height: 20 } }, React.createElement("td", { style: { height: 20 } })), React.createElement("tr", null, React.createElement("td", null, React.createElement("h2", { className: "sbHeading" }, "Pageviews"), React.createElement("div", { id: "pageviewsDiv2", style: { width: 490, height: 230 } }, React.createElement(react_chartjs_2_1.Line, { options: { maintainAspectRatio: false, legend: { display: false }, title: { display: true, text: "Pageviews for all visitors" } }, onElementsClick: function onElementsClick(e) {
	            return e[0] && p.showDayById(e[0]._index);
	        }, data: { labels: p.labels, datasets: [{ data: p.pageviews, label: "Pageviews", borderColor: p.pageviewsColor, fill: false }] } }))), React.createElement("td", { style: { width: 20 } }), React.createElement("td", null, React.createElement("h2", { className: "sbHeading" }, "Traffic Sources Overview"), React.createElement("div", { id: "trafficDiv2", style: { width: 490, height: 230 } }, p.sources && React.createElement(TrafficSourcesPie, { data: p.sources, directColor: p.directColor, searchColor: p.searchColor, otherColor: p.otherColor, referringColor: p.referringColor })))), React.createElement("tr", { style: { height: 20 } }, React.createElement("td", { style: { height: 20 } })))), React.createElement(Tabs, { active: p.activeTab, onActivate: p.switchTab }, React.createElement(Panel, { name: "Top Traffic Sources", id: "traffic sources" }, React.createElement(DatagridPanel, { makeRow: makeSourceRow, headings: trafficSourcesHeadings, index: 'traffic sources', title: "Top Traffic Sources", data: p.tabs, callbacks: p.paginationCallbacks })), React.createElement(Panel, { name: "Top Keywords", id: "keywords" }, React.createElement(DatagridPanel, { makeRow: makeKeywordRow, headings: keywordsHeadings, index: "keywords", title: "Top Keywords", data: p.tabs, callbacks: p.paginationCallbacks })), React.createElement(Panel, { name: "Content Overview", id: "content" }, React.createElement(DatagridPanel, { makeRow: makeContentOverviewRow, headings: contentOverviewHeadings, index: 'content', title: "Content Overview", data: p.tabs, callbacks: p.paginationCallbacks })), p.hasEventTracking && React.createElement(Panel, { name: "Event Tracking Overview", id: "event detail" }, React.createElement(DatagridPanel, { makeRow: makeContentOverviewRow, headings: contentOverviewHeadings, index: 'event detail', title: "Event Tracking Overview", data: p.tabs, callbacks: p.paginationCallbacks })), p.hasEcommerceTracking && React.createElement(Panel, { name: "Ecommerce Overview", id: "ecommerce" }, React.createElement(DatagridPanel, { makeRow: makeEcommerceRow, headings: ecommerceOverviewHeadings, index: 'ecommerce', title: "Ecommerce Overview", data: p.tabs, callbacks: p.paginationCallbacks }))));
	};
	var makeKeywordRow = function makeKeywordRow(d) {
	    return {
	        id: { node: d.i + ".", alignment: "right" },
	        data: { node: d.keyword, alignment: "left", minWidth: "48%" },
	        visits: { node: d.visitsTotal + "", alignment: "right", minWidth: "18%" },
	        time: { node: utils_1.secsToHMS(d.avgTime), alignment: "right", minWidth: "28%" }
	    };
	};
	var makeSourceRow = function makeSourceRow(i) {
	    return {
	        id: { node: i.i + ".", alignment: "right" },
	        data: { node: React.createElement("span", null, i.source, " ", React.createElement("span", { style: { color: "#777" } }, i.medium)), alignment: "left", minWidth: "48%" },
	        visits: { node: i.visits + "", alignment: "right", minWidth: "18%" },
	        time: { node: utils_1.secsToHMS(i.avgTimeOnSite), alignment: "right", minWidth: "28%" }
	    };
	};
	var makeEcommerceRow = function makeEcommerceRow(i) {
	    return {
	        id: { node: i.i + ".", alignment: "right" },
	        data: { node: React.createElement("span", null, i.productName), alignment: "left", minWidth: "48%" },
	        visits: { node: "" + i.uniquePurchasesTotal, alignment: "right", minWidth: "18%" },
	        time: { node: "$" + i.itemRevenueTotal, alignment: "right", minWidth: "28%" }
	    };
	};
	var makeContentOverviewRow = function makeContentOverviewRow(i) {
	    return {
	        id: { node: i.i + ".", alignment: "right" },
	        time: { node: utils_1.secsToHMS(i.time), alignment: "right", minWidth: "28%" },
	        data: { alignment: "left", minWidth: "48%",
	            node: React.createElement("span", null, React.createElement("a", { href: i.url, target: "_new", title: "View this link" }, React.createElement("img", { src: "/sb/static/images/url_icon.gif" })), " ", i.maintitle, React.createElement("span", { style: { color: "#777" } }, "(", i.greytitle, ")"))
	        },
	        visits: { node: i.pageviewsTotal, alignment: "right", minWidth: "18%" }
	    };
	};
	var DatagridPanel = function DatagridPanel(p) {
	    var Grid = GridMaker(p.makeRow, p.headings);
	    var data = p.data[p.index];
	    return React.createElement("span", null, React.createElement("h3", { style: { margin: "0 0 5px", color: "#036" } }, p.title), data.data ? React.createElement(Grid, { pagination: Object.assign({}, data.pagination, p.callbacks(p.index)), data: data.data }) : React.createElement("span", null, "No data to display"));
	};
	var Tabs = tabs_1.Tabs;
	var Panel = tabs_1.Panel;
	var GridMaker = function GridMaker(makeRow, headings) {
	    return function (props) {
	        return React.createElement(PaginatedDataGridOfFields, Object.assign({}, props.pagination, { heading: headings, data: props.data.map(makeRow) }));
	    };
	};
	
	var PaginatedDataGridOfFields = function (_fixed_data_grid_1$Pa) {
	    _inherits(PaginatedDataGridOfFields, _fixed_data_grid_1$Pa);
	
	    function PaginatedDataGridOfFields() {
	        _classCallCheck(this, PaginatedDataGridOfFields);
	
	        return _possibleConstructorReturn(this, (PaginatedDataGridOfFields.__proto__ || Object.getPrototypeOf(PaginatedDataGridOfFields)).apply(this, arguments));
	    }
	
	    return PaginatedDataGridOfFields;
	}(fixed_data_grid_1.PaginatedDataGrid);
	
	var keywordsHeadings = { id: "", data: "Keyword", visits: "Visits", time: "Avg. Time On Site" };
	var trafficSourcesHeadings = { id: "", data: "Source/Medium", visits: "Visits", time: "Avg. Time On Site" };
	var contentOverviewHeadings = { id: "", data: "Page", visits: "Pageviews", time: "Avg. Time On Site" };
	var ecommerceOverviewHeadings = { id: "", data: "Product", visits: "Quantity", time: "Product Revenue" };
	var TrafficSourcesPie = function TrafficSourcesPie(props) {
	    return React.createElement(react_chartjs_2_1.Pie, { data: {
	            datasets: [{
	                backgroundColor: [props.searchColor, props.referringColor, props.directColor, props.otherColor],
	                data: [props.data.organicTotal || 0, props.data.referralTotal || 0, props.data.noneTotal || 0, props.data.otherTotal || 0]
	            }],
	            labels: ["Search Engines", "Referring Sites", "Direct Traffic", "Other"]
	        } });
	};

/***/ },

/***/ 540:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var utils_1 = __webpack_require__(4);
	exports.reducer = function (s, a) {
	    console.log(s, "this is the dashboard state");
	    if (!a) {
	        return s;
	    }
	    switch (a.type) {
	        case "set new visitors checked":
	            return Object.assign({}, s, { includesNewVisitors: a.to });
	        case "set returning visitors checked":
	            return Object.assign({}, s, { includesReturningVisitors: a.to });
	        case "switch tab":
	            return Object.assign({}, s, { activeTab: a.tab });
	        case "set from date":
	            return utils_1.debug(Object.assign({}, s, { fromDate: a.date }));
	        case "set to date":
	            return Object.assign({}, s, { toDate: a.date });
	        case "start obtaining dashboard data":
	            return Object.assign({}, s, { loading: "loading" });
	        case "aborted obtaining dashboard data":
	            return Object.assign({}, s, { loading: "failed" });
	        case "finished obtaining dashboard data":
	            return Object.assign({}, s, { visits: a.data.visits, times: a.data.times, sources: a.data.sources, loading: "done", tabs: {
	                    'traffic sources': Object.assign({}, s.tabs['traffic sources'], { pagination: Object.assign({}, s.tabs['traffic sources'].pagination, { page: 1 }), data: a.data.sourcesDetail }),
	                    'keywords': Object.assign({}, s.tabs['keywords'], { pagination: Object.assign({}, s.tabs['keywords'].pagination, { page: 1 }), data: a.data.keywordsDetail }),
	                    'content': Object.assign({}, s.tabs['content'], { pagination: Object.assign({}, s.tabs['content'].pagination, { page: 1 }), data: a.data.contentDetail }),
	                    'event detail': Object.assign({}, s.tabs['event detail'], { pagination: Object.assign({}, s.tabs['event detail'].pagination, { page: 1 }), data: a.data.eventDetail }),
	                    'ecommerce': Object.assign({}, s.tabs['ecommerce'], { pagination: Object.assign({}, s.tabs['ecommerce'].pagination, { page: 1 }), data: a.data.ecommerce })
	                } });
	        case "set limit":
	            return function () {
	                var tabs = Object.assign({}, s.tabs);
	                tabs[a.on].pagination.limit = a.limit;
	                return Object.assign({}, s, { tabs: tabs });
	            }();
	        case "set page":
	            return function () {
	                var tabs = Object.assign({}, s.tabs);
	                tabs[a.on].pagination.page = a.page;
	                return Object.assign({}, s, { tabs: tabs });
	            }();
	        case "open overview for day by id":
	            return Object.assign({}, s, { overviewing: a.dayId });
	        case "close overview":
	            return Object.assign({}, s, { overviewing: undefined });
	        case "add to keyword cache":
	            var keywords = Object.assign({}, s.keywords);
	            keywords[a.dayId] = a.result;
	            return Object.assign({}, s, { keywords: keywords });
	    }
	};

/***/ },

/***/ 541:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(3);
	var ReactDOM = __webpack_require__(6);
	var redux_thunk_1 = __webpack_require__(33);
	var redux_1 = __webpack_require__(22);
	var utils_1 = __webpack_require__(4);
	var common_1 = __webpack_require__(134);
	var data_1 = __webpack_require__(178);
	var app_1 = __webpack_require__(544);
	var reducers_1 = __webpack_require__(546);
	var presentation_1 = __webpack_require__(542);
	var data_2 = __webpack_require__(110);
	var data_3 = __webpack_require__(262);
	exports.list = function (replace, params) {
	    var columns = data_2.toColumn(params.columns);
	    var ownProps = function ownProps(store) {
	        return {
	            store: store,
	            columns: columns,
	            templateId: params.templateId,
	            ajaxPageUrl: params.ajaxPageUrl,
	            editArticleTemplatePageUrl: params.editArticleTemplatePageUrl
	        };
	    };
	    var initialState = {
	        layout: data_1.layoutFromTemplates(params.articleTemplates, columns),
	        selected: [],
	        toolbar: {
	            canEdit: false,
	            canMulti: false
	        }
	    };
	    var div = document.createElement('div');
	    replace(div);
	    var store = redux_1.createStore(utils_1.withDefault(reducers_1.reducer, initialState), initialState, redux_1.applyMiddleware(redux_thunk_1.default));
	    ReactDOM.render(React.createElement(app_1.ArticleTemplateListApp, Object.assign({}, ownProps(store))), div);
	};
	//todo: refresh this grid if the user copies/deletes some articles (will likely need to create and expose a store)
	exports.listReadOnly = function (replace, params) {
	    var div = document.createElement('div');
	    replace(div);
	    ReactDOM.render(React.createElement(presentation_1.ReadOnlyArticleTemplateList, { articleTemplates: data_3.templatesFromPHPTemplates(params.articleTemplates, data_2.toColumn(params.columns)), viewArticle: function viewArticle(id) {
	            return common_1.redirect({ pageUrl: params.viewArticleTemplatePageUrl + "/" + id });
	        } }), div);
	};

/***/ },

/***/ 542:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(3);
	exports.ReadOnlyArticleTemplateList = function (props) {
	    //todo: replace with fixed data grid if possible
	    return React.createElement("div", null, React.createElement(LayoutGrid, { articleTemplates: props.articleTemplates, viewArticle: props.viewArticle }));
	};
	var LayoutGrid = function LayoutGrid(props) {
	    return React.createElement("div", { className: "dataGridPanel sbRoundedEdges", style: { width: '100%' } }, React.createElement("table", { className: "dataGrid sbRoundedEdges", style: { width: '100%' }, cellSpacing: "0", cellPadding: "2" }, React.createElement("thead", null, React.createElement("tr", { className: "dataGridTitlebar sbRoundedEdges", style: { height: '30px' } }, React.createElement("th", { style: { width: '40px', textAlign: 'center' } }, "#"), React.createElement("th", { style: { textAlign: 'left' } }, "Title"), React.createElement("th", { style: { width: '80px', textAlign: 'center' } }, "Column"), React.createElement("th", { style: { width: '80px', textAlign: 'center' } }, "Priority"))), React.createElement("tbody", null, props.articleTemplates.map(function (a, i) {
	        return React.createElement(ArticleTemplateRow, Object.assign({ key: "article-" + a.id }, a, { rowClass: i % 2 ? 'row1' : 'row0', viewArticle: props.viewArticle }));
	    }))));
	};
	var ArticleTemplateRow = function ArticleTemplateRow(props) {
	    var viewOnClick = function viewOnClick() {
	        return props.viewArticle(props.id);
	    };
	    return React.createElement("tr", { className: props.rowClass, onClick: viewOnClick }, React.createElement("td", { style: { textAlign: 'center', cursor: 'pointer' } }, props.id), React.createElement("td", { style: { textAlign: 'left', cursor: 'pointer' } }, props.title), React.createElement("td", { style: { textAlign: 'center', cursor: 'pointer' } }, props.column), React.createElement("td", { style: { textAlign: 'center', cursor: 'pointer' } }, props.priority));
	};

/***/ },

/***/ 543:
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.isListAction = function (a) {
	  return a.type == 'list action';
	};

/***/ },

/***/ 544:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) {
	            try {
	                step(generator.next(value));
	            } catch (e) {
	                reject(e);
	            }
	        }
	        function rejected(value) {
	            try {
	                step(generator["throw"](value));
	            } catch (e) {
	                reject(e);
	            }
	        }
	        function step(result) {
	            result.done ? resolve(result.value) : new P(function (resolve) {
	                resolve(result.value);
	            }).then(fulfilled, rejected);
	        }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var react_redux_1 = __webpack_require__(23);
	var presentation_1 = __webpack_require__(545);
	var data_1 = __webpack_require__(178);
	var utils_1 = __webpack_require__(4);
	var commands_1 = __webpack_require__(12);
	var common_1 = __webpack_require__(134);
	var data_2 = __webpack_require__(110);
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	    var articleTemplates = utils_1.objToList(data_2.restrictColumn(ownProps.columns), state.layout).sort(data_2.sortByColumnAndPriority);
	    return {
	        articleTemplates: articleTemplates,
	        selected: state.selected,
	        columns: ownProps.columns,
	        priorities: data_1.maxPrioritiesFromList(articleTemplates),
	        canEdit: state.toolbar.canEdit,
	        canMulti: state.toolbar.canMulti
	    };
	};
	var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
	    var wrap = function wrap(action) {
	        return {
	            type: 'list action',
	            action: action
	        };
	    };
	    var dispatchAction = utils_1.compose(wrap, dispatch);
	    return {
	        selectAll: function selectAll() {
	            return dispatchAction({ type: 'select all article templates' });
	        },
	        unselectAll: function unselectAll() {
	            return dispatchAction({ type: 'unselect all article templates' });
	        },
	        select: function select(id) {
	            return dispatchAction({ type: 'select article template', id: id });
	        },
	        unselect: function unselect(id) {
	            return dispatchAction({ type: 'unselect article template', id: id });
	        },
	        changeColumn: function changeColumn(id, column) {
	            return dispatchAction({ type: 'change column', id: id, column: column });
	        },
	        changePriority: function changePriority(id, priority) {
	            return dispatchAction({ type: 'change priority', id: id, priority: priority });
	        },
	        addArticle: function addArticle() {
	            return common_1.redirect({ pageUrl: ownProps.editArticleTemplatePageUrl });
	        },
	        editArticle: function editArticle(id) {
	            return common_1.redirect({ pageUrl: ownProps.editArticleTemplatePageUrl + "/" + id });
	        },
	        editSelectedArticle: function editSelectedArticle() {
	            return dispatch(function (dispatchUnwrapped, getState) {
	                return __awaiter(undefined, void 0, void 0, regeneratorRuntime.mark(function _callee() {
	                    var id;
	                    return regeneratorRuntime.wrap(function _callee$(_context) {
	                        while (1) {
	                            switch (_context.prev = _context.next) {
	                                case 0:
	                                    id = getState().selected[0];
	
	                                    common_1.redirect({ pageUrl: ownProps.editArticleTemplatePageUrl + "/" + id });
	
	                                case 2:
	                                case "end":
	                                    return _context.stop();
	                            }
	                        }
	                    }, _callee, this);
	                }));
	            });
	        },
	        copyArticles: function copyArticles() {
	            return dispatch(function (dispatchUnwrapped, getState) {
	                return __awaiter(undefined, void 0, void 0, regeneratorRuntime.mark(function _callee2() {
	                    var s, r;
	                    return regeneratorRuntime.wrap(function _callee2$(_context2) {
	                        while (1) {
	                            switch (_context2.prev = _context2.next) {
	                                case 0:
	                                    s = getState();
	                                    _context2.next = 3;
	                                    return new commands_1.CommandCaller(ownProps.ajaxPageUrl).runPost('copy article templates', { templateId: ownProps.templateId, ids: s.selected });
	
	                                case 3:
	                                    r = _context2.sent;
	
	                                    dispatchAction({ type: 'add copied article templates', copiedArticleTemplates: r.copiedArticleTemplates });
	
	                                case 5:
	                                case "end":
	                                    return _context2.stop();
	                            }
	                        }
	                    }, _callee2, this);
	                }));
	            });
	        },
	        deleteArticles: function deleteArticles() {
	            return dispatch(function (dispatchUnwrapped, getState) {
	                return __awaiter(undefined, void 0, void 0, regeneratorRuntime.mark(function _callee3() {
	                    var s, plural;
	                    return regeneratorRuntime.wrap(function _callee3$(_context3) {
	                        while (1) {
	                            switch (_context3.prev = _context3.next) {
	                                case 0:
	                                    s = getState();
	                                    plural = s.selected.length > 1 ? 's' : '';
	
	                                    if (!confirm("Are you sure you want to permanently delete the selected article template" + plural + "?")) {
	                                        _context3.next = 6;
	                                        break;
	                                    }
	
	                                    _context3.next = 5;
	                                    return new commands_1.CommandCaller(ownProps.ajaxPageUrl).runPost('delete article templates', { templateId: ownProps.templateId, ids: s.selected });
	
	                                case 5:
	                                    dispatchAction({ type: 'delete article templates', deletedArticleTemplateIds: s.selected });
	
	                                case 6:
	                                case "end":
	                                    return _context3.stop();
	                            }
	                        }
	                    }, _callee3, this);
	                }));
	            });
	        }
	    };
	};
	exports.ArticleTemplateListApp = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(presentation_1.ArticleTemplateList);

/***/ },

/***/ 545:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(3);
	var checkbox_1 = __webpack_require__(92);
	var select_1 = __webpack_require__(39);
	var utils_1 = __webpack_require__(4);
	var data_1 = __webpack_require__(110);
	exports.ArticleTemplateList = function (props) {
	    //todo: replace with fixed data grid if possible
	    return React.createElement("div", null, React.createElement(Toolbar, { canEdit: props.canEdit, canMulti: props.canMulti, addArticle: props.addArticle, editSelectedArticle: props.editSelectedArticle, copyArticles: props.copyArticles, deleteArticles: props.deleteArticles }), React.createElement(LayoutGrid, { articleTemplates: props.articleTemplates, selected: props.selected, columns: props.columns, priorities: props.priorities, editArticle: props.editArticle, selectAll: props.selectAll, unselectAll: props.unselectAll, select: props.select, unselect: props.unselect, changeColumn: props.changeColumn, changePriority: props.changePriority }));
	};
	var Toolbar = function Toolbar(props) {
	    return React.createElement("div", { className: "sbToolbar sbRoundedEdges" }, React.createElement(ToolbarButton, { imgName: 'addIcon.png', disabled: false, onClick: props.addArticle }), React.createElement(ToolbarButton, { imgName: props.canEdit ? 'editIcon.png' : 'editIconDisabled.png', disabled: !props.canEdit, onClick: props.editSelectedArticle }), React.createElement(ToolbarButton, { imgName: props.canMulti ? 'copy.png' : 'copyDisabled.png', disabled: !props.canMulti, onClick: props.copyArticles }), React.createElement(ToolbarButton, { imgName: props.canMulti ? 'deleteIcon.png' : 'deleteIconDisabled.png', disabled: !props.canMulti, onClick: props.deleteArticles }));
	};
	var ToolbarButton = function ToolbarButton(props) {
	    var onClick = !props.disabled ? { onClick: props.onClick } : {};
	    return React.createElement("button", Object.assign({}, onClick, { disabled: props.disabled, className: "sbToolbarButton", style: { backgroundImage: "url('/sb/static/images/icons/" + props.imgName + "')" }, type: "button" }));
	};
	var LayoutGrid = function LayoutGrid(props) {
	    var imgStyle = { cursor: 'pointer', width: '16px', height: '16px' };
	    return React.createElement("div", { className: "dataGridPanel sbRoundedEdges", style: { width: '100%' } }, React.createElement("table", { className: "dataGrid sbRoundedEdges", style: { width: '100%' }, cellSpacing: "0", cellPadding: "2" }, React.createElement("thead", null, React.createElement("tr", { className: "dataGridTitlebar sbRoundedEdges", style: { height: '30px' } }, React.createElement("th", { style: { width: '40px', textAlign: 'center' } }, React.createElement("img", { src: '/sb/static/images/icons/delete.png', title: 'check all boxes', style: imgStyle, onClick: props.unselectAll }), React.createElement("img", { src: '/sb/static/images/icons/accept.png', title: 'uncheck all boxes', style: imgStyle, onClick: props.selectAll })), React.createElement("th", { style: { width: '40px', textAlign: 'center' } }, "#"), React.createElement("th", { style: { textAlign: 'left' } }, "Title"), React.createElement("th", { style: { width: '80px', textAlign: 'center' } }, "Column"), React.createElement("th", { style: { width: '80px', textAlign: 'center' } }, "Priority"))), React.createElement("tbody", null, props.articleTemplates.map(function (a, i) {
	        var checked = props.selected.find(function (id) {
	            return id === a.id;
	        }) !== undefined;
	        return React.createElement(ArticleTemplateRow, Object.assign({ key: "article-" + a.id }, a, { rowClass: checked ? 'rowOn' : i % 2 ? 'row1' : 'row0', checked: checked, editArticle: props.editArticle, onSelectChange: checked ? props.unselect : props.select, onColumnChange: props.changeColumn, onPriorityChange: props.changePriority, maxColumn: props.columns, maxPriority: props.priorities[a.column] }));
	    }))));
	};
	var ArticleTemplateRow = function ArticleTemplateRow(props) {
	    var editOnClick = function editOnClick() {
	        return props.editArticle(props.id);
	    };
	    return React.createElement("tr", { className: props.rowClass }, React.createElement("td", { style: { textAlign: 'center', cursor: 'pointer' } }, React.createElement(checkbox_1.Checkbox, { checked: props.checked, onChange: function onChange() {
	            return props.onSelectChange(props.id);
	        } })), React.createElement("td", { style: { textAlign: 'center', cursor: 'pointer' }, onClick: editOnClick }, props.id), React.createElement("td", { style: { textAlign: 'left', cursor: 'pointer' }, onClick: editOnClick }, props.title), React.createElement("td", { style: { textAlign: 'center', cursor: 'pointer' } }, React.createElement(select_1.SingleBox, { value: props.column, onChange: function onChange(c) {
	            return props.onColumnChange(props.id, data_1.isColumn(c) ? c : '1');
	        }, name: "c-" + props.id }, utils_1.range(1, parseInt(props.maxColumn)).map(function (column) {
	        return React.createElement("option", { key: "c-" + props.id + "-" + column, value: utils_1.toString(column) }, column);
	    }))), React.createElement("td", { style: { textAlign: 'center', cursor: 'pointer' } }, React.createElement(select_1.SingleBox, { value: utils_1.toString(props.priority), onChange: function onChange(p) {
	            return props.onPriorityChange(props.id, parseInt(p));
	        }, name: "p-" + props.id }, utils_1.range(1, props.maxPriority).map(function (priority) {
	        return React.createElement("option", { key: "p-" + props.id + "-" + priority, value: utils_1.toString(priority) }, priority);
	    }))));
	};

/***/ },

/***/ 546:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var R = __webpack_require__(62);
	var data_1 = __webpack_require__(178);
	var actions_1 = __webpack_require__(543);
	var utils_1 = __webpack_require__(4);
	var data_2 = __webpack_require__(110);
	exports.reducer = function (s, a) {
	    if (actions_1.isListAction(a)) {
	        return listReducer(s, a.action);
	    }
	    return s;
	};
	var listReducer = function listReducer(s, a) {
	    var _ret = function () {
	        switch (a.type) {
	            case "select all article templates":
	                var s1 = utils_1.objToList(function (a) {
	                    return a.id;
	                }, s.layout);
	                return {
	                    v: Object.assign({}, s, { selected: s1, toolbar: toolbarState(s1) })
	                };
	            case "unselect all article templates":
	                var s2 = [];
	                return {
	                    v: Object.assign({}, s, { selected: s2, toolbar: toolbarState(s2) })
	                };
	            case "select article template":
	                var s3 = [a.id].concat(s.selected);
	                return {
	                    v: Object.assign({}, s, { selected: s3, toolbar: toolbarState(s3) })
	                };
	            case "unselect article template":
	                var s4 = s.selected.filter(function (id) {
	                    return id != a.id;
	                });
	                return {
	                    v: Object.assign({}, s, { selected: s4, toolbar: toolbarState(s4) })
	                };
	            case "change column":
	                var p = 1;
	                var oldColumn = s.layout[a.id].column;
	                return {
	                    v: Object.assign({}, s, { layout: utils_1.reduceToObj(function (articleTemplate) {
	                            return articleTemplate.id;
	                        }, function (articleTemplate) {
	                            var x = Object.assign({}, articleTemplate);
	                            if (articleTemplate.id === a.id) {
	                                x['column'] = a.column;
	                                x['priority'] = data_1.maxPrioritiesFromLayout(s.layout)[a.column] + 1;
	                            } else if (articleTemplate.column === oldColumn) {
	                                x['priority'] = p++;
	                            }
	                            return x;
	                        }, utils_1.objToList(function (a) {
	                            return a;
	                        }, s.layout).sort(data_2.sortByColumnAndPriority)) })
	                };
	            case "change priority":
	                var article1 = s.layout[a.id];
	                var article2 = exports.findArticleInColumnWithPriority(s.layout, article1.column, a.priority);
	                var article2New = article2 !== undefined ? _defineProperty({}, article2.id, Object.assign({}, article2, { priority: article1.priority })) : {};
	                return {
	                    v: Object.assign({}, s, { layout: Object.assign({}, s.layout, article2New, _defineProperty({}, article1.id, Object.assign({}, article1, { priority: a.priority }))) })
	                };
	            case "add copied article templates":
	                var newLayout = Object.assign({}, s.layout);
	                a.copiedArticleTemplates.forEach(function (a) {
	                    var id = a.id.toString();
	                    newLayout[id] = {
	                        id: id,
	                        title: a.title,
	                        column: data_2.toColumn(a.column),
	                        priority: a.priority
	                    };
	                });
	                return {
	                    v: Object.assign({}, s, { layout: newLayout })
	                };
	            case "delete article templates":
	                var s5 = s.selected.filter(function (id) {
	                    return !R.contains(id, a.deletedArticleTemplateIds);
	                });
	                return {
	                    v: Object.assign({}, s, { selected: s5, layout: R.omit(a.deletedArticleTemplateIds, s.layout), toolbar: toolbarState(s5) })
	                };
	        }
	    }();
	
	    if ((typeof _ret === "undefined" ? "undefined" : _typeof(_ret)) === "object") return _ret.v;
	};
	exports.findArticleInColumnWithPriority = function (layout, column, priority) {
	    return utils_1.findInObj(function (a) {
	        return a.column === column && a.priority === priority;
	    }, layout);
	};
	var toolbarState = function toolbarState(selected) {
	    return {
	        canEdit: selected.length === 1,
	        canMulti: selected.length >= 1
	    };
	};

/***/ },

/***/ 547:
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.SetSessionOnChange = function (callback, params) {
	    $(function () {
	        var target = $("#" + params.inputId);
	        target.change(function () {
	            setCommunicationsSessionVar(params.table, params.field, target.val());
	        });
	    });
	};

/***/ },

/***/ 548:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var Message_ = __webpack_require__(549);
	var Template_ = __webpack_require__(554);
	var ArticleTemplate_ = __webpack_require__(541);
	var common_1 = __webpack_require__(547);
	exports.Message = Message_;
	exports.Template = Template_;
	exports.ArticleTemplate = ArticleTemplate_;
	exports.SetSessionOnChange = common_1.SetSessionOnChange;

/***/ },

/***/ 549:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(3);
	var $ = __webpack_require__(10);
	var ajax_1 = __webpack_require__(111);
	var ReactDOM = __webpack_require__(6);
	var app_1 = __webpack_require__(551);
	var utils_1 = __webpack_require__(4);
	var redux_1 = __webpack_require__(22);
	var reducers_1 = __webpack_require__(553);
	var redux_thunk_1 = __webpack_require__(33);
	var data_1 = __webpack_require__(597);
	function getCommunicationRecipientList(page, messageId, hasSubscriptions) {
	    var querySelections = $("input[name='selectedQueries']").val();
	    var subSelections = !hasSubscriptions ? '' : $("input[name='subscriptions[]']:checked").map(function () {
	        return $(this).val();
	    }).get().join();
	    if (querySelections.length > 0) {
	        $('#tempRecipientListDiv').attr('style', 'visibility: hidden;');
	        $('#tempRecipientListLoadingDiv').attr('style', 'display: block; width: 300px; text-align: center;');
	        var params = Object.assign({
	            command: 'createTempRecipientList',
	            messageId: messageId,
	            noheaders: 1,
	            queries: querySelections
	        }, subSelections ? { subSelections: subSelections } : {});
	        new ajax_1.AjaxRequest(page).runGet(params).then(function () {
	            afterCommunicationRecipientList();
	        });
	    }
	}
	exports.getCommunicationRecipientList = getCommunicationRecipientList;
	var queryFromCallJsQuery = function queryFromCallJsQuery(q) {
	    return {
	        id: +q.id,
	        instance: q.instance,
	        title: q.title,
	        owner: q.owner
	    };
	};
	var queryCategoryMapFromCallJsQueryCategoryMap = function queryCategoryMapFromCallJsQueryCategoryMap(map) {
	    return Object.keys(map).reduce(function (acc, k) {
	        acc[+k] = map[k].map(function (m) {
	            return +m;
	        });
	        return acc;
	    }, {});
	};
	exports.queriesWidget = function (replace, params) {
	    var queries = params.queries.map(queryFromCallJsQuery);
	    var queryCategoryMap = queryCategoryMapFromCallJsQueryCategoryMap(params.queryCategoryMap);
	    var ownProps = function ownProps(store) {
	        return {
	            store: store,
	            categories: params.categories.map(data_1.categoryFromCallJsCategory),
	            queries: queries,
	            queryCategoryMap: queryCategoryMap
	        };
	    };
	    var initialState = {
	        selectedCategories: [],
	        selectedQueries: params.selectedQueries,
	        visibleQueries: queries.map(function (q) {
	            return q.id;
	        }),
	        titleMap: titleMap(queries)
	    };
	    var div = document.createElement('div');
	    replace(div);
	    var store = redux_1.createStore(utils_1.withDefault(reducers_1.reducer(queries, queryCategoryMap), initialState), initialState, redux_1.applyMiddleware(redux_thunk_1.default));
	    ReactDOM.render(React.createElement(app_1.QueriesWidgetApp, Object.assign({}, ownProps(store))), div);
	};
	var titleMap = function titleMap(queries) {
	    return queries.reduce(function (acc, v) {
	        var instance = v.instance != '' ? v.instance + ": " : '';
	        var owner = v.owner != '' ? " (Owner: <strong>" + v.owner + "</strong>)" : '';
	        acc[v.id] = "" + instance + v.title + owner;
	        return acc;
	    }, {});
	};

/***/ },

/***/ 550:
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.isQueriesWidgetAction = function (a) {
	  return a.type == 'queries widget action';
	};

/***/ },

/***/ 551:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) {
	            try {
	                step(generator.next(value));
	            } catch (e) {
	                reject(e);
	            }
	        }
	        function rejected(value) {
	            try {
	                step(generator["throw"](value));
	            } catch (e) {
	                reject(e);
	            }
	        }
	        function step(result) {
	            result.done ? resolve(result.value) : new P(function (resolve) {
	                resolve(result.value);
	            }).then(fulfilled, rejected);
	        }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var R = __webpack_require__(62);
	var react_redux_1 = __webpack_require__(23);
	var presentation_1 = __webpack_require__(552);
	var utils_1 = __webpack_require__(4);
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	    return Object.assign({}, R.omit(['titleMap', 'visibleQueries'], state), { categories: ownProps.categories, queries: ownProps.queries.filter(function (q) {
	            return state.visibleQueries.indexOf(q.id) >= 0;
	        }) });
	};
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    var wrap = function wrap(action) {
	        return {
	            type: 'queries widget action',
	            action: action
	        };
	    };
	    var dispatchAction = utils_1.compose(wrap, dispatch);
	    return {
	        setCategoryFilters: function setCategoryFilters(categories) {
	            return dispatchAction({ type: "set category filters", categories: categories });
	        },
	        setQueryCheckbox: function setQueryCheckbox(query) {
	            return dispatch(function (dispatchUnwrapped, getState) {
	                return __awaiter(undefined, void 0, void 0, regeneratorRuntime.mark(function _callee() {
	                    var state;
	                    return regeneratorRuntime.wrap(function _callee$(_context) {
	                        while (1) {
	                            switch (_context.prev = _context.next) {
	                                case 0:
	                                    dispatchAction({ type: "set query checkbox", query: query });
	                                    state = getState();
	
	                                    setCommunicationRecipientListButton(utils_1.toStrings(state.selectedQueries).join(), selectedQueryLabels(state));
	
	                                case 3:
	                                case "end":
	                                    return _context.stop();
	                            }
	                        }
	                    }, _callee, this);
	                }));
	            });
	        },
	        unsetQueryCheckbox: function unsetQueryCheckbox(query) {
	            return dispatch(function (dispatchUnwrapped, getState) {
	                return __awaiter(undefined, void 0, void 0, regeneratorRuntime.mark(function _callee2() {
	                    var state;
	                    return regeneratorRuntime.wrap(function _callee2$(_context2) {
	                        while (1) {
	                            switch (_context2.prev = _context2.next) {
	                                case 0:
	                                    dispatchAction({ type: "unset query checkbox", query: query });
	                                    state = getState();
	
	                                    setCommunicationRecipientListButton(utils_1.toStrings(state.selectedQueries).join(), selectedQueryLabels(state));
	
	                                case 3:
	                                case "end":
	                                    return _context2.stop();
	                            }
	                        }
	                    }, _callee2, this);
	                }));
	            });
	        }
	    };
	};
	var selectedQueryLabels = function selectedQueryLabels(state) {
	    return state.selectedQueries.map(function (q) {
	        return state.titleMap[q];
	    }).join('<br />');
	};
	exports.QueriesWidgetApp = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(presentation_1.QueriesWidget);

/***/ },

/***/ 552:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(3);
	var chosen_1 = __webpack_require__(272);
	var utils_1 = __webpack_require__(600);
	var checkbox_1 = __webpack_require__(92);
	var utils_2 = __webpack_require__(4);
	exports.QueriesWidget = function (props) {
	    var flatCategories = utils_1.flattenCategoryTree(props.categories);
	    var options = mapCategoriesToOptions(flatCategories, props.selectedCategories);
	    return React.createElement("div", null, props.categories.length > 0 && React.createElement(chosen_1.Chosen, { multi: true, removeSelected: false, value: props.selectedCategories, options: options, onChange: chosen_1.onChangeHandler(props.setCategoryFilters), placeholder: "Filter unselected queries by category..." }), props.queries.length > 0 && React.createElement(Queries, Object.assign({}, props)));
	};
	var mapCategoriesToOptions = function mapCategoriesToOptions(flatCats, selectedCategories) {
	    return flatCats.map(function (fcti) {
	        return {
	            value: fcti.categorySerial,
	            label: (fcti.depth > 0 ? " .... ".repeat(fcti.depth) : '') + fcti.title,
	            disabled: selectedCategories.find(function (sc) {
	                return sc == fcti.categorySerial;
	            }) !== undefined
	        };
	    });
	};
	var Queries = function Queries(props) {
	    return React.createElement("div", null, React.createElement("input", { hidden: true, readOnly: true, name: "selectedQueries", key: "selectedQueries", value: utils_2.toStrings(props.selectedQueries).join() }), React.createElement("ul", { style: { listStyleType: "none", padding: 0 } }, props.queries.map(function (q) {
	        var queryId = q.id;
	        var checked = props.selectedQueries.find(function (sq) {
	            return sq == queryId;
	        }) !== undefined;
	        var arr1 = [q.instance != '' && q.instance + ": ", q.title];
	        var label = arr1.concat(q.owner != '' ? [" (Owner: ", React.createElement("strong", { key: "owner-" + queryId }, q.owner), ")"] : []);
	        return React.createElement("li", { key: queryId }, React.createElement(checkbox_1.Checkbox, { name: "queryid_array[]", value: utils_2.toString(queryId), label: label, checked: checked, onChange: function onChange() {
	                return (checked ? props.unsetQueryCheckbox : props.setQueryCheckbox)(queryId);
	            } }));
	    })));
	};

/***/ },

/***/ 553:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var actions_1 = __webpack_require__(550);
	exports.reducer = function (q, map) {
	    return function (s, a) {
	        if (actions_1.isQueriesWidgetAction(a)) {
	            return queriesWidgetReducer(q, map, s, a.action);
	        }
	        return s;
	    };
	};
	/**
	 * filterCategories => [1,2]
	 * map[q.id] => [2,3]
	 * difference => [1]
	 * this indicates that query q is not in all the selected categories, thus filter out of list
	 */
	var filterQueries = function filterQueries(queries, map, filterCategories) {
	    return filterCategories.length == 0 ? queries : queries.filter(function (q) {
	        return map[q.id] && _.difference(filterCategories, map[q.id]).length === 0;
	    });
	};
	var queriesWidgetReducer = function queriesWidgetReducer(q, map, s, a) {
	    switch (a.type) {
	        case "set category filters":
	            var visibleQueries = filterQueries(q, map, a.categories).map(function (q) {
	                return q.id;
	            }).concat(s.selectedQueries);
	            return Object.assign({}, s, { selectedCategories: a.categories, visibleQueries: visibleQueries });
	        case "set query checkbox":
	            var v = [a.query];
	            return Object.assign({}, s, { selectedQueries: v.concat(s.selectedQueries) });
	        case "unset query checkbox":
	            return Object.assign({}, s, { selectedQueries: s.selectedQueries.filter(function (qid) {
	                    return qid != a.query;
	                }) });
	    }
	};

/***/ },

/***/ 554:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(3);
	var ReactDOM = __webpack_require__(6);
	var commands_1 = __webpack_require__(12);
	var common_1 = __webpack_require__(134);
	var presentation_1 = __webpack_require__(555);
	exports.getTemplateGridData = function (props) {
	    return function (callback) {
	        var cc = new commands_1.CommandCaller(props.ajaxPageUrl);
	        cc.runGet('templates', {}).then(function (response) {
	            callback(response.content);
	        });
	    };
	};
	exports.addTemplate = function (props) {
	    return function () {
	        common_1.redirect(props);
	    };
	};
	exports.editTemplate = function (props) {
	    return function (id) {
	        common_1.redirect({ pageUrl: props.pageUrl + "/" + id });
	    };
	};
	exports.deleteTemplates = function (props) {
	    return function (ids) {
	        var plural = ids.split(',').length > 1 ? 's' : '';
	        if (confirm("Are you sure you want to permanently delete the selected template" + plural + "?")) {
	            var cc = new commands_1.CommandCaller(props.ajaxPageUrl);
	            cc.runPost('delete templates', { ids: ids }).then(function () {
	                refreshTemplatesGrid();
	            });
	        }
	    };
	};
	exports.copyTemplates = function (props) {
	    return function (ids) {
	        var cc = new commands_1.CommandCaller(props.ajaxPageUrl);
	        cc.runPost('copy templates', { ids: ids }).then(function () {
	            refreshTemplatesGrid();
	        });
	    };
	};
	var refreshTemplatesGrid = function refreshTemplatesGrid() {
	    new HtmlDataGrid('templatesDataGrid').refresh();
	};
	exports.versionHistory = function (replace, params) {
	    var div = document.createElement('div');
	    replace(div);
	    ReactDOM.render(React.createElement(presentation_1.VersionHistoryList, { templateVersions: revisionsFromParams(params), activeVersion: params.activeVersion.toString(), viewingVersion: params.viewingVersion.toString(), editTemplate: function editTemplate() {
	            return common_1.redirect({ pageUrl: params.editTemplatePageUrl });
	        }, viewTemplate: function viewTemplate(id) {
	            return common_1.redirect({ pageUrl: params.viewTemplatePageUrl + "/" + id });
	        } }), div);
	};
	var revisionsFromParams = function revisionsFromParams(params) {
	    return params.templateVersions.map(function (tr) {
	        return {
	            id: tr.id.toString(),
	            title: tr.title,
	            createdBy: tr.createdBy,
	            createdDate: tr.createdDate,
	            isActiveVersion: tr.id === params.activeVersion
	        };
	    });
	};

/***/ },

/***/ 555:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(3);
	var fixed_data_grid_1 = __webpack_require__(94);
	var headings = {
	    id: "#",
	    title: 'Title',
	    createdBy: 'Created By',
	    createdDate: 'Created Date',
	    onClick: ''
	};
	var makeRow = function makeRow(props) {
	    return function (tr) {
	        var title = tr.isActiveVersion ? React.createElement("span", null, tr.title, " ", React.createElement(ActiveLabel, null)) : tr.title;
	        return {
	            onClick: function onClick() {
	                var id = tr.id;
	                id === props.activeVersion ? props.editTemplate() : props.viewTemplate(id);
	            },
	            id: { node: tr.id, minWidth: '40px' },
	            title: { node: title, alignment: "left" },
	            createdBy: { node: tr.createdBy, alignment: "left" },
	            createdDate: { node: tr.createdDate, alignment: "left" }
	        };
	    };
	};
	var ActiveLabel = function ActiveLabel() {
	    // Ravi requested a button like this so I let him make it :lul:
	    return React.createElement("small", { style: {
	            marginLeft: '8px',
	            backgroundColor: '#00ab4e',
	            backgroundClip: 'padding-box',
	            border: '1px solid #00ab4e',
	            whiteSpace: 'nowrap',
	            padding: '2px 5px',
	            borderRadius: '3px',
	            fontWeight: 700,
	            lineHeight: '1em',
	            color: '#fff'
	        } }, "Active");
	};
	
	var VersionHistoryDataGrid = function (_fixed_data_grid_1$Fi) {
	    _inherits(VersionHistoryDataGrid, _fixed_data_grid_1$Fi);
	
	    function VersionHistoryDataGrid() {
	        _classCallCheck(this, VersionHistoryDataGrid);
	
	        return _possibleConstructorReturn(this, (VersionHistoryDataGrid.__proto__ || Object.getPrototypeOf(VersionHistoryDataGrid)).apply(this, arguments));
	    }
	
	    return VersionHistoryDataGrid;
	}(fixed_data_grid_1.FixedDataGrid);
	
	exports.VersionHistoryList = function (props) {
	    var rows = props.templateVersions.map(makeRow(props));
	    return React.createElement(VersionHistoryDataGrid, { heading: headings, data: rows, highlight: function highlight(r) {
	            return r.id.node === props.viewingVersion;
	        }, rowClick: 'onClick' });
	};

/***/ },

/***/ 556:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(3);
	var ReactDOM = __webpack_require__(6);
	var Utils = __webpack_require__(4);
	var multi_select_1 = __webpack_require__(607);
	var Immutable = __webpack_require__(103);
	exports.renderer = function (replace, params) {
	    var div = document.createElement('div');
	    replace(div);
	    ReactDOM.render(React.createElement(AccessConfigurerRenderer, { selectedAccessType: accessTypeFromName(params.accessType), selectedMembershipTypes: Immutable.OrderedMap(params.selectedTypes), allMembershipTypes: Immutable.OrderedMap(params.allTypes), selectedAccessGroups: Immutable.OrderedMap(params.selectedGroups), allAccessGroups: Immutable.OrderedMap(params.allGroups) }), div);
	};
	var accessTypeFromName = function accessTypeFromName(accessType) {
	    switch (accessType) {
	        case 'none':
	            return 0 /* none */;
	        case 'types':
	            return 1 /* types */;
	        case 'groups':
	            return 2 /* groups */;
	        case 'or':
	            return 3 /* or */;
	    }
	    throw new Error("Could not recognise access type with name \"" + accessType + "\"");
	};
	
	var AccessConfigurerRenderer = function (_React$Component) {
	    _inherits(AccessConfigurerRenderer, _React$Component);
	
	    function AccessConfigurerRenderer(props, context) {
	        _classCallCheck(this, AccessConfigurerRenderer);
	
	        var _this = _possibleConstructorReturn(this, (AccessConfigurerRenderer.__proto__ || Object.getPrototypeOf(AccessConfigurerRenderer)).call(this, props, context));
	
	        _this.state = {
	            selectedAccessType: props.selectedAccessType,
	            selectedMembershipTypes: props.selectedMembershipTypes,
	            selectedAccessGroups: props.selectedAccessGroups,
	            remainingHighlightedMembershipTypes: Immutable.OrderedMap({}),
	            selectedHighlightedMembershipTypes: Immutable.OrderedMap({}),
	            remainingHighlightedAccessGroups: Immutable.OrderedMap({}),
	            selectedHighlightedAccessGroups: Immutable.OrderedMap({})
	        };
	        return _this;
	    }
	
	    _createClass(AccessConfigurerRenderer, [{
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var radioRendererOnChangeHandler = function radioRendererOnChangeHandler(accessType) {
	                return function (e) {
	                    return _this2.setState(function (state) {
	                        state.selectedAccessType = accessType;return state;
	                    });
	                };
	            };
	            var addTypesHandler = function addTypesHandler() {
	                return _this2.setState(function (state) {
	                    state.selectedMembershipTypes = state.selectedMembershipTypes.merge(state.remainingHighlightedMembershipTypes);
	                    state.remainingHighlightedMembershipTypes = Immutable.OrderedMap({});
	                    return state;
	                });
	            };
	            var addGroupsHandler = function addGroupsHandler() {
	                return _this2.setState(function (state) {
	                    state.selectedAccessGroups = state.selectedAccessGroups.merge(state.remainingHighlightedAccessGroups);
	                    state.remainingHighlightedAccessGroups = Immutable.OrderedMap({});
	                    return state;
	                });
	            };
	            var removeTypesHandler = function removeTypesHandler() {
	                return _this2.setState(function (state) {
	                    state.selectedMembershipTypes = Utils.mapSubtract(state.selectedMembershipTypes, state.selectedHighlightedMembershipTypes);
	                    state.selectedHighlightedMembershipTypes = Immutable.OrderedMap({});
	                    return state;
	                });
	            };
	            var removeGroupsHandler = function removeGroupsHandler() {
	                return _this2.setState(function (state) {
	                    state.selectedAccessGroups = Utils.mapSubtract(state.selectedAccessGroups, state.selectedHighlightedAccessGroups);
	                    state.selectedHighlightedAccessGroups = Immutable.OrderedMap({});
	                    return state;
	                });
	            };
	            var addSelectedTypesHandler = function addSelectedTypesHandler(newItems) {
	                return _this2.setState(function (state) {
	                    state.remainingHighlightedMembershipTypes = newItems;
	                    return state;
	                });
	            };
	            var addSelectedGroupsHandler = function addSelectedGroupsHandler(newItems) {
	                return _this2.setState(function (state) {
	                    state.remainingHighlightedAccessGroups = newItems;return state;
	                });
	            };
	            var removeSelectedTypesHandler = function removeSelectedTypesHandler(newItems) {
	                return _this2.setState(function (state) {
	                    state.selectedHighlightedMembershipTypes = newItems;return state;
	                });
	            };
	            var removeSelectedGroupsHandler = function removeSelectedGroupsHandler(newItems) {
	                return _this2.setState(function (state) {
	                    state.selectedHighlightedAccessGroups = newItems;return state;
	                });
	            };
	            var typesContainer = React.createElement("div", null, React.createElement("label", null, "Select Membership Type(s) and click on the 'Add >>' button"), React.createElement(multi_select_1.MultiSelect, { name: "typesSelectedValues", keyPrefix: "type", selectedItems: this.state.selectedMembershipTypes, allItems: this.props.allMembershipTypes, remainingHighlightedItems: this.state.remainingHighlightedMembershipTypes, selectedHighlightedItems: this.state.selectedHighlightedMembershipTypes, addOptionsHandler: addTypesHandler, removeOptionsHandler: removeTypesHandler, remainingHighlightHandler: addSelectedTypesHandler, selectedHighlightHandler: removeSelectedTypesHandler }));
	            var groupsContainer = React.createElement("div", null, React.createElement("label", null, "Select Access Group(s) and click on the 'Add >>' button"), React.createElement(multi_select_1.MultiSelect, { name: "groupsSelectedValues", keyPrefix: "group", selectedItems: this.state.selectedAccessGroups, allItems: this.props.allAccessGroups, remainingHighlightedItems: this.state.remainingHighlightedAccessGroups, selectedHighlightedItems: this.state.selectedHighlightedAccessGroups, addOptionsHandler: addGroupsHandler, removeOptionsHandler: removeGroupsHandler, remainingHighlightHandler: addSelectedGroupsHandler, selectedHighlightHandler: removeSelectedGroupsHandler }));
	            var onMessage = React.createElement("label", null, "Note: User's must be in a selected Membership Type OR a selected Access Group");
	            return React.createElement("div", null, React.createElement(AccessTypeRadioGroup, { selectedAccessType: this.state.selectedAccessType, onChangeHandler: radioRendererOnChangeHandler }), React.createElement("br", null), this.state.selectedAccessType === 1 /* types */ || this.state.selectedAccessType === 3 /* or */ ? typesContainer : null, this.state.selectedAccessType === 2 /* groups */ || this.state.selectedAccessType === 3 /* or */ ? groupsContainer : null, this.state.selectedAccessType === 3 /* or */ ? onMessage : null);
	        }
	    }]);
	
	    return AccessConfigurerRenderer;
	}(React.Component);
	
	var AccessTypeRadioGroup = function (_React$Component2) {
	    _inherits(AccessTypeRadioGroup, _React$Component2);
	
	    function AccessTypeRadioGroup() {
	        _classCallCheck(this, AccessTypeRadioGroup);
	
	        return _possibleConstructorReturn(this, (AccessTypeRadioGroup.__proto__ || Object.getPrototypeOf(AccessTypeRadioGroup)).apply(this, arguments));
	    }
	
	    _createClass(AccessTypeRadioGroup, [{
	        key: "render",
	        value: function render() {
	            var name = 'accessType';
	            var onChangeHandler = this.props.onChangeHandler;
	            return React.createElement("div", null, React.createElement("input", { onChange: onChangeHandler(0 /* none */), id: "none", type: "radio", checked: this.props.selectedAccessType === 0 /* none */, name: name, value: "none" }), React.createElement("label", { htmlFor: "none" }, "Do Not Limit Access to This Group"), React.createElement("br", null), React.createElement("input", { onChange: onChangeHandler(1 /* types */), id: "types", type: "radio", checked: this.props.selectedAccessType === 1 /* types */, name: name, value: "types" }), React.createElement("label", { htmlFor: "types" }, "Limit Access by Membership Type(s)"), React.createElement("br", null), React.createElement("input", { onChange: onChangeHandler(2 /* groups */), id: "groups", type: "radio", checked: this.props.selectedAccessType === 2 /* groups */, name: name, value: "groups" }), React.createElement("label", { htmlFor: "groups" }, "Limit Access by Access Group(s)"), React.createElement("br", null), React.createElement("input", { onChange: onChangeHandler(3 /* or */), id: "or", type: "radio", checked: this.props.selectedAccessType === 3 /* or */, name: name, value: "or" }), React.createElement("label", { htmlFor: "or" }, "Limit Access by Membership Type(s) OR Access Group(s)"), React.createElement("br", null));
	        }
	    }]);
	
	    return AccessTypeRadioGroup;
	}(React.Component);

/***/ },

/***/ 557:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var AccessConfigurer = __webpack_require__(556);
	exports.accessConfigurerRenderer = AccessConfigurer.renderer;

/***/ },

/***/ 558:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var EligibleGoal_ = __webpack_require__(561);
	exports.EligibleGoals = EligibleGoal_;

/***/ },

/***/ 559:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var $ = __webpack_require__(10);
	var modal_1 = __webpack_require__(135);
	
	var EventDefiner = function () {
	    function EventDefiner(callback, params) {
	        _classCallCheck(this, EventDefiner);
	
	        this.callback = callback;
	        this.existingGoalUsers = params.existingGoalUsers;
	        this.newGoalUsers = params.newGoalUsers;
	        this.goalUsersCount = params.goalUsersCount;
	        this.contentsHtml = params.contentsHtml;
	        this.formId = params.formId;
	    }
	
	    _createClass(EventDefiner, [{
	        key: "define",
	        value: function define() {
	            var _this = this;
	
	            $("[name=saveSubmit]").click(function () {
	                _this.onSaveGoal('saveSubmit');return false;
	            });
	            $("[name=saveReturnSubmit]").click(function () {
	                _this.onSaveGoal('saveReturnSubmit');return false;
	            });
	        }
	    }, {
	        key: "onApplyChanges",
	        value: function onApplyChanges() {
	            var basedOnRg0 = $('#applyChangesTypeRadioGroup_0').prop('checked') ? this.newGoalUsers : -1;
	            var basedOnBoth = $('#applyChangesTypeRadioGroup_1').prop('checked') ? this.existingGoalUsers : basedOnRg0;
	            $('#applyTo').val(basedOnBoth);
	            document.getElementById(this.formId).submit();
	        }
	    }, {
	        key: "modal",
	        value: function modal() {
	            var _this2 = this;
	
	            return modal_1.renderModal('applyChangestypeModal', 'Save Goal', this.contentsHtml, new modal_1.Dimension(550, 350), this.callback, function () {
	                return _this2.onApplyChanges();
	            });
	        }
	    }, {
	        key: "onSaveGoal",
	        value: function onSaveGoal(mode) {
	            if (mode === 'saveSubmit') document.getElementById('saveSubmit').value = '1';else if (mode === 'saveReturnSubmit') document.getElementById('saveReturnSubmit').value = '1';
	            if (this.goalUsersCount > 0) {
	                this.modal().dialog('open');
	            } else {
	                ;
	                document.getElementById('applyTo').value = this.existingGoalUsers;
	                document.getElementById(this.formId).submit();
	            }
	        }
	    }]);
	
	    return EventDefiner;
	}();
	
	exports.EventDefiner = EventDefiner;

/***/ },

/***/ 560:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var commands_1 = __webpack_require__(12);
	var $ = __webpack_require__(10);
	
	var EnrolLinkMaker = function () {
	    function EnrolLinkMaker(attribute, ajaxPageUrl) {
	        _classCallCheck(this, EnrolLinkMaker);
	
	        this.ajaxPageUrl = ajaxPageUrl;
	        this.attribute = attribute;
	    }
	
	    _createClass(EnrolLinkMaker, [{
	        key: "makeEnrollableLinks",
	        value: function makeEnrollableLinks() {
	            var _this = this;
	
	            var enrolByNode = function enrolByNode(e) {
	                var getIdFromAttribute = function getIdFromAttribute() {
	                    return $(e).attr(_this.attribute);
	                };
	                _this.enrolById(parseInt(getIdFromAttribute()));
	            };
	            this.assignClickHandlerToMatchingNodes(enrolByNode, $('[' + this.attribute + ']'));
	        }
	    }, {
	        key: "assignClickHandlerToMatchingNodes",
	        value: function assignClickHandlerToMatchingNodes(callback, nodes) {
	            nodes.each(function (_, e) {
	                return $(e).click(function (event) {
	                    event.preventDefault();
	                    return callback(e);
	                });
	            });
	        }
	    }, {
	        key: "enrolById",
	        value: function enrolById(id) {
	            var command = new commands_1.CommandCaller(this.ajaxPageUrl);
	            var result = command.runPost('enrol', id);
	            result.then(function (str) {
	                return window.location.assign(str);
	            });
	        }
	    }]);
	
	    return EnrolLinkMaker;
	}();
	
	exports.makeEnrollableLinks = function (attribute, url) {
	    return new EnrolLinkMaker(attribute, url).makeEnrollableLinks();
	};

/***/ },

/***/ 561:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var $ = __webpack_require__(10);
	var Admin_ = __webpack_require__(559);
	var Public_ = __webpack_require__(560);
	var Admin;
	(function (Admin) {
	    Admin.defineSelfAppliableGoalChangeEvent = function () {
	        $("#isSelfAppliableGoal").change(function () {
	            $("[name=eligibleMembershipTypes]").closest("li").css("display", $("#isSelfAppliableGoal").prop("checked") ? "block" : "none");
	        });
	    };
	    Admin.defineAdminEvents = function (cb, params) {
	        $(function () {
	            return new Admin_.EventDefiner(cb, params).define();
	        });
	    };
	})(Admin = exports.Admin || (exports.Admin = {}));
	var Public;
	(function (Public) {
	    Public.makeEnrollableLinks = function (cb, params) {
	        $(function () {
	            return Public_.makeEnrollableLinks(params.attribute, params.url);
	        });
	    };
	})(Public = exports.Public || (exports.Public = {}));

/***/ },

/***/ 562:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var MemoryFileWidget_ = __webpack_require__(263);
	exports.MemoryFileWidget = MemoryFileWidget_;
	//# sourceMappingURL=spare fields.js.map

/***/ },

/***/ 563:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var utils_1 = __webpack_require__(4);
	var ReactDOM = __webpack_require__(6);
	var React = __webpack_require__(3);
	var stateInfo = {};
	exports.initializeStateInfo = function (callback, params) {
	    stateInfo[params.fieldName] = { stateSelectList: params.stateSelectList, stateInput: params.stateInput };
	    exports.updateState(params.fieldName)(params.country);
	    //hopefully not needed, but it's contacts - who knows
	    window[params.simplerName + "Update"] = exports.updateState(params.fieldName);
	    $(function () {
	        var countries = document.getElementsByName(params.countryField);
	        countries.forEach(function (c) {
	            return c.onchange = function () {
	                exports.updateState(params.fieldName)(this.value);
	            };
	        });
	    });
	};
	exports.updateState = function (stateFieldId) {
	    return function (country) {
	        var rootDiv = document.getElementById(stateFieldId);
	        if (!rootDiv) return;
	        var child = rootDiv.firstChild;
	        if (!child) return;
	        if (!country || country == 'Australia' || country.length == 0) {
	            if (child.nodeName != 'SELECT') {
	                rootDiv.innerHTML = stateInfo[stateFieldId].stateSelectList;
	            }
	        } else {
	            rootDiv.innerHTML = stateInfo[stateFieldId].stateInput;
	        }
	    };
	};
	exports.renderError = function (callback, params) {
	    alert(params.error_message);
	};
	exports.renderEmailPlaceholders = function (callback, params) {
	    var reactDiv = document.createElement('div');
	    var res = [];
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	        for (var _iterator = utils_1.group(utils_1.concatenate(params.ClientOrAccess, params.Info), 4)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var placeholders = _step.value;
	
	            var eles = [];
	            var _iteratorNormalCompletion2 = true;
	            var _didIteratorError2 = false;
	            var _iteratorError2 = undefined;
	
	            try {
	                for (var _iterator2 = placeholders[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	                    var pl = _step2.value;
	
	                    if (pl === undefined) {
	                        eles.push(React.createElement("td", { style: { textAlign: 'center' } }));
	                    } else {
	                        var label = "[" + pl.label + "]";
	                        var content = pl.isActive ? React.createElement("span", { style: { color: "red" } }, label) : label;
	                        eles.push(React.createElement("td", { style: { textAlign: 'center' } }, content));
	                    }
	                }
	            } catch (err) {
	                _didIteratorError2 = true;
	                _iteratorError2 = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                        _iterator2.return();
	                    }
	                } finally {
	                    if (_didIteratorError2) {
	                        throw _iteratorError2;
	                    }
	                }
	            }
	
	            res.push(React.createElement("tr", null, eles));
	        }
	    } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	    } finally {
	        try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	                _iterator.return();
	            }
	        } finally {
	            if (_didIteratorError) {
	                throw _iteratorError;
	            }
	        }
	    }
	
	    ReactDOM.render(React.createElement("table", { cellPadding: 0, cellSpacing: 0, className: "adminlist", style: { width: "100%" } }, React.createElement("tr", null, React.createElement("td", { colSpan: 4 }, React.createElement("strong", null, "The following placeholders can be added to the email"), "\xa0\xa0\xa0", "(", React.createElement("span", { style: { color: 'red' } }, "[PlaceHolders]"), " = Already In Message):")), res), reactDiv);
	    callback(reactDiv);
	};
	exports.passwordField = function (callback, params) {
	    $(function () {
	        var progressbar = $("#" + params.name + "-password-validation-progress");
	        if (!progressbar.progressbar) return;
	        var securityType = function securityType(value) {
	            if (value < 20) return 'Very Weak';else if (value < 40) return 'Weak';else if (value < 60) return 'Good';else if (value < 80) return 'Strong';
	            return 'Very Strong';
	        };
	        progressbar.progressbar();
	        var progressbarValue = progressbar.find('.ui-progressbar-value');
	        var progressLabel = progressbar.find('.progress-label');
	        var passwordField = $("#" + params.name);
	        passwordField.complexify({
	            minComplexity: params.minComplexity,
	            minimumChars: params.minLength,
	            strengthScaleFactor: 0.5
	        }, function (valid, complexity) {
	            progressbar.progressbar('option', 'value', complexity);
	            progressbarValue.css({ 'background': valid ? '#88bb88' : '#ffaaaa', border: '1px solid ' + (valid ? 'green' : 'red') });
	            progressLabel.text(securityType(complexity));
	            passwordField.data('sb-invalid-message', valid ? null : 'The password is not valid');
	        });
	    });
	};

/***/ },

/***/ 564:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var employmentHistory_ = __webpack_require__(568);
	var savedQueries_ = __webpack_require__(581);
	var querybuilderFilters_ = __webpack_require__(575);
	var querybuilderOperators_ = __webpack_require__(576);
	var contactPage_ = __webpack_require__(563);
	exports.employmentHistory = employmentHistory_;
	exports.savedQueries = savedQueries_;
	exports.querybuilderFilters = querybuilderFilters_;
	exports.querybuilderOperators = querybuilderOperators_;
	exports.contactPage = contactPage_;

/***/ },

/***/ 565:
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.actionCreator = {
	    field: {
	        startDateChanged: function startDateChanged(text, date) {
	            return { type: 'changeStartDate', text: text, date: date };
	        },
	        endDateChanged: function endDateChanged(text, date) {
	            return { type: 'changeEndDate', text: text, date: date };
	        },
	        changeCompanyName: function changeCompanyName(newName) {
	            return { type: 'changeCompanyName', text: newName };
	        },
	        changePositionTitle: function changePositionTitle(newTitle) {
	            return { type: 'changePositionTitle', text: newTitle };
	        },
	        changeCompanyId: function changeCompanyId(selectorId, newCompany) {
	            var newId = newCompany ? newCompany.companyId : 0;
	            var newName = newCompany ? newCompany.companyName : '';
	            return { type: 'changeCompanyId', id: newId, text: newName };
	        },
	        validateFailure: function validateFailure(errorFields) {
	            return { type: 'validateFailure', errorFields: errorFields };
	        }
	    },
	    server: {
	        save: function save() {
	            return { type: 'save' };
	        },
	        saveAddSuccess: function saveAddSuccess(id) {
	            return { type: 'saveAddSuccess' };
	        },
	        saveUpdateSuccess: function saveUpdateSuccess() {
	            return { type: 'saveUpdateSuccess' };
	        },
	        saveFailure: function saveFailure(serverErrors) {
	            return { type: 'saveFailure', serverErrors: serverErrors };
	        }
	    }
	};

/***/ },

/***/ 566:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	//todo this whole employment history feature, all of it, it isn't used
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(3);
	var select_1 = __webpack_require__(39);
	// TODO alanb company list structure better as a hash?
	exports.CompanySelector = function (props) {
	    var options = props.companies.map(function (company) {
	        return React.createElement("option", { key: "company-" + company.companyId, value: company.companyId.toString() }, company.companyName);
	    });
	    var onChange = function onChange(value) {
	        return props.onSelectorChange(props.selectorId, props.companies.find(function (company) {
	            return company.companyId == Number(value);
	        }));
	    };
	    return React.createElement(select_1.SingleBox, { onChange: onChange, value: props.selectedId.toString(), name: props.selectorId + "CompanySelector" }, React.createElement("option", { key: 'company-0', value: '0' }), options);
	};

/***/ },

/***/ 567:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(3);
	var modal_1 = __webpack_require__(95);
	var form_1 = __webpack_require__(55);
	var input_1 = __webpack_require__(34);
	var companySelector_1 = __webpack_require__(566);
	var datePicker_1 = __webpack_require__(93);
	var FormErrors = function FormErrors(props) {
	    if (!props.msgs || props.msgs.length == 0) {
	        return React.createElement("div", null);
	    }
	    var reactMsgList = props.msgs.map(function (msg, i) {
	        return React.createElement(FormError, { msg: msg, key: i });
	    });
	    return React.createElement("div", { style: { border: "solid red 2px", margin: "10px 3px 3px 3px" } }, reactMsgList);
	};
	var FormError = function FormError(props) {
	    return React.createElement("div", { key: props.key }, props.msg);
	};
	var CurrentPositionForm = function CurrentPositionForm(props) {
	    return React.createElement("div", null, React.createElement(modal_1.Modal, { isOpen: true, title: "Employment History Position", onRequestClose: props.onClose }, React.createElement("div", null, "You have selected the user's current position. It cannot be updated from here.")));
	};
	var PositionForm = function PositionForm(props) {
	    return React.createElement("div", null, React.createElement(form_1.Form, { hasSave: true, hasCancel: true, onCancel: props.onClose, onSubmit: props.onSave, isSubmitting: props.isSaving }, React.createElement("table", null, React.createElement("tbody", null, React.createElement("tr", null, React.createElement("td", null, "* ", props.labels.startDate), React.createElement("td", null, React.createElement(datePicker_1.DatePicker, { date: props.startDate, buttonImage: props.datePickerProps.buttonImage, onChange: function onChange(text, date) {
	            return props.startDateChanged(text, date);
	        }, invalid: props.errorFields != undefined && props.errorFields.indexOf('startDate') !== -1, readonly: true }))), React.createElement("tr", null, React.createElement("td", null, "* ", props.labels.endDate), React.createElement("td", null, React.createElement(datePicker_1.DatePicker, { date: props.endDate, buttonImage: props.datePickerProps.buttonImage, onChange: function onChange(text, date) {
	            return props.endDateChanged(text, date);
	        }, invalid: props.errorFields != undefined && props.errorFields.indexOf('endDate') !== -1, readonly: true }))), React.createElement("tr", null, React.createElement("td", null, "* ", props.labels.companyName), React.createElement("td", null, React.createElement(input_1.Input, { value: props.companyName, onChange: function onChange(value) {
	            return props.companyNameChanged(value);
	        }, invalid: props.errorFields != undefined && props.errorFields.indexOf('companyName') !== -1 }))), React.createElement("tr", null, React.createElement("td", null, "Select ", props.labels.companyName), React.createElement("td", null, React.createElement(companySelector_1.CompanySelector, { selectorId: 'employmentHistoryCompanySelector', selectedId: props.companyId, companies: props.companies, onSelectorChange: function onSelectorChange(selectorId, company) {
	            return props.companyIdChanged(selectorId, company);
	        } }))), React.createElement("tr", null, React.createElement("td", null, props.labels.positionTitle), React.createElement("td", null, React.createElement(input_1.Input, { value: props.positionTitle, onChange: function onChange(value) {
	            return props.positionTitleChanged(value);
	        } }))))), React.createElement(FormErrors, { msgs: props.errorMsgs })));
	};
	exports.EmploymentHistoryPositionView = function (props) {
	    if (props.id == -1) {
	        return React.createElement(CurrentPositionForm, Object.assign({}, props));
	    }
	    return React.createElement("div", null, React.createElement(modal_1.Modal, { isOpen: true, title: "Employment History Position", onRequestClose: function onRequestClose() {
	            setTimeout(props.onClose, 0); // put at end of event queue?
	        }, style: { width: '400px' } }, React.createElement(PositionForm, Object.assign({}, props))));
	};

/***/ },

/***/ 568:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * This file provides the entrance points for php to the javascript components
	 */
	var commands_1 = __webpack_require__(12);
	var React = __webpack_require__(3);
	var ReactDOM = __webpack_require__(6);
	var Redux = __webpack_require__(22);
	var redux_thunk_1 = __webpack_require__(33);
	var containers_1 = __webpack_require__(264);
	var reducers_1 = __webpack_require__(569);
	/*
	 * something to represent the table (the data grid)
	 */
	
	var EmploymentHistory = function EmploymentHistory(data, dataGridId) {
	    var _this = this;
	
	    _classCallCheck(this, EmploymentHistory);
	
	    this.getData = function () {
	        return _this.data;
	    };
	    this.getRow = function (rowId) {
	        return _this.data[rowId];
	    };
	    this.getId = function () {
	        return _this.dataGridId;
	    };
	    this.data = data;
	    this.dataGridId = dataGridId;
	};
	
	var employmentHistory;
	var companies = void 0;
	var fieldLabels = void 0;
	var mapFieldLabels = function mapFieldLabels(serverFieldLabels) {
	    return serverFieldLabels; // works as UIFieldLabels is a structure type which is a subset of FieldLabels
	};
	var admin;
	(function (admin) {
	    // refresh grid getting data from server after any server update (and close of modal edit dialog)
	    var refreshEmploymentHistoryList = function refreshEmploymentHistoryList() {
	        new HtmlDataGrid(employmentHistory.getId()).refresh();
	    };
	    /*
	     * To attach to the data grid dataFunction.  Provides the callback function to request the employment history list
	     * from the server.  It is called on initial display and on every refresh
	     */
	    admin.getEmploymentHistoryGridData = function (props, dataGridId, userId) {
	        return function (callback) {
	            var cc = new commands_1.CommandCaller(props.ajaxPageUrl);
	            cc.runGet('getEmploymentHistoryList', { dataGridId: dataGridId,
	                userId: userId
	            }).then(function (response) {
	                employmentHistory = new EmploymentHistory(response.data, dataGridId);
	                companies = response.companies;
	                fieldLabels = response.labels;
	                callback(response.content);
	            });
	        };
	    };
	    admin.getInitialState = function (rowId, isNew) {
	        if (isNew) {
	            var _props = employmentHistory.getRow(-1);
	            return {
	                id: 0,
	                userId: _props.userId,
	                startDate: '',
	                endDate: '',
	                companyName: '',
	                companyId: 0,
	                positionTitle: '',
	                isSaving: false
	            };
	        }
	        var props = employmentHistory.getRow(rowId);
	        return {
	            id: props.id,
	            userId: props.userId,
	            startDate: props.startDate,
	            endDate: props.endDate,
	            companyName: props.companyName,
	            companyId: props.companyId,
	            positionTitle: props.positionTitle,
	            isSaving: false
	        };
	    };
	    admin.showEmploymentHistoryPositionModal = function (commandProps, rowId, isNew) {
	        var div = document.createElement('div');
	        var body = document.getElementsByTagName('body')[0];
	        body.appendChild(div);
	        var initialState = admin.getInitialState(rowId, isNew);
	        var store = Redux.createStore(reducers_1.reducer, initialState, Redux.applyMiddleware(redux_thunk_1.default));
	        ReactDOM.render(React.createElement(containers_1.EmploymentHistoryContainer, { store: store, companies: companies, fieldLabels: mapFieldLabels(fieldLabels), ajaxPageUrl: commandProps.ajaxPageUrl, datePickerProps: commandProps.datePickerProps, onClose: function onClose() {
	                ReactDOM.unmountComponentAtNode(div);
	                refreshEmploymentHistoryList();
	            } }), div);
	    };
	    admin.deletePositions = function (commandProps, rowIds) {
	        var cc = new commands_1.CommandCaller(commandProps.ajaxPageUrl);
	        cc.runPost('deleteEmploymentHistoryPositions', { ids: rowIds, userId: employmentHistory.getRow(-1).userId }).then(function (response) {
	            refreshEmploymentHistoryList();
	            if (response.content.length) {
	                alert(response.content.join("\n"));
	            }
	        });
	    };
	})(admin = exports.admin || (exports.admin = {}));

/***/ },

/***/ 569:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var containers_1 = __webpack_require__(264);
	exports.removeErrorField = function (errorFields, field) {
	    if (errorFields) {
	        var newErrorFields = [].concat(_toConsumableArray(errorFields));
	        var index = newErrorFields.indexOf(field);
	        if (index > -1) {
	            newErrorFields.splice(index, 1);
	        }
	        return newErrorFields;
	    }
	    return errorFields;
	};
	exports.reducer = function (store, action) {
	    var newStore = _.cloneDeep(store);
	    if (action.type != 'saveFailure') {
	        newStore.serverErrors = undefined;
	    }
	    switch (action.type) {
	        case 'changeStartDate':
	            {
	                var a = action;
	                newStore.startDate = containers_1.formatDate(a.date);
	                if (newStore.errorFields) {
	                    newStore.errorFields = exports.removeErrorField(newStore.errorFields, 'startDate');
	                    newStore.errorFields = exports.removeErrorField(newStore.errorFields, 'endDate');
	                }
	                return newStore;
	            }
	        case 'changeEndDate':
	            {
	                var _a = action;
	                newStore.endDate = containers_1.formatDate(_a.date);
	                if (newStore.errorFields) {
	                    newStore.errorFields = exports.removeErrorField(newStore.errorFields, 'startDate');
	                    newStore.errorFields = exports.removeErrorField(newStore.errorFields, 'endDate');
	                }
	                return newStore;
	            }
	        case 'changeCompanyName':
	            {
	                var _a2 = action;
	                newStore.companyName = _a2.text;
	                if (newStore.errorFields) {
	                    newStore.errorFields = exports.removeErrorField(newStore.errorFields, 'companyName');
	                }
	                return newStore;
	            }
	        case 'changeCompanyId':
	            {
	                var _a3 = action;
	                newStore.companyId = _a3.id;
	                // if no company selected
	                if (_a3.id > 0) {
	                    newStore.companyName = _a3.text;
	                    if (newStore.errorFields) {
	                        newStore.errorFields = exports.removeErrorField(newStore.errorFields, 'companyName');
	                    }
	                }
	                return newStore;
	            }
	        case 'changePositionTitle':
	            {
	                var _a4 = action;
	                newStore.positionTitle = _a4.text;
	                return newStore;
	            }
	        case 'validateFailure':
	            {
	                var _a5 = action;
	                newStore.isSaving = false;
	                newStore.errorFields = _a5.errorFields;
	                return newStore;
	            }
	        case 'save':
	        case 'update':
	            {
	                newStore.isSaving = true;
	                return newStore;
	            }
	        case 'saveFailure':
	            {
	                var _a6 = action;
	                newStore.isSaving = false;
	                newStore.serverErrors = _a6.serverErrors;
	                return newStore;
	            }
	        case 'saveUpdateSuccess':
	            {
	                newStore.isSaving = false;
	                newStore.errorFields = [];
	                return newStore;
	            }
	        case 'saveAddSuccess':
	            {
	                var _a7 = action;
	                newStore.isSaving = false;
	                newStore.errorFields = [];
	                newStore.id = _a7.id;
	                return newStore;
	            }
	        default:
	            return store;
	    }
	};

/***/ },

/***/ 570:
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.isCommunicationsMessageFiltersAction = function (a) {
	    return a.type == "communications message filters action";
	};

/***/ },

/***/ 571:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var presentation_1 = __webpack_require__(573);
	var react_redux_1 = __webpack_require__(23);
	var utils_1 = __webpack_require__(4);
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	    return Object.assign({}, state, { messages: ownProps.messages });
	};
	var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
	    var wrap = function wrap(action) {
	        return {
	            type: "communications message filters action",
	            action: action
	        };
	    };
	    var dispatchAction = utils_1.compose(wrap, dispatch);
	    return {
	        setMessages: function setMessages(messages) {
	            return dispatchAction({ type: "set messages", messages: messages });
	        },
	        setSentStatus: function setSentStatus(sentStatus) {
	            return dispatchAction({ type: "set sent status", sentStatus: sentStatus });
	        },
	        setOpenedStatus: function setOpenedStatus(openedStatus) {
	            return dispatchAction({ type: "set opened status", openedStatus: openedStatus });
	        }
	    };
	};
	exports.CommunicationsMessageFiltersApp = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(presentation_1.CommunicationsMessageFilters);

/***/ },

/***/ 572:
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.isSentStatus = function (value) {
	    return value == "any" || value == "sent" || value == "unsent";
	};
	exports.isOpenedStatus = function (value) {
	    return value == "any" || value == "opened" || value == "unopened";
	};

/***/ },

/***/ 573:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(3);
	var chosen_1 = __webpack_require__(272);
	var select_1 = __webpack_require__(39);
	var data_1 = __webpack_require__(572);
	var utils_1 = __webpack_require__(4);
	var input_1 = __webpack_require__(34);
	exports.CommunicationsMessageFilters = function (props) {
	    var options = mapMessagesToOptions(props.messages, props.selectedMessages);
	    return React.createElement("div", null, React.createElement(input_1.AlwaysPost, { name: "cm_messages", value: utils_1.toStrings(props.selectedMessages).join() }), React.createElement(input_1.AlwaysPost, { name: "cm_sentStatus", value: props.sentStatus }), React.createElement(input_1.AlwaysPost, { name: "cm_openedStatus", value: props.openedStatus }), React.createElement("label", null, React.createElement("p", null, "Messages: "), React.createElement(chosen_1.Chosen, { multi: true, removeSelected: true, value: props.selectedMessages, options: options, onChange: chosen_1.onChangeHandler(props.setMessages), placeholder: "Select messages...", style: { width: '600px' } })), React.createElement("label", null, React.createElement("p", null, "Sent Status: "), React.createElement(select_1.SingleBox, { value: props.sentStatus, onChange: function onChange(ss) {
	            return props.setSentStatus(data_1.isSentStatus(ss) ? ss : 'any');
	        }, enabled: props.selectedMessages.length > 0 }, React.createElement("option", { value: "any" }, "Any"), React.createElement("option", { value: "sent" }, "Sent"), React.createElement("option", { value: "unsent" }, "Unsent"))), React.createElement("label", null, React.createElement("p", null, "Opened Status: "), React.createElement(select_1.SingleBox, { value: props.openedStatus, onChange: function onChange(os) {
	            return props.setOpenedStatus(data_1.isOpenedStatus(os) ? os : 'any');
	        }, enabled: props.selectedMessages.length > 0 }, React.createElement("option", { value: "any" }, "Any"), React.createElement("option", { value: "opened" }, "Opened"), React.createElement("option", { value: "unopened" }, "Unopened"))));
	};
	var mapMessagesToOptions = function mapMessagesToOptions(messages, selectedMessages) {
	    return messages.map(function (m) {
	        return {
	            value: m.id,
	            label: m.title,
	            disabled: selectedMessages.find(function (sm) {
	                return sm == m.id;
	            }) !== undefined
	        };
	    });
	};

/***/ },

/***/ 574:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var actions_1 = __webpack_require__(570);
	exports.reducer = function (s, a) {
	    if (actions_1.isCommunicationsMessageFiltersAction(a)) {
	        return communicationsMessageFiltersReducer(s, a.action);
	    }
	    return s;
	};
	var communicationsMessageFiltersReducer = function communicationsMessageFiltersReducer(s, a) {
	    switch (a.type) {
	        case "set messages":
	            var numMessages = a.messages.length;
	            return Object.assign({}, s, { selectedMessages: a.messages, sentStatus: numMessages ? s.sentStatus : 'any', openedStatus: numMessages ? s.openedStatus : 'any' });
	        case "set sent status":
	            return Object.assign({}, s, { sentStatus: a.sentStatus });
	        case "set opened status":
	            return Object.assign({}, s, { openedStatus: a.openedStatus });
	    }
	};

/***/ },

/***/ 575:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(3);
	var ReactDOM = __webpack_require__(6);
	var app_1 = __webpack_require__(571);
	var redux_1 = __webpack_require__(22);
	var utils_1 = __webpack_require__(4);
	var reducers_1 = __webpack_require__(574);
	exports.communicationsMessageFilters = function (replace, params) {
	    var ownProps = function ownProps(store) {
	        return {
	            store: store,
	            messages: params.messages
	        };
	    };
	    var initialState = {
	        selectedMessages: params.selectedMessages,
	        sentStatus: params.sentStatus,
	        openedStatus: params.openedStatus
	    };
	    var div = document.createElement('div');
	    replace(div);
	    var store = redux_1.createStore(utils_1.withDefault(reducers_1.reducer, initialState), initialState);
	    ReactDOM.render(React.createElement(app_1.CommunicationsMessageFiltersApp, Object.assign({}, ownProps(store))), div);
	};

/***/ },

/***/ 576:
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.makeOperators = function (cb, params) {
	    var fragment = document.createDocumentFragment();
	    var hidden = document.createElement('input');
	    hidden.type = 'hidden';
	    hidden.name = params.name;
	    hidden.value = params.value;
	    fragment.appendChild(hidden);
	    var $field = params.field;
	    if ($field == 'c_BirthDate' || $field == 'c_DateCreated' || $field == 'c_LastEdit' || $field == 'membership2_CreatedDate' || $field == 'membership2_StartDate' || $field == 'membership2_ExpiryDate') {
	        var help = document.createElement('input');
	        help.type = 'button';
	        help.value = '?';
	        help.className = 'helpbutton';
	        help.onclick = function () {
	            return new_window(params.queryPage + '?command=displaySearchDatesHelp&noheaders=1&field=' + $field, 780, 580);
	        };
	        fragment.appendChild(help);
	    }
	    var button = document.createElement('input');
	    button.type = 'button';
	    button.name = 'button_' + params.name;
	    button.value = params.text;
	    button.style.color = '#555555';
	    //button.style.fontSize = '10px'
	    button.style.background = '#FFFFFF';
	    button.style.border = '1px solid #DDDDDD';
	    button.style.width = '100px';
	    //button onclick below due to forward reference
	    fragment.appendChild(button);
	    fragment.appendChild(document.createElement('br'));
	    var operators = document.createElement('div');
	    operators.className = 'hide';
	    operators.id = params.id;
	    operators.style.background = "#FFFFFF";
	    fragment.appendChild(operators);
	
	    var _loop = function _loop(operator_key) {
	        if (!params.operators.hasOwnProperty(operator_key)) return "continue";
	        var field = document.createElement('div');
	        field.style.color = '#000000';
	        field.style.fontSize = '12px';
	        field.style.background = '#EEEEEE';
	        field.style.border = '1px solid #000000';
	        field.style.width = '100px';
	        field.style.padding = '5px';
	        field.style.cursor = 'pointer';
	        field.onclick = function () {
	            hidden.value = operator_key;
	            button.value = params.operators[operator_key];
	            operators.className = 'hide';
	        };
	        field.textContent = params.operators[operator_key];
	        operators.appendChild(field);
	    };
	
	    for (var operator_key in params.operators) {
	        var _ret = _loop(operator_key);
	
	        if (_ret === "continue") continue;
	    }
	    button.onclick = function () {
	        operators.className = operators.className == 'show' ? 'hide' : 'show';
	    };
	    cb(fragment);
	};

/***/ },

/***/ 577:
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.isQueryFormAction = function (a) {
	  return a.type == 'query form action';
	};

/***/ },

/***/ 578:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) {
	            try {
	                step(generator.next(value));
	            } catch (e) {
	                reject(e);
	            }
	        }
	        function rejected(value) {
	            try {
	                step(generator["throw"](value));
	            } catch (e) {
	                reject(e);
	            }
	        }
	        function step(result) {
	            result.done ? resolve(result.value) : new P(function (resolve) {
	                resolve(result.value);
	            }).then(fulfilled, rejected);
	        }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var R = __webpack_require__(62);
	var react_redux_1 = __webpack_require__(23);
	var utils_1 = __webpack_require__(4);
	var presentation_1 = __webpack_require__(579);
	var commands_1 = __webpack_require__(12);
	var app_1 = __webpack_require__(596);
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	    return Object.assign({}, R.omit(['queryId', 'categoryManagerState'], state), { categoryManagerValueProps: app_1.categoryManagerMapStateToProps(state.categoryManagerState, ownProps) });
	};
	var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
	    var wrap = function wrap(action) {
	        return {
	            type: "query form action",
	            action: action
	        };
	    };
	    var dispatchAction = utils_1.compose(wrap, dispatch);
	    return {
	        setTitle: function setTitle(title) {
	            return dispatchAction({ type: "set title", title: title });
	        },
	        setSubmitting: function setSubmitting(submitting) {
	            return dispatchAction({ type: "set submitting", submitting: submitting });
	        },
	        onCancel: ownProps.onClose,
	        onSave: function onSave() {
	            return dispatch(saveQueryAction(dispatchAction, ownProps));
	        },
	        categoryManagerCallbackProps: app_1.categoryManagerMapDispatchToProps(dispatch)
	    };
	};
	var saveQueryAction = function saveQueryAction(dispatchWrapped, ownProps) {
	    return function (dispatchUnwrapped, getState) {
	        return __awaiter(undefined, void 0, void 0, regeneratorRuntime.mark(function _callee() {
	            var state, queryId, command, r;
	            return regeneratorRuntime.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            dispatchWrapped({ type: "set submitting", submitting: true });
	                            state = getState();
	                            _context.prev = 2;
	                            queryId = state.queryId;
	                            command = queryId > 0 ? 'save query' : 'create query';
	                            _context.next = 7;
	                            return new commands_1.CommandCaller(ownProps.ajaxPageUrl).runPost(command, commandParams(command, state));
	
	                        case 7:
	                            r = _context.sent;
	
	                            if (r.errorFields.length == 0) {
	                                ownProps.onClose();
	                            } else {
	                                dispatchWrapped({ type: 'set failure', errorFields: r.errorFields });
	                            }
	                            _context.next = 14;
	                            break;
	
	                        case 11:
	                            _context.prev = 11;
	                            _context.t0 = _context["catch"](2);
	
	                            window.alert("There was an unexpected error. Ensure you're logged in, your internet connection is working, and try reloading the page");
	
	                        case 14:
	                            dispatchWrapped({ type: "set submitting", submitting: false });
	
	                        case 15:
	                        case "end":
	                            return _context.stop();
	                    }
	                }
	            }, _callee, this, [[2, 11]]);
	        }));
	    };
	};
	var commandParams = function commandParams(ct, state) {
	    var selectedCategories = state.categoryManagerState.selectedCategories;
	    switch (ct) {
	        case 'create query':
	            return {
	                title: state.title,
	                categories: selectedCategories
	            };
	        case 'save query':
	            return {
	                queryId: +state.queryId,
	                title: state.title,
	                categories: selectedCategories
	            };
	    }
	};
	exports.QueryFormModalApp = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(presentation_1.QueryFormModal);

/***/ },

/***/ 579:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(3);
	var form_1 = __webpack_require__(55);
	var input_1 = __webpack_require__(34);
	var modal_1 = __webpack_require__(95);
	var presentation_1 = __webpack_require__(598);
	exports.QueryForm = function (props) {
	    var titleErrors = props.errorFields !== undefined ? props.errorFields.filter(function (e) {
	        return e.fieldType == 'title';
	    }) : [];
	    return React.createElement(form_1.Form, { hasSave: true, onSubmit: props.onSave, hasCancel: true, onCancel: props.onCancel, isSubmitting: props.submitting }, React.createElement("label", null, React.createElement("p", null, "Title: "), React.createElement(input_1.Input, { style: { width: "95%" }, value: props.title, onChange: props.setTitle, invalid: titleErrors.length > 0 }), titleErrors.length > 0 && React.createElement("ul", null, titleErrors.map(function (e) {
	        return React.createElement("li", { key: "error-" + e.fieldType, style: { color: "red" } }, React.createElement("p", { style: { color: "red" } }, e.errorMessage));
	    }))), props.categoryManagerValueProps.categories.length > 0 && React.createElement("label", null, React.createElement("p", null, "Categories: "), React.createElement(presentation_1.CategoryManager, Object.assign({}, props.categoryManagerValueProps, props.categoryManagerCallbackProps))));
	};
	exports.QueryFormModal = function (props) {
	    var style = modal_1.centeredModalProps('400px');
	    return React.createElement(modal_1.Modal, { style: style, isOpen: true, title: "Edit Query", onRequestClose: props.onCancel }, React.createElement(exports.QueryForm, Object.assign({}, props)));
	};

/***/ },

/***/ 580:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var actions_1 = __webpack_require__(577);
	var reducers_1 = __webpack_require__(599);
	var actions_2 = __webpack_require__(267);
	exports.reducer = function (s, a) {
	    if (actions_1.isQueryFormAction(a)) {
	        return queryFormReducer(s, a.action);
	    } else if (actions_2.isCategoryManagerAction(a)) {
	        return Object.assign({}, s, { categoryManagerState: reducers_1.categoryManagerReducer(s.categoryManagerState, a.action) });
	    }
	    return s;
	};
	var queryFormReducer = function queryFormReducer(s, a) {
	    switch (a.type) {
	        case "set title":
	            return Object.assign({}, s, { title: a.title });
	        case "set failure":
	            return Object.assign({}, s, { errorFields: a.errorFields });
	        case "set submitting":
	            return Object.assign({}, s, { submitting: a.submitting });
	    }
	};

/***/ },

/***/ 581:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) {
	            try {
	                step(generator.next(value));
	            } catch (e) {
	                reject(e);
	            }
	        }
	        function rejected(value) {
	            try {
	                step(generator["throw"](value));
	            } catch (e) {
	                reject(e);
	            }
	        }
	        function step(result) {
	            result.done ? resolve(result.value) : new P(function (resolve) {
	                resolve(result.value);
	            }).then(fulfilled, rejected);
	        }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(3);
	var commands_1 = __webpack_require__(12);
	var ReactDOM = __webpack_require__(6);
	var app_1 = __webpack_require__(578);
	var redux_1 = __webpack_require__(22);
	var utils_1 = __webpack_require__(4);
	var reducers_1 = __webpack_require__(580);
	var redux_thunk_1 = __webpack_require__(33);
	exports.getQueriesGridData = function (props) {
	    console.log(props);
	    return function (callback) {
	        var cc = new commands_1.CommandCaller(props.ajaxPageUrl);
	        cc.runGet(props.command, { categoryId: props.categoryId }).then(function (response) {
	            callback(response.content);
	        });
	    };
	};
	exports.deleteQueries = function (props) {
	    return function (ids) {
	        var pluralQueries = ids.split(',').length > 1 ? 'queries' : 'query';
	        if (confirm("Are you sure you want to permanently delete the selected " + pluralQueries + "?")) {
	            var cc = new commands_1.CommandCaller(props.ajaxPageUrl);
	            cc.runPost('delete queries', { ids: ids }).then(function () {
	                new HtmlDataGrid(props.grid).refresh();
	            });
	        }
	    };
	};
	exports.queryForm = function (props) {
	    return __awaiter(undefined, void 0, void 0, regeneratorRuntime.mark(function _callee() {
	        var sc, ownProps, initialState, div, body, store;
	        return regeneratorRuntime.wrap(function _callee$(_context) {
	            while (1) {
	                switch (_context.prev = _context.next) {
	                    case 0:
	                        _context.next = 2;
	                        return new commands_1.CommandCaller(props.ajaxPageUrl).runGet('get category tree data');
	
	                    case 2:
	                        sc = _context.sent;
	
	                        ownProps = function ownProps(store) {
	                            return {
	                                store: store,
	                                ajaxPageUrl: props.ajaxPageUrl,
	                                onClose: function onClose() {
	                                    ReactDOM.unmountComponentAtNode(div);
	                                    if (props.datagridId !== undefined) {
	                                        new HtmlDataGrid(props.datagridId).refresh();
	                                    }
	                                },
	                                categories: sc.categories
	                            };
	                        };
	
	                        initialState = {
	                            queryId: props.queryId !== undefined ? props.queryId : 0,
	                            title: props.title !== undefined ? props.title : '',
	                            submitting: false,
	                            errorFields: [],
	                            categoryManagerState: {
	                                selectedCategories: props.selectedCategories !== undefined ? props.selectedCategories : []
	                            }
	                        };
	                        div = document.createElement('div');
	                        body = document.getElementsByTagName('body')[0];
	
	                        body.appendChild(div);
	                        store = redux_1.createStore(utils_1.withDefault(reducers_1.reducer, initialState), initialState, redux_1.applyMiddleware(redux_thunk_1.default));
	
	                        ReactDOM.render(React.createElement(app_1.QueryFormModalApp, Object.assign({}, ownProps(store))), div);
	
	                    case 10:
	                    case "end":
	                        return _context.stop();
	                }
	            }
	        }, _callee, this);
	    }));
	};

/***/ },

/***/ 582:
/***/ function(module, exports) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	
	var Person = function () {
	    function Person(_id, _firstName, _lastName, _email) {
	        _classCallCheck(this, Person);
	
	        this._id = _id;
	        this._firstName = _firstName;
	        this._lastName = _lastName;
	        this._email = _email;
	    }
	
	    _createClass(Person, [{
	        key: "isLoggedIn",
	        value: function isLoggedIn() {
	            return this.id > 2;
	        }
	    }, {
	        key: "id",
	        get: function get() {
	            return this._id;
	        }
	    }, {
	        key: "firstName",
	        get: function get() {
	            return this._firstName;
	        }
	    }, {
	        key: "lastName",
	        get: function get() {
	            return this._lastName;
	        }
	    }, {
	        key: "email",
	        get: function get() {
	            return this._email;
	        }
	    }], [{
	        key: "fromObject",
	        value: function fromObject(object) {
	            return new Person(object.id, object.firstName, object.lastName, object.email);
	        }
	    }]);
	
	    return Person;
	}();
	
	exports.Person = Person;
	//# sourceMappingURL=value objects.js.map

/***/ },

/***/ 583:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var wbc = __webpack_require__(584);
	var ajax_1 = __webpack_require__(111);
	exports.wbcexport = wbc;
	exports.runThemeEditPage = function (cb, params) {
	    var i = params.i || 1;
	    var btn = document.getElementById("applyEverywhere");
	    //if we have nowhere to apply to, let's just wait a bit. "a bit" grows so that eventually we'll wait long enough no-one will know
	    if (!btn) {
	        if (i < 100000000) setTimeout(function () {
	            return exports.runThemeEditPage(cb, Object.assign({}, params, { i: i + 1 }));
	        }, i * 50);
	        return;
	    }
	    var ajax = new ajax_1.AjaxRequest(params.page);
	    btn.onclick = function () {
	        return confirm('Are you sure you want to apply this theme everywhere?') ? ajax.postForm({ 'apply this theme everywhere?': 'yes indeed' }) : void 0;
	    };
	};

/***/ },

/***/ 584:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var R = __webpack_require__(62); //we use this instead of Object.keys because it has better types
	var React = __webpack_require__(3);
	var ReactDOM = __webpack_require__(6);
	var Redux = __webpack_require__(22);
	var ReactRedux = __webpack_require__(23);
	var input_1 = __webpack_require__(34);
	var select_1 = __webpack_require__(39);
	var redux_thunk_1 = __webpack_require__(33);
	var DropDown = function DropDown(props) {
	    return React.createElement(select_1.SingleBox, { style: { width: "100%" }, onChange: props.onChange, value: props.selected, onFocus: function onFocus() {
	            return props.onFocus();
	        }, onKeyDown: function onKeyDown() {
	            return props.onFocus();
	        }, onMouseOver: function onMouseOver() {
	            return props.onMouseOver();
	        } }, React.createElement("option", { value: '', key: "string-literal" }, "(fixed string literal)"), props.active ? props.options : props.aoField.FieldName == "" ? [] : React.createElement("option", { key: props.aoField.FieldName, value: props.aoField.FieldName }, props.aoField.Status ? '* ' : '', props.aoField.Label));
	};
	var sortWordsBeforeNumbers = function sortWordsBeforeNumbers(a, b) {
	    var aIsNaN = isNaN(+a);
	    var bIsNaN = isNaN(+b);
	    return aIsNaN && !bIsNaN ? -1 : !aIsNaN && bIsNaN ? 1 : -1; //todo test this out. i want it to be stable.
	    //a < b ? -1 :
	    //a > b ? 1 :
	    //-1;
	};
	var keys = R.keys;
	var Display = function Display(props) {
	    var existing = props.existing && props.existing.length > 0 && React.createElement("div", null, React.createElement("p", null, "There are some existing downloads. These are deleted overnight."), React.createElement("ul", null, props.existing.map(function (e) {
	        return React.createElement("li", { key: e }, React.createElement("a", { href: "/.uploads/" + e }, e));
	    })));
	    return React.createElement("div", null, existing, React.createElement("p", null, React.createElement("button", { onClick: function onClick() {
	            props.submit(props.state);return false;
	        } }, "Run export")), React.createElement("p", null, "iMIS edition: ", React.createElement(select_1.SingleBox, { onChange: function onChange(e) {
	            return props.setEdition(e == '100' ? '100' : '300');
	        }, value: props.edition }, React.createElement("option", { value: '100' }, "WBC for iMIS 100"), React.createElement("option", { value: '300' }, "WBC for iMIS 300"))), React.createElement("table", null, React.createElement("tr", null, React.createElement("td", null, "Include Notes"), React.createElement("td", null, React.createElement("input", { checked: props.includeNotes, onChange: props.toggleIncludeNotes, type: "checkbox" }))), React.createElement("tr", null, React.createElement("td", null, "Include CPD"), React.createElement("td", null, React.createElement("input", { checked: props.includeCPD, onChange: props.toggleIncludeCPD, type: "checkbox" }))), React.createElement("tr", null, React.createElement("td", null, "Include Conferences"), React.createElement("td", null, React.createElement("input", { checked: props.includeConferences, onChange: props.toggleIncludeConferences, type: "checkbox" }))), React.createElement("tr", null, React.createElement("td", null, "Include Segmentation"), React.createElement("td", null, React.createElement("input", { checked: props.includeSegmentation, onChange: props.toggleIncludeSegmentation, type: "checkbox" }))), React.createElement("tr", null, React.createElement("td", null, "Include Subscriptions"), React.createElement("td", null, React.createElement("input", { checked: props.includeSubscriptions, onChange: props.toggleIncludeSubscriptions, type: "checkbox" }))), React.createElement("tr", null, React.createElement("td", null, "Include Events"), React.createElement("td", null, React.createElement("input", { checked: props.includeEvents, onChange: props.toggleIncludeEvents, type: "checkbox" })))), React.createElement("p", null, "How many records per go? If it doesn't work reduce these numbers."), React.createElement("p", null, "Records to hold in memory while generating ", React.createElement(input_1.Input, { numeric: { step: 1 }, value: props.recordsRead, onChange: props.setRecordsRead })), React.createElement("p", null, "Max records in an xlsx ", React.createElement(input_1.Input, { numeric: { step: 1 }, value: props.recordsPerFile, onChange: props.setRecordsPerFile }), ". If the final file would exceed this, we create separate xlsx files and give you a zip."), React.createElement("p", null, "Select the field mapping. We've made a best guess but we can't tell what all the spare fields mean. Consider copying the URL or bookmarking the page once you're set up since we load up from the url."), React.createElement("p", null, "Notes."), React.createElement("dl", null, React.createElement("dd", null, "AddressLine1, 2, 3"), React.createElement("dt", null, "AO can either store the local part of an address as separate lines or a single blob. If you select Address (i.e. a blob) you'll only get the matching line here, so you better select it for all three. We've guessed which you want based on which fields are enabled.")), React.createElement("table", null, React.createElement("thead", { style: { fontWeight: "bold" } }, React.createElement("tr", null, React.createElement("td", null, "AO Membership Status"), React.createElement("td", null, "WBC Membership Status"))), React.createElement("tbody", null, keys(props.statuses).sort(sortWordsBeforeNumbers).map(function (a) {
	        return React.createElement("tr", { key: props.statuses[a].label + "-status" }, React.createElement("td", null, props.statuses[a].label), React.createElement("td", null, React.createElement(input_1.Input, { value: props.statuses[a].newLabel, onChange: props.setMembershipStatus(a) })));
	    })), React.createElement("tfoot", null, React.createElement("tr", null, React.createElement("td", null, "Include Archived?"), React.createElement("td", null, React.createElement("input", { checked: props.includeArchived, onChange: props.toggleIncludeArchived, type: "checkbox" }))))), React.createElement("table", null, React.createElement("thead", { style: { fontWeight: "bold" } }, React.createElement("tr", null, React.createElement("td", null, "AO Membership Type"), React.createElement("td", null, "WBC Membership Type"), React.createElement("td", null, "Target"))), React.createElement("tbody", null, keys(props.membershipTypes).sort(sortWordsBeforeNumbers).map(function (a) {
	        return React.createElement("tr", { key: props.membershipTypes[a].label + "-key" }, React.createElement("td", null, props.membershipTypes[a].label), React.createElement("td", null, React.createElement(input_1.Input, { value: props.membershipTypes[a].newLabel, onChange: props.setMembershipType(a) })), React.createElement("td", null, props.membershipTypes[a].target));
	    }))), React.createElement("table", null, React.createElement("thead", null, React.createElement("tr", null, React.createElement("td", null, "WBC field"), React.createElement("td", null, "AO field label"), React.createElement("td", null, "AO internal field name"), React.createElement("td", null, "AO tab"), React.createElement("td", null, "AO field status"), React.createElement("td", null, "WBC literal content"))), keys(props.tabs).map(function (tabKind) {
	        var tab = props.tabs[tabKind];
	        var options = tab.aoFields.map(function (f) {
	            return React.createElement("option", { key: f.FieldName, value: f.FieldName }, f.Status ? '* ' : '', f.Label);
	        });
	        var defaultFields = tab.defaultFields;
	        return React.createElement("tbody", { key: tabKind }, React.createElement("tr", { onClick: function onClick() {
	                return props.toggle(tabKind);
	            } }, React.createElement("th", { style: { background: "#CCCCCC" }, colSpan: 6 }, tab.isVisible ? "▼" : "►", " ", tab.label)), tab.isVisible && keys(defaultFields).filter(function (a) {
	            return tab.defaultFields[a].editions.indexOf(props.edition) >= 0;
	        }).map(function (f) {
	            var selected = tab.fieldMap[f] || Object.assign({ isActive: false }, tab.defaultFields[f]);
	            var details = tab.aoFields.find(function (a) {
	                return a.FieldName == selected.aoField;
	            }) || {
	                Label: "(fixed string literal)",
	                FieldName: "",
	                Tab: '',
	                Status: false,
	                Configured: false,
	                Required: false,
	                Type: 'String'
	            };
	            var activate = function activate() {
	                return props.mouseOverField(tabKind, f);
	            };
	            return React.createElement("tr", { style: tab.defaultFields[f].isRelevant ? { background: 'yellow' } : undefined, key: (tab.focused || tab.moused ? "active" : "inactive") + f, onMouseOver: activate }, React.createElement("td", null, f), React.createElement("td", null, React.createElement(DropDown, { selected: selected.aoField, options: options, active: f == tab.focused || f == tab.moused, field: f, aoField: details, onMouseOver: activate, onFocus: function onFocus() {
	                    return props.focusField(tabKind, f);
	                }, onChange: function onChange(aoField) {
	                    return props.setField(f, aoField, selected.literal, tabKind);
	                } })), React.createElement("td", null, details.FieldName, " "), React.createElement("td", null, details.Tab), React.createElement("td", null, details.Required ? 'Required' : details.Status || !details.FieldName ? '' : 'Disabled'), React.createElement("td", null, selected.aoField === '' ? React.createElement(input_1.Input, { onChange: function onChange(literal) {
	                    return props.setField(f, '', literal, tabKind);
	                }, value: selected.literal }) : false));
	        }));
	    })));
	};
	var isActiveEdition = function isActiveEdition(test, actives) {
	    return actives.indexOf(test) >= 0;
	};
	var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
	    return {
	        submit: function submit(stateRO) {
	            return dispatch(function () {
	                var form = document.createElement("form");
	                form.method = 'POST';
	                var transferrableState = keys(ownProps.tabs).reduce(function (state, tab) {
	                    return reduceTab(tab, state, { fieldMap: Object.assign({}, ownProps.tabs[tab].defaultFields, state.tabs[tab].fieldMap) });
	                }, JSON.parse(JSON.stringify(stateRO)));
	                //remove such fields as are irrelevant
	                keys(ownProps.tabs).forEach(function (tab) {
	                    return keys(ownProps.tabs[tab].defaultFields).filter(
	                    // field => true // there should be none left
	                    function (field) {
	                        return !isActiveEdition(stateRO.imisEdition, ownProps.tabs[tab].defaultFields[field].editions);
	                    }).forEach(function (field) {
	                        return transferrableState.tabs[tab].fieldMap[field] = undefined;
	                    });
	                });
	                //note the side-effect
	                keys(ownProps.membershipTypes).reduce(function (types, type) {
	                    return Object.assign(transferrableState.membershipTypes, _defineProperty({}, type, types.hasOwnProperty(type) ? types[type] : ownProps.membershipTypes[type].label));
	                }, transferrableState.membershipTypes);
	                var stateField = document.createElement('input');
	                form.appendChild(stateField);
	                stateField.type = "hidden";
	                stateField.name = "state";
	                stateField.value = JSON.stringify(transferrableState);
	                form.style.display = 'none';
	                document.body.appendChild(form);
	                form.submit();
	            });
	        },
	        setRecordsRead: function setRecordsRead(value) {
	            return dispatch({ type: 'set records read', value: Number.parseInt(value) });
	        },
	        setRecordsPerFile: function setRecordsPerFile(value) {
	            return dispatch({ type: 'set records per file', value: Number.parseInt(value) });
	        },
	        setField: function setField(wbcField, aoField, literal, tab) {
	            return dispatch({ type: 'set field map', tab: tab, wbcField: wbcField, fieldMap: { aoField: aoField, literal: literal } });
	        },
	        toggle: function toggle(tab) {
	            return dispatch({ type: 'toggle visibility', tab: tab });
	        },
	        focusField: function focusField(tab, field) {
	            return dispatch({ type: 'focus field', tab: tab, field: field });
	        },
	        mouseOverField: function mouseOverField(tab, field) {
	            return dispatch({ type: 'mouse over field', tab: tab, field: field });
	        },
	        setMembershipType: function setMembershipType(serial) {
	            return function (newLabel) {
	                return dispatch({ type: 'set membership type', serial: serial, newLabel: newLabel });
	            };
	        },
	        setMembershipStatus: function setMembershipStatus(serial) {
	            return function (newLabel) {
	                return dispatch({ type: 'set membership status', serial: serial, newLabel: newLabel });
	            };
	        },
	        setEdition: function setEdition(edition) {
	            return dispatch({ type: 'set edition', edition: edition });
	        },
	        toggleIncludeArchived: function toggleIncludeArchived() {
	            return dispatch({ type: 'toggle include archived' });
	        },
	        toggleIncludeNotes: function toggleIncludeNotes() {
	            return dispatch({ type: 'toggle include notes' });
	        },
	        toggleIncludeCPD: function toggleIncludeCPD() {
	            return dispatch({ type: 'toggle include CPD' });
	        },
	        toggleIncludeConferences: function toggleIncludeConferences() {
	            return dispatch({ type: 'toggle include conferences' });
	        },
	        toggleIncludeSegmentation: function toggleIncludeSegmentation() {
	            return dispatch({ type: 'toggle include segmentation' });
	        },
	        toggleIncludeSubscriptions: function toggleIncludeSubscriptions() {
	            return dispatch({ type: 'toggle include subscriptions' });
	        },
	        toggleIncludeEvents: function toggleIncludeEvents() {
	            return dispatch({ type: 'toggle include events' });
	        }
	    };
	};
	var reduceFieldMap = function reduceFieldMap(fieldMap, action, defaults) {
	    if (defaults[action.wbcField].aoField == action.fieldMap.aoField && defaults[action.wbcField].literal == action.fieldMap.literal) {
	        var it = Object.assign({}, fieldMap);
	        delete it[action.wbcField];
	        return it;
	    } else {
	        return Object.assign({}, fieldMap, _defineProperty({}, action.wbcField, action.fieldMap));
	    }
	};
	var reduceTab = function reduceTab(tab, state, replace) {
	    return Object.assign({}, state, { tabs: Object.assign({}, state.tabs, _defineProperty({}, tab, Object.assign({}, state.tabs[tab], replace))) });
	};
	var mkReducer = function mkReducer(initialState, ownProps) {
	    return function () {
	        var s = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	        var action = arguments[1];
	
	        var tabs = ownProps.tabs;
	        var assign = function assign(c) {
	            return Object.assign({}, s, c);
	        };
	
	        var _ret = function () {
	            switch (action.type) {
	                case "set membership status":
	                    return {
	                        v: assign({ statuses: Object.assign({}, s.statuses, _defineProperty({}, action.serial, action.newLabel.slice(0, 5))) })
	                    };
	                case "set membership type":
	                    return {
	                        v: assign({ membershipTypes: Object.assign({}, s.membershipTypes, _defineProperty({}, action.serial, action.newLabel)) })
	                    };
	                case "toggle include archived":
	                    return {
	                        v: assign({ includeArchived: !s.includeArchived })
	                    };
	                case "toggle include notes":
	                    return {
	                        v: assign({ includeNotes: !s.includeNotes })
	                    };
	                case "toggle include CPD":
	                    return {
	                        v: assign({ includeCPD: !s.includeCPD })
	                    };
	                case "toggle include conferences":
	                    return {
	                        v: assign({ includeConferences: !s.includeConferences })
	                    };
	                case "toggle include segmentation":
	                    return {
	                        v: assign({ includeSegmentation: !s.includeSegmentation })
	                    };
	                case "toggle include subscriptions":
	                    return {
	                        v: assign({ includeSubscriptions: !s.includeSubscriptions })
	                    };
	                case "toggle include events":
	                    return {
	                        v: assign({ includeEvents: !s.includeEvents })
	                    };
	                case "mouse over field":
	                    return {
	                        v: reduceTab(action.tab, s, { moused: action.field })
	                    };
	                case "focus field":
	                    return {
	                        v: reduceTab(action.tab, s, { focused: action.field })
	                    };
	                case "set records per file":
	                    return {
	                        v: assign({ recordsPerFile: action.value })
	                    };
	                case "set records read":
	                    return {
	                        v: assign({ recordsRead: action.value })
	                    };
	                case "set edition":
	                    return {
	                        v: assign({ imisEdition: action.edition })
	                    };
	                case "toggle visibility":
	                    return {
	                        v: reduceTab(action.tab, s, { isVisible: !s.tabs[action.tab].isVisible })
	                    };
	                case "set field map":
	                    return {
	                        v: reduceTab(action.tab, s, { fieldMap: reduceFieldMap(s.tabs[action.tab].fieldMap, action, tabs[action.tab].defaultFields) })
	                    };
	                case "@@ INIT":
	                    return {
	                        v: initialState
	                    };
	                case "inject state":
	                    var recordsPerFile = action.state.hasOwnProperty('recordsPerFile') && typeof action.state['recordsPerFile'] == 'number' ? action.state['recordsPerFile'] : initialState.recordsPerFile;
	                    var recordsRead = action.state.hasOwnProperty('recordsRead') && typeof action.state['recordsRead'] == 'number' ? action.state['recordsRead'] : initialState.recordsRead;
	                    var statuses = {};
	                    if (action.state.hasOwnProperty('statuses') && _typeof(action.state.statuses) == 'object') {
	                        (function () {
	                            var stateStatuses = action.state.statuses;
	                            statuses = keys(stateStatuses).reduce(function (acc, k) {
	                                // noinspection SuspiciousTypeOfGuard who knows what it looks like
	                                if (stateStatuses.hasOwnProperty(k) && typeof stateStatuses[k] == 'string') {
	                                    return Object.assign(acc, _defineProperty({}, k, stateStatuses[k]));
	                                } else {
	                                    return acc;
	                                }
	                            }, {});
	                        })();
	                    }
	                    var membershipTypes = {};
	                    if (action.state.hasOwnProperty('membershipTypes') && _typeof(action.state.membershipTypes) == 'object') {
	                        (function () {
	                            var stateTypes = action.state.membershipTypes;
	                            membershipTypes = keys(stateTypes).reduce(function (acc, k) {
	                                // noinspection SuspiciousTypeOfGuard who knows what it looks like
	                                if (stateTypes.hasOwnProperty(k) && typeof stateTypes[k] == 'string') {
	                                    return Object.assign(acc, _defineProperty({}, k, stateTypes[k]));
	                                } else {
	                                    return acc;
	                                }
	                            }, {});
	                        })();
	                    }
	                    var edition = action.state.hasOwnProperty('imisEdition') && action.state.imisEdition == '100' ? '100' : '300';
	                    var includeArchived = action.state.hasOwnProperty('includeArchived') ? !!action.state.includeArchived : false;
	                    var includeNotes = action.state.hasOwnProperty('includeNotes') ? !!action.state.includeNotes : true;
	                    var includeCPD = action.state.hasOwnProperty('includeCPD') ? !!action.state.includeCPD : true;
	                    var includeConferences = action.state.hasOwnProperty('includeConferences') ? !!action.state.includeConferences : true;
	                    var includeSegmentation = action.state.hasOwnProperty('includeSegmentation') ? !!action.state.includeSegmentation : true;
	                    var includeSubscriptions = action.state.hasOwnProperty('includeSubscriptions') ? !!action.state.includeSubscriptions : true;
	                    var includeEvents = action.state.hasOwnProperty('includeEvents') ? !!action.state.includeEvents : true;
	                    var newState = {
	                        version: "one",
	                        imisEdition: edition,
	                        includeArchived: includeArchived,
	                        includeNotes: includeNotes,
	                        includeCPD: includeCPD,
	                        includeConferences: includeConferences,
	                        includeSegmentation: includeSegmentation,
	                        includeSubscriptions: includeSubscriptions,
	                        includeEvents: includeEvents,
	                        recordsPerFile: recordsPerFile,
	                        recordsRead: recordsRead,
	                        membershipTypes: membershipTypes,
	                        statuses: statuses,
	                        tabs: {
	                            Individuals: {
	                                isVisible: true,
	                                fieldMap: {}
	                            },
	                            Organisations: {
	                                isVisible: true,
	                                fieldMap: {}
	                            },
	                            WBCNameO: {
	                                isVisible: true,
	                                fieldMap: {}
	                            },
	                            WBCNameP: {
	                                isVisible: true,
	                                fieldMap: {}
	                            }
	                        }
	                    };
	                    //the intention is that all the casting here should be perfectly valid because
	                    //(a) we cast it to something that is generic and therefore will require us to check it before we use it
	                    //(b) we are casting to tell typescript to shut up in the case that is identifying code as an error since it's partially redundant
	                    //    (for instance, we're passing an array of {} to something that's meant to take a subset of {}, but it's safe because it will
	                    //    simply return false in the extra cases and therefore there's technically no type error)
	                    //i advise you not to trust me willy nilly.
	                    var state = action.state;
	                    if (state.hasOwnProperty('tabs') && _typeof(state.tabs) == 'object') {
	                        (function () {
	                            var stateTabs = action.state.tabs;
	                            keys(tabs).map(function (tabName) {
	                                if (stateTabs.hasOwnProperty(tabName) && _typeof(stateTabs[tabName]) == 'object' && stateTabs[tabName]) {
	                                    var stateTab = stateTabs[tabName];
	                                    if (stateTab && stateTab.hasOwnProperty('fieldMap') && _typeof(stateTab.fieldMap) == 'object') {
	                                        var newFields = stateTab.fieldMap;
	
	                                        var _loop = function _loop(wbcField) {
	                                            var field = newFields[wbcField];
	                                            if (tabs[tabName].defaultFields.hasOwnProperty(wbcField) && field.hasOwnProperty('aoField') && (field.aoField === '' || tabs[tabName].aoFields.find(function (a) {
	                                                return a.FieldName == field.aoField;
	                                            })) && field.hasOwnProperty('literal') && typeof field.literal == 'string') {
	                                                var literal = field.literal; //verified in the if
	                                                var aoField = field.aoField; // verified in the if - either branch confirms it's a string, since '' is a string and if it's in array of strings, it must be a string
	                                                var _action = {
	                                                    type: 'set field map',
	                                                    wbcField: wbcField,
	                                                    fieldMap: { literal: literal, aoField: aoField },
	                                                    tab: tabName
	                                                };
	                                                newState = reduceTab(tabName, newState, { fieldMap: reduceFieldMap(newState.tabs[tabName].fieldMap, _action, tabs[tabName].defaultFields) });
	                                            }
	                                        };
	
	                                        for (var wbcField in newFields) {
	                                            _loop(wbcField);
	                                        }
	                                    }
	                                }
	                            });
	                        })();
	                    }
	                    return {
	                        v: newState
	                    };
	            }
	        }();
	
	        if ((typeof _ret === "undefined" ? "undefined" : _typeof(_ret)) === "object") return _ret.v;
	    };
	};
	exports.runPage = function (cb, params) {
	    var div = document.createElement('div');
	    cb(div);
	    var addressEnabled = params.contactFields.filter(function (a) {
	        return a.FieldName === 'Address';
	    }).reduce(function (acc, it) {
	        return acc || it.Status;
	    }, false);
	    var companyAddressEnabled = params.companyFields.filter(function (a) {
	        return a.FieldName === 'CompanyAddress';
	    }).reduce(function (acc, it) {
	        return acc || it.Status;
	    }, false);
	    var defaultContactsFields = {
	        Id: { aoField: 'UserId', literal: '', isRelevant: true, editions: ['100', '300'] },
	        PartyType: { aoField: '', literal: 'P', isRelevant: true, editions: ['100', '300'] },
	        Status: { aoField: 'special:Archival Status', literal: '', isRelevant: true, editions: ['100', '300'] },
	        Category: { aoField: 'special:Category Title', literal: '', isRelevant: true, editions: ['300'] },
	        MemberType: { aoField: 'special:Membership Type', literal: '', isRelevant: true, editions: ['300'] },
	        PrimaryOrganizationId: { aoField: 'CompanyId', literal: '', isRelevant: true, editions: ['100', '300'] },
	        NamePrefix: { aoField: 'Title', literal: '', isRelevant: true, editions: ['100', '300'] },
	        FirstName: { aoField: 'FirstName', literal: '', isRelevant: true, editions: ['100', '300'] },
	        MiddleName: { aoField: '', literal: '', isRelevant: true, editions: ['100', '300'] },
	        LastName: { aoField: 'LastName', literal: '', isRelevant: true, editions: ['100', '300'] },
	        InformalName: { aoField: 'FirstName', literal: '', isRelevant: true, editions: ['100', '300'] },
	        NameSuffix: { aoField: '', literal: '', isRelevant: true, editions: ['100', '300'] },
	        Designation: { aoField: '', literal: '', isRelevant: true, editions: ['100', '300'] },
	        BirthDate: { aoField: 'BirthDate', literal: '', isRelevant: true, editions: ['100', '300'] },
	        Gender: { aoField: 'Gender', literal: '', isRelevant: true, editions: ['100', '300'] },
	        PrimaryOrganizationTitle: { aoField: '', literal: '', isRelevant: true, editions: ['100', '300'] },
	        OrganizationName: { aoField: '', literal: '', isRelevant: false, editions: ['100', '300'] },
	        MobilePhone: { aoField: 'Mobile', literal: '', isRelevant: true, editions: ['100', '300'] },
	        AddressPurpose: { aoField: '', literal: 'Street', isRelevant: true, editions: ['100', '300'] },
	        CommunicationReasons: { aoField: '', literal: 'default', isRelevant: true, editions: ['100', '300'] },
	        AddressLine1: { aoField: addressEnabled ? 'Address' : 'AddressLine1', literal: '', isRelevant: true, editions: ['100', '300'] },
	        AddressLine2: { aoField: addressEnabled ? 'Address' : 'AddressLine2', literal: '', isRelevant: true, editions: ['100', '300'] },
	        AddressLine3: { aoField: addressEnabled ? 'Address' : 'AddressLine3', literal: '', isRelevant: true, editions: ['100', '300'] },
	        CityName: { aoField: 'City', literal: '', isRelevant: true, editions: ['100', '300'] },
	        CountrySubEntityCode: { aoField: 'State', literal: '', isRelevant: true, editions: ['100', '300'] },
	        CountrySubEntityName: { aoField: 'State', literal: '', isRelevant: true, editions: ['100', '300'] },
	        CountryCode: { aoField: '', literal: '', isRelevant: true, editions: ['100', '300'] },
	        CountryName: { aoField: 'Country', literal: '', isRelevant: true, editions: ['100', '300'] },
	        PostalCode: { aoField: 'Postcode', literal: '', isRelevant: true, editions: ['100', '300'] },
	        Email: { aoField: 'Email1', literal: '', isRelevant: true, editions: ['100', '300'] },
	        Phone: { aoField: 'Phone', literal: '', isRelevant: true, editions: ['100', '300'] },
	        Fax: { aoField: 'Fax', literal: '', isRelevant: true, editions: ['100', '300'] },
	        ReceiptPreference: { aoField: '', literal: '', isRelevant: true, editions: ['100'] }
	    };
	    var defaultCompanyFields = {
	        Id: { aoField: 'UserId', literal: '', isRelevant: true, editions: ['100', "300"] },
	        PartyType: { aoField: '', literal: 'O', isRelevant: true, editions: ['100', '300'] },
	        Status: { aoField: 'special:Archival Status', literal: '', isRelevant: true, editions: ['100', '300'] },
	        Category: { aoField: 'special:Category Title', literal: '', isRelevant: true, editions: ['300'] },
	        MemberType: { aoField: 'special:Membership Type', literal: '', isRelevant: true, editions: ['300'] },
	        PrimaryOrganizationId: { aoField: '', literal: '', isRelevant: false, editions: ['100', '300'] },
	        NamePrefix: { aoField: '', literal: '', isRelevant: false, editions: ['100', '300'] },
	        FirstName: { aoField: '', literal: '', isRelevant: false, editions: ['100', '300'] },
	        MiddleName: { aoField: '', literal: '', isRelevant: false, editions: ['100', '300'] },
	        LastName: { aoField: '', literal: '', isRelevant: false, editions: ['100', '300'] },
	        InformalName: { aoField: '', literal: '', isRelevant: false, editions: ['100', '300'] },
	        NameSuffix: { aoField: '', literal: '', isRelevant: false, editions: ['100', '300'] },
	        Designation: { aoField: '', literal: '', isRelevant: false, editions: ['100', '300'] },
	        BirthDate: { aoField: '', literal: '', isRelevant: false, editions: ['100', '300'] },
	        Gender: { aoField: '', literal: '', isRelevant: false, editions: ['100', '300'] },
	        PrimaryOrganizationTitle: { aoField: '', literal: '', isRelevant: false, editions: ['100', '300'] },
	        OrganizationName: { aoField: 'Company', literal: '', isRelevant: true, editions: ['100', '300'] },
	        MobilePhone: { aoField: 'CompanyPhone', literal: '', isRelevant: true, editions: ['100', '300'] },
	        AddressPurpose: { aoField: '', literal: 'Street', isRelevant: true, editions: ['100', '300'] },
	        CommunicationReasons: { aoField: '', literal: 'default', isRelevant: true, editions: ['100', '300'] },
	        AddressLine1: { aoField: companyAddressEnabled ? 'CompanyAddress' : 'CompanyAddressLine1', literal: '', isRelevant: true, editions: ['100', '300'] },
	        AddressLine2: { aoField: companyAddressEnabled ? 'CompanyAddress' : 'CompanyAddressLine2', literal: '', isRelevant: true, editions: ['100', '300'] },
	        AddressLine3: { aoField: companyAddressEnabled ? 'CompanyAddress' : 'CompanyAddressLine3', literal: '', isRelevant: true, editions: ['100', '300'] },
	        CityName: { aoField: 'CompanyCity', literal: '', isRelevant: true, editions: ['100', '300'] },
	        CountrySubEntityCode: { aoField: 'CompanyState', literal: '', isRelevant: true, editions: ['100', '300'] },
	        CountrySubEntityName: { aoField: 'CompanyState', literal: '', isRelevant: true, editions: ['100', '300'] },
	        CountryCode: { aoField: '', literal: '', isRelevant: true, editions: ['100', '300'] },
	        CountryName: { aoField: 'CompanyCountry', literal: '', isRelevant: true, editions: ['100', '300'] },
	        PostalCode: { aoField: 'CompanyPostcode', literal: '', isRelevant: true, editions: ['100', '300'] },
	        Email: { aoField: 'CompanyEmail1', literal: '', isRelevant: true, editions: ['100', '300'] },
	        Phone: { aoField: 'CompanyPhone', literal: '', isRelevant: true, editions: ['100', '300'] },
	        Fax: { aoField: 'CompanyFax', literal: '', isRelevant: true, editions: ['100', '300'] },
	        ReceiptPreference: { aoField: '', literal: '', isRelevant: false, editions: ['100'] }
	    };
	    var defaultWbcNameFields = {
	        Website: { aoField: 'Web', literal: '', isRelevant: true, editions: ['100', '300'] },
	        Status: { aoField: '', literal: 'I', isRelevant: true, editions: ['300'] }
	    };
	    var defaultWbcNameOFields = {
	        Website: { aoField: 'CompanyWeb', literal: '', isRelevant: true, editions: ['100', '300'] },
	        Status: { aoField: '', literal: 'I', isRelevant: true, editions: ['300'] }
	    };
	    var initialState = {
	        version: "one",
	        includeArchived: false,
	        includeNotes: true,
	        includeCPD: true,
	        includeConferences: true,
	        includeSegmentation: true,
	        includeSubscriptions: true,
	        includeEvents: true,
	        imisEdition: "300",
	        tabs: {
	            Individuals: { isVisible: true, fieldMap: {} },
	            Organisations: { isVisible: true, fieldMap: {} },
	            WBCNameP: { isVisible: true, fieldMap: {} },
	            WBCNameO: { isVisible: true, fieldMap: {} }
	        },
	        recordsRead: 1000,
	        recordsPerFile: 10000,
	        membershipTypes: { "contact": "", "company": "" },
	        statuses: { "1": "A", "2": "L" }
	    };
	    var tabsProps = {
	        Individuals: {
	            label: "Individuals",
	            defaultFields: defaultContactsFields,
	            aoFields: params.contactFields
	        },
	        Organisations: {
	            label: "Organisations",
	            defaultFields: defaultCompanyFields,
	            aoFields: params.companyFields
	        },
	        WBCNameP: {
	            label: "WBC_Name (Individual memberships)",
	            defaultFields: defaultWbcNameFields,
	            aoFields: params.contactFields
	        },
	        WBCNameO: {
	            label: "WBC_Name (Organisational memberships)",
	            defaultFields: defaultWbcNameOFields,
	            aoFields: params.companyFields
	        }
	    };
	    var membershipTypes = params.membershipTypes.reduce(function (acc, me) {
	        return Object.assign(acc, _defineProperty({}, me.id, { label: me.title, target: me.target == 'organisation' ? 'organisation' : 'individual' }));
	    }, {
	        "contact": { label: "(contacts without memberships)", target: 'individual' },
	        "company": { label: "(companies without memberships but with exported members)", target: 'organisation' }
	    });
	    var addStatusToStatuses = function addStatusToStatuses(acc, me) {
	        return Object.assign(acc, _defineProperty({}, "" + me.id, me.title));
	    };
	    var existing = params.existing.filter(function (e) {
	        return e.endsWith('.zip');
	    });
	    var ownProps = {
	        tabs: tabsProps,
	        membershipTypes: membershipTypes,
	        statuses: params.membershipStatuses.reduce(addStatusToStatuses, {}),
	        existing: existing
	    };
	    var store = Redux.createStore(mkReducer(initialState, ownProps), initialState, Redux.applyMiddleware(redux_thunk_1.default));
	    var mapStateToProps = function mapStateToProps() {
	        var s = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	        var ownProps = arguments[1];
	        return {
	            existing: ownProps.existing,
	            edition: s.imisEdition,
	            recordsRead: s.recordsRead + "",
	            recordsPerFile: s.recordsPerFile + "",
	            state: s,
	            includeArchived: s.includeArchived,
	            includeNotes: s.includeNotes,
	            includeCPD: s.includeCPD,
	            includeConferences: s.includeConferences,
	            includeSubscriptions: s.includeSubscriptions,
	            includeSegmentation: s.includeSegmentation,
	            includeEvents: s.includeEvents,
	            tabs: {
	                Individuals: Object.assign({}, ownProps.tabs.Individuals, s.tabs.Individuals),
	                Organisations: Object.assign({}, ownProps.tabs.Organisations, s.tabs.Organisations),
	                WBCNameP: Object.assign({}, ownProps.tabs.WBCNameP, s.tabs.WBCNameP),
	                WBCNameO: Object.assign({}, ownProps.tabs.WBCNameO, s.tabs.WBCNameO)
	            },
	            membershipTypes: keys(ownProps.membershipTypes).reduce(function (acc, key) {
	                return Object.assign(acc, _defineProperty({}, key, {
	                    label: ownProps.membershipTypes[key].label,
	                    target: ownProps.membershipTypes[key].target,
	                    newLabel: s.membershipTypes.hasOwnProperty(key) ? s.membershipTypes[key] : ownProps.membershipTypes[key].label
	                }));
	            }, {}),
	            statuses: keys(ownProps.statuses).reduce( // todo some kind of indexwise zip
	            function (acc, key) {
	                return Object.assign(acc, _defineProperty({}, key, {
	                    label: ownProps.statuses[key],
	                    newLabel: s.statuses.hasOwnProperty(key) ? s.statuses[key] : ''
	                }));
	            }, {})
	        };
	    };
	    store.subscribe(function () {
	        var state = JSON.stringify(store.getState());
	        if (state !== window.location.hash) {
	            window.location.hash = state;
	        }
	    });
	    var loadFromUri = function loadFromUri() {
	        var hash = decodeURIComponent(window.location.hash.slice(1).replace('+', '%20'));
	        try {
	            var state = JSON.stringify(store.getState());
	            if (hash !== state) {
	                store.dispatch({ type: 'inject state', state: JSON.parse(hash) });
	            }
	        } catch (_a) {}
	    };
	    loadFromUri();
	    window.addEventListener('hashchange', loadFromUri);
	    var App = ReactRedux.connect(mapStateToProps, mapDispatchToProps)(Display);
	    ReactDOM.render(React.createElement(App, Object.assign({}, ownProps, { store: store })), div);
	};

/***/ },

/***/ 585:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var commands_1 = __webpack_require__(12);
	var reports_1 = __webpack_require__(586);
	var admin;
	(function (admin) {
	    admin.displayReports = function (apply, props) {
	        var div = document.createElement("div");
	        apply(div);
	        reports_1.addReportsToDiv(div, props);
	    };
	    admin.getFromEmailAddressStatsGridData = function (props) {
	        return function (callback) {
	            var cc = new commands_1.CommandCaller(props.ajaxPageUrl);
	            cc.runGet('emailmanager.fromEmailAddressStats', {}).then(function (response) {
	                callback(response.content);
	            });
	        };
	    };
	})(admin = exports.admin || (exports.admin = {}));

/***/ },

/***/ 586:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) {
	            try {
	                step(generator.next(value));
	            } catch (e) {
	                reject(e);
	            }
	        }
	        function rejected(value) {
	            try {
	                step(generator["throw"](value));
	            } catch (e) {
	                reject(e);
	            }
	        }
	        function step(result) {
	            result.done ? resolve(result.value) : new P(function (resolve) {
	                resolve(result.value);
	            }).then(fulfilled, rejected);
	        }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(3);
	var ReactDOM = __webpack_require__(6);
	var report_builder_1 = __webpack_require__(179);
	var redux_1 = __webpack_require__(22);
	var redux_thunk_1 = __webpack_require__(33);
	var commands_1 = __webpack_require__(12);
	var lib_1 = __webpack_require__(181);
	var graph_renderer_1 = __webpack_require__(137);
	var react_redux_1 = __webpack_require__(23);
	var lib1_1 = __webpack_require__(270);
	var utils_1 = __webpack_require__(4);
	var ReportApp = react_redux_1.connect(function (a, b) {
	    return lib_1.mapStateToProps(a.report, b);
	}, function (a, b) {
	    return lib_1.mapDispatchToProps(a, b);
	})(lib1_1.Report);
	var isStatsAction = function isStatsAction(a) {
	    return a.type == "update report stats";
	};
	var statsReducer = function statsReducer(s, a) {
	    return isStatsAction(a) ? a.stats : s;
	};
	var reducer = function reducer(s, a) {
	    return {
	        report: report_builder_1.reducer(s.report, a),
	        stats: statsReducer(s.stats, a)
	    };
	};
	exports.addReportsToDiv = function (div, params) {
	    var content = document.getElementById('content');
	    if (content) {
	        content.getElementsByTagName('table')[0].style.width = '100%';
	    }
	    var fromDate = new Date(params.dates.startYear, params.dates.startMonth, params.dates.startDay);
	    var toDate = new Date(params.dates.endYear, params.dates.endMonth, params.dates.endDay);
	    var initialState = {
	        report: {
	            reportType: "Sent Messages",
	            displayMode: "Graph",
	            filters: { date: { type: "date range", fromDate: fromDate, toDate: toDate }, messages: { type: "checkbox", checked: [] } }
	        },
	        stats: undefined
	    };
	    var store = redux_1.createStore(utils_1.withDefault(reducer, initialState), initialState, redux_1.applyMiddleware(redux_thunk_1.default));
	    var isHidden = params.emailIdentifier.length > 0;
	    var props = {
	        modes: Object.assign({}, graph_renderer_1.standardModes, { Statistics: function Statistics() {
	                var s = store.getState();
	                var data = s.stats;
	                return !data ? React.createElement("div", null, "No data") : React.createElement("table", null, React.createElement("tr", null, React.createElement("th", null, "Query:"), React.createElement("td", null, data.quantityFormat)), React.createElement("tr", null, React.createElement("th", null, "Unsubscribed:"), React.createElement("td", null, data.unsubscribedCountFormat)), React.createElement("tr", null, React.createElement("th", null, "Invalid Email:"), React.createElement("td", null, data.invalidEmailCountFormat)), React.createElement("tr", null, React.createElement("th", null, "Bounced:"), React.createElement("td", null, data.bouncedCountFormat)), React.createElement("tr", null, React.createElement("th", null, "Sent:"), React.createElement("td", null, data.sentCountFormat)), React.createElement("tr", null, React.createElement("th", null, "Unique Opened:"), React.createElement("td", null, data.uniqueOpenedTotalFormat)), React.createElement("tr", null, React.createElement("th", null, "Unique Opened %:"), React.createElement("td", null, data.uniqueOpenedPercentageFormat)));
	            } }),
	        reportTypes: {
	            "Sent Messages": {
	                label: "Sent Messages",
	                axis: 'email types',
	                filters: ["date", "messages"],
	                renderAs: "line",
	                removeEmptyAxes: true,
	                keys: [{ id: 'Date', label: 'Date' }],
	                defaultDisplayMode: "Graph",
	                displayModes: ["Graph", "Table", "Statistics"]
	            }
	        },
	        filters: { date: {
	                type: "date range", isHidden: isHidden
	            }, messages: {
	                type: "checkbox", isHidden: isHidden, label: "Messages", group: params.messages.map(function (m) {
	                    return { value: m.serial, label: m.title };
	                })
	            } },
	        axes: { "email types": [{ label: "Undelivered Messages", value: "unOpened" }, { value: "bounced", label: "Bounced Messages" }, { value: "opened", label: "Opened Messages" }, { value: "sent", label: "Sent Messages" }] },
	        runReport: function runReport(dispatchWrapped) {
	            return function (dispatchUnwrapped, getState) {
	                return __awaiter(undefined, void 0, void 0, regeneratorRuntime.mark(function _callee() {
	                    var instance, state, date, messages, identifiers, commandParams, a, action;
	                    return regeneratorRuntime.wrap(function _callee$(_context) {
	                        while (1) {
	                            switch (_context.prev = _context.next) {
	                                case 0:
	                                    instance = params.instance;
	                                    state = getState().report;
	                                    date = state.filters.date;
	                                    messages = state.filters.messages;
	                                    identifiers = params.emailIdentifier.length == 1 ? [0, params.emailIdentifier[0]] //some weird special case in the service
	                                    : messages.type == "checkbox" ? messages.checked : params.emailIdentifier;
	                                    commandParams = {
	                                        startDate: utils_1.dateToYYYYMMDD(date.type == "date range" ? date.fromDate : new Date()),
	                                        endDate: utils_1.dateToYYYYMMDD(date.type == "date range" ? date.toDate : new Date()),
	                                        emailIdentifiers: identifiers,
	                                        instance: instance
	                                    };
	                                    _context.next = 8;
	                                    return new commands_1.CommandCaller(params.ajaxPageUrl).runGet('run sent emails report', commandParams);
	
	                                case 8:
	                                    a = _context.sent;
	                                    action = { stats: a.statistics, type: "update report stats" };
	
	                                    dispatchUnwrapped(action);
	                                    dispatchWrapped({
	                                        type: "set new report data",
	                                        data: {
	                                            renderAs: 'line',
	                                            axis: "email types",
	                                            data: utils_1.flatten(a.list.map(function (item) {
	                                                return [{ id: 'unOpened', key: item.DateFormat, value: item.unOpened }, { id: 'opened', key: item.DateFormat, value: item.opened }, { id: 'sent', key: item.DateFormat, value: item.sent }, { id: 'bounced', key: item.DateFormat, value: item.bounced }];
	                                            }))
	                                        }
	                                    });
	
	                                case 12:
	                                case "end":
	                                    return _context.stop();
	                            }
	                        }
	                    }, _callee, this);
	                }));
	            };
	        },
	        title: "Email Reports"
	    };
	    ReactDOM.render(React.createElement(ReportApp, Object.assign({}, props, { store: store })), div);
	    var dispatchers = lib_1.mapDispatchToProps(store.dispatch, props);
	    dispatchers.runReport();
	};

/***/ },

/***/ 587:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) {
	            try {
	                step(generator.next(value));
	            } catch (e) {
	                reject(e);
	            }
	        }
	        function rejected(value) {
	            try {
	                step(generator["throw"](value));
	            } catch (e) {
	                reject(e);
	            }
	        }
	        function step(result) {
	            result.done ? resolve(result.value) : new P(function (resolve) {
	                resolve(result.value);
	            }).then(fulfilled, rejected);
	        }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(3);
	var ReactDOM = __webpack_require__(6);
	var utils_1 = __webpack_require__(4);
	var ajax_1 = __webpack_require__(111);
	var StandardButtons = function StandardButtons(params) {
	    return React.createElement("tr", null, React.createElement("td", { colSpan: 7, style: { textAlign: "center" } }, React.createElement("button", { type: "button", className: "submit", style: { width: "auto" }, onClick: function onClick() {
	            return new_window_resizable(params.nameTagsLink, 800, 600);
	        }, disabled: params.nameTagsDisabled }, "Print Name Tags"), "\u2003", React.createElement("button", { type: "button", className: "submit", style: { width: "auto" }, onClick: function onClick() {
	            return new_window_resizable(params.nameTagsSpeakerLink, 800, 600);
	        }, disabled: params.nameTagsSpeakerDisabled }, "Print Speaker Name Tags"), "\u2003", React.createElement("button", { type: "button", className: "submit", style: { width: "auto" }, onClick: function onClick() {
	            return new_window_resizable(params.seatingLink, 800, 600);
	        }, disabled: params.seatingDisabled }, "Print Seating"), "\u2003", React.createElement("button", { type: "button", className: "submit", style: { width: "auto" }, onClick: function onClick() {
	            return document.location.assign(params.exportLink);
	        } }, "Export"), params.withETANSWExport && React.createElement("button", { type: "button", className: "submit", style: { width: "auto" }, onClick: function onClick() {
	            return document.location.assign(params.exportLink + "&etanswexport=1");
	        } }, "ETANSW Export"), React.createElement("br", null)));
	};
	exports.noRegistrationsFound = function (replace, params) {
	    var div = document.createElement('div');
	    ReactDOM.render(React.createElement(NoRegistrationsUI, null), div);
	    replace(div);
	};
	var NoRegistrationsUI = function NoRegistrationsUI() {
	    return React.createElement("div", { className: "form", style: { padding: '10px' } }, React.createElement("h3", { style: { textAlign: 'center' } }, "No Registrations Found"));
	};
	exports.registrations = function (replace, params) {
	    var div = document.createElement('div');
	    replace(div);
	    ReactDOM.render(React.createElement(RegistrationsUI, Object.assign({}, params)), div);
	};
	var RegistrationsUI = function RegistrationsUI(params) {
	    return React.createElement("table", { className: "adminlist border", cellSpacing: 0 }, React.createElement("thead", null, React.createElement(StandardButtons, Object.assign({}, params)), React.createElement("tr", null, React.createElement("th", { style: { width: "30px" } }, React.createElement("a", { href: "#", onClick: function onClick() {
	            if (confirm('This action will delete the checked registrations from the event.\n\nNO MONEY WILL BE REFUNDED\n\nAre you sure you want to delete?')) {
	                document.deleteRegistrationsForm.deleteRegistrationsTrigger.value = '1';
	                document.deleteRegistrationsForm.submit();
	            }
	        } }, React.createElement("img", { src: "/sb/static/images/icons/delete.gif", width: "20", height: "22" }))), React.createElement("th", { style: { width: "220px", textAlign: "left" } }, "Name"), React.createElement("th", { style: { width: "215px" } }, "Email"), React.createElement("th", { style: { width: "80px" } }, "Status"), React.createElement("th", { style: { width: "70px" } }, "Reg Date"), React.createElement("th", { style: { width: "55px" } }, "Order No"), params.withMoodle && React.createElement("th", { style: { width: "55px" } }, "Moodle"), React.createElement("th", { style: { width: "24px" } }, "\xA0"))), React.createElement("tbody", null, params.records.map(function (p) {
	        return React.createElement(RegistrationUI, { withMoodle: params.withMoodle, key: p.ix, props: p });
	    })), React.createElement("tfoot", null, React.createElement(StandardButtons, Object.assign({}, params))));
	};
	var RegistrationUI = function RegistrationUI(params) {
	    switch (params.props.type) {
	        case "group":
	            return React.createElement(exports.GroupRegistrationUI, Object.assign({ withMoodle: params.withMoodle }, params.props.prop));
	        case "record":
	            return React.createElement(StandardRegistrationUI, Object.assign({ withMoodle: params.withMoodle }, params.props.prop));
	    }
	};
	exports.GroupRegistrationUI = function (params) {
	    var topBorderStyle = { borderTop: '1px solid #808040' };
	    var leftBorderStyle = { borderLeft: '1px solid #808040' };
	    var rightBorderStyle = { borderRight: '1px solid #808040' };
	    var moodleSkip = params.withMoodle ? 1 : 0;
	    return React.createElement("tr", null, React.createElement("th", { colSpan: 6 + moodleSkip, style: Object.assign({ textAlign: "left", paddingLeft: "4px" }, topBorderStyle, leftBorderStyle) }, React.createElement("a", { href: params.editGroupLink }, params.groupIdentifierText, params.groupNumberInfo)), React.createElement("th", { style: Object.assign({}, topBorderStyle, rightBorderStyle) }, React.createElement("a", { href: params.editGroupLink, title: "Edit Group Registration" }, React.createElement("img", { src: "/sb/static/images/icons/group_edit.png", width: "16", height: "16" }))));
	};
	var allReasons = {
	    alreadyEnrolled: " - they were already enrolled",
	    couldNotConnect: " - we could not connect to moodle",
	    noEmail: " - the user doesn't have a valid email address - please set one in Contacts",
	    noMoodle: " - this site has not been connected to Moodle",
	    noMoodleCourse: " - this event has not been assigned a Moodle course - please set one in the Event Details",
	    perfectSuccess: "The user has been successfully enrolled in the moodle course"
	};
	
	var StandardRegistrationUI = function (_React$Component) {
	    _inherits(StandardRegistrationUI, _React$Component);
	
	    function StandardRegistrationUI(props, context) {
	        _classCallCheck(this, StandardRegistrationUI);
	
	        var _this = _possibleConstructorReturn(this, (StandardRegistrationUI.__proto__ || Object.getPrototypeOf(StandardRegistrationUI)).call(this, props, context));
	
	        _this.state = { isHovering: false, isRemoodling: false, moodleReg: props.moodleReg };
	        _this.setHover = function (state) {
	            return _this.setState({ isHovering: state });
	        };
	        _this.remoodle = function (e) {
	            return __awaiter(_this, void 0, void 0, regeneratorRuntime.mark(function _callee2() {
	                var _this2 = this;
	
	                return regeneratorRuntime.wrap(function _callee2$(_context2) {
	                    while (1) {
	                        switch (_context2.prev = _context2.next) {
	                            case 0:
	                                e.preventDefault();
	                                this.setState({ isRemoodling: true });
	                                _context2.prev = 2;
	                                return _context2.delegateYield(regeneratorRuntime.mark(function _callee() {
	                                    var res, failure, reasons;
	                                    return regeneratorRuntime.wrap(function _callee$(_context) {
	                                        while (1) {
	                                            switch (_context.prev = _context.next) {
	                                                case 0:
	                                                    _context.next = 2;
	                                                    return new ajax_1.AjaxRequest(_this2.props.remoodleUrl).runGet({});
	
	                                                case 2:
	                                                    res = _context.sent;
	                                                    failure = res.perfectSuccess ? "" : "The user was not enrolled: \n";
	                                                    //hack around some filthy typescriptian lies
	
	                                                    reasons = utils_1.mapObjectKeys(res, function (k) {
	                                                        return res[k] ? allReasons[k] : false;
	                                                    }) // why can't typescript tell that? sigh
	                                                    .filter(function (x) {
	                                                        return x;
	                                                    });
	
	                                                    alert(failure + reasons.join("\n"));
	                                                    if (res.perfectSuccess || res.alreadyEnrolled) {
	                                                        _this2.setState({ moodleReg: true });
	                                                    }
	
	                                                case 7:
	                                                case "end":
	                                                    return _context.stop();
	                                            }
	                                        }
	                                    }, _callee, _this2);
	                                })(), "t0", 4);
	
	                            case 4:
	                                _context2.next = 10;
	                                break;
	
	                            case 6:
	                                _context2.prev = 6;
	                                _context2.t1 = _context2["catch"](2);
	
	                                alert("An error occurred while communicating with the server. Please refresh the page, and if necessary try again.");
	                                console.log(_context2.t1);
	
	                            case 10:
	                                this.setState({ isRemoodling: false });
	
	                            case 11:
	                            case "end":
	                                return _context2.stop();
	                        }
	                    }
	                }, _callee2, this, [[2, 6]]);
	            }));
	        };
	        return _this;
	    }
	
	    _createClass(StandardRegistrationUI, [{
	        key: "render",
	        value: function render() {
	            var _this3 = this;
	
	            var isPending = !!Number.parseInt(this.props.regDetails.isPending);
	            var bgColor = this.state.isHovering ? '#D0D0D0' : this.props.bgColor;
	            var leftBorderStyle = this.props.regDetails.registrationGroupSerial > 0 ? { borderLeft: '1px solid #808040' } : {};
	            var rightBorderStyle = this.props.regDetails.registrationGroupSerial > 0 ? { borderRight: '1px solid #808040' } : {};
	            var bottomBorderStyle = this.props.isLastInGroup ? { borderBottom: '1px solid #808040' } : {};
	            var textStyle = isPending ? { color: '#777777' } : {};
	            var deleteRegistrationCheckbox = Number.parseInt(this.props.regDetails.tablePriceSerial) || isPending ? React.createElement("span", null, "\xA0") : React.createElement("input", { type: "checkbox", name: "deleteRegistrations[]", value: this.props.regDetails.registrationSerial });
	            return React.createElement("tr", { style: {
	                    height: "25px",
	                    backgroundColor: bgColor
	                }, onMouseOver: function onMouseOver() {
	                    return _this3.setHover(true);
	                }, onMouseOut: function onMouseOut() {
	                    return _this3.setHover(false);
	                } }, React.createElement("td", { style: Object.assign({ textAlign: 'center' }, leftBorderStyle, bottomBorderStyle) }, deleteRegistrationCheckbox), React.createElement("td", { style: bottomBorderStyle }, React.createElement("a", { href: this.props.eventRegistrationFormUrl, style: textStyle }, this.props.regDetailsNote)), React.createElement("td", { style: Object.assign({ textAlign: 'center' }, bottomBorderStyle, textStyle) }, this.props.regDetails.email, "\xA0"), React.createElement("td", { style: Object.assign({ textAlign: 'center' }, bottomBorderStyle, textStyle) }, this.props.regStatus), React.createElement("td", { style: Object.assign({ textAlign: 'center' }, bottomBorderStyle, textStyle) }, this.props.regDate), React.createElement("td", { style: Object.assign({ textAlign: 'center' }, bottomBorderStyle, textStyle) }, this.props.regOrderSerial), this.props.withMoodle && React.createElement("td", { style: Object.assign({ textAlign: 'center' }, bottomBorderStyle, textStyle) }, !isPending && (this.state.moodleReg ? "✔️" : React.createElement("input", { onClick: this.remoodle, disabled: this.state.isRemoodling, type: "image", height: 16, width: 16, src: this.state.isRemoodling ? "/sb/static/images/loadergif.gif" : "/sb/static/images/icons/arrow_refresh.png" }))), React.createElement("td", { style: Object.assign({ textAlign: 'center' }, rightBorderStyle, bottomBorderStyle) }, React.createElement("a", { href: this.props.eventRegistrationFormUrl }, React.createElement("img", { src: "/sb/static/images/icons/note_edit.png", width: "16", height: "16" }))));
	        }
	    }]);
	
	    return StandardRegistrationUI;
	}(React.Component);

/***/ },

/***/ 588:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var $ = __webpack_require__(10);
	function onAttendanceChange(registrationSerial, attendanceName) {
	    var dateDiv = $("#ad_" + registrationSerial);
	    var yesChecked = $("#" + attendanceName + "_yes:checked").length;
	    if (yesChecked) {
	        dateDiv.show();
	    } else {
	        dateDiv.hide();
	    }
	}
	exports.onAttendanceChange = onAttendanceChange;

/***/ },

/***/ 589:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var EventAttendance_ = __webpack_require__(588);
	var FrontPage_ = __webpack_require__(590);
	var AdminEventRegistrationPage_ = __webpack_require__(587);
	exports.EventAttendance = EventAttendance_;
	exports.FrontPage = FrontPage_;
	exports.AdminEventRegistrationPage = AdminEventRegistrationPage_;

/***/ },

/***/ 590:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) {
	            try {
	                step(generator.next(value));
	            } catch (e) {
	                reject(e);
	            }
	        }
	        function rejected(value) {
	            try {
	                step(generator["throw"](value));
	            } catch (e) {
	                reject(e);
	            }
	        }
	        function step(result) {
	            result.done ? resolve(result.value) : new P(function (resolve) {
	                resolve(result.value);
	            }).then(fulfilled, rejected);
	        }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var $ = __webpack_require__(10);
	var commands_1 = __webpack_require__(12);
	exports.filterByCategory = function (ajaxPageUrl) {
	    return __awaiter(undefined, void 0, void 0, regeneratorRuntime.mark(function _callee() {
	        var filter, target, filterCategoryId;
	        return regeneratorRuntime.wrap(function _callee$(_context) {
	            while (1) {
	                switch (_context.prev = _context.next) {
	                    case 0:
	                        filter = document.getElementById('frontPageCategoryFilterId');
	                        target = document.getElementById('frontPageContent');
	
	                        if (!(filter && target)) {
	                            _context.next = 9;
	                            break;
	                        }
	
	                        filterCategoryId = filter.value;
	                        /* we use jquery here because we need the replacement javascript to be evaluated */
	
	                        _context.t0 = $(target);
	                        _context.next = 7;
	                        return new commands_1.CommandCaller(ajaxPageUrl).runGet('front page content for category', { filterCategoryId: filterCategoryId });
	
	                    case 7:
	                        _context.t1 = _context.sent;
	
	                        _context.t0.replaceWith.call(_context.t0, _context.t1);
	
	                    case 9:
	                    case "end":
	                        return _context.stop();
	                }
	            }
	        }, _callee, this);
	    }));
	};

/***/ },

/***/ 591:
/***/ function(module, exports) {

	"use strict";
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	
	var TemplateParser = function () {
	    function TemplateParser() {
	        _classCallCheck(this, TemplateParser);
	    }
	
	    _createClass(TemplateParser, null, [{
	        key: "parse",
	        value: function parse(templateString) {
	            var root = new Template();
	            var template = root;
	            var regex = /<(tplnot|tpl)\s.*?id="(.*?)".*?>|<\/(tplnot|tpl)>|\[(.*?)\]/ig;
	            var match = regex.exec(templateString);
	            var currentIndex = 0;
	            while (match != null) {
	                // The bit between the last match and the current match is a piece of text.
	                // Note that it may be empty, but we don't really care about that.
	                var previousTextPart = templateString.substring(currentIndex, match.index);
	                template = template.handleText(previousTextPart);
	                template = template.handleText(match[0]);
	                currentIndex = regex.lastIndex;
	                match = regex.exec(templateString);
	            }
	            root.handleText(templateString.substring(currentIndex));
	            return root;
	        }
	    }]);
	
	    return TemplateParser;
	}();
	
	var Template = function () {
	    function Template() {
	        _classCallCheck(this, Template);
	
	        this.parts = [];
	        this.knownPlaceholders = [];
	    }
	
	    _createClass(Template, [{
	        key: "getKnownPlaceholders",
	        value: function getKnownPlaceholders() {
	            return this.knownPlaceholders;
	        }
	    }, {
	        key: "handleText",
	        value: function handleText(text) {
	            var conditional = TemplatePartConditional.create(this, text);
	            if (conditional != null) {
	                this.parts.push(conditional);
	                this.knownPlaceholders.push(conditional.getId());
	                return conditional;
	            } else if (text.charAt(0) == '[' && text.charAt(text.length - 1) == ']') {
	                var placeholder = new TemplatePartPlaceholder(text.substring(1, text.length - 1));
	                this.parts.push(placeholder);
	                this.knownPlaceholders.push(placeholder.getName());
	                return this;
	            } else {
	                this.parts.push(new TemplatePartText(text));
	                return this;
	            }
	        }
	    }, {
	        key: "evaluate",
	        value: function evaluate(placeholders) {
	            var template = "";
	            this.parts.forEach(function (part) {
	                template += part.evaluate(placeholders);
	            });
	            return template;
	        }
	    }, {
	        key: "addKnownPlaceholders",
	        value: function addKnownPlaceholders(placeholders) {
	            var _this = this;
	
	            placeholders.forEach(function (placeholder) {
	                _this.knownPlaceholders.push(placeholder);
	            });
	        }
	    }], [{
	        key: "fromString",
	        value: function fromString(templateString) {
	            return TemplateParser.parse(templateString);
	        }
	    }]);
	
	    return Template;
	}();
	
	exports.Template = Template;
	
	var TemplatePartConditional = function (_Template) {
	    _inherits(TemplatePartConditional, _Template);
	
	    function TemplatePartConditional(parent, id) {
	        _classCallCheck(this, TemplatePartConditional);
	
	        var _this2 = _possibleConstructorReturn(this, (TemplatePartConditional.__proto__ || Object.getPrototypeOf(TemplatePartConditional)).call(this));
	
	        _this2.parent = parent;
	        _this2.id = id;
	        _this2.inverted = false;
	        return _this2;
	    }
	
	    _createClass(TemplatePartConditional, [{
	        key: "getId",
	        value: function getId() {
	            return this.id;
	        }
	    }, {
	        key: "handleText",
	        value: function handleText(text) {
	            var isTplNot = text == "</tplnot>";
	            var isTpl = text == "</tpl>";
	            if (isTplNot && !this.inverted || isTpl && this.inverted) {
	                // Note that at time of writing, we don't have a way to get javascript errors to notify developers.
	                // However, this should get picked up by deployment at the time that templates are changed, when they
	                // try to view the template and it doesn't work.
	                throw new Error("Mismatching tpl/tplnot tags when parsing template.");
	            }
	            if (isTplNot || isTpl) {
	                this.parent.addKnownPlaceholders(this.getKnownPlaceholders());
	                return this.parent;
	            }
	            return _get(TemplatePartConditional.prototype.__proto__ || Object.getPrototypeOf(TemplatePartConditional.prototype), "handleText", this).call(this, text);
	        }
	    }, {
	        key: "invert",
	        value: function invert() {
	            this.inverted = true;
	        }
	    }, {
	        key: "matches",
	        value: function matches(value) {
	            // Inspired by the PHP "contentAsBool" method in inner template manager.
	            return value != null && value.toString().length > 0 && value.toString() != "0";
	        }
	    }, {
	        key: "evaluate",
	        value: function evaluate(placeholders) {
	            var value = placeholders.hasOwnProperty(this.id) ? placeholders[this.id] : null;
	            var matches = this.matches(value);
	            if (matches && !this.inverted || !matches && this.inverted) {
	                return _get(TemplatePartConditional.prototype.__proto__ || Object.getPrototypeOf(TemplatePartConditional.prototype), "evaluate", this).call(this, placeholders);
	            } else {
	                return "";
	            }
	        }
	    }], [{
	        key: "create",
	        value: function create(parent, text) {
	            var conditionalRegex = /<(tplnot|tpl)\s.*?id="(.*?)".*?>/;
	            var conditionalMatch = text.match(conditionalRegex);
	            if (conditionalMatch == null) {
	                return null;
	            }
	            var id = conditionalMatch[2];
	            var inverted = conditionalMatch[1].toLocaleLowerCase() == "tplnot";
	            var valueRegex = /value="(.*?)"/;
	            var valueMatch = text.match(valueRegex);
	            var conditional = valueMatch == null ? new TemplatePartConditional(parent, id) : new TemplatePartConditionalValue(parent, id, valueMatch[1]);
	            if (inverted) {
	                conditional.invert();
	            }
	            return conditional;
	        }
	    }]);
	
	    return TemplatePartConditional;
	}(Template);
	
	var TemplatePartConditionalValue = function (_TemplatePartConditio) {
	    _inherits(TemplatePartConditionalValue, _TemplatePartConditio);
	
	    function TemplatePartConditionalValue(parent, id, expectedValue) {
	        _classCallCheck(this, TemplatePartConditionalValue);
	
	        var _this3 = _possibleConstructorReturn(this, (TemplatePartConditionalValue.__proto__ || Object.getPrototypeOf(TemplatePartConditionalValue)).call(this, parent, id));
	
	        _this3.id = id;
	        _this3.expectedValue = expectedValue;
	        return _this3;
	    }
	
	    _createClass(TemplatePartConditionalValue, [{
	        key: "matches",
	        value: function matches(value) {
	            return value == this.expectedValue;
	        }
	    }]);
	
	    return TemplatePartConditionalValue;
	}(TemplatePartConditional);
	
	var TemplatePartText = function () {
	    function TemplatePartText(text) {
	        _classCallCheck(this, TemplatePartText);
	
	        this.text = text;
	    }
	
	    _createClass(TemplatePartText, [{
	        key: "evaluate",
	        value: function evaluate(placeholders) {
	            return this.text;
	        }
	    }]);
	
	    return TemplatePartText;
	}();
	
	var TemplatePartPlaceholder = function () {
	    function TemplatePartPlaceholder(name) {
	        _classCallCheck(this, TemplatePartPlaceholder);
	
	        this.name = name;
	    }
	
	    _createClass(TemplatePartPlaceholder, [{
	        key: "getName",
	        value: function getName() {
	            return this.name;
	        }
	    }, {
	        key: "evaluate",
	        value: function evaluate(placeholders) {
	            var value = placeholders.hasOwnProperty(this.name) ? placeholders[this.name] : null;
	            return value != null ? value : '';
	        }
	    }]);

	    return TemplatePartPlaceholder;
	}();

/***/ },

/***/ 592:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var Admin_1 = __webpack_require__(281);
	var React = __webpack_require__(3);
	var ReactDOM = __webpack_require__(6);
	// Was "export default", but then https://github.com/Microsoft/TypeScript/issues/6962
	
	var RepositoryFileList = function () {
	    function RepositoryFileList(params, folders, files, parentNode) {
	        _classCallCheck(this, RepositoryFileList);
	
	        this.params = params;
	        this.folders = folders;
	        this.files = files;
	        this.parentNode = parentNode;
	        this.form = $('form[name=my_form]')[0];
	    }
	
	    _createClass(RepositoryFileList, [{
	        key: "render",
	        value: function render() {
	            var _this = this;
	
	            ReactDOM.render(React.createElement(Admin_1.FilesFoldersWidget, { fieldName: "knowledge2MemoryFiles", folders: this.folders, files: this.files, memoryParams: this.params, folderDeletedCallback: function folderDeletedCallback(id) {
	                    _this.folderDeleted(id);return true;
	                }, fileDeletedCallback: function fileDeletedCallback(id) {
	                    _this.fileDeleted(id);return true;
	                }, folderSelectedCallback: function folderSelectedCallback(id, memoryInstance) {
	                    _this.folderSelected(id, memoryInstance);return true;
	                }, fileSelectedCallback: function fileSelectedCallback(id, memoryInstance) {
	                    _this.fileSelected(id, memoryInstance);return true;
	                } }), this.parentNode);
	        }
	    }, {
	        key: "appendHiddenInput",
	        value: function appendHiddenInput(name, value) {
	            var input = document.createElement('input');
	            input.type = 'hidden';
	            input.name = name;
	            input.value = value.toString();
	            this.form.appendChild(input);
	        }
	    }, {
	        key: "folderDeleted",
	        value: function folderDeleted(folderId) {
	            this.appendHiddenInput('delete_repository_category', folderId);
	            this.form.submit();
	        }
	    }, {
	        key: "fileDeleted",
	        value: function fileDeleted(fileId) {
	            var message = "Are you sure you want to remove this document from this article?";
	            if (confirm(message)) {
	                this.appendHiddenInput('filesToggledForDeletion[]', fileId);
	                this.form.submit();
	            }
	        }
	    }, {
	        key: "folderSelected",
	        value: function folderSelected(id, memoryInstance) {
	            this.appendHiddenInput('memory_category_selected', id);
	            this.appendHiddenInput('memory_instance', memoryInstance);
	            this.form.submit();
	        }
	    }, {
	        key: "fileSelected",
	        value: function fileSelected(id, memoryInstance) {
	            this.appendHiddenInput('memory_file_selected', id);
	            this.appendHiddenInput('memory_instance', memoryInstance);
	            this.form.submit();
	        }
	    }]);
	
	    return RepositoryFileList;
	}();
	
	exports.RepositoryFileList = RepositoryFileList;

/***/ },

/***/ 593:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(3);
	var ReactDOM = __webpack_require__(6);
	var utils_1 = __webpack_require__(4);
	var button_1 = __webpack_require__(138);
	var R = __webpack_require__(62);
	exports.templateImporter = function (replace, params) {
	    var div = document.createElement('div');
	    replace(div);
	    ReactDOM.render(React.createElement(Importer, { modules: params.modules }), div);
	};
	var Importer = function Importer(params) {
	    var options = utils_1.reduceObj(function (id, instance, acc) {
	        acc.push(React.createElement("option", { key: id, value: instance }, instance));
	        return acc;
	    }, params.modules, []);
	    var keys = R.keys(params.modules);
	    return React.createElement("div", null, React.createElement("h1", null, "Template Importer"), React.createElement("div", null, "Select a module from the list below then hit 'Import' to import the templates from that module into this one."), React.createElement("form", { method: 'post' }, React.createElement("div", null, React.createElement("select", { defaultValue: keys[0], name: 'contentInstance' }, options)), React.createElement("div", null, React.createElement(button_1.Button, { type: 1 /* submit */ }, "Import"))));
	};

/***/ },

/***/ 594:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var RepositoryFileList_1 = __webpack_require__(592);
	var import_1 = __webpack_require__(593);
	exports.RepositoryFileList = RepositoryFileList_1.RepositoryFileList;
	exports.importer = import_1.templateImporter;

/***/ },

/***/ 595:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(3);
	var ReactDOM = __webpack_require__(6);
	var Ramda = __webpack_require__(62);
	var react_redux_1 = __webpack_require__(23);
	var redux_1 = __webpack_require__(22);
	var ReadOnlyMultiCheckbox = function ReadOnlyMultiCheckbox(params) {
	    return React.createElement("div", null, params.options.map(function (option) {
	        return option.selected && React.createElement("li", { key: option.key }, option.displayName);
	    }));
	};
	var EditableMultiCheckbox = function EditableMultiCheckbox(params) {
	    return params.label ? React.createElement(LabelledEditableMultiCheckbox, Object.assign({}, params)) : React.createElement(UnlabelledEditableMultiCheckbox, Object.assign({}, params));
	};
	var UnlabelledEditableMultiCheckbox = function UnlabelledEditableMultiCheckbox(params) {
	    return React.createElement("div", null, React.createElement("input", { type: "hidden", name: params.name, id: params.id || undefined, value: '' }), React.createElement("table", { cellPadding: params.cellpadding, cellSpacing: params.cellspacing, style: { width: params.width } }, React.createElement("tbody", null, Ramda.splitEvery(params.displayLimit || 1, params.options).map(function (l, i) {
	        return React.createElement("tr", { key: "tr-" + i }, l.map(function (option, idx) {
	            var key = option.key;
	            var rowParams = {
	                onClick: option.selected ? function (k) {
	                    return params.onDeselect(k);
	                } : function (k) {
	                    return params.onSelect(k);
	                },
	                idx: i * (params.displayLimit || 0) + idx,
	                required: params.required,
	                name: params.name,
	                highlight: params.highlight,
	                option: option
	            };
	            return [React.createElement(RowA, Object.assign({ key: "rowA-" + idx + "-" + i }, rowParams)), React.createElement(RowB, Object.assign({ key: "rowB-" + idx + "-" + i }, rowParams))];
	        }), params.options.length % (params.displayLimit || 0) > 1 && React.createElement("td", { colSpan: params.options.length % (params.displayLimit || 0) }));
	    }))));
	};
	var RowB = function RowB(params) {
	    var style = Object.assign({ cursor: 'pointer' }, params.option.selected ? { background: params.highlight } : {});
	    return React.createElement("td", { id: makeName(params, "right"), style: style }, React.createElement("label", { htmlFor: makeName(params, 'checkbox') }, params.option.displayName));
	};
	var RowA = function RowA(params) {
	    var style = Object.assign({ width: 20 }, params.option.selected ? { background: params.highlight } : undefined);
	    return React.createElement("td", { id: makeName(params, 'left'), style: style }, React.createElement("input", { onClick: function onClick() {
	            return params.onClick(params.option.key);
	        }, type: "checkbox", name: params.name + "[]", value: params.option.key, title: params.required, id: makeName(params, "checkbox"), checked: params.option.selected }));
	};
	var makeName = function makeName(params, suffix) {
	    return "highlight_" + params.name + "_" + params.idx + "_" + suffix;
	};
	var LabelledEditableMultiCheckbox = function LabelledEditableMultiCheckbox(params) {
	    return React.createElement("table", null, React.createElement("tr", null, React.createElement("th", { style: { textAlign: params.labelAlign || 'right', width: params.labelWidth } }, params.label), React.createElement("td", null, React.createElement(UnlabelledEditableMultiCheckbox, Object.assign({}, params)))));
	};
	exports.Multicheckbox = function (params) {
	    return params.readOnly ? React.createElement(ReadOnlyMultiCheckbox, Object.assign({}, params)) : React.createElement(EditableMultiCheckbox, Object.assign({}, params));
	};
	var reducer = function reducer(store, action) {
	    if (!action) return store;
	    switch (action.type) {
	        case "add selected":
	            var addOptions = store.options.map(function (v) {
	                return v.key === action.key ? Object.assign({}, v, { selected: true }) : v;
	            });
	            return Object.assign({}, store, { options: addOptions });
	        case "remove selected":
	            var removeOptions = store.options.map(function (v) {
	                return v.key === action.key ? Object.assign({}, v, { selected: false }) : v;
	            });
	            return Object.assign({}, store, { options: removeOptions });
	    }
	    return store;
	};
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        onDeselect: function onDeselect(a) {
	            if (a === 0) throw a;dispatch({ type: "remove selected", key: a });
	        },
	        onSelect: function onSelect(a) {
	            return dispatch({ type: "add selected", key: a });
	        }
	    };
	};
	exports.MulticheckboxCallJs = function (replace, params) {
	    var div = document.createElement('div');
	    replace(div);
	    var store = redux_1.createStore(reducer, params);
	    var Widget = react_redux_1.connect(function (a) {
	        return a;
	    }, mapDispatchToProps)(exports.Multicheckbox);
	    ReactDOM.render(React.createElement(Widget, { store: store }), div);
	};

/***/ },

/***/ 596:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var utils_1 = __webpack_require__(4);
	exports.categoryManagerMapStateToProps = function (state, ownProps) {
	    return Object.assign({}, state, { categories: ownProps.categories });
	};
	exports.categoryManagerMapDispatchToProps = function (dispatch) {
	    var wrap = function wrap(action) {
	        return {
	            type: "category manager action",
	            action: action
	        };
	    };
	    var dispatchAction = utils_1.compose(wrap, dispatch);
	    return {
	        setCategoryCheckbox: function setCategoryCheckbox(value) {
	            return dispatchAction({ type: "set category checkbox", value: value });
	        },
	        unsetCategoryCheckbox: function unsetCategoryCheckbox(value) {
	            return dispatchAction({ type: "unset category checkbox", value: value });
	        }
	    };
	};

/***/ },

/***/ 597:
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.categoryFromCallJsCategory = function (cat) {
	    return {
	        categorySerial: +cat.categorySerial,
	        parentSerial: 'parentSerial' in cat && cat.parentSerial !== undefined ? +cat.parentSerial : undefined,
	        title: cat.title,
	        children: 'children' in cat && cat.children !== undefined ? cat.children.map(exports.categoryFromCallJsCategory) : undefined,
	        isLinked: cat.isLinked
	    };
	};

/***/ },

/***/ 598:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(3);
	var checkbox_1 = __webpack_require__(92);
	var utils_1 = __webpack_require__(4);
	exports.CategoryManager = function (props) {
	    return React.createElement("div", null, props.categories.length > 0 && React.createElement(CategoryManagerInner, Object.assign({}, props)));
	};
	var CategoryManagerInner = function CategoryManagerInner(props) {
	    var categories = props.categories;
	    return React.createElement("ul", { style: { listStyleType: "none" } }, categories.map(function (cti) {
	        var cid = cti.categorySerial;
	        var checked = props.selectedCategories.find(function (c) {
	            return c == cid;
	        }) !== undefined;
	        return React.createElement("li", { key: cid }, React.createElement(checkbox_1.Checkbox, { label: cti.title, checked: checked, value: utils_1.toString(cid), onChange: function onChange() {
	                return (checked ? props.unsetCategoryCheckbox : props.setCategoryCheckbox)(cid);
	            } }), cti.children !== undefined && cti.children.length > 0 && React.createElement(exports.CategoryManager, Object.assign({}, props, { categories: cti.children })));
	    }));
	};

/***/ },

/***/ 599:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var actions_1 = __webpack_require__(267);
	exports.reducer = function (s, a) {
	    if (actions_1.isCategoryManagerAction(a)) {
	        return exports.categoryManagerReducer(s, a.action);
	    }
	    return s;
	};
	exports.categoryManagerReducer = function (s, a) {
	    switch (a.type) {
	        case "set category checkbox":
	            var v = [a.value];
	            return Object.assign({}, s, { selectedCategories: v.concat(s.selectedCategories) });
	        case "unset category checkbox":
	            return Object.assign({}, s, { selectedCategories: s.selectedCategories.filter(function (cid) {
	                    return cid != a.value;
	                }) });
	    }
	};

/***/ },

/***/ 600:
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.flattenCategoryTree = function (tree) {
	    var depth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	    var accumulator = [];
	    return tree.reduce(function (acc, v) {
	        acc = acc.concat([Object.assign({}, v, { depth: depth })]);
	        if (v.children !== undefined) {
	            acc = acc.concat(exports.flattenCategoryTree(v.children, depth + 1));
	        }
	        return acc;
	    }, accumulator);
	};

/***/ },

/***/ 601:
/***/ function(module, exports) {

	"use strict";
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Intended to assist in the filtering of JS bugsnag errors in future
	 */
	
	var IVTError = function (_Error) {
	  _inherits(IVTError, _Error);
	
	  function IVTError() {
	    _classCallCheck(this, IVTError);
	
	    return _possibleConstructorReturn(this, (IVTError.__proto__ || Object.getPrototypeOf(IVTError)).apply(this, arguments));
	  }
	
	  return IVTError;
	}(Error);
	
	exports.IVTError = IVTError;

/***/ },

/***/ 602:
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var mimetypeFromExtension = function mimetypeFromExtension(extn) {
	    switch (extn) {
	        case "*.jpg":
	            return ['image/jpeg'];
	        case '*.gif':
	            return ['image/gif'];
	        case '*.png':
	            return ['image/png'];
	        case '*.csv':
	            return ['text/csv'];
	        case '*.flv':
	            return ['video/x-flv'];
	        case '*.mov':
	            return ['video/quicktime'];
	        case '*.wmv':
	            return ['video/x-ms-wmv'];
	        case '*.mp4':
	            return ['video/mp4'];
	        case '*.zip':
	            return ['application/zip', 'application/x-zip', 'application/x-zip-compressed'];
	    }
	    return [];
	};
	// our extensions are globs: *.zip. browsers only care about the ending: .zip. This assumes and requires the glob to start with *
	var browserExtn = function browserExtn(extn) {
	    return extn.substr(1);
	};
	exports.makeAcceptFromExtensions = function (extns) {
	    return extns.split(';').map(function (extn) {
	        return mimetypeFromExtension(extn.trim()).concat(browserExtn(extn));
	    }).reduce(concat);
	};
	exports.matchesGlob = function (filename, extns) {
	    return !extns || extns.length == 0 || extns == '*.*' || extns.split(';').map(function (extn) {
	        return extn.trim().slice(-3);
	    }).indexOf(filename.slice(-3)) >= 0;
	};
	var concat = function concat(a, b) {
	    return a.concat(b);
	};

/***/ },

/***/ 603:
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.validateDollars = function (value) {
	    var result = /^-?\d*\.?\d?\d?/.exec(value);
	    return result ? result[0] : '';
	};
	// todo these turned out to be less useful than i'd hoped
	// perhaps they're not worth keeping, up to you.
	exports.toDollars = function (totalValue) {
	    var cents = totalValue % 100;
	    var dollars = (totalValue - cents) / 100;
	    return dollarsAndCents(dollars, cents);
	};
	exports.fromDollars = function (dollars) {
	    var parts = dollars.split(".");
	    return Number.parseInt(parts[0]) * 100 + Number.parseInt(parts[1] || "0");
	};
	var dollarsAndCents = function dollarsAndCents(dollars, cents) {
	    return dollars.toString() + (cents ? "." + renderJustCents(cents) : "");
	};
	var renderJustCents = function renderJustCents(cents) {
	    return 0 < cents && cents < 10 ? "0" + cents : (cents % 100).toString();
	};

/***/ },

/***/ 604:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(3);
	var ReactDOM = __webpack_require__(6);
	var react_google_recaptcha_1 = __webpack_require__(1150);
	exports.SbRecaptcha = function (replace, params) {
	    var div = document.createElement('div');
	    replace(div);
	    ReactDOM.render(React.createElement(react_google_recaptcha_1.default, { sitekey: params.sitekey, onChange: function onChange() {} }), div);
	};

/***/ },

/***/ 605:
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var reduceFilterGeneric = function reduceFilterGeneric(s, action, f) {
	    var filters = Object.assign({}, s.filters);
	    filters[action.filter] = f(filters[action.filter], action);
	    return Object.assign({}, s, { filters: filters });
	};
	var setFilterCheckboxUpdater = function setFilterCheckboxUpdater(filter, action) {
	    return { type: "checkbox", checked: [action.value].concat(filter.type == 'checkbox' ? filter.checked : []) };
	};
	var unsetFilterCheckboxUpdater = function unsetFilterCheckboxUpdater(filter, action) {
	    return { type: "checkbox", checked: (filter.type == 'checkbox' ? filter.checked : []).filter(function (a) {
	            return a != action.value;
	        }) };
	};
	var reduceFilter = function reduceFilter(s, action) {
	    var filters = Object.assign({}, s.filters);
	    filters[action.filter] = Object.assign({}, filters[action.filter], action.filterData);
	    return Object.assign({}, s, { filters: filters });
	};
	var reportsReducer = function reportsReducer(s, action) {
	    switch (action.type) {
	        case "set display mode":
	            return Object.assign({}, s, { displayMode: action.mode });
	        case "set new report data":
	            return Object.assign({}, s, { reportData: action.data });
	        case "set report type":
	            return Object.assign({}, s, { reportType: action.value });
	        case "set filter":
	            return reduceFilter(s, action);
	        case "set filter checkbox":
	            return reduceFilterGeneric(s, action, setFilterCheckboxUpdater);
	        case "unset filter checkbox":
	            return reduceFilterGeneric(s, action, unsetFilterCheckboxUpdater);
	    }
	};
	var isReportFilter = function isReportFilter(a) {
	    return a.type == "report action";
	};
	exports.reducer = function (s, a) {
	    if (isReportFilter(a)) {
	        return reportsReducer(s, a.action);
	    }
	    return s;
	};

/***/ },

/***/ 606:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(3);
	exports.HorizontalRule = function () {
	  return React.createElement("div", { className: "sbHorizontalRule" });
	};

/***/ },

/***/ 607:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 *  React implementation of the the SbHtml 'Multi-Select' Widget
	 *
	 *  A widget that allows a user to move items between an available 'remaining' list, and a 'selected' list
	 *  by highlighting items and clicking either the 'Add >>' or '<< Remove' buttons
	 *
	 *  Required React Properties
	 *
	 *    - name: When posting a form containing this widget to the server, the selected values will be
	 *            indexed in $_POST by this value.
	 *
	 *    - keyPrefix: All options in react are required to have a unique key. This value is used to generate such a key.
	 *
	 *    - selectedItems: A list of the selected items
	 *
	 *    - allItems: A list of all the items (list of remaining items can be inferred from allItems - selectedItems)
	 *
	 *    - addOptionsHandler: Fires when the 'Add >>' button is clicked
	 *
	 *    - removeOptionsHandler: Fires when the '<< Remove' button is clicked
	 *
	 *    - remainingHighlightHandler: Fires when an item(s) is highlighted/un-highlighted in the remaining items list
	 *
	 *    - selectedHighlightHandler: Fires when an item(s) is highlighted/un-highlighted in the selected items list
	 *
	 *    - remainingHighlightedItems: The highlighted values for the remaining items list
	 *
	 *    - selectedHighlightedItems: The highlighted values for the selected items list
	 */
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(3);
	var Utils = __webpack_require__(4);
	
	var MultiSelect = function (_React$Component) {
	    _inherits(MultiSelect, _React$Component);
	
	    function MultiSelect() {
	        _classCallCheck(this, MultiSelect);
	
	        return _possibleConstructorReturn(this, (MultiSelect.__proto__ || Object.getPrototypeOf(MultiSelect)).apply(this, arguments));
	    }
	
	    _createClass(MultiSelect, [{
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var forwardLabel = "Add >>";
	            var backwardLabel = "<< Remove";
	            var remainingItems = Utils.mapSubtract(this.props.allItems, this.props.selectedItems);
	            var selectedOptions = this.selectedItemsFromOptions(this.props.selectedItems);
	            var remainingOptions = this.selectedItemsFromOptions(remainingItems);
	            /**
	             * On given an FormEvent, this function loops over the options of the HtmlSelectElement that generated
	             * the event.
	             * For each option it checks if it is highlighted.
	             * If it is, it is pushes its id (the option's value) into an array of selected ids.
	             * This list is then used to return the corresponding set of items from the "all" available items map.
	             */
	            var findHighlightedItems = function findHighlightedItems(e) {
	                var el = e.currentTarget;
	                var selectedIds = [];
	                for (var i = 0, l = el.options.length; i < l; i++) {
	                    var option = el.options[i];
	                    if (option.selected) {
	                        selectedIds.push(option.value);
	                    }
	                }
	                return _this2.props.allItems.filter(function (v, k) {
	                    return selectedIds.find(function (optionsValue) {
	                        return k === optionsValue;
	                    }) !== undefined;
	                });
	            };
	            var remainingHighlightHandler = function remainingHighlightHandler(e) {
	                _this2.props.remainingHighlightHandler(findHighlightedItems(e));
	            };
	            var selectedHighlightHandler = function selectedHighlightHandler(e) {
	                _this2.props.selectedHighlightHandler(findHighlightedItems(e));
	            };
	            // Replace this with some kind javascript join once Immutable typings are not rubbish
	            var valueString = this.props.selectedItems.reduce(function (p, v, k) {
	                return p === undefined || p === '' ? k : p + ',' + k;
	            }, '');
	            return React.createElement("div", { style: { width: '100%' } }, React.createElement("table", { className: "sbHbox", style: { width: "100%", height: "100%" }, cellSpacing: "0", cellPadding: "5" }, React.createElement("tbody", null, React.createElement("tr", null, React.createElement("td", { style: { width: "50%" }, className: "hboxElement" }, React.createElement("button", { onClick: this.props.addOptionsHandler, type: "button", className: "sbButton sbRoundedEdges", style: { width: '100%' } }, forwardLabel), React.createElement("br", null), React.createElement("select", { onChange: remainingHighlightHandler, value: Utils.mapKeys(this.props.remainingHighlightedItems), className: "sbSelect", style: { width: '100%' }, size: 10, multiple: true }, remainingOptions)), React.createElement("td", { style: { width: "50%" }, className: "hboxElement" }, React.createElement("button", { onClick: this.props.removeOptionsHandler, type: "button", className: "sbButton sbRoundedEdges", style: { width: '100%' } }, backwardLabel), React.createElement("br", null), React.createElement("input", { name: this.props.name, type: "hidden", value: valueString }), React.createElement("select", { onChange: selectedHighlightHandler, value: Utils.mapKeys(this.props.selectedHighlightedItems), className: "sbSelect", style: { width: '100%' }, size: 10, multiple: true }, selectedOptions))))));
	        }
	    }, {
	        key: "selectedItemsFromOptions",
	        value: function selectedItemsFromOptions(options) {
	            var _this3 = this;
	
	            return options.map(
	            // No idea why v and k include undefined. They don't with the ImmutableJS 4.0 types.
	            function (v, k) {
	                return _this3.createOptionElement(v, k);
	            }).toArray();
	        }
	    }, {
	        key: "createOptionElement",
	        value: function createOptionElement(v, k) {
	            return React.createElement("option", { key: this.props.keyPrefix + '-' + k, value: k }, v);
	        }
	    }]);
	
	    return MultiSelect;
	}(React.Component);
	
	exports.MultiSelect = MultiSelect;

/***/ },

/***/ 608:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(3);
	/**
	 * A panel has a heading and a body. The heading is displayed in Glossy Bar with beautiful orange, or purple
	 * in purple bar. The body will be whatever the children of this component are.
	 * In addiition to a title, you can also have an icon show in the left corner by specifying the 'iconPath'
	 * property. If you require, there is also an icon to dipslay in the right, via 'rightIconPath'. This handles
	 * click events via the 'rightIconClick' property (e.g. for closing the panel with an 'x' icon).
	 */
	
	var Panel = function (_React$Component) {
	    _inherits(Panel, _React$Component);
	
	    function Panel() {
	        _classCallCheck(this, Panel);
	
	        return _possibleConstructorReturn(this, (Panel.__proto__ || Object.getPrototypeOf(Panel)).apply(this, arguments));
	    }
	
	    _createClass(Panel, [{
	        key: "render",
	        value: function render() {
	            return React.createElement("div", { className: "sbPanel sbRoundedEdges react" }, React.createElement("div", { className: "sbPanelTitlebar sbRoundedEdges" }, this.renderLeftIcon(), this.props.title, this.renderRightIcon()), React.createElement("div", { className: "sbPanelContents" }, this.props.children));
	        }
	    }, {
	        key: "renderLeftIcon",
	        value: function renderLeftIcon() {
	            if (this.props.iconPath == null) {
	                return null;
	            }
	            return React.createElement("span", { className: "icon" }, React.createElement("img", { src: this.props.iconPath }));
	        }
	    }, {
	        key: "renderRightIcon",
	        value: function renderRightIcon() {
	            if (this.props.rightIconPath == null) {
	                return null;
	            }
	            var img = React.createElement("img", { src: this.props.rightIconPath });
	            var rightIconClick = this.props.rightIconClick;
	            var inner = rightIconClick == null ? img : React.createElement("a", { href: "#", onClick: function onClick(event) {
	                    rightIconClick();event.preventDefault();
	                } }, img);
	            return React.createElement("span", { className: "right-icon" }, inner);
	        }
	    }]);
	
	    return Panel;
	}(React.Component);
	
	exports.Panel = Panel;

/***/ },

/***/ 609:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(3);
	var sbhtml_1 = __webpack_require__(610);
	var unlabelledButton = function unlabelledButton(props, id) {
	    var onChange = props.onChange;
	    return React.createElement("input", { type: "radio", name: props.name, value: props.value, checked: props.checked, disabled: props.disabled, onChange: onChange ? function (e) {
	            return onChange(e.target.checked);
	        } : undefined, className: "sbRadioButton", id: id });
	};
	exports.Radio = function (props) {
	    var id = sbhtml_1.uniqueId();
	    var button = unlabelledButton(props, id);
	    return props.label === undefined ? button : React.createElement("label", { htmlFor: id }, button, props.label);
	};

/***/ },

/***/ 610:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var _ = __webpack_require__(125);
	exports.uniqueId = function () {
	  return _.uniqueId();
	};

/***/ },

/***/ 611:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(3);
	var utils_1 = __webpack_require__(4);
	exports.Panel = function (props) {
	    return React.createElement("div", null, props.children);
	};
	exports.Tabs = function (props) {
	    var children = React.Children.toArray(props.children);
	    var mapped = children.map(function (child) {
	        if (typeof child !== "string" && typeof child !== "number") {
	            if (child.type != exports.Panel) throw new Error('Tabs was expecting a Panel, but got something else.');
	            var isActive = props.active == child.props.id;
	            var classNames = ["ui-state-default", "ui-corner-top"].concat(isActive ? ["ui-tabs-active", "ui-state-active"] : []).join(" ");
	            return [isActive && React.createElement("div", { key: "tab-" + child.props.id, className: "ui-tabs-panel ui-widget-content ui-corner-bottom", role: "tabpanel" }, child), React.createElement("li", { key: "panel-" + child.props.id, className: classNames }, React.createElement("a", { onClick: function onClick() {
	                    return props.onActivate(child.props.id);
	                }, className: "ui-tabs-anchor" }, child.props.name))];
	        }
	        throw new Error('Tabs was expecting a Panel, but got something else.');
	    });
	
	    var _utils_1$unzip = utils_1.unzip(mapped),
	        _utils_1$unzip2 = _slicedToArray(_utils_1$unzip, 2),
	        panels = _utils_1$unzip2[0],
	        tabs = _utils_1$unzip2[1];
	
	    return React.createElement("div", { className: "ui-tabs ui-widget ui-widget-content ui-corner-all" }, React.createElement("ul", { className: "ui-tabs-nav ui-helper-reset ui-helper-clearfix ui-widget-header ui-corner-all", role: "tablist" }, tabs), panels);
	};

/***/ },

/***/ 612:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var utils_1 = __webpack_require__(4);
	var fileprogress_1 = __webpack_require__(275);
	var swfuploader_1 = __webpack_require__(182);
	/*  the methods defined here are exported below by assigning them to window. This odd api is due to a backwards compatibilty requirement.*/
	function uploadError(file, errorCode, message) {
	    try {
	        var progress = new fileprogress_1.FileProgress(file, this.custom_settings.progressTarget);
	        progress.setError();
	        progress.toggleCancel(false);
	        switch (errorCode) {
	            case swfuploader_1.SWFUpload.UPLOAD_ERROR.HTTP_ERROR:
	                progress.setStatus("Upload Error: " + message);
	                break;
	            case swfuploader_1.SWFUpload.UPLOAD_ERROR.UPLOAD_FAILED:
	                progress.setStatus("Upload Failed.");
	                break;
	            case swfuploader_1.SWFUpload.UPLOAD_ERROR.IO_ERROR:
	                progress.setStatus("Server (IO) Error");
	                break;
	            case swfuploader_1.SWFUpload.UPLOAD_ERROR.SECURITY_ERROR:
	                progress.setStatus("Security Error");
	                break;
	            case swfuploader_1.SWFUpload.UPLOAD_ERROR.UPLOAD_LIMIT_EXCEEDED:
	                progress.setStatus("Upload limit exceeded.");
	                break;
	            case swfuploader_1.SWFUpload.UPLOAD_ERROR.FILE_VALIDATION_FAILED:
	                progress.setStatus("Failed Validation.  Upload skipped.");
	                break;
	            case swfuploader_1.SWFUpload.UPLOAD_ERROR.FILE_CANCELLED:
	                // If there aren't any files left (they were all cancelled) disable the cancel button
	                if (this.getStats().files_queued === 0) {
	                    var button = document.getElementById(this.custom_settings.cancelButtonId);
	                    if (button && button instanceof HTMLInputElement || button instanceof HTMLButtonElement) button.disabled = true;
	                }
	                progress.setStatus("Cancelled");
	                progress.setCancelled();
	                break;
	            case swfuploader_1.SWFUpload.UPLOAD_ERROR.UPLOAD_STOPPED:
	                progress.setStatus("Stopped");
	                break;
	            default:
	                progress.setStatus("Unhandled Error: " + errorCode);
	                break;
	        }
	    } catch (ex) {}
	}
	function fileQueueError(file, errorCode, message) {
	    try {
	        if (errorCode === swfuploader_1.SWFUpload.QUEUE_ERROR.QUEUE_LIMIT_EXCEEDED) {
	            alert("You have attempted to queue too many files.\n" + (message === 0 ? "You have reached the upload limit." : "You may select " + (message > 1 ? "up to " + message + " files." : "one file.")));
	            return;
	        }
	        var progress = new fileprogress_1.FileProgress(file, this.custom_settings.progressTarget);
	        progress.setError();
	        progress.toggleCancel(false);
	        switch (errorCode) {
	            case swfuploader_1.SWFUpload.QUEUE_ERROR.FILE_EXCEEDS_SIZE_LIMIT:
	                progress.setStatus("File is too big.");
	                break;
	            case swfuploader_1.SWFUpload.QUEUE_ERROR.ZERO_BYTE_FILE:
	                progress.setStatus("Cannot upload Zero Byte files.");
	                break;
	            case swfuploader_1.SWFUpload.QUEUE_ERROR.INVALID_FILETYPE:
	                progress.setStatus("Invalid File Type.");
	                break;
	            default:
	                if (file !== null) {
	                    progress.setStatus("Unhandled Error");
	                }
	                break;
	        }
	    } catch (ex) {}
	}
	function fileQueued(file) {
	    try {
	        var progress = new fileprogress_1.FileProgress(file, this.custom_settings.progressTarget);
	        progress.setStatus("Pending...");
	        progress.toggleCancel(true, this);
	    } catch (ex) {}
	}
	function uploadStart(file) {
	    try {
	        /* I don't want to do any file validation or anything,  I'll just update the UI and
	        return true to indicate that the upload should start.
	        It's important to update the UI here because in Linux no uploadProgress events are called. The best
	        we can do is say we are uploading.
	         */
	        var progress = new fileprogress_1.FileProgress(file, this.custom_settings.progressTarget);
	        progress.setStatus("Uploading...");
	        progress.toggleCancel(true, this);
	    } catch (ex) {}
	    return true;
	}
	function uploadProgress(file, bytesLoaded, bytesTotal) {
	    try {
	        var percent = Math.ceil(bytesLoaded / bytesTotal * 100);
	        var progress = new fileprogress_1.FileProgress(file, this.custom_settings.progressTarget);
	        progress.setProgress(percent);
	        progress.setStatus("Uploading...");
	    } catch (ex) {}
	}
	// the next functions are used from php code. i cannot warrant their necessity or utility.
	function fileDialogComplete() {}
	function uploadSuccess(file) {
	    try {
	        var progress = new fileprogress_1.FileProgress(file, this.custom_settings.progressTarget);
	        progress.setComplete();
	        progress.setStatus("Complete.");
	        progress.toggleCancel(false);
	    } catch (ex) {}
	}
	function uploadComplete() {
	    if (this.getStats().files_queued === 0) {
	        utils_1.mapClass(document.getElementById(this.custom_settings.cancelButtonId), HTMLButtonElement, function (e) {
	            return e.disabled = true;
	        });
	    }
	}
	// This event comes from the Queue Plugin
	function queueComplete(numFilesUploaded) {
	    var status = document.getElementById("divStatus");
	    if (status) {
	        status.innerHTML = numFilesUploaded + " file" + (numFilesUploaded === 1 ? "" : "s") + " uploaded.";
	    }
	}
	//these are accessed from php code. we use this rather than direct exports because php code excepts to be able to change them.
	;
	window.uploadError = uploadError;
	window.fileQueueError = fileQueueError;
	window.fileQueued = fileQueued;
	window.uploadStart = uploadStart;
	window.uploadProgress = uploadProgress;
	window.fileDialogComplete = fileDialogComplete;
	window.uploadSuccess = uploadSuccess;
	window.uploadComplete = uploadComplete;
	window.queueComplete = queueComplete;
	exports.done = true;

/***/ },

/***/ 613:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var $ = __webpack_require__(10);
	// Was "export default", but then https://github.com/Microsoft/TypeScript/issues/6962
	
	var OptionWidget = function () {
	    function OptionWidget() {
	        _classCallCheck(this, OptionWidget);
	    }
	
	    _createClass(OptionWidget, null, [{
	        key: "renderSelectList",
	        value: function renderSelectList(place, params) {
	            var select = document.createElement('select');
	            if (params.usesChosen) select.dataset['placeholder'] = params.defaultText;
	            select.id = params.id;
	            select.name = params.name;
	            if (params.many) select.multiple = true;
	            select.onchange = new Function('event', params.onchange);
	            select.onclick = new Function('event', params.onchange);
	            var hasColor = false;
	            var selectedColor = null;
	            var first = true;
	            params.options.forEach(function (option) {
	                var opt = document.createElement('option');
	                // We only want mark the first item as selected if we arn't dealing with a chosen widget
	                if (option.selected || first && !params.usesChosen) {
	                    opt.selected = true;
	                    selectedColor = option.color;
	                    first = false;
	                }
	                hasColor = hasColor || !!option.color;
	                opt.value = option.value;
	                if (option.color) opt.style.backgroundColor = '#' + option.color;
	                opt.appendChild(document.createTextNode(option.label));
	                select.appendChild(opt);
	            });
	            if (hasColor) {
	                select.style.backgroundColor = '#' + selectedColor;
	                $(select).change(function () {
	                    select.style.backgroundColor = select.options[select.selectedIndex].style.backgroundColor;
	                });
	            }
	            // jQuery.chosen() only works on elements that have already been added to the document.
	            place(select);
	            if (params.usesChosen) {
	                var chosenOptions = {};
	                if (params.width != null) chosenOptions.width = params.width;
	                $(select).chosen(chosenOptions);
	            }
	        }
	    }, {
	        key: "renderCheckboxes",
	        value: function renderCheckboxes(callback, params) {
	            var div = document.createElement('div');
	            div.style.display = 'inline-block';
	            params.options.forEach(function (option) {
	                var label = document.createElement('label');
	                label.style.display = params.inline ? 'inline-block' : 'block';
	                label.style.padding = '0.5em';
	                label.style.whiteSpace = 'nowrap';
	                if (params.minWidth != null) label.style.minWidth = params.minWidth + 'px';
	                if (option.color != null) label.style.backgroundColor = '#' + option.color;
	                var input = document.createElement('input');
	                input.type = params.many ? 'checkbox' : 'radio';
	                input.value = option.value;
	                input.style.verticalAlign = 'bottom';
	                input.style.padding = '0';
	                input.style.margin = '0';
	                input.name = params.name;
	                input.onchange = new Function('event', params.onchange);
	                input.onclick = new Function('event', params.onchange);
	                input.checked = option.selected;
	                label.appendChild(input);
	                label.appendChild(document.createTextNode(' ' + option.label));
	                div.appendChild(label);
	            });
	            callback(div);
	        }
	    }]);
	
	    return OptionWidget;
	}();
	
	exports.OptionWidget = OptionWidget;

/***/ },

/***/ 614:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) {
	            try {
	                step(generator.next(value));
	            } catch (e) {
	                reject(e);
	            }
	        }
	        function rejected(value) {
	            try {
	                step(generator["throw"](value));
	            } catch (e) {
	                reject(e);
	            }
	        }
	        function step(result) {
	            result.done ? resolve(result.value) : new P(function (resolve) {
	                resolve(result.value);
	            }).then(fulfilled, rejected);
	        }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(3);
	var ReactDOM = __webpack_require__(6);
	var redux_1 = __webpack_require__(22);
	var redux_thunk_1 = __webpack_require__(33);
	var _ = __webpack_require__(125);
	var app_1 = __webpack_require__(615);
	var reducer_1 = __webpack_require__(617);
	var utils_1 = __webpack_require__(4);
	var commands_1 = __webpack_require__(12);
	var stores = {};
	exports.runProcessTest = function (uniqueId, time) {
	    var ix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
	    return function (cb) {
	        return __awaiter(undefined, void 0, void 0, regeneratorRuntime.mark(function _callee() {
	            var info, state, response;
	            return regeneratorRuntime.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            if (stores.hasOwnProperty(uniqueId)) {
	                                _context.next = 3;
	                                break;
	                            }
	
	                            setTimeout(function () {
	                                return exports.runProcessTest(uniqueId, time, ix * 2);
	                            }, ix);
	                            return _context.abrupt("return");
	
	                        case 3:
	                            info = stores[uniqueId];
	                            state = info.store.getState();
	                            _context.next = 7;
	                            return new commands_1.CommandCaller(info.ajaxUrl).runGet('getProcessTestData', {
	                                days: state.processDays,
	                                beforeAfter: state.processDirection,
	                                collation: state.collationType,
	                                pricingOptions: state.selectedPricingOptions,
	                                paymentType: state.selectedPaymentType,
	                                statuses: state.selectedStatuses,
	                                time: time
	                            });
	
	                        case 7:
	                            response = _context.sent;
	
	                            cb(response.content);
	
	                        case 9:
	                        case "end":
	                            return _context.stop();
	                    }
	                }
	            }, _callee, this);
	        }));
	    };
	};
	exports.runProcessForm = function (replace, params) {
	    var pricingOptions = params.pricingOptions.map(function (po) {
	        return { id: utils_1.toString(po.id), label: po.displayName };
	    });
	    var statuses = params.statuses.map(function (s) {
	        return { id: utils_1.toString(s.id), label: s.name, color: s.color };
	    });
	    var paymentTypes = params.paymentTypes;
	    var ownProps = function ownProps(store, dataGridId) {
	        return {
	            refreshSampleGrid: _.debounce(function () {
	                return new HtmlDataGrid(dataGridId).refresh();
	            }, 600),
	            disabledPricingOptions: utils_1.toStrings(params.disabledPricingOptions),
	            paymentTypes: paymentTypes,
	            store: store,
	            returnUrl: params.returnUrl,
	            ajaxUrl: params.ajaxUrl
	        };
	    };
	    var initialState = reducer_1.validate({
	        processId: params.processId,
	        name: params.name,
	        pricingOptions: pricingOptions,
	        multiPricingOption: params.selectedPricingOptions.length > 1,
	        selectedPricingOptions: utils_1.toStrings(params.selectedPricingOptions),
	        statuses: statuses,
	        multiStatus: params.selectedStatuses.length > 1,
	        selectedStatuses: utils_1.toStrings(params.selectedStatuses),
	        selectedPaymentType: params.selectedPaymentType,
	        processDays: utils_1.toString(Math.abs(params.processDays)),
	        processDirection: params.processDays > 0 ? 'after' : 'before',
	        collationType: params.collationType,
	        sendEmails: params.sendEmails,
	        enabled: params.enabled,
	        submitting: false
	    });
	    var div = document.createElement('div');
	    replace(div);
	    var store = redux_1.createStore(utils_1.withDefault(reducer_1.reducer, initialState), initialState, redux_1.applyMiddleware(redux_thunk_1.default));
	    stores[params.uniqueid] = { store: store, ajaxUrl: params.ajaxUrl };
	    ReactDOM.render(React.createElement(app_1.ProcessFormApp, Object.assign({}, ownProps(store, params.dataGridId))), div);
	};

/***/ },

/***/ 615:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) {
	            try {
	                step(generator.next(value));
	            } catch (e) {
	                reject(e);
	            }
	        }
	        function rejected(value) {
	            try {
	                step(generator["throw"](value));
	            } catch (e) {
	                reject(e);
	            }
	        }
	        function step(result) {
	            result.done ? resolve(result.value) : new P(function (resolve) {
	                resolve(result.value);
	            }).then(fulfilled, rejected);
	        }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var utils_1 = __webpack_require__(4);
	var react_redux_1 = __webpack_require__(23);
	var presentation_1 = __webpack_require__(616);
	var commands_1 = __webpack_require__(12);
	var form_1 = __webpack_require__(55);
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	    return Object.assign({}, state, { disabledPricingOptions: ownProps.disabledPricingOptions, paymentTypes: ownProps.paymentTypes, collationEnabled: state.selectedPaymentType == 'all', hasPaymentField: ownProps.paymentTypes.length > 1 });
	};
	var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
	    var wrap = function wrap(action) {
	        return {
	            type: "process form action",
	            action: action
	        };
	    };
	    var dispatchAction = utils_1.compose(wrap, dispatch);
	    var _saveProcess = makeSaveProcessAction(dispatchAction, ownProps);
	    var dispatchAndRefresh = function dispatchAndRefresh(f) {
	        return function (a) {
	            return dispatch(function () {
	                f(a);ownProps.refreshSampleGrid();
	            });
	        };
	    };
	    return {
	        onCancel: function onCancel() {
	            window.location.assign(ownProps.returnUrl);
	        },
	        setName: dispatchAndRefresh(function (name) {
	            return dispatchAction({ type: "set name", name: name });
	        }),
	        setMultiPricingOption: dispatchAndRefresh(function (multiPricingOption) {
	            return dispatchAction({ type: "set multi pricing option", multiPricingOption: multiPricingOption });
	        }),
	        setPricingOptions: dispatchAndRefresh(function (pricingOptions) {
	            return dispatchAction({ type: "set pricing options", pricingOptions: pricingOptions });
	        }),
	        setMultiStatus: dispatchAndRefresh(function (multiStatus) {
	            return dispatchAction({ type: "set multi status", multiStatus: multiStatus });
	        }),
	        setStatuses: dispatchAndRefresh(function (statuses) {
	            return dispatchAction({ type: "set statuses", statuses: statuses });
	        }),
	        setPaymentType: dispatchAndRefresh(function (paymentType) {
	            return dispatchAction({ type: "set payment type", paymentType: paymentType });
	        }),
	        setProcessDays: dispatchAndRefresh(function (processDays) {
	            return dispatchAction({ type: "set process days", processDays: processDays });
	        }),
	        setProcessDirection: dispatchAndRefresh(function (processDirection) {
	            return dispatchAction({ type: "set process direction", processDirection: processDirection });
	        }),
	        setCollationType: dispatchAndRefresh(function (collationType) {
	            return dispatchAction({ type: "set collation type", collationType: collationType });
	        }),
	        setSendEmails: function setSendEmails(sendEmails) {
	            return dispatchAction({ type: "set send emails", sendEmails: sendEmails });
	        },
	        setEnabled: function setEnabled(enabled) {
	            return dispatchAction({ type: "set enabled", enabled: enabled });
	        },
	        saveProcess: function saveProcess() {
	            return dispatch(_saveProcess);
	        },
	        saveProcessThenReturn: function saveProcessThenReturn() {
	            return dispatch(form_1.saveReturnCallback(dispatch, _saveProcess, ownProps.returnUrl));
	        }
	    };
	};
	var makeSaveProcessAction = function makeSaveProcessAction(dispatchWrapped, ownProps) {
	    return function (dispatchUnwrapped, getState) {
	        return __awaiter(undefined, void 0, void 0, regeneratorRuntime.mark(function _callee() {
	            var state, processId, process, saveParams, id;
	            return regeneratorRuntime.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            dispatchWrapped({ type: "set submitting", submitting: true });
	                            state = getState();
	                            _context.prev = 2;
	                            processId = state.processId;
	                            process = processId > 0 ? { processId: processId } : {};
	                            saveParams = Object.assign({}, process, { name: state.name, pricingOptions: state.selectedPricingOptions, statuses: state.selectedStatuses, paymentType: state.selectedPaymentType, days: state.processDays, beforeAfter: state.processDirection, collation: state.collationType, sendEmails: state.sendEmails, enabled: state.enabled });
	                            _context.next = 8;
	                            return new commands_1.CommandCaller(ownProps.ajaxUrl).runPost('save process', saveParams);
	
	                        case 8:
	                            id = _context.sent;
	
	                            dispatchWrapped({ type: "set process id", id: id });
	                            _context.next = 15;
	                            break;
	
	                        case 12:
	                            _context.prev = 12;
	                            _context.t0 = _context["catch"](2);
	
	                            window.alert("There was an unexpected error. Ensure you're logged in, your internet connection is working, and try reloading the page");
	
	                        case 15:
	                            dispatchWrapped({ type: "set submitting", submitting: false });
	
	                        case 16:
	                        case "end":
	                            return _context.stop();
	                    }
	                }
	            }, _callee, this, [[2, 12]]);
	        }));
	    };
	};
	exports.ProcessFormApp = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(presentation_1.ProcessForm);

/***/ },

/***/ 616:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(3);
	var field_1 = __webpack_require__(112);
	var form_1 = __webpack_require__(55);
	var input_1 = __webpack_require__(34);
	var checkbox_1 = __webpack_require__(92);
	var select_1 = __webpack_require__(39);
	var notification_1 = __webpack_require__(139);
	exports.ProcessForm = function (props) {
	    return React.createElement(form_1.Form, { hasSave: true, onSubmit: props.saveProcess, hasCancel: true, onCancel: props.onCancel, isSubmitting: props.submitting, onSaveReturn: props.saveProcessThenReturn }, React.createElement(field_1.Group, null, React.createElement(field_1.Item, { label: "Name" }, React.createElement(input_1.Input, { name: "name", value: props.name, onChange: props.setName })), React.createElement(field_1.Item, { label: "Membership Type(s)" }, React.createElement(PricingOptions, Object.assign({}, props)), React.createElement(checkbox_1.Checkbox, { label: "Multiple", checked: props.multiPricingOption, value: '1', onChange: props.setMultiPricingOption }), props.disabledPricingOptions.length > 0 && React.createElement("div", { style: { maxWidth: "500px" } }, React.createElement(notification_1.Notification, { type: "info" }, "The following Membership Type(s) cannot be auto renewed because the renewal price is determined from a form field: The following Membership Type(s) cannot be auto renewed because the renewal price is determined from a form field:", React.createElement("ul", null, props.disabledPricingOptions.map(function (id) {
	        return React.createElement("li", { key: id }, typeLabel(id, props.pricingOptions));
	    }))))), React.createElement(field_1.Item, { label: "Membership Statuses" }, React.createElement(Statuses, Object.assign({}, props)), React.createElement(checkbox_1.Checkbox, { label: "Multiple", checked: props.multiStatus, value: '1', onChange: props.setMultiStatus })), props.hasPaymentField && React.createElement(field_1.Item, { label: "Only renew members with payment type" }, React.createElement(select_1.SingleBox, { name: "paymentType", value: props.selectedPaymentType, onChange: function onChange(p) {
	            return props.setPaymentType(isPaymentType(p) ? p : 'all');
	        } }, props.paymentTypes.map(function (pt) {
	        return React.createElement("option", { key: pt, value: pt }, paymentLabel(pt));
	    }))), React.createElement(field_1.Item, { label: "Process Days" }, React.createElement(input_1.Input, { name: "days", value: props.processDays, onChange: props.setProcessDays, numeric: { min: 0 } }), React.createElement(select_1.SingleBox, { name: "beforeAfter", value: props.processDirection, onChange: function onChange(processDirection) {
	            props.setProcessDirection(isProcessDirection(processDirection) ? processDirection : 'before');
	        } }, React.createElement("option", { key: 'before', value: 'before' }, "before expiry date"), React.createElement("option", { key: 'after', value: 'after' }, "after expiry date"))), React.createElement(field_1.Item, { label: "Collation By" }, React.createElement(select_1.SingleBox, { name: "collation", value: props.collationType, enabled: props.collationEnabled, onChange: function onChange(collationType) {
	            props.setCollationType(isCollationType(collationType) ? collationType : 'none');
	        } }, React.createElement("option", { key: 'none', value: 'none' }, "Do not collate"), React.createElement("option", { key: 'member', value: 'member' }, "Individual Memberships"), React.createElement("option", { key: 'organisation', value: 'organisation' }, "Organisation Memberships"))), React.createElement(field_1.Item, { label: "Send Emails" }, React.createElement(checkbox_1.Checkbox, { checked: props.sendEmails, value: '1', onChange: props.setSendEmails })), React.createElement(field_1.Item, { label: "Enable Process" }, React.createElement(checkbox_1.Checkbox, { checked: props.enabled, value: '1', onChange: props.setEnabled }))));
	};
	var PricingOptions = function PricingOptions(props) {
	    return React.createElement(select_1.FlexiBox, { name: "pricingOptions", multiple: props.multiPricingOption, value: props.selectedPricingOptions, onChange: props.setPricingOptions }, props.pricingOptions.map(function (po) {
	        return React.createElement("option", { key: po.id, value: po.id, disabled: isDisabledType(po, props.disabledPricingOptions) }, po.label);
	    }));
	};
	var Statuses = function Statuses(props) {
	    return React.createElement(select_1.FlexiBox, { name: "statuses", multiple: props.multiStatus, value: props.selectedStatuses, onChange: props.setStatuses }, props.statuses.map(function (s) {
	        return React.createElement("option", { key: s.id, value: s.id, style: { backgroundColor: s.color } }, s.label);
	    }));
	};
	var isDisabledType = function isDisabledType(type, disabledTypes) {
	    return disabledTypes.find(function (id) {
	        return id == type.id;
	    }) != undefined;
	};
	var isProcessDirection = function isProcessDirection(value) {
	    return value == "before" || value == "after";
	};
	var isPaymentType = function isPaymentType(value) {
	    return value == "all" || value == "scheduled payments" || value == "reusable payer";
	};
	var isCollationType = function isCollationType(value) {
	    return value == "none" || value == "member" || value == "organisation";
	};
	var typeLabel = function typeLabel(id, types) {
	    var type = types.find(function (t) {
	        return t.id == id;
	    });
	    return type ? type.label : '';
	};
	var paymentLabel = function paymentLabel(pt) {
	    switch (pt) {
	        case "all":
	            return "All";
	        case "scheduled payments":
	            return "Scheduled Payments";
	        case "reusable payer":
	            return "Automatic Payments";
	    }
	};

/***/ },

/***/ 617:
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.reducer = function (s, a) {
	    if (isProcessFormAction(a)) {
	        return processFormReducer(s, a.action);
	    }
	    return s;
	};
	var isProcessFormAction = function isProcessFormAction(a) {
	    return a.type == 'process form action';
	};
	var processFormReducer = function processFormReducer(s, a) {
	    return exports.validate(processFormReducer_(s, a));
	};
	exports.validate = function (s) {
	    if (!s.multiPricingOption && !s.selectedPricingOptions.length) {
	        return exports.validate(Object.assign({}, s, { selectedPricingOptions: [s.pricingOptions[0].id] }));
	    }
	    if (!s.multiStatus && !s.selectedStatuses.length) {
	        return exports.validate(Object.assign({}, s, { selectedStatuses: [s.statuses[0].id] }));
	    }
	    return s;
	};
	var processFormReducer_ = function processFormReducer_(s, a) {
	    switch (a.type) {
	        case "set process id":
	            return Object.assign({}, s, { processId: a.id });
	        case "set name":
	            return Object.assign({}, s, { name: a.name });
	        case "set multi pricing option":
	            return Object.assign({}, s, { multiPricingOption: a.multiPricingOption });
	        case "set pricing options":
	            return Object.assign({}, s, { selectedPricingOptions: a.pricingOptions });
	        case "set multi status":
	            return Object.assign({}, s, { multiStatus: a.multiStatus });
	        case "set statuses":
	            return Object.assign({}, s, { selectedStatuses: a.statuses });
	        case "set process days":
	            return Object.assign({}, s, { processDays: a.processDays });
	        case "set process direction":
	            return Object.assign({}, s, { processDirection: a.processDirection });
	        case "set collation type":
	            return Object.assign({}, s, { collationType: a.collationType });
	        case "set send emails":
	            return Object.assign({}, s, { sendEmails: a.sendEmails });
	        case "set enabled":
	            return Object.assign({}, s, { enabled: a.enabled });
	        case "set submitting":
	            return Object.assign({}, s, { submitting: a.submitting });
	        case "set payment type":
	            return Object.assign({}, s, { selectedPaymentType: a.paymentType, collationType: a.paymentType == 'all' ? s.collationType : 'none' });
	    }
	};

/***/ },

/***/ 618:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var $ = __webpack_require__(10);
	var error_types_1 = __webpack_require__(601);
	function onPendingStatusUpdated() {
	    var membershipForm = $('form[name=membershipForm]');
	    var pendingStatusSerial = membershipForm.find('[name=pendingStatusSerial]');
	    var selectedOption = pendingStatusSerial.find(':selected');
	    pendingStatusSerial.css('backgroundColor', selectedOption[0].style.backgroundColor || "");
	}
	exports.onPendingStatusUpdated = onPendingStatusUpdated;
	var statusChanged = false;
	exports.getStatusChanged = function () {
	    return statusChanged;
	};
	var newStatus = '';
	exports.getNewStatus = function () {
	    return newStatus;
	};
	function statusSerialOnChange() {
	    var membershipForm = $('form[name=membershipForm]');
	    var statusSerial = membershipForm.find('[name=statusSerial]');
	    var selectedOption = statusSerial.find(':selected');
	    statusSerial.css('backgroundColor', selectedOption[0].style.backgroundColor || "");
	    newStatus = selectedOption.text();
	    statusChanged = true;
	}
	exports.statusSerialOnChange = statusSerialOnChange;
	function preReqMaskedStatusSerialOnChange() {
	    var membershipForm = $('form[name=membershipForm]');
	    var statusSerial = membershipForm.find('[name=preReqMaskedStatusSerial]');
	    var selectedOption = statusSerial.find(':selected');
	    statusSerial.css('backgroundColor', selectedOption[0].style.backgroundColor || "");
	}
	exports.preReqMaskedStatusSerialOnChange = preReqMaskedStatusSerialOnChange;
	var oldExpiryValue;
	function updateExpiryCheckbox(checkboxId) {
	    var expiryDate = $('#expiryDateFormatted');
	    if ($("#" + checkboxId + ":checked").length > 0) {
	        if (expiryDate.datepicker('getDate') != null) oldExpiryValue = expiryDate.datepicker('getDate');
	        expiryDate.datepicker('setDate', null);
	        expiryDate.datepicker('disable');
	    } else {
	        if (oldExpiryValue) expiryDate.datepicker('setDate', oldExpiryValue);
	        expiryDate.datepicker('enable');
	    }
	}
	exports.updateExpiryCheckbox = updateExpiryCheckbox;
	var oldApprovedValue = {};
	var currentStatusSerial = {};
	function updateApprovedCheckbox(membership, approvalType, activeStatusSerial) {
	    var approvalTabField = ApprovalTabField.createFromApprovalType(membership, approvalType);
	    var name = approvalTabField.name();
	    var statusTarget = approvalTabField.statusTarget();
	    var date = $("#" + name + "DateFormatted");
	    var status = $("select[name=" + statusTarget + "]");
	    if ($("#" + name + "Checkbox:checked").length > 0) {
	        date.datepicker('setDate', oldApprovedValue[statusTarget]);
	        date.datepicker('enable');
	        status.val("" + activeStatusSerial);
	        approvalTabField.updateStatus();
	    } else {
	        if (date.datepicker('getDate') != null) oldApprovedValue[statusTarget] = date.datepicker('getDate');
	        date.datepicker('setDate', null);
	        date.datepicker('disable');
	        status.val(currentStatusSerial[statusTarget]);
	        approvalTabField.updateStatus();
	    }
	}
	exports.updateApprovedCheckbox = updateApprovedCheckbox;
	exports.initaliseApprovalCheckbox = function (replace, params) {
	    var approvalTabField = ApprovalTabField.createFromApprovalType(params.membership, params.approvalType);
	    var name = approvalTabField.name();
	    var statusTarget = approvalTabField.statusTarget();
	    oldApprovedValue[statusTarget] = new Date();
	    currentStatusSerial[statusTarget] = $("select[name=" + statusTarget + "]").find(':selected').val();
	};
	
	var ApprovalTabField = function () {
	    function ApprovalTabField(membership) {
	        _classCallCheck(this, ApprovalTabField);
	
	        this.membership = membership;
	    }
	
	    _createClass(ApprovalTabField, null, [{
	        key: "createFromApprovalType",
	        value: function createFromApprovalType(membership, approvalType) {
	            switch (approvalType) {
	                case 'signupApproval':
	                    return new SignupApprovalTabField(membership);
	                case 'renewalApproval':
	                    return new CurrentRenewalApprovalTabField(membership);
	                case 'futureRenewalApproval':
	                    return new FutureRenewalApprovalTabField(membership);
	                default:
	                    throw new error_types_1.IVTError("Unknown type: '" + approvalType + "'");
	            }
	        }
	    }]);
	
	    return ApprovalTabField;
	}();
	
	var SignupApprovalTabField = function (_ApprovalTabField) {
	    _inherits(SignupApprovalTabField, _ApprovalTabField);
	
	    function SignupApprovalTabField() {
	        _classCallCheck(this, SignupApprovalTabField);
	
	        return _possibleConstructorReturn(this, (SignupApprovalTabField.__proto__ || Object.getPrototypeOf(SignupApprovalTabField)).apply(this, arguments));
	    }
	
	    _createClass(SignupApprovalTabField, [{
	        key: "name",
	        value: function name() {
	            return 'approved';
	        }
	    }, {
	        key: "statusTarget",
	        value: function statusTarget() {
	            return this.membership.preReqMaskedStatus == 0 ? 'statusSerial' : 'preReqMaskedStatusSerial';
	        }
	    }, {
	        key: "updateStatus",
	        value: function updateStatus() {
	            return this.membership.preReqMaskedStatus == 0 ? statusSerialOnChange() : preReqMaskedStatusSerialOnChange();
	        }
	    }]);
	
	    return SignupApprovalTabField;
	}(ApprovalTabField);
	
	var CurrentRenewalApprovalTabField = function (_ApprovalTabField2) {
	    _inherits(CurrentRenewalApprovalTabField, _ApprovalTabField2);
	
	    function CurrentRenewalApprovalTabField() {
	        _classCallCheck(this, CurrentRenewalApprovalTabField);
	
	        return _possibleConstructorReturn(this, (CurrentRenewalApprovalTabField.__proto__ || Object.getPrototypeOf(CurrentRenewalApprovalTabField)).apply(this, arguments));
	    }
	
	    _createClass(CurrentRenewalApprovalTabField, [{
	        key: "name",
	        value: function name() {
	            return 'approvedAfterRenewal';
	        }
	    }, {
	        key: "statusTarget",
	        value: function statusTarget() {
	            return this.membership.preReqMaskedStatus == 0 ? 'statusSerial' : 'preReqMaskedStatusSerial';
	        }
	    }, {
	        key: "updateStatus",
	        value: function updateStatus() {
	            return this.membership.preReqMaskedStatus == 0 ? statusSerialOnChange() : preReqMaskedStatusSerialOnChange();
	        }
	    }]);
	
	    return CurrentRenewalApprovalTabField;
	}(ApprovalTabField);
	
	var FutureRenewalApprovalTabField = function (_ApprovalTabField3) {
	    _inherits(FutureRenewalApprovalTabField, _ApprovalTabField3);
	
	    function FutureRenewalApprovalTabField() {
	        _classCallCheck(this, FutureRenewalApprovalTabField);
	
	        return _possibleConstructorReturn(this, (FutureRenewalApprovalTabField.__proto__ || Object.getPrototypeOf(FutureRenewalApprovalTabField)).apply(this, arguments));
	    }
	
	    _createClass(FutureRenewalApprovalTabField, [{
	        key: "name",
	        value: function name() {
	            return 'approvedAfterRenewal';
	        }
	    }, {
	        key: "statusTarget",
	        value: function statusTarget() {
	            return this.membership.type.applyStatusAfterRenewal && this.membership.hasStatusAfterRenewal ? 'pendingStatusSerial' : this.membership.preReqMaskedStatus == 0 ? 'statusSerial' : 'preReqMaskedStatusSerial';
	        }
	    }, {
	        key: "updateStatus",
	        value: function updateStatus() {
	            this.membership.type.applyStatusAfterRenewal && this.membership.hasStatusAfterRenewal ? onPendingStatusUpdated() : this.membership.preReqMaskedStatus == 0 ? statusSerialOnChange : preReqMaskedStatusSerialOnChange();
	        }
	    }]);
	
	    return FutureRenewalApprovalTabField;
	}(ApprovalTabField);

/***/ },

/***/ 619:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) {
	            try {
	                step(generator.next(value));
	            } catch (e) {
	                reject(e);
	            }
	        }
	        function rejected(value) {
	            try {
	                step(generator["throw"](value));
	            } catch (e) {
	                reject(e);
	            }
	        }
	        function step(result) {
	            result.done ? resolve(result.value) : new P(function (resolve) {
	                resolve(result.value);
	            }).then(fulfilled, rejected);
	        }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(3);
	var ReactDOM = __webpack_require__(6);
	var redux_1 = __webpack_require__(22);
	var redux_thunk_1 = __webpack_require__(33);
	var report1_1 = __webpack_require__(620);
	var utils_1 = __webpack_require__(4);
	var report_builder_1 = __webpack_require__(179);
	var graph_renderer_1 = __webpack_require__(137);
	var chart_data_1 = __webpack_require__(180);
	// noinspection JSUnusedGlobalSymbols called via call_js in membership3 oldreports page
	exports.runReports = function (callback, params) {
	    var div = document.createElement("div");
	    var content = document.getElementById('content');
	    if (content) {
	        content.getElementsByTagName('table')[0].style.width = '100%';
	    }
	    var types = params.types.map(function (t) {
	        return { value: "" + t.serial, label: t.title };
	    });
	    var axes = { types: types };
	    var reducer = report_builder_1.reducer;
	    var isHidden = false;
	    var filters = {
	        "date range": { type: "date range", isHidden: isHidden },
	        "timeframe": {
	            type: "select box", isHidden: isHidden,
	            selectedDefault: "auto",
	            options: {
	                auto: "Auto",
	                day: "Day",
	                month: "Month",
	                year: "Year"
	            }
	        },
	        status: {
	            type: "checkbox", isHidden: isHidden,
	            label: "Status",
	            group: params.statuses.map(function (t) {
	                return { value: "" + t.serial, label: t.title };
	            })
	        },
	        "states": {
	            type: "checkbox", isHidden: isHidden,
	            label: "States",
	            group: params.states.map(function (t) {
	                return { value: "" + t.serial, label: t.state };
	            })
	        },
	        types: {
	            type: "checkbox", isHidden: isHidden,
	            label: "Membership Types",
	            group: types
	        }
	    };
	    var keys = [{ id: 'Date', label: 'Date' }, { id: 'Period', label: 'Period' }];
	    var displayModes = ["Graph", "Table"];
	    var reportTypes = {
	        numtypes: {
	            axis: "types",
	            filters: ["date range", "timeframe", "status"],
	            label: "Number of memberships by Type",
	            renderAs: "bar",
	            removeEmptyAxes: true,
	            keys: keys,
	            defaultDisplayMode: "Graph",
	            displayModes: displayModes
	        },
	        current: {
	            axis: "types",
	            filters: ["status"],
	            label: "Current memberships by Type",
	            renderAs: "pie",
	            removeEmptyAxes: true,
	            keys: keys,
	            defaultDisplayMode: "Graph",
	            displayModes: displayModes
	        },
	        statetype: {
	            axis: "types",
	            filters: ["date range", "timeframe", "status", "states", "types"],
	            label: "Memberships by state or Type",
	            renderAs: "line",
	            removeEmptyAxes: true,
	            keys: keys,
	            defaultDisplayMode: "Graph",
	            displayModes: displayModes
	        }
	    };
	    var ownProps = function ownProps(store, ajaxPageUrl) {
	        return {
	            title: "Membership Reports",
	            store: store,
	            modes: graph_renderer_1.standardModes,
	            reportTypes: reportTypes,
	            filters: filters,
	            axes: axes,
	            runReport: function runReport(dispatchWrapped) {
	                return function (dispatchUnwrapped, getState) {
	                    return __awaiter(undefined, void 0, void 0, regeneratorRuntime.mark(function _callee() {
	                        var state, a, renderAs, dateRange, timeframe, _a;
	
	                        return regeneratorRuntime.wrap(function _callee$(_context) {
	                            while (1) {
	                                switch (_context.prev = _context.next) {
	                                    case 0:
	                                        state = getState();
	                                        _context.prev = 1;
	
	                                        if (!(state.reportType == "current")) {
	                                            _context.next = 9;
	                                            break;
	                                        }
	
	                                        _context.next = 5;
	                                        return report1_1.runCurrentReport(state.filters.status, ajaxPageUrl);
	
	                                    case 5:
	                                        a = _context.sent;
	
	                                        dispatchWrapped({
	                                            type: "set new report data",
	                                            data: { data: a, renderAs: 'pie', axis: reportTypes.current.axis }
	                                        });
	                                        _context.next = 17;
	                                        break;
	
	                                    case 9:
	                                        renderAs = reportTypes[state.reportType].renderAs;
	                                        // A bug could occur here if the reportType is not "current" but
	                                        // renderAs is "pie". Our app would be in a state where the reportType and
	                                        // filters have changed, but the report data will not have been updated
	                                        // to reflect this
	
	                                        if (!(renderAs !== "pie")) {
	                                            _context.next = 17;
	                                            break;
	                                        }
	
	                                        dateRange = state.filters['date range'];
	                                        timeframe = state.filters.timeframe;
	                                        _context.next = 15;
	                                        return report1_1.runReport(state.filters.status, state.filters.states, state.filters.types, state.reportType, dateRange.type == "date range" ? dateRange.fromDate : new Date(), dateRange.type == "date range" ? dateRange.toDate : new Date(), timeframe.type == "select box" ? timeframe.selected : "auto", ajaxPageUrl);
	
	                                    case 15:
	                                        _a = _context.sent;
	
	                                        dispatchWrapped({
	                                            type: "set new report data",
	                                            data: { data: chart_data_1.flattenReportChartData(_a.data), renderAs: renderAs, axis: reportTypes[state.reportType].axis }
	                                        });
	
	                                    case 17:
	                                        _context.next = 22;
	                                        break;
	
	                                    case 19:
	                                        _context.prev = 19;
	                                        _context.t0 = _context["catch"](1);
	
	                                        window.alert("There was an unexpected error. Ensure you're logged in, your internet connection is working, and try reloading the page");
	
	                                    case 22:
	                                    case "end":
	                                        return _context.stop();
	                                }
	                            }
	                        }, _callee, this, [[1, 19]]);
	                    }));
	                };
	            }
	        };
	    };
	    var initialState = {
	        displayMode: "Graph",
	        reportType: "numtypes",
	        filters: {
	            "date range": { type: "date range", fromDate: new Date(), toDate: new Date() },
	            "timeframe": { type: "select box", selected: "auto" },
	            "states": { type: "checkbox", checked: [] },
	            types: { type: "checkbox", checked: [] },
	            "status": { type: "checkbox", checked: [] }
	        }
	    };
	    callback(div);
	    var store = redux_1.createStore(utils_1.withDefault(reducer, initialState), initialState, redux_1.applyMiddleware(redux_thunk_1.default));
	    var ReportApp = report_builder_1.makeReportApp();
	    ReactDOM.render(React.createElement(ReportApp, Object.assign({}, ownProps(store, params.ajaxPageUrl))), div);
	};

/***/ },

/***/ 620:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) {
	            try {
	                step(generator.next(value));
	            } catch (e) {
	                reject(e);
	            }
	        }
	        function rejected(value) {
	            try {
	                step(generator["throw"](value));
	            } catch (e) {
	                reject(e);
	            }
	        }
	        function step(result) {
	            result.done ? resolve(result.value) : new P(function (resolve) {
	                resolve(result.value);
	            }).then(fulfilled, rejected);
	        }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var commands_1 = __webpack_require__(12);
	var utils_1 = __webpack_require__(4);
	exports.runCurrentReport = function (status, ajaxPageUrl) {
	    return __awaiter(undefined, void 0, void 0, regeneratorRuntime.mark(function _callee() {
	        var statusSerials, params;
	        return regeneratorRuntime.wrap(function _callee$(_context) {
	            while (1) {
	                switch (_context.prev = _context.next) {
	                    case 0:
	                        statusSerials = status.type == "checkbox" ? status.checked : [];
	                        params = {
	                            statusSerials: statusSerials.length ? statusSerials : undefined
	                        };
	                        _context.next = 4;
	                        return new commands_1.CommandCaller(ajaxPageUrl).runGet('count memberships per type by statustype', params);
	
	                    case 4:
	                        return _context.abrupt("return", _context.sent);
	
	                    case 5:
	                    case "end":
	                        return _context.stop();
	                }
	            }
	        }, _callee, this);
	    }));
	};
	exports.runReport = function (status, statesFilter, typeFilter, reportType, fromDate, toDate, period, ajaxPageUrl) {
	    return __awaiter(undefined, void 0, void 0, regeneratorRuntime.mark(function _callee2() {
	        var statusSerials, states, typeSerials, params;
	        return regeneratorRuntime.wrap(function _callee2$(_context2) {
	            while (1) {
	                switch (_context2.prev = _context2.next) {
	                    case 0:
	                        statusSerials = status.type == "checkbox" ? status.checked : [];
	                        states = statesFilter.type == "checkbox" ? statesFilter.checked : [];
	                        typeSerials = reportType == "statetype" && typeFilter.type == "checkbox" ? typeFilter.checked : [];
	                        params = {
	                            startDate: utils_1.dateToYYYYMMDD(fromDate),
	                            endDate: utils_1.dateToYYYYMMDD(toDate),
	                            period: isPeriod(period) ? period : "auto",
	                            states: states && states.length ? states : undefined,
	                            typeSerials: typeSerials && typeSerials.length ? typeSerials : undefined,
	                            statusSerials: statusSerials.length ? statusSerials : undefined
	                        };
	                        _context2.next = 6;
	                        return new commands_1.CommandCaller(ajaxPageUrl).runGet('count memberships per period and type by statustype and state', params);
	
	                    case 6:
	                        return _context2.abrupt("return", _context2.sent);
	
	                    case 7:
	                    case "end":
	                        return _context2.stop();
	                }
	            }
	        }, _callee2, this);
	    }));
	};
	var isPeriod = function isPeriod(s) {
	    return s == "auto" || s == "year" || s == "month" || s == "day";
	};

/***/ },

/***/ 621:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var OptionWidget_1 = __webpack_require__(613);
	var pricing_option_form_1 = __webpack_require__(623);
	var MembershipDetails_ = __webpack_require__(618);
	var autorenewal_details_1 = __webpack_require__(622);
	var Reports_ = __webpack_require__(619);
	var ProcessForm_ = __webpack_require__(614);
	exports.OptionWidget = OptionWidget_1.OptionWidget;
	exports.CostItemForm = pricing_option_form_1.CostItemForm;
	exports.MembershipDetails = MembershipDetails_;
	exports.MyMemberships = { AutorenewalDetails: autorenewal_details_1.AutorenewalDetailsCallJs };
	exports.Reports = Reports_;
	exports.ProcessForm = ProcessForm_;

/***/ },

/***/ 622:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(3);
	var ReactDOM = __webpack_require__(6);
	var ajax_1 = __webpack_require__(111);
	var credit_card_1 = __webpack_require__(268);
	var redux_1 = __webpack_require__(22);
	var react_redux_1 = __webpack_require__(23);
	var redux_thunk_1 = __webpack_require__(33);
	var payment_details_widget_1 = __webpack_require__(654);
	var post = function post(path) {
	    return new ajax_1.AjaxRequest(path).runPost('application/x-www-form-urlencoded');
	};
	var AutorenewalDetails = function AutorenewalDetails(params) {
	    return React.createElement("div", null, "Autorenewed memberships ", params.multicurrency && "using " + credit_card_1.renderCurrencyName(params.details.currency), " will be paid with:", React.createElement(payment_details_widget_1.Payer, { details: params.details.payerDetails }), React.createElement("p", null, "Created ", params.details.date, " by ", params.details.owner), React.createElement("button", { onClick: function onClick() {
	            return params.revoke(params.details.revokePath);
	        } }, "Opt Out"));
	};
	var reducer = function reducer() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { loading: false, details: [] };
	    var action = arguments[1];
	
	    if (!action) return state;
	    switch (action.type) {
	        case 'update state':
	            return { loading: false, details: action.state };
	        case 'start':
	            return Object.assign({}, state, { loading: true });
	        case 'abort':
	            return Object.assign({}, state, { loading: false });
	    }
	    return state;
	};
	var AutorenewalDetailsView = function AutorenewalDetailsView(params) {
	    return React.createElement("div", { style: params.obscure ? { opacity: 0.5 } : undefined }, params.details.map(function (d) {
	        return React.createElement(AutorenewalDetails, { revoke: params.revoke, key: d.revokePath, multicurrency: params.multicurrency, details: d });
	    }), React.createElement("p", null, "To opt ", !!params.details.length && "back ", "in for future renewals, manually renew memberships and save credit card details during the process."));
	};
	var stateMap = function stateMap(state, ownProps) {
	    return {
	        details: state.details,
	        multicurrency: ownProps.multicurrency,
	        obscure: state.loading
	    };
	};
	var dispatchMap = function dispatchMap(dispatch) {
	    var _revoke = function _revoke(path) {
	        return function (dispatch) {
	            dispatch({ type: 'start' });
	            post(path).then(function (result) {
	                if (result.errors.length) {
	                    alert(result.errors.join("\n"));
	                }
	                var action = { type: 'update state', state: result.details };
	                dispatch(action);
	            }, function (e) {
	                if (e.statusNumber == 403) {
	                    alert('You do not have permission at this time to revoke payment details. Make sure you are logged in. If it still fails, please contact us.');
	                } else {
	                    alert('An error has occurred trying to revoke the details. Please reload the window and try again.');
	                }
	                dispatch({ type: 'abort' });
	            });
	        };
	    };
	    return {
	        revoke: function revoke(path) {
	            return dispatch(_revoke(path));
	        }
	    };
	};
	exports.AutorenewalDetailsCallJs = function (replace, params) {
	    var div = document.createElement('div');
	    replace(div);
	    var store = redux_1.createStore(reducer, { details: params.details, loading: false }, redux_1.applyMiddleware(redux_thunk_1.default));
	    var App = react_redux_1.connect(stateMap, dispatchMap)(AutorenewalDetailsView);
	    ReactDOM.render(React.createElement(App, { multicurrency: params.multicurrency, store: store }), div);
	};

/***/ },

/***/ 623:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(3);
	var ReactDOM = __webpack_require__(6);
	var redux_1 = __webpack_require__(22);
	var app_1 = __webpack_require__(624);
	var reduxStateFromCallJsParams = function reduxStateFromCallJsParams(params) {
	    return {
	        standardCostItems: {
	            items: params.standardCostItems.items,
	            signupFields: params.standardCostItems.signupFields.filter(function (field) {
	                return !field.supportsMultiselect;
	            }),
	            renewFields: params.standardCostItems.renewFields.filter(function (field) {
	                return !field.supportsMultiselect;
	            }),
	            autoRenewalEnabled: params.standardCostItems.autoRenewalEnabled
	        },
	        signupFieldCostItems: params.signupFieldCostItems,
	        renewFieldCostItems: params.renewFieldCostItems
	    };
	};
	exports.CostItemForm = function (callback, params) {
	    var div = document.createElement("div");
	    callback(div);
	    var store = redux_1.createStore(app_1.pricesApp, reduxStateFromCallJsParams(params));
	    ReactDOM.render(React.createElement(app_1.Form, { labels: params.financialCodeLabels, store: store }), div);
	};

/***/ },

/***/ 624:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(3);
	var react_redux_1 = __webpack_require__(23);
	var redux_1 = __webpack_require__(22);
	var horizontal_rule_1 = __webpack_require__(606);
	var container_1 = __webpack_require__(627);
	var container_2 = __webpack_require__(625);
	var reducer_1 = __webpack_require__(280);
	var reducer_2 = __webpack_require__(279);
	var noOpReducer = function noOpReducer(defaultState) {
	    return function () {
	        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
	        var action = arguments[1];
	        return state;
	    };
	};
	exports.pricesApp = redux_1.combineReducers({
	    standardCostItems: redux_1.combineReducers({
	        items: reducer_1.items,
	        signupFields: noOpReducer([]),
	        renewFields: noOpReducer([]),
	        autoRenewalEnabled: noOpReducer(false)
	    }),
	    signupFieldCostItems: reducer_2.fieldCostItems,
	    renewFieldCostItems: reducer_2.fieldCostItems
	});
	var FormContainer = function FormContainer(props) {
	    return React.createElement("div", null, React.createElement(horizontal_rule_1.HorizontalRule, null), React.createElement(container_1.StandardItemsContainer, { labels: props.labels, store: props.store }), React.createElement(horizontal_rule_1.HorizontalRule, null), React.createElement("div", null, React.createElement("div", { style: { float: "left", minWidth: "300px", maxWidth: "500px" } }, React.createElement(container_2.SignupFieldItemsContainer, { labels: props.labels, store: props.store })), React.createElement("div", { style: { float: "left", minWidth: "300px", maxWidth: "500px", marginLeft: "2em" } }, React.createElement(container_2.RenewFieldItemsContainer, { labels: props.labels, store: props.store }))), React.createElement("div", { style: { clear: "both" } }), React.createElement(horizontal_rule_1.HorizontalRule, null));
	};
	var secondId = function secondId(a, b) {
	    return b;
	};
	exports.Form = react_redux_1.connect(secondId, secondId)(FormContainer);

/***/ },

/***/ 625:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var reducer_1 = __webpack_require__(279);
	var react_redux_1 = __webpack_require__(23);
	var presentation_1 = __webpack_require__(626);
	var utils_1 = __webpack_require__(278);
	var mapDispatchToFieldItemProps = function mapDispatchToFieldItemProps(dispatch) {
	    return {
	        onFieldProrataPeriodChange: function onFieldProrataPeriodChange(fieldCostItem, prorataPeriod) {
	            return dispatch(reducer_1.ChangeActions.prorataPeriod(fieldCostItem, prorataPeriod));
	        }
	    };
	};
	/**
	 * Given a store, search the store for the Standard Cost Item which is matched by the "costChecker" function (e.g.
	 * isSignupCost or isRenewCost). Once we have that cost item, figure out if its price is derived from an infoform
	 * field, and if so, return the id of that field.
	 */
	var findInfoformFieldForAnnualCost = function findInfoformFieldForAnnualCost(costChecker, store) {
	    var annualField = store.standardCostItems.items.find(costChecker);
	    return annualField !== undefined && annualField.mode == "infoform field" ? annualField.infoformField : 0;
	};
	var canProrata = function canProrata(store, costFinder) {
	    var item = store.standardCostItems.items.find(costFinder);
	    return item !== undefined && item.prorataPeriod != null;
	};
	var mapStateToSignupFieldItemProps = function mapStateToSignupFieldItemProps(store) {
	    return {
	        fields: store.signupFieldCostItems,
	        annualCostInfoformField: findInfoformFieldForAnnualCost(utils_1.isSignupCost, store),
	        canProrata: canProrata(store, utils_1.isSignupCost)
	    };
	};
	var mapStateToRenewFieldItemProps = function mapStateToRenewFieldItemProps(store) {
	    return {
	        fields: store.renewFieldCostItems,
	        annualCostInfoformField: findInfoformFieldForAnnualCost(utils_1.isRenewCost, store),
	        canProrata: canProrata(store, utils_1.isRenewCost)
	    };
	};
	exports.SignupFieldItemsContainer = react_redux_1.connect(mapStateToSignupFieldItemProps, mapDispatchToFieldItemProps)(presentation_1.SignupFieldCostItems);
	exports.RenewFieldItemsContainer = react_redux_1.connect(mapStateToRenewFieldItemProps, mapDispatchToFieldItemProps)(presentation_1.RenewFieldCostItems);

/***/ },

/***/ 626:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var fixed_data_grid_1 = __webpack_require__(94);
	var help_button_1 = __webpack_require__(136);
	var React = __webpack_require__(3);
	var heading_1 = __webpack_require__(273);
	var notification_1 = __webpack_require__(139);
	var input_1 = __webpack_require__(34);
	var presentation_1 = __webpack_require__(276);
	var strings = __webpack_require__(277);
	var headings = {
	    Field: "Field",
	    ProrataPeriod: "Pro-rata Period",
	    GlCode: "Item Code",
	    JobCode: "Job Code",
	    AccountNumber: "Account Number"
	};
	
	var CostItemFixedDataGrid = function (_fixed_data_grid_1$Fi) {
	    _inherits(CostItemFixedDataGrid, _fixed_data_grid_1$Fi);
	
	    function CostItemFixedDataGrid() {
	        _classCallCheck(this, CostItemFixedDataGrid);
	
	        return _possibleConstructorReturn(this, (CostItemFixedDataGrid.__proto__ || Object.getPrototypeOf(CostItemFixedDataGrid)).apply(this, arguments));
	    }
	
	    return CostItemFixedDataGrid;
	}(fixed_data_grid_1.FixedDataGrid);
	
	var renderCostItem = function renderCostItem(props) {
	    return function (fieldCostItem) {
	        return {
	            'Field': {
	                node: React.createElement("span", null, fieldCostItem.field.label),
	                alignment: "right",
	                minWidth: "120px"
	            },
	            'ProrataPeriod': {
	                minWidth: "100px",
	                node: fieldCostItem.prorataPeriod == null ? null : props.annualCostInfoformField == fieldCostItem.field.id ? React.createElement("div", null, props.title, " Cost", ' ', React.createElement(help_button_1.HelpButton, { message: strings.currentlyConfiguredViaStandardCostItem(props.title) })) : React.createElement(presentation_1.ProrataPeriodInput, { value: props.canProrata ? fieldCostItem.prorataPeriod : null, onChange: function onChange(period) {
	                        return props.onFieldProrataPeriodChange(fieldCostItem, period);
	                    }, name: props.formType + "_field_" + fieldCostItem.field.id + "_prorata" })
	            },
	            "GlCode": { node: React.createElement(input_1.Input, { size: "tiny", disabled: true, value: fieldCostItem.field.glCode }) },
	            "JobCode": { node: React.createElement(input_1.Input, { size: "tiny", disabled: true, value: fieldCostItem.field.jobCode }) },
	            "AccountNumber": { node: React.createElement(input_1.Input, { size: "tiny", disabled: true, value: fieldCostItem.field.accountNumber }) }
	        };
	    };
	};
	var FormFieldCostItems = function FormFieldCostItems(props) {
	    var myHeadings = Object.assign({}, headings, { AccountNumber: props.labels.accountNumber, JobCode: props.labels.jobCode, GlCode: props.labels.glCode });
	    var toShow = props.fields.length == 0 ? React.createElement(notification_1.Notification, { type: "info" }, strings.noFormFieldsWithPrices(props.formType)) : React.createElement(CostItemFixedDataGrid, { heading: myHeadings, data: props.fields.map(renderCostItem(props)) });
	    return React.createElement("div", null, React.createElement(heading_1.SectionHeading, { title: props.title + " Form Cost Items" }), toShow);
	};
	exports.SignupFieldCostItems = function (props) {
	    return React.createElement(FormFieldCostItems, Object.assign({ title: "Signup" }, props, { formType: "signup" }));
	};
	exports.RenewFieldCostItems = function (props) {
	    return React.createElement(FormFieldCostItems, Object.assign({ title: "Renewal" }, props, { formType: "renew" }));
	};

/***/ },

/***/ 627:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var react_redux_1 = __webpack_require__(23);
	var presentation_1 = __webpack_require__(628);
	var reducer_1 = __webpack_require__(280);
	var utils_1 = __webpack_require__(4);
	var mapDispatchToStandardItemProps = function mapDispatchToStandardItemProps(dispatch) {
	    var actionCreatorToCallback = utils_1.curriedCompose(dispatch);
	    return {
	        onPriceChange: actionCreatorToCallback(reducer_1.ChangeActions.price),
	        onPriceFieldChange: actionCreatorToCallback(reducer_1.ChangeActions.priceField),
	        onModeChangeToPrice: actionCreatorToCallback(reducer_1.ChangeActions.modeToPrice),
	        onModeChangeToInfoformField: actionCreatorToCallback(reducer_1.ChangeActions.modeToInfoformField),
	        onGstStatusChange: actionCreatorToCallback(reducer_1.ChangeActions.gstStatus),
	        onItemCodeChange: actionCreatorToCallback(reducer_1.ChangeActions.itemCode),
	        onJobCodeChange: actionCreatorToCallback(reducer_1.ChangeActions.jobCode),
	        onAccountNumberChange: actionCreatorToCallback(reducer_1.ChangeActions.accountNumber),
	        onProrataPeriodChange: actionCreatorToCallback(reducer_1.ChangeActions.prorataPeriod)
	    };
	};
	var mapStateToStandardItemProps = function mapStateToStandardItemProps(store, ownProps) {
	    return {
	        CostItems: store.standardCostItems.items,
	        SignupFields: store.standardCostItems.signupFields,
	        RenewFields: store.standardCostItems.renewFields,
	        AutoRenewalEnabled: store.standardCostItems.autoRenewalEnabled,
	        FinancialCodeLabels: ownProps.labels
	    };
	};
	exports.StandardItemsContainer = react_redux_1.connect(mapStateToStandardItemProps, mapDispatchToStandardItemProps)(presentation_1.StandardCostItems);

/***/ },

/***/ 628:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var fixed_data_grid_1 = __webpack_require__(94);
	var input_1 = __webpack_require__(34);
	var heading_1 = __webpack_require__(273);
	var select_1 = __webpack_require__(39);
	var React = __webpack_require__(3);
	var price_utilities_1 = __webpack_require__(603);
	var help_button_1 = __webpack_require__(136);
	var strings = __webpack_require__(277);
	var utils_1 = __webpack_require__(278);
	var presentation_1 = __webpack_require__(276);
	var heading = {
	    CostItem: "Cost Item",
	    Price: "Price",
	    Mode: "Price Type",
	    GstStatus: "GST Status",
	    ProrataPeriod: "Pro-rata Period",
	    Signup: "Signup",
	    Renewal: "Renewal",
	    ItemCode: "Item Code",
	    JobCode: "Job Code",
	    AccountNumber: "Account Number"
	};
	
	var CostItemFixedDataGrid = function (_fixed_data_grid_1$Fi) {
	    _inherits(CostItemFixedDataGrid, _fixed_data_grid_1$Fi);
	
	    function CostItemFixedDataGrid() {
	        _classCallCheck(this, CostItemFixedDataGrid);
	
	        return _possibleConstructorReturn(this, (CostItemFixedDataGrid.__proto__ || Object.getPrototypeOf(CostItemFixedDataGrid)).apply(this, arguments));
	    }
	
	    return CostItemFixedDataGrid;
	}(fixed_data_grid_1.FixedDataGrid);
	
	var FieldSelector = function FieldSelector(props) {
	    var options = props.fields.map(function (field) {
	        return React.createElement("option", { key: "costItem-" + props.costItem.id + "-field-" + field.id, value: field.id.toString() }, field.label);
	    });
	    var onChange = function onChange(value) {
	        return props.onFieldChange(props.costItem.id, props.fields.find(function (field) {
	            return field.id == parseInt(value);
	        }));
	    };
	    return React.createElement(select_1.SingleBox, { onChange: onChange, value: props.costItem.infoformField > 0 ? props.costItem.infoformField.toString() : undefined, name: props.costItem.id + "InfoformField" }, options);
	};
	var PriceInput = function PriceInput(props) {
	    return utils_1.isAnnual(props.costItem) && props.costItem.mode == "infoform field" && props.fields.length > 0 ? React.createElement(FieldSelector, { costItem: props.costItem, fields: props.fields, onFieldChange: props.onFieldChange }) : React.createElement(input_1.Input, { size: "tiny", value: price_utilities_1.validateDollars(props.costItem.price), name: props.costItem.id + "Price", onChange: function onChange(value) {
	            return props.onPriceChange(props.costItem.id, value);
	        } });
	};
	var cantUseInfoformsError = function cantUseInfoformsError(costItem, autoRenewEnabled, fields) {
	    if (autoRenewEnabled && utils_1.isRenewCost(costItem)) {
	        return strings.cantUseFieldsDueToAutoRenewal;
	    } else if (fields.length == 0) {
	        var type = utils_1.isSignupCost(costItem) ? "signup" : "renew";
	        return strings.noFormFieldsWithPrices_requiresConfiguration(type);
	    } else {
	        return null;
	    }
	};
	var ModeInput = function ModeInput(props) {
	    var errorMessage = cantUseInfoformsError(props.costItem, props.autoRenewalEnabled, props.fields);
	    var canUseInfoformsField = errorMessage === null;
	    var fieldName = props.costItem.id + "Mode";
	    var cantUseInfoformsJsx = errorMessage === null ? null : React.createElement("span", null, ' ', React.createElement(help_button_1.HelpButton, { message: errorMessage }), React.createElement("input", { type: "hidden", name: fieldName, value: props.costItem.mode }));
	    return React.createElement("div", { style: { whiteSpace: "nowrap" } }, React.createElement(ModeInputSelectList, { fieldName: fieldName, value: canUseInfoformsField ? props.costItem.mode : "price", onChange: props.onChange, enabled: canUseInfoformsField }), cantUseInfoformsJsx);
	};
	var ModeInputSelectList = function ModeInputSelectList(props) {
	    return React.createElement(select_1.SingleBox, { name: props.fieldName, value: props.value, onChange: function onChange(value) {
	            return props.onChange(value);
	        }, enabled: props.enabled }, React.createElement("option", { value: "price" }, "Fixed"), React.createElement("option", { value: "infoform field" }, "Form Field"));
	};
	var renderCostItem = function renderCostItem(props) {
	    return function (costItem) {
	        var infoformFields = !utils_1.isAnnual(costItem) ? [] : utils_1.isSignupCost(costItem) ? props.SignupFields : props.RenewFields;
	        var infoformField = infoformFields.find(function (field) {
	            return field.id == costItem.infoformField;
	        });
	        var financialCodes = costItem.mode == "infoform field" && infoformField != null ? infoformField : costItem;
	        return {
	            'CostItem': {
	                alignment: "right",
	                node: React.createElement("div", { className: "sbReadOnlyField sbTextInputMedium" }, costItem.costItem)
	            },
	            'Mode': {
	                alignment: "left",
	                node: !utils_1.isAnnual(costItem) ? null : React.createElement(ModeInput, { costItem: costItem, fields: infoformFields, autoRenewalEnabled: props.AutoRenewalEnabled, onChange: function onChange(mode) {
	                        return mode == "price" ? props.onModeChangeToPrice(costItem.id) : props.onModeChangeToInfoformField(costItem.id, infoformFields[0]);
	                    } })
	            },
	            'Price': {
	                node: React.createElement(PriceInput, { costItem: costItem, fields: infoformFields, onPriceChange: props.onPriceChange, onFieldChange: props.onPriceFieldChange })
	            },
	            'GstStatus': {
	                node: React.createElement(select_1.SingleBox, { value: costItem.gstStatus, onChange: function onChange(value) {
	                        return props.onGstStatusChange(costItem.id, value);
	                    }, name: costItem.id + "GstStatus" }, React.createElement("option", { value: "type" }, "Use Default"), React.createElement("option", { value: "inclusive" }, "GST Inclusive"), React.createElement("option", { value: "exclusive" }, "GST Exclusive"), React.createElement("option", { value: "exempt" }, "GST Exempt"))
	            },
	            'ProrataPeriod': {
	                node: !utils_1.isAnnual(costItem) ? null : React.createElement(presentation_1.ProrataPeriodInput, { value: costItem.prorataPeriod, onChange: function onChange(period) {
	                        return props.onProrataPeriodChange(costItem.id, period);
	                    }, name: costItem.id + "ProrataPeriod" })
	            },
	            'Signup': { node: React.createElement("input", { type: "checkbox", checked: costItem.signup, disabled: true }) },
	            'Renewal': { node: React.createElement("input", { type: "checkbox", checked: costItem.renewal, disabled: true }) },
	            'ItemCode': {
	                node: React.createElement(input_1.Input, { size: "tiny", value: financialCodes.glCode, name: costItem.id + "GlCode", disabled: costItem.mode == "infoform field", onChange: function onChange(value) {
	                        return props.onItemCodeChange(costItem.id, value);
	                    } })
	            },
	            'JobCode': {
	                node: React.createElement(input_1.Input, { size: "tiny", value: financialCodes.jobCode, name: costItem.id + "JobCode", disabled: costItem.mode == "infoform field", onChange: function onChange(value) {
	                        return props.onJobCodeChange(costItem.id, value);
	                    } })
	            },
	            'AccountNumber': {
	                node: React.createElement(input_1.Input, { size: "tiny", value: financialCodes.accountNumber, name: costItem.id + "AccountNumber", disabled: costItem.mode == "infoform field", onChange: function onChange(value) {
	                        return props.onAccountNumberChange(costItem.id, value);
	                    } })
	            }
	        };
	    };
	};
	var CostItemList = function CostItemList(props) {
	    var myHeadings = Object.assign({}, heading, { AccountNumber: props.FinancialCodeLabels.accountNumber, JobCode: props.FinancialCodeLabels.jobCode, ItemCode: props.FinancialCodeLabels.glCode });
	    return React.createElement(CostItemFixedDataGrid, { heading: myHeadings, data: props.CostItems.map(renderCostItem(props)) });
	};
	exports.StandardCostItems = function (props) {
	    return React.createElement("div", null, React.createElement(heading_1.SectionHeading, { title: "Standard Cost Items" }), React.createElement(CostItemList, Object.assign({}, props)));
	};

/***/ },

/***/ 629:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var commands_1 = __webpack_require__(12);
	
	var Commands = function () {
	    function Commands(ajaxPageUrl) {
	        _classCallCheck(this, Commands);
	
	        this.ajaxPageUrl = ajaxPageUrl;
	    }
	
	    _createClass(Commands, [{
	        key: "isFolderEmpty",
	        value: function isFolderEmpty(folderId) {
	            return new commands_1.CommandCaller(this.ajaxPageUrl).runGet('is folder empty', folderId);
	        }
	    }]);
	
	    return Commands;
	}();
	
	exports.Commands = Commands;

/***/ },

/***/ 630:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(3);
	var Component_1 = __webpack_require__(113);
	var Component_2 = __webpack_require__(113);
	
	var FileWidget = function (_React$Component) {
	    _inherits(FileWidget, _React$Component);
	
	    function FileWidget() {
	        _classCallCheck(this, FileWidget);
	
	        return _possibleConstructorReturn(this, (FileWidget.__proto__ || Object.getPrototypeOf(FileWidget)).apply(this, arguments));
	    }
	
	    _createClass(FileWidget, [{
	        key: "render",
	        value: function render() {
	            return React.createElement("div", { className: "memory-module" }, React.createElement(Component_1.FileComponent, { file: this.props.file }));
	        }
	    }]);
	
	    return FileWidget;
	}(React.Component);
	
	exports.FileWidget = FileWidget;
	
	var FilesFoldersWidget = function (_React$Component2) {
	    _inherits(FilesFoldersWidget, _React$Component2);
	
	    function FilesFoldersWidget() {
	        _classCallCheck(this, FilesFoldersWidget);
	
	        return _possibleConstructorReturn(this, (FilesFoldersWidget.__proto__ || Object.getPrototypeOf(FilesFoldersWidget)).apply(this, arguments));
	    }
	
	    _createClass(FilesFoldersWidget, [{
	        key: "render",
	        value: function render() {
	            return React.createElement("div", { className: "memory-module items" }, React.createElement(FilesList, { files: this.props.files }), React.createElement(FolderHierarchyRenderer, { folders: this.props.folders, directoryIconPath: this.props.memoryParams.directoryIconPath }));
	        }
	    }]);
	
	    return FilesFoldersWidget;
	}(React.Component);
	
	exports.FilesFoldersWidget = FilesFoldersWidget;
	
	var FilesList = function (_React$Component3) {
	    _inherits(FilesList, _React$Component3);
	
	    function FilesList() {
	        _classCallCheck(this, FilesList);
	
	        return _possibleConstructorReturn(this, (FilesList.__proto__ || Object.getPrototypeOf(FilesList)).apply(this, arguments));
	    }
	
	    _createClass(FilesList, [{
	        key: "render",
	        value: function render() {
	            if (this.props.files.length === 0) {
	                return null;
	            }
	            return React.createElement("ul", { className: "file-list item-list" }, this.props.files.map(function (file) {
	                return React.createElement(Component_1.FileComponent, { key: "file-item-" + file.id, file: file });
	            }));
	        }
	    }]);
	
	    return FilesList;
	}(React.Component);
	
	var FolderHierarchyRenderer = function (_React$Component4) {
	    _inherits(FolderHierarchyRenderer, _React$Component4);
	
	    function FolderHierarchyRenderer() {
	        _classCallCheck(this, FolderHierarchyRenderer);
	
	        return _possibleConstructorReturn(this, (FolderHierarchyRenderer.__proto__ || Object.getPrototypeOf(FolderHierarchyRenderer)).apply(this, arguments));
	    }
	
	    _createClass(FolderHierarchyRenderer, [{
	        key: "render",
	        value: function render() {
	            var _this5 = this;
	
	            // No folders were selected at all, or the ones which were selected were not accessible to the current user.
	            if (this.props.folders == null || this.props.folders.length == 0) {
	                return null;
	            }
	            // Folders were selected, but due to permissions, the current user was not able to access any of its children.
	            var withoutChildren = this.props.folders.find(function (folder) {
	                return folder.hierarchy == null || folder.hierarchy.length == 0;
	            });
	            if (withoutChildren != null) {
	                return null;
	            }
	            return React.createElement("ul", { className: "category-list item-list" }, this.props.folders.map(function (folder) {
	                return React.createElement(Component_2.RecursiveFolderTree, { key: "category-tree-" + folder.folderId, parentId: folder.folderId, directoryIconPath: _this5.props.directoryIconPath, allPotentialChildren: folder.hierarchy });
	            }));
	        }
	    }]);
	
	    return FolderHierarchyRenderer;
	}(React.Component);

/***/ },

/***/ 631:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var $ = __webpack_require__(10);
	var Commands_1 = __webpack_require__(629);
	var MemoryFileWidget = __webpack_require__(263);
	var swfuploader_1 = __webpack_require__(182);
	var utils_1 = __webpack_require__(4);
	var updateFormByFolderId = function updateFormByFolderId(p, folderId) {
	    var inheritPermissions = p.inheritPermissionsInput.is(':checked');
	    var isTopLevel = p.topLevelFolderInput.is(':checked');
	    var folderSelected = isTopLevel || folderId > 0;
	    var uploadComplete = p.zipFileIdInput.val() != '';
	    var isFolderEmpty = p.isFolderEmptyInput.val() == '0';
	    inheritPermissions ? p.permissionsInput.hide() : p.permissionsInput.show();
	    isTopLevel ? p.folderSelectorWrapper.hide() : p.folderSelectorWrapper.show();
	    !isTopLevel && !isFolderEmpty ? p.notEmptyNotification.show() : p.notEmptyNotification.hide();
	    uploadComplete ? p.uploadDoneNotification.show() : p.uploadDoneNotification.hide();
	    p.btnSubmit.prop('disabled', !(folderSelected && isFolderEmpty && uploadComplete));
	};
	var updateFormKnowingFolderIdWidget = function updateFormKnowingFolderIdWidget(p) {
	    var folderId = parseInt($('input[name=folderId]').val());
	    updateFormByFolderId(p, folderId);
	};
	var folderSelected = function folderSelected(ajaxPageUrl, updateForm) {
	    return function (folderId) {
	        new Commands_1.Commands(ajaxPageUrl).isFolderEmpty(folderId).then(function (isEmpty) {
	            ;
	            document.getElementById('isFolderEmpty').value = isEmpty ? '0' : '1';
	            updateForm(folderId);
	        });
	        return false;
	    };
	};
	var onUploadSuccess = function onUploadSuccess(updateForm) {
	    return function (file, serverData) {
	        var processUploadedFile = function processUploadedFile(result) {
	            ;
	            document.getElementById('zipFileId').value = result.zipFileId;
	            updateForm();
	        };
	        var result = JSON.parse(serverData);
	        if (result.error) alert(result.error.title + "\n\n" + result.error.message);else processUploadedFile(result.response);
	    };
	};
	var uploader = function uploader(replace, params) {
	    swfuploader_1.swfuploader(replace, {
	        showCancelButton: false,
	        showQueue: true,
	        showUploadTotal: true,
	        showUploadedTotal: true,
	        uploadUrl: params.known.url,
	        maxSize: params.known.maxSize,
	        fileTypes: '*.zip',
	        fileTypesDescription: 'Zip File',
	        queueLimit: 1,
	        uploadCallback: params.uploadSuccess
	    });
	};
	exports.folderSelector = function (replace, params) {
	    var node = document.createElement('div');
	    replace(node);
	    $(function () {
	        var p = {
	            notEmptyNotification: $('#nonEmptyFolderWrapper'),
	            uploadDoneNotification: $('#uploadDoneNotificationFormItem'),
	            folderSelectorWrapper: $('#folderSelectorWrapper'),
	            topLevelFolderInput: $('#topLevelFolder'),
	            zipFileIdInput: $('#zipFileId'),
	            isFolderEmptyInput: $('#isFolderEmpty'),
	            btnSubmit: $('#btnSubmit'),
	            inheritPermissionsInput: $('#inheritPermissions'),
	            permissionsInput: $('#permissionsContainer')
	        };
	        var formUpdater = function formUpdater() {
	            return updateFormKnowingFolderIdWidget(p), false;
	        };
	        $('#selectPermissions').change(formUpdater);
	        p.inheritPermissionsInput.change(formUpdater);
	        p.permissionsInput.change(formUpdater);
	        p.topLevelFolderInput.change(formUpdater);
	        $('#specificFolder').change(formUpdater);
	        uploader(function (e) {
	            return utils_1.getElementByIdOrThrow(document, params.fileUploaderDivId).appendChild(e);
	        }, {
	            known: params.uploaderParams,
	            uploadSuccess: onUploadSuccess(formUpdater)
	        });
	        MemoryFileWidget.renderAdminFolder('folderId', params.memoryParams, params.selectedFolder, utils_1.getElementByIdOrThrow(document, params.adminFolderSelectorDivId), 'Select a Folder', folderSelected(params.ajaxPageUrl, function (id) {
	            return updateFormByFolderId(p, id);
	        }), formUpdater);
	        updateFormKnowingFolderIdWidget(p);
	    });
	};

/***/ },

/***/ 632:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var $ = __webpack_require__(10);
	exports.checkbox_permission_column = function (isChecked, value1, value2) {
	    var checkboxes = $('#permissions-input-wrapper').find('input[type=checkbox][name|="group_"]');
	    checkboxes.each(function (i, element) {
	        var e = $(element);
	        if (e.val() == value1 || e.val() == value2) e.prop('checked', isChecked);
	    });
	};

/***/ },

/***/ 633:
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.initToolbar = function (replace, params) {
	    {
	        var eles = Array.from(document.getElementsByName('downloadLogEditButton'));
	        eles.forEach(function (ele) {
	            ele.onclick = function () {
	                var serial = window.downloadLogListToolbarSelections;
	                if (serial.length == 1) {
	                    document.location.assign(params.downloadLogPage + "?command=displaydownloadlog&downloadLogSerial=" + serial[0]);
	                }
	            };
	        });
	    }
	    {
	        var _eles = Array.from(document.getElementsByName('downloadLogExportButton'));
	        _eles.forEach(function (ele) {
	            ele.onclick = function () {
	                var serial = window.downloadLogListToolbarSelections;
	                var serials = serial.join(',');
	                document.location.assign(params.downloadLogPage + "/export/?command=exportdownloadlog&downloadLogSerial=" + serials);
	            };
	        });
	    }
	};

/***/ },

/***/ 634:
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	function on_key_down() {
	    // Empty function
	}
	exports.setup = function (replace, params) {
	    window.on_key_down = on_key_down;
	    /** @deprecated */
	    function check_illegal_chars() {}
	    /** @deprecated */
	    window.check_illegal_chars = check_illegal_chars;
	    function change_parent_directory(id_string, name, name_value) {
	        var read_el = 'select_dir_read';
	        var write_el = 'select_dir_write';
	        var select_dir_read_ele = document.getElementById('select_dir_read');
	        var select_dir_write_ele = document.getElementById('select_dir_write');
	        if (select_dir_read_ele && select_dir_read_ele.style.display == 'block') {
	            select_dir_read_ele.style.display = 'none';
	            if (select_dir_write_ele) select_dir_write_ele.style.display = 'block';
	        } else if (id_string == 'cancel') {
	            if (select_dir_write_ele) select_dir_write_ele.style.display = 'none';
	            if (select_dir_read_ele) select_dir_read_ele.style.display = 'block';
	            return;
	        }
	        var original_name = name + '_id';
	        var id = Array.from(document.getElementsByName(original_name)).map(function (e) {
	            return e instanceof HTMLInputElement && e.form && e.form.name == 'my_form' ? e.value : null;
	        }).filter(function (i) {
	            return i !== null;
	        })[0];
	        var url = params.page + '?command=get_directory_form_data&id_string=' + id_string + '&name=' + name + '&id=' + id;
	        if (name_value != '') {
	            Array.from(document.getElementsByName(name)).forEach(function (e) {
	                if (e instanceof HTMLInputElement && e.form && e.form.name == 'my_form') e.value = name_value;
	            });
	        }
	        var http = new XMLHttpRequest();
	        http.open("GET", url, true);
	        http.onreadystatechange = function () {
	            if (http.readyState == 4) {
	                // Get the data from the server
	                var data = http.responseText;
	                if (select_dir_write_ele) select_dir_write_ele.innerHTML = data;
	            }
	        };
	        http.send(null);
	    }
	    window.change_parent_directory = change_parent_directory;
	    function check_file_name(file_name) {
	        return null;
	    }
	    window.check_file_name = check_file_name;
	    function check_if_record_exists(element, id, parent_id, is_directory) {
	        var value = Array.from(document.getElementsByName(element)).map(function (e) {
	            return e instanceof HTMLInputElement && e.form && e.form.name == 'my_form' ? e.value : null;
	        }).filter(function (i) {
	            return i !== null;
	        })[0];
	        var url = params.page + '?command=record_exists&parent_id=' + parent_id + '&id=' + id + '&is_directory=' + is_directory + '&value=' + value;
	        var http = new XMLHttpRequest();
	        http.open("GET", url, true);
	        http.onreadystatechange = function () {
	            if (http.readyState == 4) {
	                // Get the data from the server
	                var data = http.responseText;
	                if (data) {
	                    alert(data);
	                    return false;
	                } else {
	                    var ele = document.getElementById('my_form_buttons');
	                    if (ele) ele.innerHTML = params.form_processing_message;
	                    Array.from(document.getElementsByName('my_form')).forEach(function (ele) {
	                        return ele instanceof HTMLFormElement && ele.submit();
	                    });
	                }
	            }
	            return undefined;
	        };
	        http.send(null);
	        return false;
	    }
	    window.check_if_record_exists = check_if_record_exists;
	    function set_checkbox(field_name, field_value) {
	        var field = Array.from(document.getElementsByName(field_name)).forEach(function (e) {
	            if (e instanceof HTMLInputElement && e.form && e.form.name == 'my_form') {
	                if (e.value == field_value) {
	                    e.checked = true;
	                    return;
	                }
	            }
	        });
	    }
	    window.set_checkbox = set_checkbox;
	};

/***/ },

/***/ 635:
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.removeBrowserElements = function (replace, params) {
	    params.map(function (p) {
	        return window.opener.remove_browser_window_element(p);
	    });
	};
	exports.refreshWindows = function (replace, params) {
	    params.map(function (p) {
	        var r = window.opener.refresh_window;
	        r(p.window_num, p.parent_id, p.parent_is_directory, p.id);
	    });
	    self.close();
	};
	exports.initializeKeyJavascript = function (replace, params) {
	    var super_user = params.super_user;
	    // record_type key
	    // 0 = File
	    // 1 = Directory
	    // 3 = Version
	    window.set_delete_id = function (id, record_type) {
	        var ele = document.getElementById('memory_delete_id');
	        if (ele) ele.innerHTML = id + '-' + record_type;
	    };
	    var delete_record = function delete_record(id) {
	        if (id != '') {
	            var url;
	
	            (function () {
	                var http = new XMLHttpRequest();
	                url = params.page + '?command=get_confirm_delete_message&id=' + id + params.outside_navigation;
	
	                http.open("GET", url, true);
	                http.onreadystatechange = function () {
	                    if (http.readyState == 4) {
	                        if (http.responseText.length > 0) {
	                            if (confirm('Are you sure you want to delete this record?')) {
	                                if (confirm(http.responseText)) {
	                                    if (confirm('THIS ACTION CANNOT BE UNDONE!\nAre you sure you want to delete these records?')) {
	                                        document.location.assign(params.page + '?command=delete&id=' + id + params.outside_navigation);
	                                    }
	                                }
	                            }
	                        } else {
	                            alert('Permission denied');
	                        }
	                    }
	                };
	                http.send(null);
	            })();
	        }
	    };
	    window.delete_record = delete_record;
	    window.on_key_down = function (code) {
	        var id = 0;
	        // Capture delete key
	        if (code == 46) {
	            // Passed from one of the iframs
	            var ele = document.getElementById('memory_delete_id');
	            if (ele) id = ele.innerHTML;
	            delete_record(id);
	        }
	    };
	};
	exports.doit = function (replace, params) {
	    var state = {
	        window_num: 0,
	        max_window_num: 0,
	        displaying_previous_view: false
	    };
	    window.refresh_window = refresh_window(params);
	    window.add_browser_window = add_browser_window(params, state);
	    window.revert_browser = revert_browser;
	    window.remove_browser_window_element = remove_browser_window_element;
	};
	function remove_browser_window_element(my_count) {
	    if (document.getElementById('browser_window_' + my_count)) {
	        var tr_elm = document.getElementById("outer_tr");
	        var rm_td = document.getElementById("browser_window_" + my_count);
	        if (tr_elm && rm_td) {
	            tr_elm.removeChild(rm_td);
	        }
	    }
	}
	function revert_browser(url) {
	    parent.document.location.assign(url);
	}
	var add_browser_window = function add_browser_window(params, state) {
	    return function (new_window_num, parent_id, parent_is_directory_any, id, command, parent_name, dir_is_writeable, file_is_writeable) {
	        var parent_is_directory = parent_is_directory_any == 1 || parent_is_directory_any == 'true' ? 1 : 0; //remarkably, this works. we use a number to try avoid the 'true'/'false' string
	        if (id == undefined) id = '';
	        if (new_window_num == 1) {
	            parent_name = params.page_title;
	            if (params.super_user) {
	                dir_is_writeable = true;
	                file_is_writeable = true;
	            } else {
	                dir_is_writeable = false;
	                file_is_writeable = false;
	            }
	        }
	        // Change the global variable so that it can be used in the event handler
	        state.window_num = new_window_num;
	        // Add outer table
	        if (!document.getElementById('outer_table')) {
	            var new_table = document.createElement("TABLE");
	            new_table.setAttribute('id', 'outer_table');
	            new_table.setAttribute('cellpadding', '0');
	            new_table.setAttribute('cellspacing', '0');
	            new_table.setAttribute('border', '0');
	            document.body.appendChild(new_table);
	            var new_tbody = document.createElement("TBODY");
	            new_tbody.setAttribute('id', 'outer_tbody');
	            var table_elm = document.getElementById("outer_table");
	            if (table_elm) table_elm.appendChild(new_tbody);
	            var new_tr = document.createElement("TR");
	            new_tr.setAttribute('id', 'outer_tr');
	            var tbody_elm = document.getElementById("outer_tbody"); //todo redundant
	            if (tbody_elm) tbody_elm.appendChild(new_tr);
	        }
	        if (state.window_num > state.max_window_num) {
	            state.max_window_num = state.window_num;
	        } else if (state.window_num <= state.max_window_num) {
	            for (var i = state.window_num; i <= state.max_window_num; i++) {
	                remove_browser_window_element(i);
	            }
	            if (!state.displaying_previous_view) {
	                state.max_window_num = state.window_num;
	            }
	        }
	        // Hide add links for windows other than this one
	        if (state.max_window_num > 1) {
	            for (var _i = 1; _i < state.max_window_num; _i++) {
	                if (document.getElementById('tr_' + _i)) {
	                    var ele = document.getElementById('tr_' + _i);
	                    if (ele) ele.style.visibility = 'hidden';
	                }
	            }
	        }
	        if (!document.getElementById('browser_window_' + state.window_num)) {
	            {
	                var new_td = document.createElement("TD");
	                new_td.setAttribute('id', 'browser_window_' + state.window_num);
	                new_td.setAttribute('valign', 'top');
	                var tr_elm = document.getElementById("outer_tr");
	                if (tr_elm) tr_elm.appendChild(new_td);
	            }
	            {
	                var new_div = document.createElement("div");
	                new_div.setAttribute("className", "fieldset_title");
	                new_div.setAttribute("class", "fieldset_title");
	                var div_text = document.createTextNode(parent_name.substring(0, 24));
	                new_div.appendChild(div_text);
	                var new_link = document.createElement("a");
	                new_link.setAttribute("style", "text-decoration: none;");
	                var revert_url = "" + params.page + "?command=revert_browser&window_num=" + state.window_num + params.outside_navigation;
	                new_link.setAttribute("href", "javascript:revert_browser('" + revert_url + "');");
	                new_link.appendChild(new_div);
	                new_div.setAttribute('style', 'padding:3px;margin:0px;');
	                var td_elm = document.getElementById('browser_window_' + state.window_num);
	                if (td_elm) td_elm.appendChild(new_link);
	            }
	            var new_url = params.page + '?command=' + command + '&window_num=' + state.window_num + '&parent_is_directory=' + parent_is_directory + '&parent_id=' + parent_id + '&id=' + id + '&dir_is_writeable=' + dir_is_writeable + '&file_is_writeable=' + file_is_writeable + '&parent_name=' + parent_name;
	            var idhm = 'browser_frame_' + state.window_num;
	            var id_td_lm = 'browser_window_' + state.window_num;
	            var new_iframe = document.createElement("IFRAME");
	            new_iframe.setAttribute('id', idhm);
	            new_iframe.setAttribute('name', 'browser_frame_' + state.window_num);
	            new_iframe.setAttribute('width', params.window_width);
	            new_iframe.setAttribute('height', params.window_height);
	            new_iframe.setAttribute('border', '0');
	            new_iframe.setAttribute('src', new_url);
	            new_iframe.setAttribute('style', 'border: 1px solid ' + params.on_background + '; padding:0');
	            var add_args = '?window_num=' + state.window_num + '&parent_is_directory=1&parent_id=' + parent_id;
	            var add_url = params.page + add_args;
	            var dir_url = add_url + '&command=display_directory_form';
	            var file_url = add_url + '&command=display_file_form';
	            var version_url = params.page + "/display_version_form" + add_args;
	            {
	                var _td_elm = document.getElementById(id_td_lm);
	                if (_td_elm) _td_elm.appendChild(new_iframe);
	                var _new_table = document.createElement("TABLE");
	                _new_table.setAttribute('id', 'table_' + state.window_num);
	                _new_table.setAttribute('cellpadding', '1');
	                _new_table.setAttribute('cellspacing', '1');
	                _new_table.setAttribute('border', '0');
	                _new_table.setAttribute('align', 'center');
	                if (_td_elm) _td_elm.appendChild(_new_table);
	            }
	            {
	                var _new_tbody = document.createElement("TBODY");
	                _new_tbody.setAttribute('id', 'tbody_' + state.window_num);
	                var _table_elm = document.getElementById('table_' + state.window_num);
	                if (_table_elm) _table_elm.appendChild(_new_tbody);
	            }
	            {
	                var _new_tr = document.createElement("TR");
	                _new_tr.setAttribute('id', 'tr_' + state.window_num);
	                var _tbody_elm = document.getElementById('tbody_' + state.window_num);
	                if (_tbody_elm) _tbody_elm.appendChild(_new_tr);
	            }
	            {
	                var _new_td = document.createElement("TD");
	                _new_td.setAttribute('id', 'td_1_' + state.window_num);
	                _new_td.setAttribute('valign', 'top');
	                _new_td.setAttribute('height', '20');
	                var _tr_elm = document.getElementById('tr_' + state.window_num);
	                if (_tr_elm) _tr_elm.appendChild(_new_td);
	                _new_td.setAttribute('valign', 'middle');
	            }
	            if ((dir_is_writeable || file_is_writeable) && (state.window_num == state.max_window_num || state.window_num == 1)) {
	                if (parent_is_directory) {
	                    if (dir_is_writeable) {
	                        var new_image = document.createElement("img");
	                        new_image.setAttribute("src", params.dir_new_image);
	                        new_image.setAttribute("border", "0");
	                        {
	                            var _new_link = document.createElement("a");
	                            _new_link.setAttribute("href", "javascript:new_window('" + dir_url + "'," + params.popup_width + "," + params.popup_height + ")");
	                            _new_link.appendChild(new_image);
	                            var _td_elm2 = document.getElementById('td_1_' + state.window_num);
	                            if (_td_elm2) _td_elm2.appendChild(_new_link);
	                        }
	                        {
	                            var _new_td2 = document.createElement("TD");
	                            _new_td2.setAttribute('id', 'td_2_' + state.window_num);
	                            _new_td2.setAttribute('valign', 'top');
	                            var _tr_elm2 = document.getElementById('tr_' + state.window_num);
	                            if (_tr_elm2) _tr_elm2.appendChild(_new_td2);
	                            _new_td2.setAttribute('valign', 'middle');
	                        }
	                        {
	                            var _new_link2 = document.createElement("a");
	                            var link_text = document.createTextNode("Add " + params.dir_short_label);
	                            _new_link2.setAttribute("href", "javascript:new_window('" + dir_url + "'," + params.popup_width + "," + params.popup_height + ")");
	                            _new_link2.appendChild(link_text);
	                            var _td_elm3 = document.getElementById('td_2_' + state.window_num);
	                            if (_td_elm3) _td_elm3.appendChild(_new_link2);
	                        }
	                    }
	                    if (file_is_writeable) {
	                        {
	                            var _new_td3 = document.createElement("TD");
	                            _new_td3.setAttribute('id', 'td_3_' + state.window_num);
	                            _new_td3.setAttribute('valign', 'top');
	                            var _tr_elm3 = document.getElementById('tr_' + state.window_num);
	                            if (_tr_elm3) _tr_elm3.appendChild(_new_td3);
	                            _new_td3.setAttribute('valign', 'middle');
	                        }
	                        {
	                            var _new_image = document.createElement("img");
	                            _new_image.setAttribute("src", params.file_image);
	                            _new_image.setAttribute("border", "0");
	                            var _new_link3 = document.createElement("a");
	                            _new_link3.setAttribute("href", "javascript:new_window('" + file_url + "'," + params.popup_width + "," + params.popup_height + ")");
	                            _new_link3.appendChild(_new_image);
	                            var _td_elm4 = document.getElementById('td_3_' + state.window_num);
	                            if (_td_elm4) _td_elm4.appendChild(_new_link3);
	                        }
	                        {
	                            var _new_td4 = document.createElement("TD");
	                            _new_td4.setAttribute('id', 'td_4_' + state.window_num);
	                            _new_td4.setAttribute('valign', 'top');
	                            var _tr_elm4 = document.getElementById('tr_' + state.window_num);
	                            if (_tr_elm4) _tr_elm4.appendChild(_new_td4);
	                            _new_td4.setAttribute('valign', 'middle');
	                        }
	                        {
	                            var _new_link4 = document.createElement("a");
	                            var _link_text = document.createTextNode("Add " + params.file_short_label);
	                            _new_link4.setAttribute("href", "javascript:new_window('" + file_url + "'," + params.popup_width + "," + params.popup_height + ")");
	                            _new_link4.appendChild(_link_text);
	                            var _td_elm5 = document.getElementById('td_4_' + state.window_num);
	                            if (_td_elm5) _td_elm5.appendChild(_new_link4);
	                        }
	                    }
	                } else if (file_is_writeable) {
	                    {
	                        var _new_image2 = document.createElement("img");
	                        _new_image2.setAttribute("src", params.arrow_image);
	                        _new_image2.setAttribute("border", "0");
	                        var _new_link5 = document.createElement("a");
	                        _new_link5.setAttribute("href", "javascript:new_window('" + version_url + "'," + params.popup_width + "," + params.popup_height + ")");
	                        _new_link5.appendChild(_new_image2);
	                        var _td_elm6 = document.getElementById('td_1_' + state.window_num);
	                        if (_td_elm6) _td_elm6.appendChild(_new_link5);
	                    }
	                    {
	                        var _new_td5 = document.createElement("TD");
	                        _new_td5.setAttribute('id', 'td_2_' + state.window_num);
	                        _new_td5.setAttribute('valign', 'top');
	                        var _tr_elm5 = document.getElementById('tr_' + state.window_num);
	                        if (_tr_elm5) _tr_elm5.appendChild(_new_td5);
	                        _new_td5.setAttribute('valign', 'middle');
	                    }
	                    {
	                        var _new_link6 = document.createElement("a");
	                        var _link_text2 = document.createTextNode("Add New " + params.version_short_label);
	                        _new_link6.setAttribute("href", "javascript:new_window('" + version_url + "'," + params.popup_width + "," + params.popup_height + ")");
	                        _new_link6.appendChild(_link_text2);
	                        var _td_elm7 = document.getElementById('td_2_' + state.window_num);
	                        if (_td_elm7) _td_elm7.appendChild(_new_link6);
	                    }
	                }
	            }
	        }
	        parent.window.frames['my_frame'].focus();
	        parent.window.frames['my_frame'].scrollBy(params.window_width + 20, 0);
	    };
	};
	var refresh_window = function refresh_window(params) {
	    return function (window_num, parent_id, parent_is_directory, id) {
	        var my_frame = 'browser_frame_' + window_num;
	        if (document.getElementById(my_frame)) {
	            var frame_elm = document.getElementById(my_frame);
	            if (frame_elm) frame_elm.setAttribute('src', params.page + '?command=get_session_window_data&window_num=' + window_num + '&parent_is_directory=' + parent_is_directory + '&parent_id=' + parent_id + '&id=' + id);
	        }
	    };
	};

/***/ },

/***/ 636:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var BulkUploads = __webpack_require__(631);
	var SingleUpload = __webpack_require__(635);
	var CheckboxPermissionColumn = __webpack_require__(632);
	var Form = __webpack_require__(634);
	var DownloadLog = __webpack_require__(633);
	var VersionForm = __webpack_require__(637);
	exports.bulkUploads = BulkUploads;
	exports.single_upload = SingleUpload;
	exports.checkbox_permission_column = CheckboxPermissionColumn.checkbox_permission_column;
	exports.form = Form;
	exports.download_log = DownloadLog;
	exports.version_form = VersionForm;

/***/ },

/***/ 637:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(3);
	var ReactDOM = __webpack_require__(6);
	var datePicker_1 = __webpack_require__(93);
	var form_buttons_1 = __webpack_require__(266);
	exports.run_version_form = function (replace, params) {
	    var div = document.createElement('div');
	    replace(div);
	    ReactDOM.render(React.createElement(Form, Object.assign({}, params)), div);
	};
	var ensure_valid_published_status = function ensure_valid_published_status(status) {
	    switch (status) {
	        case 0:
	            return 0;
	        case 1:
	            return 1;
	        case 3:
	            return 3;
	        default:
	            return null;
	    }
	};
	
	var Form = function (_React$Component) {
	    _inherits(Form, _React$Component);
	
	    function Form(p, ctx) {
	        _classCallCheck(this, Form);
	
	        var _this = _possibleConstructorReturn(this, (Form.__proto__ || Object.getPrototypeOf(Form)).call(this, p, ctx));
	
	        _this.state = { publish_status: ensure_valid_published_status(p.type == 'new' ? 0 : p.result.previously_published_status) };
	        _this.updatePublishStatus = function (status) {
	            return _this.setState({ publish_status: status });
	        };
	        return _this;
	    }
	
	    _createClass(Form, [{
	        key: "render",
	        value: function render() {
	            var params = this.props;
	            var onsubmit = function onsubmit(e) {
	                var form = document.getElementById('my_form');
	                if (form && form instanceof HTMLFormElement && validate(form)) {
	                    var buttons = document.getElementById('my_form_buttons');
	                    if (buttons) buttons.innerHTML = params.form_processing_message;
	                    return true;
	                } else {
	                    e.preventDefault();
	                    return false;
	                }
	            };
	            var mode = params.type == 'new' ? { type: 'new' } : {
	                type: 'update',
	                id: params.params.id,
	                read_only_file_link: '',
	                read_only_filename: params.result.version_read_filename
	            };
	            var publish_params = {
	                name: 'PublishedStatus',
	                label: params.type == 'new' && !params.params.is_publishable ? 'Publish Request' : 'Publish',
	                title: '',
	                allow_read_only_upload: true,
	                file_id: params.result.serial,
	                mode: mode
	            };
	            var publish_props = {
	                params: publish_params,
	                file_label: params.file_label,
	                page: params.page,
	                published_status: this.state.publish_status,
	                update: this.updatePublishStatus
	            };
	            var expiry_date = params.result.expiry_date ? new Date(params.result.expiry_date) : null;
	            return React.createElement("form", { id: "my_form", name: "my_form", action: params.action, method: 'post', encType: 'multipart/form-data', onSubmit: onsubmit }, params.type == "update" && React.createElement("input", { type: "hidden", name: "id", value: params.params.id }), React.createElement("input", { type: "hidden", name: "window_num", value: params.params.window_num.toString() }), React.createElement("input", { type: "hidden", name: "DataSerial", value: params.params.parent_id == null ? '' : params.params.parent_id.toString() }), React.createElement("input", { type: "hidden", name: "VersionNumber", value: "" }), React.createElement("input", { type: "hidden", name: "previous_published_status", value: "" + (params.type == 'new' ? 0 : params.result.previously_published_status) }), React.createElement("input", { type: "hidden", name: "ParentSerial", value: "" }), React.createElement("div", { className: "border" }, React.createElement("div", { className: "fieldset_title" }, params.version_label.toUpperCase(), " FORM"), React.createElement("div", { style: { overflow: 'auto' } }, React.createElement("div", { className: "form" }, React.createElement("table", { style: { border: 0 } }, React.createElement(FormReadOnly, { name: "file_label", label: params.file_label, value: params.result.title }), React.createElement(FormReadOnly, { name: "version_label", label: params.version_label, value: params.result.version_number }), params.type == 'new' ? React.createElement(FormInput, { class_name: 'medium', title: 'Upload', label: 'Upload', name: 'upload', type: 'file' }) : React.createElement(RowStart, { name: "link" }, React.createElement("a", { href: params.page + "?command=download_version&id=" + params.result.version_serial, target: "_new" }, params.result.version_original_filename)), React.createElement(ControlledFormPublish, Object.assign({}, publish_props)), React.createElement(FormInputDate, { visible: !!this.state.publish_status, value: expiry_date, name: "ExpiryDate", label: "Expiry Date", title: "moo", date_format: "d/m/Y" }), React.createElement(FormTextArea, { title: "", name: "VersionComment", value: params.result.version_comment, label: "Comment", className: "small", width: "250px" }))))), React.createElement("br", null), React.createElement(form_buttons_1.FormButtons, { form: "my_form", single: true, command_value: "", cancel: function cancel() {
	                    self.close();
	                }, cancel_label: "Close", enableCancel: true, save_label: "Save" }));
	        }
	    }]);
	
	    return Form;
	}(React.Component);
	
	var FormInput = function (_React$Component2) {
	    _inherits(FormInput, _React$Component2);
	
	    function FormInput(p, ctx) {
	        _classCallCheck(this, FormInput);
	
	        var _this2 = _possibleConstructorReturn(this, (FormInput.__proto__ || Object.getPrototypeOf(FormInput)).call(this, p, ctx));
	
	        _this2.state = { blurred: true };
	        _this2.onblur = function () {
	            return _this2.setState({ blurred: true });
	        };
	        _this2.onfocus = function () {
	            return _this2.setState({ blurred: false });
	        };
	        return _this2;
	    }
	
	    _createClass(FormInput, [{
	        key: "render",
	        value: function render() {
	            var params = this.props;
	            var class_name = "input_" + params.class_name + "_" + (this.state.blurred ? 'off' : 'on');
	            return React.createElement(RowStart, Object.assign({}, params), React.createElement("input", { type: params.type, name: params.name, title: params.title, className: class_name }));
	        }
	    }]);
	
	    return FormInput;
	}(React.Component);
	
	var FormTextArea = function (_React$Component3) {
	    _inherits(FormTextArea, _React$Component3);
	
	    function FormTextArea(p, ctx) {
	        _classCallCheck(this, FormTextArea);
	
	        var _this3 = _possibleConstructorReturn(this, (FormTextArea.__proto__ || Object.getPrototypeOf(FormTextArea)).call(this, p, ctx));
	
	        _this3.state = { value: p.value, blurred: true };
	        _this3.onblur = function () {
	            return _this3.setState({ blurred: true });
	        };
	        _this3.onfocus = function () {
	            return _this3.setState({ blurred: false });
	        };
	        return _this3;
	    }
	
	    _createClass(FormTextArea, [{
	        key: "render",
	        value: function render() {
	            var params = this.props;
	            var className = "textarea_" + params.className + "_" + (this.state.blurred ? "off" : "on");
	            return React.createElement(RowStart, Object.assign({}, params), React.createElement("textarea", { id: params.name, name: params.name, title: params.title, style: { width: params.width }, className: className, onBlur: this.onblur, onFocus: this.onfocus, defaultValue: this.state.value }));
	        }
	    }]);
	
	    return FormTextArea;
	}(React.Component);
	
	var FormInputDate = function (_React$Component4) {
	    _inherits(FormInputDate, _React$Component4);
	
	    function FormInputDate(props, context) {
	        _classCallCheck(this, FormInputDate);
	
	        var _this4 = _possibleConstructorReturn(this, (FormInputDate.__proto__ || Object.getPrototypeOf(FormInputDate)).call(this, props, context));
	
	        _this4.state = {
	            value: _this4.props.value || undefined
	        };
	        _this4.clear = function () {
	            return _this4.setState({ value: undefined });
	        };
	        _this4.onChange = function (s, d) {
	            return _this4.setState({ value: d });
	        };
	        return _this4;
	    }
	
	    _createClass(FormInputDate, [{
	        key: "pad",
	        value: function pad(str, zero, len) {
	            return str.length < len && zero.length >= 1 ? this.pad(zero + str, str, len) : str;
	        }
	    }, {
	        key: "formatDMY",
	        value: function formatDMY() {
	            if (!this.state.value) return '';
	            var month = this.pad((this.state.value.getMonth() + 1).toString(), '0', 2);
	            var date = this.pad(this.state.value.getDate().toString(), '0', 2);
	            return this.state.value.getFullYear() + "-" + month + "-" + date;
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var params = this.props;
	            var date_str = this.formatDMY();
	            return React.createElement(RowStart, Object.assign({}, params), React.createElement("div", { style: { visibility: params.visible ? 'visible' : 'hidden' }, id: params.name + "_div" }, React.createElement("table", { style: { border: 0, width: "100%" }, cellPadding: 0, cellSpacing: 0 }, React.createElement("tbody", null, React.createElement("tr", null, React.createElement("td", null, React.createElement("input", { name: "ExpiryDate", type: "hidden", value: date_str }), React.createElement(datePicker_1.DatePicker, { date: this.state.value, onChange: this.onChange, readonly: false, invalid: false, hasClearButton: this.clear })))))));
	        }
	    }]);
	
	    return FormInputDate;
	}(React.Component);
	/*
	class SelfControlledFormPublish extends React.Component<FormPublishProps, FormPublishState> {
	    update: (key: 0|1|3) => void
	
	    constructor(props: FormPublishProps, context?: any) {
	        super(props, context)
	        this.state = {published_status}
	        this.update  = (key: 0|1|3)  => this.setState({published_status: key})
	    }
	
	    render() {
	        return <ControlledFormPublish update={this.update} {...this.props} published_status={this.state.published_status} />
	    }
	}*/
	
	
	var ControlledFormPublish = function (_React$Component5) {
	    _inherits(ControlledFormPublish, _React$Component5);
	
	    function ControlledFormPublish(props, context) {
	        _classCallCheck(this, ControlledFormPublish);
	
	        var _this5 = _possibleConstructorReturn(this, (ControlledFormPublish.__proto__ || Object.getPrototypeOf(ControlledFormPublish)).call(this, props, context));
	
	        _this5.state = { focused: false };
	        _this5.blur = function () {
	            return _this5.setState({ focused: false });
	        };
	        _this5.focus = function () {
	            return _this5.setState({ focused: true });
	        };
	        return _this5;
	    }
	
	    _createClass(ControlledFormPublish, [{
	        key: "render",
	        value: function render() {
	            var _this6 = this;
	
	            var params = this.props;
	            var values = [[0, "Not published"], [1, "In original format"]];
	            if (params.params.allow_read_only_upload) values.push([3, "Uploaded read only file " + (params.params.mode.type == 'update' ? params.params.mode.read_only_filename : '')]);
	            var read_upload_title = params.params.mode.type == 'update' ? '' : "Upload read only " + params.file_label.toLowerCase();
	            var logically_selected = params.published_status == null && params.params.mode.type == 'update' && params.params.mode.read_only_file_link ? 3 : params.published_status || 1;
	            var is_visible = logically_selected == 3;
	            var visibility = is_visible ? "visible" : "hidden";
	            return React.createElement(RowStart, Object.assign({}, params.params), React.createElement("table", { cellPadding: "0", cellSpacing: "0", style: { border: "0", width: "100%" } }, React.createElement("tbody", null, values.map(function (_ref) {
	                var _ref2 = _slicedToArray(_ref, 2),
	                    key = _ref2[0],
	                    text = _ref2[1];
	
	                return React.createElement("tr", { key: key, style: { cursor: "pointer" } }, React.createElement("td", { style: { width: 10 } }, React.createElement("div", { style: { textAlign: "right" } }, React.createElement("input", { onChange: function onChange() {
	                        return _this6.props.update(key);
	                    }, type: "radio", id: "radio_" + key + "_{params.params.name}", name: params.params.name, value: key, checked: key == logically_selected }))), React.createElement("td", null, React.createElement("label", { htmlFor: "radio_" + key + "_{params.params.name}" }, text), "\xa0"));
	            }))), React.createElement("div", { id: "read_upload_div", style: { visibility: visibility } }, params.params.mode.type == 'update' && params.params.mode.read_only_file_link ? React.createElement("span", { style: { padding: "20px" } }, React.createElement("a", { href: params.page + "?command=download_read_only_file&id=" + params.params.mode.id, target: "_new" }, params.params.mode.read_only_file_link)) : React.createElement("input", { "data-sb-known-valid": is_visible ? null : true, onBlur: this.blur, onFocus: this.focus, id: "read_upload", type: "file", name: "read_upload", title: read_upload_title, className: (is_visible ? "" : "sb-known-valid") + " " + (this.state.focused ? "input_medium_on" : "input_medium_off") })));
	        }
	    }]);
	
	    return ControlledFormPublish;
	}(React.Component);
	
	var RowStart = function RowStart(params) {
	    var label_visibility = params.label_visibility || 'visible';
	    var span = params.full_span ? 2 : undefined;
	    var content = React.createElement("td", { style: { textAlign: params.align }, id: params.name + "_td", colSpan: span }, params.children);
	    var header = React.createElement("th", { id: params.name + "_th", style: { textAlign: "left" }, colSpan: span }, React.createElement("div", { id: params.name + "_label", style: { visibility: label_visibility } }, React.createElement("table", { cellPadding: "0", cellSpacing: "0", style: { width: "100%", border: 0 } }, React.createElement("tbody", null, React.createElement("tr", null, React.createElement("th", null, params.help_content /*todo ensure this is valid text, it's likely html :/*/), React.createElement("th", { style: { color: params.label_color } }, params.label))))));
	    if (params.full_span) {
	        return React.createElement("tbody", null, " ", React.createElement("tr", { id: params.name + "_row" }, header), React.createElement("tr", null, content));
	    } else {
	        return React.createElement("tbody", null, React.createElement("tr", { id: params.name + "_row" }, header, content));
	    }
	};
	var FormReadOnly = function FormReadOnly(_ref3) {
	    var name = _ref3.name,
	        label = _ref3.label,
	        value = _ref3.value;
	
	    return React.createElement(RowStart, { name: name, label: label }, value);
	};

/***/ },

/***/ 638:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) {
	            try {
	                step(generator.next(value));
	            } catch (e) {
	                reject(e);
	            }
	        }
	        function rejected(value) {
	            try {
	                step(generator["throw"](value));
	            } catch (e) {
	                reject(e);
	            }
	        }
	        function step(result) {
	            result.done ? resolve(result.value) : new P(function (resolve) {
	                resolve(result.value);
	            }).then(fulfilled, rejected);
	        }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var commands_1 = __webpack_require__(12);
	var Immutable = __webpack_require__(103);
	var React = __webpack_require__(3);
	var ReactDOM = __webpack_require__(6);
	var _ = __webpack_require__(125);
	var Loading_1 = __webpack_require__(660);
	var value_objects_1 = __webpack_require__(582);
	var Template_1 = __webpack_require__(591);
	var TemplateableComponent_1 = __webpack_require__(265);
	var FilterPlaceholder_1 = __webpack_require__(639);
	var ResultsPlaceholder_1 = __webpack_require__(641);
	var ValueObjects_1 = __webpack_require__(282);
	var ValueObjects_2 = __webpack_require__(642);
	var ValueObjects_3 = __webpack_require__(183);
	var PreferencesForm_1 = __webpack_require__(640);
	var history_1 = __webpack_require__(978);
	var state_serializer_1 = __webpack_require__(643);
	exports.advancedSearchTemplate = function (replace, params) {
	    return __awaiter(undefined, void 0, void 0, regeneratorRuntime.mark(function _callee() {
	        var user, categoriesTree, categoriesList, advancedSearchTemplate, searchResultTemplate, node, initialData;
	        return regeneratorRuntime.wrap(function _callee$(_context) {
	            while (1) {
	                switch (_context.prev = _context.next) {
	                    case 0:
	                        user = params.user ? value_objects_1.Person.fromObject(params.user) : null;
	                        categoriesTree = ValueObjects_3.Category.fromObjects(params.categoriesTree);
	                        categoriesList = ValueObjects_3.Category.flattenTree(categoriesTree);
	                        advancedSearchTemplate = Template_1.Template.fromString(params.advancedSearchTemplate);
	                        searchResultTemplate = Template_1.Template.fromString(params.searchResultTemplate);
	                        node = document.createElement('div');
	
	                        replace(node);
	                        ReactDOM.render(React.createElement(Loading_1.Loading, { className: "loading-advanced-search" }), node);
	                        _context.next = 10;
	                        return new commands_1.CommandCaller(params.ajaxPageUrl).runGet('init advanced search', {
	                            advancedSearchPagePlaceholders: advancedSearchTemplate.getKnownPlaceholders(),
	                            searchResultItemPlaceholders: searchResultTemplate.getKnownPlaceholders()
	                        });
	
	                    case 10:
	                        initialData = _context.sent;
	
	                        ReactDOM.render(React.createElement(AdvancedSearchApp, { fieldFilters: ValueObjects_1.FieldFilter.fromObjects(params.fieldFilters), archiveFilter: params.config.archiveEnabled ? new ValueObjects_1.ArchiveFilter() : null, keywordFilter: params.config.keywordsEnabled ? new ValueObjects_1.KeywordFilter() : null, categoryFilter: params.config.categoriesEnabled ? new ValueObjects_1.CategoryFilter(categoriesTree) : null, categoriesTree: categoriesTree, categoriesList: categoriesList, template: advancedSearchTemplate, templatePlaceholders: initialData.advancedSearchPagePlaceholders, searchResultTemplate: searchResultTemplate, defaultArticleResults: ValueObjects_2.ArticleSearchResult.fromObjects(initialData.defaultSearchResults.articles, categoriesList), defaultTotalResults: parseInt(initialData.defaultSearchResults.totalResults), preferences: params.preferences === null ? null : ValueObjects_3.Preferences.fromObject(params.preferences), preferencesFormHeader: params.preferencesFormHeader, user: user, ajaxPageUrl: params.ajaxPageUrl, canSendDetailsToUser: params.canSendDetailsToUser, config: params.config, labels: params.labels }), node);
	
	                    case 12:
	                    case "end":
	                        return _context.stop();
	                }
	            }
	        }, _callee, this);
	    }));
	};
	
	var AdvancedSearchAppState = function AdvancedSearchAppState() {
	    _classCallCheck(this, AdvancedSearchAppState);
	
	    this.preferences = null;
	    this.groupByCategories = false;
	    this.openPreferences = false;
	    this.searchResults = [];
	    this.filterSelections = new ValueObjects_1.FilterSelectionState();
	    this.expandedFilters = new Map();
	    this.keywords = '';
	    this.currentPage = 0;
	    this.totalResults = 0;
	    this.currentSearch = null;
	};
	
	exports.AdvancedSearchAppState = AdvancedSearchAppState;
	
	var AdvancedSearchApp = function (_React$Component) {
	    _inherits(AdvancedSearchApp, _React$Component);
	
	    function AdvancedSearchApp(props, context) {
	        _classCallCheck(this, AdvancedSearchApp);
	
	        var _this = _possibleConstructorReturn(this, (AdvancedSearchApp.__proto__ || Object.getPrototypeOf(AdvancedSearchApp)).call(this, props, context));
	
	        _this.debouncedHistoryPush = _.debounce(function (path) {
	            return _this.history.push(path);
	        }, 1000);
	        // Run a search based on the current state (i.e. current page, current filters, etc.
	        _this.runNormalSearch = function () {
	            _this.runSearch(_this.createSearcher());
	        };
	        /**
	         * Do a search after 500ms. Each call to this function will reset the counter again.
	         */
	        _this.runDebouncedSearch = _.debounce(function (searcher) {
	            return __awaiter(_this, void 0, void 0, regeneratorRuntime.mark(function _callee3() {
	                var _this2 = this;
	
	                var _ret;
	
	                return regeneratorRuntime.wrap(function _callee3$(_context3) {
	                    while (1) {
	                        switch (_context3.prev = _context3.next) {
	                            case 0:
	                                this.setState(function (prevState) {
	                                    prevState.currentSearch = searcher;
	                                    return prevState;
	                                });
	                                _context3.prev = 1;
	                                return _context3.delegateYield(regeneratorRuntime.mark(function _callee2() {
	                                    var result;
	                                    return regeneratorRuntime.wrap(function _callee2$(_context2) {
	                                        while (1) {
	                                            switch (_context2.prev = _context2.next) {
	                                                case 0:
	                                                    _context2.next = 2;
	                                                    return searcher.run();
	
	                                                case 2:
	                                                    result = _context2.sent;
	
	                                                    if (!(searcher != _this2.state.currentSearch)) {
	                                                        _context2.next = 5;
	                                                        break;
	                                                    }
	
	                                                    return _context2.abrupt("return", {
	                                                        v: void 0
	                                                    });
	
	                                                case 5:
	                                                    // Ensure that the particular parameters that were sent to the server are reflected in the UI.
	                                                    _this2.setStateAndUpdateUrl(function (prevState) {
	                                                        prevState.searchResults = _this2.props.config.resultsDisplay == "infiniteScrolling" && result.pageFetched != 0 ? prevState.searchResults.concat(result.searchResults) : result.searchResults;
	                                                        prevState.totalResults = result.totalResults;
	                                                        prevState.currentPage = result.pageFetched;
	                                                        prevState.groupByCategories = result.groupByCategories;
	                                                        prevState.currentSearch = null;
	                                                        return prevState;
	                                                    });
	
	                                                case 6:
	                                                case "end":
	                                                    return _context2.stop();
	                                            }
	                                        }
	                                    }, _callee2, _this2);
	                                })(), "t0", 3);
	
	                            case 3:
	                                _ret = _context3.t0;
	
	                                if (!((typeof _ret === "undefined" ? "undefined" : _typeof(_ret)) === "object")) {
	                                    _context3.next = 6;
	                                    break;
	                                }
	
	                                return _context3.abrupt("return", _ret.v);
	
	                            case 6:
	                                _context3.next = 13;
	                                break;
	
	                            case 8:
	                                _context3.prev = 8;
	                                _context3.t1 = _context3["catch"](1);
	
	                                if (!(searcher != this.state.currentSearch)) {
	                                    _context3.next = 12;
	                                    break;
	                                }
	
	                                return _context3.abrupt("return");
	
	                            case 12:
	                                this.setStateAndUpdateUrl(function (prevState) {
	                                    prevState.searchResults = [];
	                                    prevState.totalResults = 0;
	                                    prevState.currentPage = 0;
	                                    prevState.groupByCategories = searcher.groupByCategories;
	                                    prevState.currentSearch = null;
	                                    return prevState;
	                                });
	
	                            case 13:
	                                return _context3.abrupt("return");
	
	                            case 14:
	                            case "end":
	                                return _context3.stop();
	                        }
	                    }
	                }, _callee3, this, [[1, 8]]);
	            }));
	        }, 500);
	        _this.history = history_1.createHashHistory();
	        var state = new AdvancedSearchAppState();
	        state.searchResults = props.defaultArticleResults;
	        if (props.categoryFilter !== null) {
	            state.expandedFilters.set(props.categoryFilter, true);
	        }
	        if (props.archiveFilter !== null) {
	            state.filterSelections.setSelected(props.archiveFilter, ValueObjects_1.ArchivedStatus.CURRENT, true);
	        }
	        state.totalResults = props.defaultTotalResults;
	        state.currentPage = 0;
	        state.keywords = "";
	        state.preferences = props.preferences;
	        state.openPreferences = props.preferences == null && props.user != null;
	        var defaultCategory = _this.defaultCategory();
	        if (defaultCategory !== null && props.categoryFilter !== null) {
	            state.filterSelections.setSelected(props.categoryFilter, defaultCategory, true);
	            if (defaultCategory == ValueObjects_3.Category.PREFERRED) {
	                state.groupByCategories = true;
	            }
	        }
	        _this.state = state;
	        return _this;
	    }
	
	    _createClass(AdvancedSearchApp, [{
	        key: "defaultCategory",
	        value: function defaultCategory() {
	            var _this3 = this;
	
	            if (this.props.preferences != null && this.props.preferences.categoryIds.size > 0) {
	                return ValueObjects_3.Category.PREFERRED;
	            } else if (this.props.config.defaultCategoryId > 0) {
	                var category = this.props.categoriesList.find(function (cat) {
	                    return cat.getNumericId() == _this3.props.config.defaultCategoryId;
	                });
	                if (category != null) {
	                    return category;
	                }
	            }
	            return null;
	        }
	    }, {
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            var _this4 = this;
	
	            this.history.listen(function (location) {
	                var newState = new state_serializer_1.StateSerializer(_this4.state, _this4.props.categoryFilter, _this4.props.archiveFilter, _this4.props.fieldFilters, _this4.defaultCategory(), _this4.props.config).deserialize(location);
	                if (newState != _this4.state) {
	                    _this4.currentUrl = location.search;
	                    _this4.setState(newState, _this4.runNormalSearch);
	                }
	            });
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this5 = this;
	
	            var onShowPreferences = function onShowPreferences(show) {
	                _this5.setState(function (prevState) {
	                    prevState.openPreferences = show;
	                    return prevState;
	                });
	            };
	            return React.createElement("div", null, React.createElement(PreferencesForm_1.Form, { preferences: this.state.preferences, user: this.props.user, categoryTree: this.props.categoriesTree, isShown: this.state.openPreferences, hide: function hide() {
	                    return onShowPreferences(false);
	                }, header: this.props.preferencesFormHeader, saveCategories: function saveCategories(categories) {
	                    return _this5.savePreferences(categories);
	                } }), React.createElement(SearchPage, Object.assign({}, this.props, { placeholders: this.props.templatePlaceholders, preferences: this.state.preferences, groupByCategories: this.state.groupByCategories, currentPage: this.state.currentPage, expandedFilters: this.state.expandedFilters, filterSelections: this.state.filterSelections, keywords: this.state.keywords, totalResults: this.state.totalResults, searchResults: this.state.searchResults, onFilterExpanded: function onFilterExpanded() {}, onKeywordsChanged: function onKeywordsChanged(keywords) {
	                    return _this5.onKeywordsChanged(keywords);
	                }, onFilterCleared: function onFilterCleared(filter) {
	                    return _this5.onFilterCleared(filter);
	                }, onSelectPage: function onSelectPage(pageNum) {
	                    return _this5.onSelectPage(pageNum);
	                }, onRunSearch: function onRunSearch() {
	                    return _this5.runNormalSearch();
	                }, onFilterChanged: function onFilterChanged(filter, value, isSelected) {
	                    return _this5.onFilterChanged(filter, value, isSelected);
	                }, showPreferences: onShowPreferences, canSendDetailsToUser: this.props.canSendDetailsToUser, isLoading: this.state.currentSearch != null })));
	        }
	    }, {
	        key: "setStateAndUpdateUrl",
	        value: function setStateAndUpdateUrl(stateSetter, callback) {
	            var _this6 = this;
	
	            this.setState(stateSetter, function () {
	                var serialized = new state_serializer_1.StateSerializer(_this6.state, _this6.props.categoryFilter, _this6.props.archiveFilter, _this6.props.fieldFilters, _this6.defaultCategory(), _this6.props.config).serialize();
	                if (serialized != _this6.currentUrl) {
	                    _this6.debouncedHistoryPush(serialized);
	                }
	                if (callback != null) {
	                    callback();
	                }
	            });
	        }
	    }, {
	        key: "savePreferences",
	        value: function savePreferences(categories) {
	            return __awaiter(this, void 0, void 0, regeneratorRuntime.mark(function _callee4() {
	                var _this7 = this;
	
	                var caller, preferencesObject;
	                return regeneratorRuntime.wrap(function _callee4$(_context4) {
	                    while (1) {
	                        switch (_context4.prev = _context4.next) {
	                            case 0:
	                                caller = new commands_1.CommandCaller(this.props.ajaxPageUrl);
	                                _context4.next = 3;
	                                return caller.runPost('save search preferences', {
	                                    categoryIds: categories.map(function (category) {
	                                        return category.getId();
	                                    })
	                                });
	
	                            case 3:
	                                preferencesObject = _context4.sent;
	
	                                this.setState(function (prevState) {
	                                    prevState.preferences = ValueObjects_3.Preferences.fromObject(preferencesObject);
	                                    if (_this7.props.categoryFilter !== null) {
	                                        prevState.filterSelections.setSelected(_this7.props.categoryFilter, ValueObjects_3.Category.PREFERRED, true);
	                                    }
	                                    return prevState;
	                                }, function () {
	                                    var searcher = _this7.createSearcher();
	                                    searcher.groupByCategories = true;
	                                    searcher.categoriesToFilterOn = _this7.state.preferences === null ? [] : _this7.state.preferences.categoryIds.toArray();
	                                    searcher.pageToFetch = 0;
	                                    _this7.runSearch(searcher);
	                                });
	
	                            case 5:
	                            case "end":
	                                return _context4.stop();
	                        }
	                    }
	                }, _callee4, this);
	            }));
	        }
	    }, {
	        key: "onSelectPage",
	        value: function onSelectPage(page) {
	            this.setStateAndUpdateUrl(function (prevState) {
	                prevState.currentPage = page;
	                return prevState;
	            }, this.runNormalSearch);
	        }
	    }, {
	        key: "onFilterChanged",
	        value: function onFilterChanged(filter, value, isSelected) {
	            this.setStateAndUpdateUrl(function (prevState) {
	                prevState.filterSelections.setSelected(filter, value, isSelected);
	                prevState.currentPage = 0;
	                if (filter.autoCloseOnSelection()) {
	                    prevState.expandedFilters.set(filter, false);
	                }
	                return prevState;
	            }, this.runNormalSearch);
	        }
	    }, {
	        key: "onFilterCleared",
	        value: function onFilterCleared(filter) {
	            this.setStateAndUpdateUrl(function (prevState) {
	                prevState.filterSelections.clearSelected(filter);
	                prevState.currentPage = 0;
	                if (filter.autoCloseOnSelection()) {
	                    prevState.expandedFilters.set(filter, false);
	                }
	                return prevState;
	            }, this.runNormalSearch);
	        }
	    }, {
	        key: "onKeywordsChanged",
	        value: function onKeywordsChanged(keywords) {
	            var _this8 = this;
	
	            var doSearch = function doSearch() {
	                var searcher = _this8.createSearcher();
	                searcher.keywords = keywords;
	                searcher.pageToFetch = 0;
	                _this8.runSearch(searcher);
	            };
	            this.setStateAndUpdateUrl(function (prevState) {
	                prevState.keywords = keywords;
	                return prevState;
	            }, doSearch);
	        }
	    }, {
	        key: "runSearch",
	        value: function runSearch(searcher) {
	            return __awaiter(this, void 0, void 0, regeneratorRuntime.mark(function _callee5() {
	                return regeneratorRuntime.wrap(function _callee5$(_context5) {
	                    while (1) {
	                        switch (_context5.prev = _context5.next) {
	                            case 0:
	                                this.runDebouncedSearch(searcher);
	
	                            case 1:
	                            case "end":
	                                return _context5.stop();
	                        }
	                    }
	                }, _callee5, this);
	            }));
	        }
	    }, {
	        key: "createSearcher",
	        value: function createSearcher() {
	            var categoryFilter = this.props.categoryFilter;
	
	            var preferredCategoriesSelected = categoryFilter !== null ? this.state.filterSelections.getSelected(categoryFilter).has(ValueObjects_3.Category.PREFERRED) : false;
	            return new ArticleSearcher(this.props.ajaxPageUrl, this.state.currentPage, this.state.keywords, this.state.filterSelections, this.props.searchResultTemplate.getKnownPlaceholders(), preferredCategoriesSelected, preferredCategoriesSelected ? this.state.preferences === null ? [] : this.state.preferences.categoryIds.toArray() : categoryFilter === null ? [] : this.state.filterSelections.serializeFilter(categoryFilter), this.props.archiveFilter, this.props.categoriesList);
	        }
	    }]);
	
	    return AdvancedSearchApp;
	}(React.Component);
	// Encodes not only the result of the search (i.e. searchResults and totalResults), but also
	// the parameters of interest used to perform the search, which can be used to update the UI in
	// response to the search being completed.
	
	
	var ArticleSearcherResponse = function () {
	    function ArticleSearcherResponse(searcher, _searchResults, _totalResults, pageFetched) {
	        _classCallCheck(this, ArticleSearcherResponse);
	
	        this.searcher = searcher;
	        this._searchResults = _searchResults;
	        this._totalResults = _totalResults;
	        this.pageFetched = pageFetched;
	    }
	
	    _createClass(ArticleSearcherResponse, [{
	        key: "searchResults",
	        get: function get() {
	            return this._searchResults;
	        }
	    }, {
	        key: "totalResults",
	        get: function get() {
	            return this._totalResults;
	        }
	    }, {
	        key: "groupByCategories",
	        get: function get() {
	            return this.searcher.groupByCategories;
	        }
	    }, {
	        key: "pageToFetch",
	        get: function get() {
	            return this.searcher.pageToFetch;
	        }
	    }, {
	        key: "keywords",
	        get: function get() {
	            return this.searcher.keywords;
	        }
	    }]);
	
	    return ArticleSearcherResponse;
	}();
	
	var ArticleSearcher = function () {
	    function ArticleSearcher(ajaxPageUrl, pageToFetch, keywords, filterSelections, placeholdersToReturn, groupByCategories, categoriesToFilterOn, archiveFilter, categoriesList) {
	        _classCallCheck(this, ArticleSearcher);
	
	        this.ajaxPageUrl = ajaxPageUrl;
	        this.pageToFetch = pageToFetch;
	        this.keywords = keywords;
	        this.filterSelections = filterSelections;
	        this.placeholdersToReturn = placeholdersToReturn;
	        this.groupByCategories = groupByCategories;
	        this.categoriesToFilterOn = categoriesToFilterOn;
	        this.archiveFilter = archiveFilter;
	        this.categoriesList = categoriesList;
	    }
	
	    _createClass(ArticleSearcher, [{
	        key: "run",
	        value: function run() {
	            return __awaiter(this, void 0, void 0, regeneratorRuntime.mark(function _callee6() {
	                var params, data;
	                return regeneratorRuntime.wrap(function _callee6$(_context6) {
	                    while (1) {
	                        switch (_context6.prev = _context6.next) {
	                            case 0:
	                                params = {
	                                    keywords: this.keywords,
	                                    fieldFilters: this.filterSelections.serialize(),
	                                    selectedCategories: this.categoriesToFilterOn,
	                                    selectedArchiveStatuses: this.archiveFilter === null ? [] : this.filterSelections.serializeFilter(this.archiveFilter),
	                                    placeholdersToReturn: this.placeholdersToReturn,
	                                    currentPage: this.pageToFetch,
	                                    groupByCategories: this.groupByCategories
	                                };
	                                _context6.next = 3;
	                                return new commands_1.CommandCaller(this.ajaxPageUrl).runGet('public.search', params);
	
	                            case 3:
	                                data = _context6.sent;
	                                return _context6.abrupt("return", new ArticleSearcherResponse(this, ValueObjects_2.ArticleSearchResult.fromObjects(data.articles, this.categoriesList), data.totalResults, data.pageNum));
	
	                            case 5:
	                            case "end":
	                                return _context6.stop();
	                        }
	                    }
	                }, _callee6, this);
	            }));
	        }
	    }]);
	
	    return ArticleSearcher;
	}();
	
	var SearchPage = function (_TemplateableComponen) {
	    _inherits(SearchPage, _TemplateableComponen);
	
	    function SearchPage() {
	        _classCallCheck(this, SearchPage);
	
	        return _possibleConstructorReturn(this, (SearchPage.__proto__ || Object.getPrototypeOf(SearchPage)).apply(this, arguments));
	    }
	
	    _createClass(SearchPage, [{
	        key: "getStaticPlaceholders",
	        value: function getStaticPlaceholders() {
	            return {
	                "PreferencesForm:Show:Attribute": this.props.user != null ? SearchPage.ATTR_SHOW_PREFERENCE_FORM : ''
	            };
	        }
	    }, {
	        key: "renderPlaceholders",
	        value: function renderPlaceholders() {
	            var categoriesTreeWithPreferred = (this.props.user == null ? [] : [ValueObjects_3.Category.PREFERRED]).concat(this.props.categoriesTree);
	            return {
	                "Filter:Separate": React.createElement(FilterPlaceholder_1.SeparateFilterPlaceholder, { fieldFilters: this.props.fieldFilters, archiveFilter: this.props.archiveFilter, keywordFilter: this.props.keywordFilter, categoryFilter: this.props.categoryFilter, categories: categoriesTreeWithPreferred, keywordsChanged: this.props.onKeywordsChanged, filterSelectionChanged: this.props.onFilterChanged, filterSelectionCleared: this.props.onFilterCleared, optionFilterSelections: this.props.filterSelections, keywords: this.props.keywords, runSearch: this.props.onRunSearch, labels: this.props.labels }),
	                "Filter:Grouped": React.createElement(FilterPlaceholder_1.GroupedFilterPlaceholder, { fieldFilters: this.props.fieldFilters, archiveFilter: this.props.archiveFilter, keywordFilter: this.props.keywordFilter, categoryFilter: this.props.categoryFilter, categories: categoriesTreeWithPreferred, keywordsChanged: this.props.onKeywordsChanged, filterSelectionChanged: this.props.onFilterChanged, filterSelectionCleared: this.props.onFilterCleared, optionFilterSelections: this.props.filterSelections, keywords: this.props.keywords, runSearch: this.props.onRunSearch, labels: this.props.labels }),
	                "Results:List": this.resultsPlaceholder()
	            };
	        }
	    }, {
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            var _this10 = this;
	
	            _get(SearchPage.prototype.__proto__ || Object.getPrototypeOf(SearchPage.prototype), "componentDidMount", this).call(this);
	            var node = ReactDOM.findDOMNode(this);
	            var found = $("[" + SearchPage.ATTR_SHOW_PREFERENCE_FORM + "]");
	            found.click(function () {
	                _this10.props.showPreferences(true);
	            });
	        }
	    }, {
	        key: "resultsPlaceholder",
	        value: function resultsPlaceholder() {
	            var paginatorProps = {
	                numPages: this.props.totalResults / this.props.config.resultsPerPage,
	                currentPage: this.props.currentPage,
	                onSelectPage: this.props.onSelectPage,
	                isLoading: this.props.isLoading
	            };
	            return this.props.groupByCategories ? React.createElement(ResultsPlaceholder_1.ResultsGroupedByCategoriesPlaceholder, { paginatorProps: paginatorProps, results: this.props.searchResults, template: this.props.searchResultTemplate, keywords: this.props.keywords, categories: this.props.categoriesList, categoryIdsToHighlight: this.props.preferences === null ? Immutable.Set() : this.props.preferences.categoryIds, ajaxPageUrl: this.props.ajaxPageUrl, canSendDetailsToUser: this.props.canSendDetailsToUser, isLoading: this.props.isLoading, config: this.props.config }) : React.createElement(ResultsPlaceholder_1.ResultsPlaceholder, { paginatorProps: paginatorProps, results: this.props.searchResults, template: this.props.searchResultTemplate, keywords: this.props.keywords, ajaxPageUrl: this.props.ajaxPageUrl, canSendDetailsToUser: this.props.canSendDetailsToUser, isLoading: this.props.isLoading, config: this.props.config });
	        }
	    }], [{
	        key: "ATTR_SHOW_PREFERENCE_FORM",
	        get: function get() {
	            return 'data-show-preferences-form';
	        }
	    }]);
	
	    return SearchPage;
	}(TemplateableComponent_1.TemplateableComponent);

/***/ },

/***/ 639:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(3);
	var StyleableCheckbox_1 = __webpack_require__(662);
	var utils_1 = __webpack_require__(4);
	
	var GroupedFilterPlaceholder = function (_React$Component) {
	    _inherits(GroupedFilterPlaceholder, _React$Component);
	
	    function GroupedFilterPlaceholder(props, context) {
	        _classCallCheck(this, GroupedFilterPlaceholder);
	
	        var _this = _possibleConstructorReturn(this, (GroupedFilterPlaceholder.__proto__ || Object.getPrototypeOf(GroupedFilterPlaceholder)).call(this, props, context));
	
	        _this.state = { expanded: false };
	        return _this;
	    }
	
	    _createClass(GroupedFilterPlaceholder, [{
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var expandedFilters = this.state.expanded ? this.allFilters() : [];
	            var className = this.state.expanded ? 'expanded' : 'collapsed';
	            var onFilterClicked = function onFilterClicked() {
	                return _this2.setState({ expanded: true });
	            };
	            return React.createElement("div", { className: "grouped-filter " + className }, React.createElement(FiltersList, Object.assign({}, this.props, { filterClicked: onFilterClicked, expandedFilters: expandedFilters })), React.createElement("a", { href: "#", className: "toggle-collapse", onClick: function onClick(event) {
	                    event.preventDefault();
	                    _this2.setState({ expanded: !_this2.state.expanded });
	                } }, React.createElement("span", { className: "label" }, this.state.expanded ? 'Hide filters' : 'Show filters')));
	        }
	    }, {
	        key: "allFilters",
	        value: function allFilters() {
	            var filters = [this.props.archiveFilter, this.props.categoryFilter, this.props.keywordFilter];
	            return utils_1.removeNulls(filters.concat(this.props.fieldFilters));
	        }
	    }]);
	
	    return GroupedFilterPlaceholder;
	}(React.Component);
	
	exports.GroupedFilterPlaceholder = GroupedFilterPlaceholder;
	
	var SeparateFilterPlaceholder = function (_React$Component2) {
	    _inherits(SeparateFilterPlaceholder, _React$Component2);
	
	    function SeparateFilterPlaceholder(props, context) {
	        _classCallCheck(this, SeparateFilterPlaceholder);
	
	        var _this3 = _possibleConstructorReturn(this, (SeparateFilterPlaceholder.__proto__ || Object.getPrototypeOf(SeparateFilterPlaceholder)).call(this, props, context));
	
	        _this3.state = {
	            expandedFieldFilters: new Map()
	        };
	        return _this3;
	    }
	
	    _createClass(SeparateFilterPlaceholder, [{
	        key: "render",
	        value: function render() {
	            var _this4 = this;
	
	            var expandedFilters = Array.from(this.state.expandedFieldFilters.entries()).filter(function (entry) {
	                return entry[1];
	            }) // Only include expanded filters
	            .map(function (entry) {
	                return entry[0];
	            }); // Map to the Filter object, rather than the Map entry
	            var onExpanded = function onExpanded(filter, isExpanded) {
	                return _this4.setState(function (prevState) {
	                    prevState.expandedFieldFilters.set(filter, isExpanded);
	                    return prevState;
	                });
	            };
	            var onSelected = function onSelected(filter, value, isSelected) {
	                _this4.setState(function (prevState) {
	                    prevState.expandedFieldFilters.set(filter, false);
	                    return prevState;
	                });
	                _this4.props.filterSelectionChanged(filter, value, isSelected);
	            };
	            return React.createElement(FiltersList, Object.assign({}, this.props, { filterExpanded: onExpanded, filterClicked: function filterClicked(filter) {
	                    return onExpanded(filter, true);
	                }, filterSelectionChanged: onSelected, expandedFilters: expandedFilters }));
	        }
	    }]);
	
	    return SeparateFilterPlaceholder;
	}(React.Component);
	
	exports.SeparateFilterPlaceholder = SeparateFilterPlaceholder;
	
	var FiltersList = function (_React$Component3) {
	    _inherits(FiltersList, _React$Component3);
	
	    function FiltersList(props) {
	        _classCallCheck(this, FiltersList);
	
	        return _possibleConstructorReturn(this, (FiltersList.__proto__ || Object.getPrototypeOf(FiltersList)).call(this, props));
	    }
	
	    _createClass(FiltersList, [{
	        key: "refreshSearch",
	        value: function refreshSearch() {
	            this.props.runSearch();
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            return React.createElement("form", { className: "FilterPlaceholder", id: "advanced-search-filter-form", onSubmit: function onSubmit(event) {
	                    event.preventDefault();return false;
	                } }, this.renderFilters());
	        }
	    }, {
	        key: "onFilterClicked",
	        value: function onFilterClicked(filter) {
	            var filterClicked = this.props.filterClicked;
	
	            if (filterClicked != null) {
	                filterClicked(filter);
	            }
	        }
	    }, {
	        key: "isFilterExpanded",
	        value: function isFilterExpanded(filter) {
	            return this.props.expandedFilters.indexOf(filter) != -1;
	        }
	    }, {
	        key: "renderArchiveFilter",
	        value: function renderArchiveFilter() {
	            var _this6 = this;
	
	            var _props = this.props,
	                archiveFilter = _props.archiveFilter,
	                filterExpanded = _props.filterExpanded;
	
	            if (archiveFilter == null) {
	                return null;
	            }
	            var onToggle = filterExpanded == null ? undefined : function (isExpanded) {
	                return filterExpanded(archiveFilter, isExpanded);
	            };
	            // Note that in the future, this will likely need to be changed to support textmanager so that it isn't
	            // hard coded to "Issue". This was initially called "Issue" for VCTA who the advanced search feature was
	            // original built for.
	            return React.createElement(FilterBlock, { name: "Issue", id: "archive-filter", isExpanded: this.isFilterExpanded(archiveFilter), onClick: function onClick() {
	                    return _this6.onFilterClicked(archiveFilter);
	                }, onToggle: onToggle }, React.createElement(ArchiveOption, { filter: archiveFilter, selected: this.props.optionFilterSelections.getSelected(archiveFilter), values: archiveFilter.values, filterSelectionCleared: function filterSelectionCleared() {
	                    return _this6.props.filterSelectionCleared(archiveFilter);
	                }, changeCallback: function changeCallback(value, isChecked) {
	                    _this6.props.filterSelectionChanged(archiveFilter, value, isChecked);
	                } }));
	        }
	    }, {
	        key: "renderKeywordFilter",
	        value: function renderKeywordFilter() {
	            var _this7 = this;
	
	            var keywordFilter = this.props.keywordFilter;
	
	            if (keywordFilter == null) {
	                return null;
	            }
	            return React.createElement(FilterBlock, { name: "Keywords", id: "keywords-filter", isExpanded: true, onClick: function onClick() {
	                    return _this7.onFilterClicked(keywordFilter);
	                } }, React.createElement(FilterKeywords, { changeCallback: function changeCallback(keywords) {
	                    _this7.props.keywordsChanged(keywords);
	                }, keywords: this.props.keywords }));
	        }
	    }, {
	        key: "renderFilters",
	        value: function renderFilters() {
	            var _this8 = this;
	
	            var archive = this.renderArchiveFilter();
	            var category = this.renderCategoryFilter();
	            if (this.props.fieldFilters.length == 0 && archive == null && category == null) {
	                return null;
	            }
	            var optionFieldFilters = this.props.fieldFilters.map(function (filter) {
	                var filterExpanded = _this8.props.filterExpanded;
	
	                var onToggle = filterExpanded == null ? undefined : function (isExpanded) {
	                    filterExpanded(filter, isExpanded);
	                };
	                return React.createElement(FilterBlock, { name: filter.name, id: filter.id, key: filter.name, isExpanded: _this8.isFilterExpanded(filter), onClick: function onClick() {
	                        return _this8.onFilterClicked(filter);
	                    }, onToggle: onToggle }, React.createElement(FilterFieldOption, { filter: filter, selected: _this8.props.optionFilterSelections.getSelected(filter), values: filter.values, filterSelectionCleared: function filterSelectionCleared() {
	                        return _this8.props.filterSelectionCleared(filter);
	                    }, changeCallback: function changeCallback(value, isChecked) {
	                        _this8.props.filterSelectionChanged(filter, value, isChecked);
	                    } }));
	            });
	            return React.createElement("div", { className: "filter-by" }, archive, category, optionFieldFilters, this.renderKeywordFilter());
	        }
	    }, {
	        key: "renderCategoryFilter",
	        value: function renderCategoryFilter() {
	            var _this9 = this;
	
	            var _props2 = this.props,
	                categoryFilter = _props2.categoryFilter,
	                filterExpanded = _props2.filterExpanded;
	
	            if (categoryFilter == null) {
	                return null;
	            }
	            var onToggle = filterExpanded == null ? undefined : function (expanded) {
	                filterExpanded(categoryFilter, expanded);
	            };
	            return React.createElement(FilterBlock, { name: this.props.labels.category, id: "category", key: "category", isExpanded: this.isFilterExpanded(categoryFilter), onClick: function onClick() {
	                    return _this9.onFilterClicked(categoryFilter);
	                }, onToggle: onToggle }, React.createElement(CategoryOption, { filter: categoryFilter, selected: this.props.optionFilterSelections.getSelected(categoryFilter), values: this.props.categories, filterSelectionCleared: function filterSelectionCleared() {
	                    return _this9.props.filterSelectionCleared(categoryFilter);
	                }, changeCallback: function changeCallback(value, isChecked) {
	                    _this9.props.filterSelectionChanged(categoryFilter, value, isChecked);
	                } }));
	        }
	    }]);
	
	    return FiltersList;
	}(React.Component);
	
	var FilterBlock = function (_React$Component4) {
	    _inherits(FilterBlock, _React$Component4);
	
	    function FilterBlock() {
	        _classCallCheck(this, FilterBlock);
	
	        return _possibleConstructorReturn(this, (FilterBlock.__proto__ || Object.getPrototypeOf(FilterBlock)).apply(this, arguments));
	    }
	
	    _createClass(FilterBlock, [{
	        key: "toggle",
	        value: function toggle() {
	            var onToggle = this.props.onToggle;
	
	            if (onToggle != null) {
	                onToggle(!this.props.isExpanded, this.props.id);
	            }
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this11 = this;
	
	            var name = this.props.name;
	            var className = "filter-block " + (this.props.isExpanded ? 'expanded' : 'collapsed');
	            var blockId = "filter-block-" + this.props.id;
	            return React.createElement("div", { className: className, id: blockId, onClick: this.props.onClick }, React.createElement("div", { className: "filter-header" }, this.renderToggle(), React.createElement("div", { className: "filter-label", onClick: function onClick() {
	                    _this11.toggle();
	                } }, name)), React.createElement("div", { className: "filter-contents" }, this.props.children));
	        }
	    }, {
	        key: "renderToggle",
	        value: function renderToggle() {
	            var _this12 = this;
	
	            return this.props.onToggle == null ? null : React.createElement(StyleableCheckbox_1.StyleableCheckbox, { defaultChecked: this.props.isExpanded, onChange: function onChange() {
	                    _this12.toggle();
	                }, className: "filter-toggle" });
	        }
	    }]);
	
	    return FilterBlock;
	}(React.Component);
	
	var FilterComponent = function (_React$Component5) {
	    _inherits(FilterComponent, _React$Component5);
	
	    function FilterComponent() {
	        _classCallCheck(this, FilterComponent);
	
	        return _possibleConstructorReturn(this, (FilterComponent.__proto__ || Object.getPrototypeOf(FilterComponent)).apply(this, arguments));
	    }
	
	    return FilterComponent;
	}(React.Component);
	
	var FilterOptionsField = function (_FilterComponent) {
	    _inherits(FilterOptionsField, _FilterComponent);
	
	    function FilterOptionsField() {
	        _classCallCheck(this, FilterOptionsField);
	
	        return _possibleConstructorReturn(this, (FilterOptionsField.__proto__ || Object.getPrototypeOf(FilterOptionsField)).apply(this, arguments));
	    }
	
	    _createClass(FilterOptionsField, [{
	        key: "isSelected",
	        value: function isSelected(option) {
	            return this.props.selected.has(option);
	        }
	    }, {
	        key: "renderChildren",
	        value: function renderChildren(option) {
	            return null;
	        }
	    }, {
	        key: "isChildSelected",
	        value: function isChildSelected(parentOption) {
	            return false;
	        }
	    }, {
	        key: "includeImplicitAllOption",
	        value: function includeImplicitAllOption() {
	            return true;
	        }
	    }, {
	        key: "getInputName",
	        value: function getInputName() {
	            return "filters[" + this.props.filter.id + "]";
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this15 = this;
	
	            return React.createElement("ul", { className: ["filter-values", this.props.className == null ? '' : this.props.className].join(" ") }, this.implicitAll(), this.props.values.map(function (value) {
	                return React.createElement(FilterOptionValueComponent, { isSelected: _this15.isSelected(value), isChildSelected: _this15.isChildSelected(value), name: _this15.getInputName(), label: value.getLabel(), key: "filter-value-" + _this15.props.filter.id + "-" + value.getId(), value: value.getId(), changeCallback: function changeCallback(isChecked) {
	                        return _this15.onChange(value, isChecked);
	                    } }, _this15.renderChildren(value));
	            }));
	        }
	    }, {
	        key: "implicitAll",
	        value: function implicitAll() {
	            if (!this.includeImplicitAllOption()) {
	                return null;
	            }
	            return React.createElement(FilterOptionValueComponent, { isSelected: this.props.selected.size == 0, name: this.getInputName(), label: "All", value: undefined, changeCallback: this.props.filterSelectionCleared });
	        }
	        /**
	         * Normally we allow all change events to occur, but some subclasses need to prevent options being changed in certain
	         * situations.
	         */
	
	    }, {
	        key: "shouldAllowChange",
	        value: function shouldAllowChange(value, isChecked) {
	            return true;
	        }
	    }, {
	        key: "onChange",
	        value: function onChange(value, isChecked) {
	            if (this.shouldAllowChange(value, isChecked)) {
	                this.props.changeCallback(value, isChecked);
	            }
	        }
	    }]);
	
	    return FilterOptionsField;
	}(FilterComponent);
	
	var FilterOptionValueComponent = function (_React$Component6) {
	    _inherits(FilterOptionValueComponent, _React$Component6);
	
	    function FilterOptionValueComponent() {
	        _classCallCheck(this, FilterOptionValueComponent);
	
	        return _possibleConstructorReturn(this, (FilterOptionValueComponent.__proto__ || Object.getPrototypeOf(FilterOptionValueComponent)).apply(this, arguments));
	    }
	
	    _createClass(FilterOptionValueComponent, [{
	        key: "render",
	        value: function render() {
	            var _this17 = this;
	
	            var classNames = ["filter-value", this.props.isSelected ? "selected" : "unselected", this.props.isChildSelected != null && this.props.isChildSelected ? "child-selected" : ""];
	            return React.createElement("li", { className: classNames.join(" "), key: this.props.name + "-" + this.props.value }, React.createElement(StyleableCheckbox_1.StyleableCheckbox, { defaultChecked: this.props.isSelected, name: this.props.name, onChange: function onChange(event) {
	                    _this17.props.changeCallback(event.target.checked);
	                }, value: this.props.value, className: "filter-option", label: this.props.label }), this.props.children);
	        }
	    }]);
	
	    return FilterOptionValueComponent;
	}(React.Component);
	
	var FilterFieldOption = function (_FilterOptionsField) {
	    _inherits(FilterFieldOption, _FilterOptionsField);
	
	    function FilterFieldOption() {
	        _classCallCheck(this, FilterFieldOption);
	
	        return _possibleConstructorReturn(this, (FilterFieldOption.__proto__ || Object.getPrototypeOf(FilterFieldOption)).apply(this, arguments));
	    }
	
	    return FilterFieldOption;
	}(FilterOptionsField);
	
	var CategoryOption = function (_FilterOptionsField2) {
	    _inherits(CategoryOption, _FilterOptionsField2);
	
	    function CategoryOption() {
	        _classCallCheck(this, CategoryOption);
	
	        return _possibleConstructorReturn(this, (CategoryOption.__proto__ || Object.getPrototypeOf(CategoryOption)).apply(this, arguments));
	    }
	
	    _createClass(CategoryOption, [{
	        key: "includeImplicitAllOption",
	        value: function includeImplicitAllOption() {
	            return true;
	        }
	    }, {
	        key: "isChildSelected",
	        value: function isChildSelected(parentOption) {
	            for (var i = 0; i < parentOption.children.length; i++) {
	                var child = parentOption.children[i];
	                if (this.isSelected(child) || this.isChildSelected(child)) {
	                    return true;
	                }
	            }
	            return false;
	        }
	    }, {
	        key: "renderChildren",
	        value: function renderChildren(option) {
	            return React.createElement(CategoryChildOption, { filter: this.props.filter, values: option.children, selected: this.props.selected, className: "children", filterSelectionCleared: this.props.filterSelectionCleared, changeCallback: this.props.changeCallback });
	        }
	    }]);
	
	    return CategoryOption;
	}(FilterOptionsField);
	//todo// i think it would be good to refactor these as separate
	//       classes that use the other components and provides
	//       the "overrides" as params rather than inheriting from them
	
	
	var CategoryChildOption = function (_CategoryOption) {
	    _inherits(CategoryChildOption, _CategoryOption);
	
	    function CategoryChildOption() {
	        _classCallCheck(this, CategoryChildOption);
	
	        return _possibleConstructorReturn(this, (CategoryChildOption.__proto__ || Object.getPrototypeOf(CategoryChildOption)).apply(this, arguments));
	    }
	
	    _createClass(CategoryChildOption, [{
	        key: "includeImplicitAllOption",
	        value: function includeImplicitAllOption() {
	            return false;
	        }
	    }]);
	
	    return CategoryChildOption;
	}(CategoryOption);
	
	var ArchiveOption = function (_FilterOptionsField3) {
	    _inherits(ArchiveOption, _FilterOptionsField3);
	
	    function ArchiveOption() {
	        _classCallCheck(this, ArchiveOption);
	
	        return _possibleConstructorReturn(this, (ArchiveOption.__proto__ || Object.getPrototypeOf(ArchiveOption)).apply(this, arguments));
	    }
	
	    _createClass(ArchiveOption, [{
	        key: "includeImplicitAllOption",
	        value: function includeImplicitAllOption() {
	            return false;
	        }
	        /**
	         * Only propagate change events for archive options if they are selecting, not deselecting.
	         * We need one of these options to always be selected to make sense.
	         */
	
	    }, {
	        key: "shouldAllowChange",
	        value: function shouldAllowChange(value, isChecked) {
	            return isChecked;
	        }
	    }]);
	
	    return ArchiveOption;
	}(FilterOptionsField);
	
	var FilterKeywords = function (_FilterComponent2) {
	    _inherits(FilterKeywords, _FilterComponent2);
	
	    function FilterKeywords() {
	        _classCallCheck(this, FilterKeywords);
	
	        return _possibleConstructorReturn(this, (FilterKeywords.__proto__ || Object.getPrototypeOf(FilterKeywords)).apply(this, arguments));
	    }
	
	    _createClass(FilterKeywords, [{
	        key: "handleChange",
	        value: function handleChange(event) {
	            var inputElement = event.target;
	            this.props.changeCallback(inputElement.value);
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this23 = this;
	
	            return React.createElement("div", { className: "FilterKeywords" }, React.createElement("input", { type: "text", placeholder: "Type here", value: this.props.keywords, onChange: function onChange(event) {
	                    _this23.handleChange(event);
	                } }));
	        }
	    }]);
	
	    return FilterKeywords;
	}(FilterComponent);

/***/ },

/***/ 640:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(3);
	var immutable_1 = __webpack_require__(103);
	var ValueObjects_1 = __webpack_require__(183);
	
	var CategoryComponent = function (_React$Component) {
	    _inherits(CategoryComponent, _React$Component);
	
	    function CategoryComponent() {
	        _classCallCheck(this, CategoryComponent);
	
	        return _possibleConstructorReturn(this, (CategoryComponent.__proto__ || Object.getPrototypeOf(CategoryComponent)).apply(this, arguments));
	    }
	
	    _createClass(CategoryComponent, [{
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            return this.props.categories === null || this.props.categories.length == 0 ? null : React.createElement("ul", null, this.props.categories.map(function (category) {
	                var inputId = "preference-category-" + category.getId();
	                return React.createElement("li", { key: category.getId() }, React.createElement("input", { id: inputId, type: "checkbox", checked: _this2.isSelected(category), onChange: function onChange() {
	                        return _this2.onCategoryToggled(category);
	                    } }), React.createElement("label", { htmlFor: inputId }, category.getLabel()), React.createElement(CategoryComponent, { onSelectionUpdated: _this2.props.onSelectionUpdated, selected: _this2.props.selected, categories: category.children }));
	            }));
	        }
	    }, {
	        key: "isSelected",
	        value: function isSelected(category) {
	            return this.props.selected.has(category);
	        }
	    }, {
	        key: "onCategoryToggled",
	        value: function onCategoryToggled(toggledCategory) {
	            var selectedCategories = this.isSelected(toggledCategory) ? this.props.selected.delete(toggledCategory) : this.props.selected.add(toggledCategory);
	            this.props.onSelectionUpdated(selectedCategories);
	        }
	    }]);
	
	    return CategoryComponent;
	}(React.Component);
	
	var Form = function (_React$Component2) {
	    _inherits(Form, _React$Component2);
	
	    function Form(props, context) {
	        _classCallCheck(this, Form);
	
	        var _this3 = _possibleConstructorReturn(this, (Form.__proto__ || Object.getPrototypeOf(Form)).call(this, props, context));
	
	        var categoryList = ValueObjects_1.Category.flattenTree(_this3.props.categoryTree);
	        var preferences = _this3.props.preferences;
	
	        var selectedCategories = preferences == null ? [] : categoryList.filter(function (category) {
	            return preferences.isCategorySelected(category);
	        });
	        _this3.state = { selectedCategories: immutable_1.Set(selectedCategories) };
	        return _this3;
	    }
	
	    _createClass(Form, [{
	        key: "render",
	        value: function render() {
	            var _this4 = this;
	
	            if (!this.props.isShown || this.props.user == null) {
	                return null;
	            }
	            var close = function close(event) {
	                _this4.props.hide();
	                event.preventDefault();
	            };
	            var save = function save(event) {
	                _this4.props.saveCategories(_this4.state.selectedCategories.toArray());
	                _this4.props.hide();
	                event.preventDefault();
	            };
	            return React.createElement("div", { className: "preferences-form" }, React.createElement("div", { className: "form" }, React.createElement("a", { href: "#", className: "close-button", onClick: close }, "Close"), React.createElement("div", { className: "header", dangerouslySetInnerHTML: { __html: this.props.header } }), React.createElement("div", { className: "content" }, React.createElement(CategoryComponent, { categories: this.props.categoryTree, selected: this.state.selectedCategories, onSelectionUpdated: function onSelectionUpdated(s) {
	                    return _this4.setState({ selectedCategories: s });
	                } }), React.createElement("a", { className: "save", href: "#", onClick: save }, "Save preferences"), React.createElement("a", { className: "close", href: "#", onClick: close }, "Do this later"))));
	        }
	    }]);
	
	    return Form;
	}(React.Component);
	
	exports.Form = Form;

/***/ },

/***/ 641:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(3);
	var Immutable = __webpack_require__(103);
	var react_highlight_words_1 = __webpack_require__(1152);
	var Paginator_1 = __webpack_require__(661);
	var TemplateableComponent_1 = __webpack_require__(265);
	var ValueObjects_1 = __webpack_require__(183);
	var email_details_to_myself_1 = __webpack_require__(283);
	var utils_1 = __webpack_require__(4);
	var Results = function Results(props) {
	    var className = ["ResultsPlaceholder", props.isLoading ? "loading loading-results" : "", props.numPages == 0 ? "no-results" : ""].join(" ");
	    var results = props.config.resultsDisplay == "infiniteScrolling" ? React.createElement(ResultsWithInfiniteScrolling, Object.assign({}, props)) : React.createElement(ResultsWithPaginator, Object.assign({}, props));
	    return React.createElement("div", { className: className }, props.isLoading ? React.createElement(InfoSearching, null) : null, props.numPages == 0 ? React.createElement(InfoNoResults, null) : results);
	};
	var InfoSearching = function InfoSearching(props) {
	    return React.createElement("div", { className: "loading-info" }, React.createElement("div", { className: "text" }, "Searching..."));
	};
	var InfoNoResults = function InfoNoResults(props) {
	    return React.createElement("div", { className: "empty-result-list" }, React.createElement("div", { className: "text" }, "No results found"));
	};
	var ResultsWithInfiniteScrolling = function ResultsWithInfiniteScrolling(props) {
	    var click = function click(event) {
	        props.onSelectPage(props.currentPage + 1);
	        event.preventDefault();
	    };
	    var loadMore = props.currentPage + 1 >= props.numPages ? null : React.createElement("div", { className: "paginator" }, React.createElement("a", { href: "#", className: "load-more", onClick: click }, React.createElement("span", { className: "text" }, "Load more results")));
	    return React.createElement("div", null, props.children, loadMore);
	};
	var ResultsWithPaginator = function ResultsWithPaginator(props) {
	    return React.createElement("div", null, props.children, React.createElement("div", { className: "paginator" }, React.createElement(Paginator_1.Paginator, { currentPage: props.currentPage, numPages: props.numPages, onSelectPage: props.onSelectPage })));
	};
	var appendEmailArticleDetailsPlaceholder = function appendEmailArticleDetailsPlaceholder(placeholders, articleId, canSendEmail) {
	    var cloned = Object.assign({}, placeholders);
	    cloned['EmailArticleDetailsToCurrentUser:Attribute'] = canSendEmail ? "data-email-details-to-current-user=\"" + articleId + "\"" : '';
	    return cloned;
	};
	exports.ResultsPlaceholder = function (props) {
	    var resultItems = props.results.map(function (resultItem) {
	        var placeholders = appendEmailArticleDetailsPlaceholder(resultItem.placeholders, resultItem.articleId, props.canSendDetailsToUser);
	        return React.createElement(ResultItem, { key: resultItem.articleId.toString(), resultItem: resultItem, template: props.template, placeholders: placeholders, keywords: props.keywords, ajaxPageUrl: props.ajaxPageUrl });
	    });
	    return React.createElement(Results, Object.assign({}, props.paginatorProps, { config: props.config }), resultItems);
	};
	/**
	 * Group all search results by category, and then show a category heading before each group of results.
	 */
	
	var ResultsGroupedByCategoriesPlaceholder = function (_React$Component) {
	    _inherits(ResultsGroupedByCategoriesPlaceholder, _React$Component);
	
	    function ResultsGroupedByCategoriesPlaceholder() {
	        _classCallCheck(this, ResultsGroupedByCategoriesPlaceholder);
	
	        return _possibleConstructorReturn(this, (ResultsGroupedByCategoriesPlaceholder.__proto__ || Object.getPrototypeOf(ResultsGroupedByCategoriesPlaceholder)).apply(this, arguments));
	    }
	
	    _createClass(ResultsGroupedByCategoriesPlaceholder, [{
	        key: "categoryIdsToHighlight",
	        value: function categoryIdsToHighlight() {
	            return this.props.categoryIdsToHighlight.size > 0 ? this.props.categoryIdsToHighlight : Immutable.Set(this.props.categories.map(function (category) {
	                return category.getNumericId();
	            }));
	        }
	    }, {
	        key: "groupByCategory",
	        value: function groupByCategory() {
	            var byCategory = new Map();
	            var categoryIdsToHighlight = this.categoryIdsToHighlight();
	            var append = function append(category, item) {
	                var result = byCategory.get(category);
	                if (result === undefined) {
	                    result = [];
	                    byCategory.set(category, result);
	                }
	                result.push(item);
	            };
	            this.props.results.forEach(function (resultItem) {
	                if (resultItem.categories.length == 0) {
	                    append(ValueObjects_1.Category.UNCATEGORISED, resultItem);
	                } else {
	                    resultItem.categories.filter(function (category) {
	                        return categoryIdsToHighlight.has(category.getNumericId());
	                    }).forEach(function (category) {
	                        append(category, resultItem);
	                    });
	                }
	            });
	            return byCategory;
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var categoryGroups = [];
	            Array.from(this.groupByCategory().entries()).sort(function (c1, c2) {
	                return utils_1.compareStringsAlphabetically(c1[0].getLabel(), c2[0].getLabel());
	            }).forEach(function (entry) {
	                var category = entry[0];
	                var articles = entry[1];
	                categoryGroups.push(React.createElement("div", { className: "category-results", key: "category-" + category.getId() }, React.createElement("div", { className: "category-name" }, category.getLabel()), articles.map(function (article) {
	                    return React.createElement(ResultItem, { key: article.articleId.toString(), resultItem: article, keywords: _this2.props.keywords, template: _this2.props.template, placeholders: appendEmailArticleDetailsPlaceholder(article.placeholders, article.articleId, _this2.props.canSendDetailsToUser), ajaxPageUrl: _this2.props.ajaxPageUrl });
	                })));
	            });
	            return React.createElement(Results, Object.assign({}, this.props.paginatorProps, { config: this.props.config }), categoryGroups);
	        }
	    }]);
	
	    return ResultsGroupedByCategoriesPlaceholder;
	}(React.Component);
	
	exports.ResultsGroupedByCategoriesPlaceholder = ResultsGroupedByCategoriesPlaceholder;
	
	var ResultItem = function (_TemplateableComponen) {
	    _inherits(ResultItem, _TemplateableComponen);
	
	    function ResultItem() {
	        _classCallCheck(this, ResultItem);
	
	        return _possibleConstructorReturn(this, (ResultItem.__proto__ || Object.getPrototypeOf(ResultItem)).apply(this, arguments));
	    }
	
	    _createClass(ResultItem, [{
	        key: "renderPlaceholders",
	        value: function renderPlaceholders() {
	            var keywords = this.props.keywords != null ? this.props.keywords.split(/[\s,]+/) : [];
	            var highlightedTitlePlaceholder = this.props.resultItem.placeholders.hasOwnProperty("Title") ? React.createElement(react_highlight_words_1.default, { highlightClassName: "highlight", searchWords: keywords, textToHighlight: this.props.resultItem.placeholders["Title"] }) : null;
	            return {
	                "Categories": this.props.resultItem.categories.length == 0 ? null : React.createElement(CategoriesList, { categories: this.props.resultItem.categories }),
	                "Tags": this.props.resultItem.tags.length == 0 ? null : React.createElement(TagList, { tags: this.props.resultItem.tags }),
	                "Title:Highlighted": highlightedTitlePlaceholder
	            };
	        }
	    }, {
	        key: "placeholdersDidRender",
	        value: function placeholdersDidRender(node) {
	            email_details_to_myself_1.initElementsWithDataAttributes(this.props.ajaxPageUrl, node);
	        }
	    }]);
	
	    return ResultItem;
	}(TemplateableComponent_1.TemplateableComponent);
	
	var CategoriesList = function CategoriesList(props) {
	    return React.createElement("ul", { className: "list category-list" }, props.categories.map(function (category) {
	        return React.createElement("li", { key: "tag-" + category.getId(), className: "list-item category-list-item" }, category.getLabel());
	    }));
	};
	var TagList = function TagList(props) {
	    return React.createElement("ul", { className: "list tag-list" }, props.tags.map(function (tag) {
	        return React.createElement("li", { key: "tag-" + tag.id, className: "list-item tag-list-item" }, tag.name);
	    }));
	};

/***/ },

/***/ 642:
/***/ function(module, exports) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	
	var ArticleSearchResult = function () {
	    function ArticleSearchResult(object, allCategories) {
	        _classCallCheck(this, ArticleSearchResult);
	
	        this.articleId = object.articleId;
	        this.placeholders = object.placeholders;
	        this.tags = object.tags;
	        this.categories = allCategories.filter(function (cat) {
	            return object.categoryIds.indexOf(cat.getId()) != -1;
	        });
	    }
	
	    _createClass(ArticleSearchResult, null, [{
	        key: "fromObjects",
	        value: function fromObjects(objects, allCategories) {
	            return objects.map(function (obj) {
	                return new ArticleSearchResult(obj, allCategories);
	            });
	        }
	    }]);
	
	    return ArticleSearchResult;
	}();
	
	exports.ArticleSearchResult = ArticleSearchResult;

/***/ },

/***/ 643:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var queryString = __webpack_require__(466);
	var _ = __webpack_require__(125);
	var ValueObjects_1 = __webpack_require__(282);
	var filterKey = function filterKey(filterId) {
	    return "filter-" + filterId;
	};
	/** Helper function to deal with the result of queryString.parse */
	function queryStringGet(qs, field) {
	    var ret = qs[field];
	    // For when the parameter was there but without an equal sign, eg ?a=b&c&d
	    if (ret === null) return '';
	    if ((typeof ret === "undefined" ? "undefined" : _typeof(ret)) === "object") return ret[0];
	    return ret;
	}
	
	var StateSerializer = function () {
	    function StateSerializer(state, categoryFilter, archiveFilter, fieldFilters, defaultCategory, config) {
	        _classCallCheck(this, StateSerializer);
	
	        this.state = state;
	        this.categoryFilter = categoryFilter;
	        this.archiveFilter = archiveFilter;
	        this.fieldFilters = fieldFilters;
	        this.defaultCategory = defaultCategory;
	        this.config = config;
	    }
	
	    _createClass(StateSerializer, [{
	        key: "serialize",
	        value: function serialize() {
	            var params = new Map();
	            if (this.state.keywords.length > 0) {
	                params.set('keywords', this.state.keywords);
	            }
	            if (this.config.resultsDisplay == "paged" && this.state.currentPage > 0) {
	                params.set('page', (this.state.currentPage + 1).toString());
	            }
	            var filterSelections = this.state.filterSelections.serialize();
	            var _iteratorNormalCompletion = true;
	            var _didIteratorError = false;
	            var _iteratorError = undefined;
	
	            try {
	                for (var _iterator = Object.keys(filterSelections)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                    var filterId = _step.value;
	
	                    var selected = filterSelections[filterId][0]; // We only support selecting one filter right now.
	                    if (!this.excludeFilterValueFromSerialization(filterId, selected)) {
	                        params.set(filterKey(filterId), selected);
	                    }
	                }
	                // If the "All" meta-category is selected, but it is not the default category (because the default is explicitly
	                // set to a different category, or implicitly set to "My Preferences", then we need to explicitly encode
	                // "all" as the selected category.
	            } catch (err) {
	                _didIteratorError = true;
	                _iteratorError = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion && _iterator.return) {
	                        _iterator.return();
	                    }
	                } finally {
	                    if (_didIteratorError) {
	                        throw _iteratorError;
	                    }
	                }
	            }
	
	            if (this.categoryFilter !== null) {
	                if ((!filterSelections.hasOwnProperty(this.categoryFilter.id) || filterSelections[this.categoryFilter.id].length == 0) && this.defaultCategory != null) {
	                    params.set(filterKey(this.categoryFilter.id), "all");
	                }
	            }
	            var serialized = queryString.stringify(this.mapToObj(params));
	            return serialized.length == 0 ? '' : '?' + serialized;
	        }
	        /**
	         * If a value represents the default value that would be displayed in the UI, regardless of whether we explicitly
	         * put it in the URL or not, then don't bother putting it in the URL because it is just clutter.
	         */
	
	    }, {
	        key: "excludeFilterValueFromSerialization",
	        value: function excludeFilterValueFromSerialization(filterId, filterValue) {
	            return this.defaultCategory !== null && this.categoryFilter !== null && filterId == this.categoryFilter.id && filterValue == this.defaultCategory.getId() || this.archiveFilter !== null && filterId == this.archiveFilter.id && filterValue == ValueObjects_1.ArchivedStatus.CURRENT.getId();
	        }
	    }, {
	        key: "mapToObj",
	        value: function mapToObj(map) {
	            return Array.from(map.entries()).reduce(function (obj, entry) {
	                obj[entry[0]] = entry[1];
	                return obj;
	            }, {});
	        }
	        /**
	         * Deserialize and compare to the state which was given to the constructor. If different, then return a new
	         * state object, which is a shallow copy of the existing state, with the newly deserialized values assigned to it.
	         * If it is the same, the original state object is returned.
	         */
	
	    }, {
	        key: "deserialize",
	        value: function deserialize(location) {
	            var oldUrlState = new StateSerializer(this.state, this.categoryFilter, this.archiveFilter, this.fieldFilters, this.defaultCategory, this.config).serialize();
	            if (oldUrlState == location.search) {
	                return this.state;
	            }
	            var query = queryString.parse(location.search);
	            var newState = _.clone(this.state);
	            newState.keywords = query.hasOwnProperty('keywords') ? queryStringGet(query, 'keywords') : '';
	            newState.currentPage = this.getCurrentPage(query);
	            this.setFieldFilterSelections(newState.filterSelections, query);
	            this.setCategoryFilterSelection(newState.filterSelections, query);
	            this.setArchiveFilterSelection(newState.filterSelections, query);
	            return newState;
	        }
	    }, {
	        key: "getCurrentPage",
	        value: function getCurrentPage(query) {
	            return this.config.resultsDisplay == "infiniteScrolling" || !query.hasOwnProperty('page') ? 0 : Math.max(0, parseInt(queryStringGet(query, 'page')) - 1);
	        }
	    }, {
	        key: "setFieldFilterSelections",
	        value: function setFieldFilterSelections(filterSelections, query) {
	            var _this = this;
	
	            return this.fieldFilters.forEach(function (filter) {
	                var key = filterKey(filter.id);
	                if (!query.hasOwnProperty(key)) {
	                    filterSelections.clearSelected(filter);
	                } else {
	                    filterSelections.setSelected(filter, _this.findFilterValueInQuery(filter, query), true);
	                }
	            });
	        }
	        /**
	         * Look at the query to find out which category to select.
	         *  + If explicitly set to a particular category ID, use that.
	         *  + If explicitly set to "all" or the default category is null, then leave it blank.
	         *  + Otherwise use the default category.
	         */
	
	    }, {
	        key: "setCategoryFilterSelection",
	        value: function setCategoryFilterSelection(filterSelections, query) {
	            if (this.categoryFilter === null) {
	                return;
	            }
	            var value = this.findFilterValueInQuery(this.categoryFilter, query);
	            var queryKey = filterKey(this.categoryFilter.id);
	            if (value == null) {
	                if (this.defaultCategory != null && (!query.hasOwnProperty(queryKey) || queryStringGet(query, queryKey) != "all")) {
	                    filterSelections.setSelected(this.categoryFilter, this.defaultCategory, true);
	                } else {
	                    filterSelections.clearSelected(this.categoryFilter);
	                }
	            } else {
	                filterSelections.setSelected(this.categoryFilter, value, true);
	            }
	        }
	        /**
	         * Look at the query to find out which archived status to use. If blank, default to "Current".
	         */
	
	    }, {
	        key: "setArchiveFilterSelection",
	        value: function setArchiveFilterSelection(filterSelections, query) {
	            if (this.archiveFilter !== null) {
	                var value = this.findFilterValueInQuery(this.archiveFilter, query);
	                filterSelections.setSelected(this.archiveFilter, value != null ? value : ValueObjects_1.ArchivedStatus.CURRENT, true);
	            }
	        }
	    }, {
	        key: "findFilterValueInQuery",
	        value: function findFilterValueInQuery(filter, query) {
	            return filter.values.find(function (value) {
	                return value.getId() == queryStringGet(query, filterKey(filter.id));
	            });
	        }
	    }]);
	
	    return StateSerializer;
	}();
	
	exports.StateSerializer = StateSerializer;
	//# sourceMappingURL=state serializer.js.map

/***/ },

/***/ 644:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var AdvancedSearch_1 = __webpack_require__(638);
	var email_details_to_myself_1 = __webpack_require__(283);
	var statistics_1 = __webpack_require__(645);
	exports.advancedSearchTemplate = AdvancedSearch_1.advancedSearchTemplate;
	exports.sendDetailsToSelf = email_details_to_myself_1.sendDetailsToSelf;
	exports.renderStatisticsField = statistics_1.renderStatisticsField;

/***/ },

/***/ 645:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var utils_1 = __webpack_require__(4);
	var React = __webpack_require__(3);
	var ReactDOM = __webpack_require__(6);
	var notification_1 = __webpack_require__(139);
	exports.renderStatisticsField = function (replace, params) {
	    var node = document.createElement('div');
	    replace(node);
	    ReactDOM.render(React.createElement(StatsWidget, Object.assign({}, params)), node);
	};
	var StatsWidget = function StatsWidget(props) {
	    return React.createElement("ul", { id: "news2-stats-widget", className: "stats" }, React.createElement("li", null, React.createElement(Views, { viewCount: props.views })), props.advancedSearchConfig.isEnabled ? React.createElement("li", null, React.createElement(ViewsInAdvancedSearch, { viewCount: props.viewsInAdvancedSearch })) : null, React.createElement("li", null, React.createElement(FileDownloads, Object.assign({}, props.downloads, { showFoldersInTree: props.showFoldersInTree }))));
	};
	/**
	 * Wraps an individual statistic and prefixes it with a label.
	 */
	var Statistic = function Statistic(props) {
	    return React.createElement("span", { className: utils_1.joinStrings(["stat", props.className || ""]) }, React.createElement("span", { className: "label" }, props.label, ": "), React.createElement("span", { className: "value" }, props.children));
	};
	/**
	 * Number of times the article has been viewed (i.e. the URL representing the specific article was visited).
	 */
	var Views = function Views(props) {
	    return React.createElement(Statistic, { label: "Views" }, props.viewCount);
	};
	/**
	 * Number of times an AJAX request for search results included this article.
	 */
	var ViewsInAdvancedSearch = function ViewsInAdvancedSearch(props) {
	    return React.createElement(Statistic, { label: "Views in Advanced Search Results" }, props.viewCount);
	};
	/**
	 * Number of downloads for each document linked to this article from the memory module (via spare field manager).
	 */
	var FileDownloads = function FileDownloads(props) {
	    var files = props.files.filter(function (file) {
	        return file.details != null && file.details.id > 0;
	    });
	    var filesFolders = props.filesFolders.filter(function (data) {
	        return data.details != null && data.details.files.length > 0 || data.details.folders.length > 0;
	    });
	    var fileComponents = files.map(function (file) {
	        return React.createElement(Statistic, { label: file.fieldName, className: "downloads", key: "file-" + file.fieldName }, React.createElement(SingleFileDownload, Object.assign({}, file.details)));
	    });
	    var filesFoldersComponents = filesFolders.map(function (filesFolders) {
	        return React.createElement(Statistic, { label: filesFolders.fieldName, key: "files-folders-" + filesFolders.fieldName }, props.showFoldersInTree ? React.createElement(MemoryFilesFoldersField, Object.assign({}, filesFolders, { key: "files-folders-" + filesFolders.fieldName })) : React.createElement(MemoryFilesFoldersFieldFlattened, Object.assign({}, filesFolders, { key: "files-folders-" + filesFolders.fieldName })));
	    });
	    var downloadInfo = filesFolders.length == 0 && files.length == 0 ? null : React.createElement(DownloadInfoMessage, null);
	    return React.createElement("div", null, fileComponents, filesFoldersComponents, downloadInfo);
	};
	var DownloadInfoMessage = function DownloadInfoMessage() {
	    return React.createElement(notification_1.Notification, { type: "info" }, "Download counts include the total number of downloads recorded by the document manager for each file. If a linked file is changed, then the download count will also change.");
	};
	/**
	 * For a given document in the memory module, how many times it was downloaded.
	 */
	var SingleFileDownload = function SingleFileDownload(props) {
	    var s = props.downloadCount == 1 ? '' : 's';
	    var label = " \u2010 Downloaded " + props.downloadCount + " time" + s;
	    return React.createElement(FileNameWrapper, { label: props.title, iconPath: "/sb/static/images/icons/file.png", isImportant: props.downloadCount > 0 }, React.createElement("span", { className: utils_1.joinStrings([props.downloadCount > 0 ? 'more-important' : 'less-important']) }, label));
	};
	var FileNameWrapper = function FileNameWrapper(props) {
	    return React.createElement("span", { className: "file-name-wrapper" }, React.createElement("span", { className: utils_1.joinStrings([props.isImportant ? 'more-important' : 'less-important']) }, React.createElement("img", { className: "file-icon", src: props.iconPath }), React.createElement("span", { className: "file-name" }, props.label, " ")), props.children);
	};
	/**
	 * For a given document in the memory module, how many times it was downloaded.
	 */
	var SingleFolderDownload = function SingleFolderDownload(props) {
	    var children = props.allPotentialChildren.filter(function (fileOrFolder) {
	        return fileOrFolder.parent_serial == props.folderId;
	    });
	    var childFiles = children.filter(function (fileOrFolder) {
	        return !fileOrFolder.is_directory;
	    });
	    var childFolders = children.filter(function (fileOrFolder) {
	        return fileOrFolder.is_directory;
	    });
	    return React.createElement(FileNameWrapper, { label: props.folderName, iconPath: "/sb/static/images/icons/folder.png", isImportant: false }, React.createElement(FileList, { files: childFiles }), React.createElement(FolderList, { folders: childFolders, allPotentialChildren: props.allPotentialChildren }));
	};
	/**
	 * For a single "Document Manager (Files/Folders)" spare field, how many times each file was downloaded (recursive).
	 */
	var MemoryFilesFoldersField = function MemoryFilesFoldersField(props) {
	    return React.createElement("div", { className: "memory-files-folders-field" }, React.createElement(FileList, { files: props.details.files }), React.createElement(FolderHierarchyView, { folders: props.details.folders }));
	};
	/**
	 * Same as "MemoryFilesFoldersField", except it flattens the folder heirachy, takes all of the files from each folder,
	 * and combines it with the list of files provided via props.files.
	 */
	var MemoryFilesFoldersFieldFlattened = function MemoryFilesFoldersFieldFlattened(props) {
	    var onlyFiles = function onlyFiles(fileOrFolder) {
	        return !fileOrFolder.is_directory;
	    };
	    var reduce = function reduce(previous, current) {
	        return previous.concat(current.hierarchy.filter(onlyFiles));
	    };
	    var files = props.details.folders.reduce(reduce, []);
	    return React.createElement("div", { className: "memory-files-folders-field" }, React.createElement(FileList, { files: files }));
	};
	var FileList = function FileList(props) {
	    return React.createElement("ul", { className: "file-list" }, props.files.map(function (file) {
	        return React.createElement("li", { key: "file-" + file.id, className: "file" }, React.createElement(SingleFileDownload, Object.assign({}, file)));
	    }));
	};
	var FolderHierarchyView = function FolderHierarchyView(props) {
	    return React.createElement("ul", { className: "folder-list" }, props.folders.map(function (folder) {
	        return React.createElement("li", { key: "folder-" + folder.folderId, className: "folder" }, React.createElement(SingleFolderDownload, { folderId: folder.folderId, folderName: folder.name, allPotentialChildren: folder.hierarchy }));
	    }));
	};
	var FolderList = function FolderList(props) {
	    return React.createElement("ul", { className: "folder-list" }, props.folders.map(function (folder) {
	        return React.createElement("li", { key: "folder-" + folder.title, className: "folder" }, React.createElement(SingleFolderDownload, { folderId: folder.id, folderName: folder.title, allPotentialChildren: props.allPotentialChildren }));
	    }));
	};

/***/ },

/***/ 646:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(3);
	var ReactDOM = __webpack_require__(6);
	var $ = __webpack_require__(10);
	var modal_1 = __webpack_require__(95);
	var form_1 = __webpack_require__(55);
	var field_1 = __webpack_require__(112);
	var commands_1 = __webpack_require__(12);
	var select_1 = __webpack_require__(39);
	var input_1 = __webpack_require__(34);
	//noinspection JSUnusedGlobalSymbols
	exports.listPage = function (cb, props) {
	    var div = document.createElement('div');
	    cb(div);
	    var modal = ReactDOM.render(React.createElement(MyModal, { securePayPage: props.securePayPage, ajaxPage: props.ajaxPage, isOpen: false, dataGridId: props.dataGridId }), div);
	    $("#" + props.buttonId).click(function () {
	        return modal.setState(function (s) {
	            return Object.assign({}, s, { isOpen: true });
	        });
	    });
	};
	
	var MyModal = function (_React$Component) {
	    _inherits(MyModal, _React$Component);
	
	    function MyModal(props, context) {
	        _classCallCheck(this, MyModal);
	
	        var _this = _possibleConstructorReturn(this, (MyModal.__proto__ || Object.getPrototypeOf(MyModal)).call(this, props, context));
	
	        _this.state = {
	            isOpen: props.isOpen,
	            stageName: 0 /* Step1 */
	            , ewayAccountSettings: MyModal.blankEwayAccountSettings
	        };
	        return _this;
	    }
	
	    _createClass(MyModal, [{
	        key: "ewayChanged",
	        value: function ewayChanged(e) {
	            this.setState(function (s) {
	                s.ewayAccountSettings = e;
	                return s;
	            });
	        }
	    }, {
	        key: "submitNewEwayAccount",
	        value: function submitNewEwayAccount() {
	            var _this2 = this;
	
	            var c = new commands_1.CommandCaller(this.props.ajaxPage);
	            c.runPost('eway.new account', this.state.ewayAccountSettings).then(function () {
	                _this2.refresh();
	                _this2.close();
	            });
	        }
	    }, {
	        key: "stageFromName",
	        value: function stageFromName(name) {
	            var _this3 = this;
	
	            switch (name) {
	                case 0 /* Step1 */:
	                    return new Step1Controller(function (c) {
	                        return _this3.selectType(c);
	                    });
	                case 1 /* SecurePay */:
	                    return new SecurePayController(this.props.securePayPage);
	                case 2 /* eWayRapid */:
	                    return new EwayRapidController(function () {
	                        _this3.submitNewEwayAccount();
	                    }, this.state.ewayAccountSettings, function (e) {
	                        _this3.ewayChanged(e);
	                    });
	                default:
	                    throw new Error("unknown stage '" + name + "'");
	            }
	        }
	    }, {
	        key: "selectType",
	        value: function selectType(stageName) {
	            this.setState(function (s) {
	                s.isOpen = true;
	                s.stageName = stageName;
	                return s;
	            });
	        }
	    }, {
	        key: "refresh",
	        value: function refresh() {
	            new HtmlDataGrid(this.props.dataGridId).refresh();
	        }
	    }, {
	        key: "close",
	        value: function close() {
	            this.setState({
	                isOpen: false,
	                stageName: 0 /* Step1 */
	                , ewayAccountSettings: MyModal.blankEwayAccountSettings
	            });
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this4 = this;
	
	            var stage = this.stageFromName(this.state.stageName);
	            stage.start();
	            return React.createElement(modal_1.Modal, { style: { width: "400px" }, title: stage.title(), isOpen: this.state.isOpen, onRequestClose: function onRequestClose() {
	                    return _this4.close();
	                } }, stage.body());
	        }
	    }]);
	
	    return MyModal;
	}(React.Component);
	
	MyModal.blankEwayAccountSettings = {
	    name: "",
	    password: "",
	    apiKey: "",
	    isTestMode: true
	};
	
	var MyModalController = function () {
	    function MyModalController() {
	        _classCallCheck(this, MyModalController);
	    }
	
	    _createClass(MyModalController, [{
	        key: "start",
	        value: function start() {}
	    }]);
	
	    return MyModalController;
	}();
	
	var Step1Controller = function (_MyModalController) {
	    _inherits(Step1Controller, _MyModalController);
	
	    function Step1Controller(onSelect) {
	        _classCallCheck(this, Step1Controller);
	
	        var _this5 = _possibleConstructorReturn(this, (Step1Controller.__proto__ || Object.getPrototypeOf(Step1Controller)).call(this));
	
	        _this5.onSelect = onSelect;
	        return _this5;
	    }
	
	    _createClass(Step1Controller, [{
	        key: "body",
	        value: function body() {
	            return React.createElement(Step1Modal, { onSelect: this.onSelect });
	        }
	    }, {
	        key: "title",
	        value: function title() {
	            return "Step 1. Select type";
	        }
	    }]);
	
	    return Step1Controller;
	}(MyModalController);
	
	var Step1Modal = function (_React$Component2) {
	    _inherits(Step1Modal, _React$Component2);
	
	    function Step1Modal() {
	        _classCallCheck(this, Step1Modal);
	
	        return _possibleConstructorReturn(this, (Step1Modal.__proto__ || Object.getPrototypeOf(Step1Modal)).apply(this, arguments));
	    }
	
	    _createClass(Step1Modal, [{
	        key: "render",
	        value: function render() {
	            var _this7 = this;
	
	            return React.createElement(form_1.ManagedForm, { onSubmit: function onSubmit() {
	                    return Promise.resolve();
	                } }, React.createElement(field_1.Group, null, React.createElement(field_1.Item, { label: "SecurePay" }, React.createElement("button", { type: "button", onClick: function onClick() {
	                    return _this7.props.onSelect(1 /* SecurePay */);
	                } }, "SecurePay")), React.createElement(field_1.Item, { label: "eWay Rapid" }, React.createElement("button", { type: "button", onClick: function onClick() {
	                    return _this7.props.onSelect(2 /* eWayRapid */);
	                } }, "eWay Rapid"))));
	        }
	    }]);
	
	    return Step1Modal;
	}(React.Component);
	
	var SecurePayController = function (_MyModalController2) {
	    _inherits(SecurePayController, _MyModalController2);
	
	    function SecurePayController(securePayPage) {
	        _classCallCheck(this, SecurePayController);
	
	        var _this8 = _possibleConstructorReturn(this, (SecurePayController.__proto__ || Object.getPrototypeOf(SecurePayController)).call(this));
	
	        _this8.securePayPage = securePayPage;
	        return _this8;
	    }
	
	    _createClass(SecurePayController, [{
	        key: "title",
	        value: function title() {
	            return "Step 2. SecurePay";
	        }
	    }, {
	        key: "body",
	        value: function body() {
	            return React.createElement("div", null, "Please wait to be redirected...");
	        }
	    }, {
	        key: "start",
	        value: function start() {
	            window.location.assign(this.securePayPage);
	        }
	    }]);
	
	    return SecurePayController;
	}(MyModalController);
	
	var EwayRapidController = function (_MyModalController3) {
	    _inherits(EwayRapidController, _MyModalController3);
	
	    function EwayRapidController(done, settings, onChange) {
	        _classCallCheck(this, EwayRapidController);
	
	        var _this9 = _possibleConstructorReturn(this, (EwayRapidController.__proto__ || Object.getPrototypeOf(EwayRapidController)).call(this));
	
	        _this9.done = done;
	        _this9.settings = settings;
	        _this9.onChange = onChange;
	        return _this9;
	    }
	
	    _createClass(EwayRapidController, [{
	        key: "title",
	        value: function title() {
	            return "Step 2. Configure eWay Rapid";
	        }
	    }, {
	        key: "body",
	        value: function body() {
	            var _this10 = this;
	
	            // TODO Port to async/await
	            var done = function done() {
	                if (_this10.settings.name.length > 0) {
	                    _this10.done();
	                } else {
	                    alert('Please enter a name');
	                }
	                return Promise.resolve();
	            };
	            return React.createElement(form_1.ManagedForm, { hasSave: true, onSubmit: done }, React.createElement(EwaySettings, { onChange: this.onChange, settings: this.settings }));
	        }
	    }]);
	
	    return EwayRapidController;
	}(MyModalController);
	
	var EwaySettings = function (_React$Component3) {
	    _inherits(EwaySettings, _React$Component3);
	
	    function EwaySettings() {
	        _classCallCheck(this, EwaySettings);
	
	        return _possibleConstructorReturn(this, (EwaySettings.__proto__ || Object.getPrototypeOf(EwaySettings)).apply(this, arguments));
	    }
	
	    _createClass(EwaySettings, [{
	        key: "updateWithObject",
	        value: function updateWithObject(a) {
	            this.props.onChange(Object.assign({}, this.props.settings, a));
	        }
	    }, {
	        key: "setName",
	        value: function setName(value) {
	            this.updateWithObject({ name: value });
	        }
	    }, {
	        key: "setApiKey",
	        value: function setApiKey(value) {
	            this.updateWithObject({ apiKey: value });
	        }
	    }, {
	        key: "setPassword",
	        value: function setPassword(value) {
	            this.updateWithObject({ password: value });
	        }
	    }, {
	        key: "setTestMode",
	        value: function setTestMode(value) {
	            this.updateWithObject({ isTestMode: value == "test" });
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this12 = this;
	
	            return React.createElement(field_1.Group, null, React.createElement(field_1.Item, { label: "Name" }, React.createElement(input_1.Input, { onChange: function onChange(value) {
	                    return _this12.setName(value);
	                }, value: this.props.settings.name })), React.createElement(field_1.Item, { label: "API key" }, React.createElement(input_1.Input, { onChange: function onChange(value) {
	                    return _this12.setApiKey(value);
	                }, value: this.props.settings.apiKey })), React.createElement(field_1.Item, { label: "Password" }, React.createElement(input_1.Input, { onChange: function onChange(value) {
	                    return _this12.setPassword(value);
	                }, value: this.props.settings.password })), React.createElement(field_1.Item, { label: "Mode" }, React.createElement(select_1.SingleBox, { onChange: function onChange(value) {
	                    return _this12.setTestMode(value);
	                }, value: this.props.settings.isTestMode ? "test" : "live" }, React.createElement("option", { value: "test" }, "Test"), React.createElement("option", { value: "live" }, "Live"))));
	        }
	    }]);
	
	    return EwaySettings;
	}(React.Component);
	//noinspection JSUnusedGlobalSymbols
	
	
	exports.editEwaySettings = function (props) {
	    var cc = new commands_1.CommandCaller(props.ajaxPage);
	    var div = document.createElement('div');
	    document.body.appendChild(div);
	    cc.runGet('eway.get settings', { id: props.id }).then(function (s) {
	        ReactDOM.render(React.createElement(EditEwaySettingsModal, { settings: s, onFinished: function onFinished(s) {
	                return cc.runPost('eway.set settings', { id: props.id, settings: s }).then(function (c) {
	                    new HtmlDataGrid(props.dataGridId).refresh();
	                });
	            } }), div);
	    });
	};
	
	var EditEwaySettingsModal = function (_React$Component4) {
	    _inherits(EditEwaySettingsModal, _React$Component4);
	
	    function EditEwaySettingsModal(p, context) {
	        _classCallCheck(this, EditEwaySettingsModal);
	
	        var _this13 = _possibleConstructorReturn(this, (EditEwaySettingsModal.__proto__ || Object.getPrototypeOf(EditEwaySettingsModal)).call(this, p, context));
	
	        _this13.state = {
	            settings: p.settings,
	            isOpen: true
	        };
	        return _this13;
	    }
	
	    _createClass(EditEwaySettingsModal, [{
	        key: "onChange",
	        value: function onChange(settings) {
	            this.setState(function (s) {
	                s.settings = settings;
	                return s;
	            });
	        }
	    }, {
	        key: "onSave",
	        value: function onSave() {
	            return this.props.onFinished(this.state.settings);
	        }
	    }, {
	        key: "close",
	        value: function close() {
	            this.setState({ settings: this.props.settings, isOpen: false });
	        }
	    }, {
	        key: "onSubmit",
	        value: function onSubmit() {
	            var _this14 = this;
	
	            // TODO Write with async/await
	            if (!this.state.settings.name) {
	                alert('Please provide a name');
	                return Promise.resolve();
	            }
	            return this.onSave().then(function () {
	                _this14.close();
	            });
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this15 = this;
	
	            var title = "Editing " + this.state.settings.name;
	            var close = function close() {
	                return _this15.close();
	            };
	            return React.createElement(modal_1.Modal, { style: { width: "400px" }, title: title, isOpen: this.state.isOpen, onRequestClose: close }, React.createElement(form_1.ManagedForm, { hasSave: true, hasCancel: true, onSubmit: function onSubmit() {
	                    return _this15.onSubmit();
	                }, onCancel: close }, React.createElement(EwaySettings, { onChange: function onChange(s) {
	                    return _this15.onChange(s);
	                }, settings: this.state.settings })));
	        }
	    }]);
	
	    return EditEwaySettingsModal;
	}(React.Component);

/***/ },

/***/ 647:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(3);
	var ReactDOM = __webpack_require__(6);
	var redux_1 = __webpack_require__(22);
	var utils_1 = __webpack_require__(4);
	var app_1 = __webpack_require__(649);
	var reducers_1 = __webpack_require__(652);
	exports.ordersFiltersCallJs = function (replace, params) {
	    var ownProps = function ownProps(store) {
	        return {
	            store: store,
	            paymentMethods: params.paymentMethods,
	            origins: params.origins,
	            states: params.states,
	            paymentGroups: params.paymentGroups
	        };
	    };
	    var fromDate = params.fromDate !== undefined ? new Date(params.fromDate * 1000) : null;
	    var toDate = params.toDate !== undefined ? new Date(params.toDate * 1000) : null;
	    var initialState = {
	        selectedOrderStatus: params.selectedOrderStatus,
	        selectedPaidStatus: params.selectedPaidStatus,
	        selectedPaymentMethod: params.selectedPaymentMethod,
	        selectedOrigin: params.selectedOrigin,
	        selectedState: params.selectedState,
	        selectedPaymentGroup: params.selectedPaymentGroup,
	        selectedDateType: fromDate !== null || toDate !== null ? params.selectedDateType : 'any',
	        fromDate: fromDate,
	        toDate: toDate
	    };
	    var div = document.createElement('div');
	    replace(div);
	    var store = redux_1.createStore(utils_1.withDefault(reducers_1.reducer, initialState), initialState);
	    ReactDOM.render(React.createElement(app_1.OrdersFiltersApp, Object.assign({}, ownProps(store))), div);
	};

/***/ },

/***/ 648:
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.isOrdersFiltersAction = function (a) {
	    return a.type == "orders filters action";
	};

/***/ },

/***/ 649:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var react_redux_1 = __webpack_require__(23);
	var presentation_1 = __webpack_require__(651);
	var utils_1 = __webpack_require__(4);
	var mapStateToProps = function mapStateToProps(s, props) {
	    return {
	        selectedOrderStatus: s.selectedOrderStatus,
	        selectedPaidStatus: s.selectedPaidStatus,
	        selectedPaymentMethod: s.selectedPaymentMethod,
	        selectedOrigin: s.selectedOrigin,
	        selectedState: s.selectedState,
	        selectedPaymentGroup: s.selectedPaymentGroup,
	        selectedDateType: s.selectedDateType,
	        fromDate: s.fromDate,
	        toDate: s.toDate,
	        paymentMethods: props.paymentMethods,
	        origins: props.origins,
	        states: props.states,
	        paymentGroups: props.paymentGroups
	    };
	};
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    var wrap = function wrap(action) {
	        return {
	            type: 'orders filters action',
	            action: action
	        };
	    };
	    var dispatchAction = utils_1.compose(wrap, dispatch);
	    return {
	        setOrderStatus: function setOrderStatus(orderStatus) {
	            return dispatchAction({ type: 'set order status', orderStatus: orderStatus });
	        },
	        setPaidStatus: function setPaidStatus(paidStatus) {
	            return dispatchAction({ type: 'set paid status', paidStatus: paidStatus });
	        },
	        setPaymentMethod: function setPaymentMethod(paymentMethod) {
	            return dispatchAction({ type: 'set payment method', paymentMethod: paymentMethod });
	        },
	        setOrigin: function setOrigin(origin) {
	            return dispatchAction({ type: 'set origin', origin: origin });
	        },
	        setState: function setState(state) {
	            return dispatchAction({ type: 'set state', state: state });
	        },
	        setPaymentGroup: function setPaymentGroup(paymentGroup) {
	            return dispatchAction({ type: 'set payment group', paymentGroup: paymentGroup });
	        },
	        setDateType: function setDateType(dateType) {
	            return dispatchAction({ type: 'set date type', dateType: dateType });
	        },
	        setFromDate: function setFromDate(fromDate) {
	            return dispatchAction({ type: 'set from date', fromDate: fromDate });
	        },
	        setToDate: function setToDate(toDate) {
	            return dispatchAction({ type: 'set to date', toDate: toDate });
	        },
	        clearFromDate: function clearFromDate() {
	            return dispatchAction({ type: 'clear from date' });
	        },
	        clearToDate: function clearToDate() {
	            return dispatchAction({ type: 'clear to date' });
	        }
	    };
	};
	exports.OrdersFiltersApp = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(presentation_1.OrdersFilters);

/***/ },

/***/ 650:
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.isOrderStatus = function (value) {
	    return value == 'any' || value == "current" || value == "-3" || value == "-2" || value == "-1" || value == "0" || value == "1" || value == "2" || value == "3" || value == "4";
	};
	exports.isPaidStatus = function (value) {
	    return value == 'any' || value == "pending" || value == "paid";
	};
	exports.isDateType = function (value) {
	    return value == 'any' || value == 'submittedDate' || value == "processedDate" || value == "paymentReceivedDate";
	};

/***/ },

/***/ 651:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(3);
	var select_1 = __webpack_require__(39);
	var datePicker_1 = __webpack_require__(93);
	var data_1 = __webpack_require__(650);
	var utils_1 = __webpack_require__(4);
	var input_1 = __webpack_require__(34);
	exports.OrdersFilters = function (props) {
	    var style = function style(backgroundColor) {
	        return {
	            style: {
	                backgroundColor: backgroundColor,
	                color: "#FFFFFF"
	            }
	        };
	    };
	    var enabledGeneral = props.selectedOrderStatus !== 'any';
	    var disabledDate = props.selectedDateType === 'any';
	    var fromDateProps = props.fromDate !== null ? { date: new Date(props.fromDate) } : {};
	    var toDateProps = props.toDate !== null ? { date: new Date(props.toDate) } : {};
	    return React.createElement("div", null, React.createElement(input_1.AlwaysPost, { name: "o_orderStatus", value: props.selectedOrderStatus }), React.createElement(input_1.AlwaysPost, { name: "o_paidStatus", value: props.selectedPaidStatus }), React.createElement(input_1.AlwaysPost, { name: "o_paymentMethod", value: props.selectedPaymentMethod }), React.createElement(input_1.AlwaysPost, { name: "o_origin", value: props.selectedOrigin }), React.createElement(input_1.AlwaysPost, { name: "o_state", value: props.selectedState }), React.createElement(input_1.AlwaysPost, { name: "o_paymentGroup", value: props.selectedPaymentGroup }), React.createElement(input_1.AlwaysPost, { name: "o_dateType", value: props.selectedDateType }), React.createElement(input_1.AlwaysPost, { name: "o_fromDate", value: utils_1.dateToTimestamp(props.fromDate) }), React.createElement(input_1.AlwaysPost, { name: "o_toDate", value: utils_1.dateToTimestamp(props.toDate) }), React.createElement("label", null, React.createElement("p", null, "Order Status:"), React.createElement(select_1.SingleBox, { value: props.selectedOrderStatus, onChange: function onChange(os) {
	            return props.setOrderStatus(data_1.isOrderStatus(os) ? os : 'any');
	        } }, React.createElement("option", { value: "any" }), React.createElement("option", { value: "current" }, "Current"), React.createElement("option", { value: "-3" }, "All"), React.createElement("option", Object.assign({ value: "0" }, style('darkred')), "Unprocessed"), React.createElement("option", Object.assign({ value: "-2" }, style('darkorange')), "Processing"), React.createElement("option", Object.assign({ value: "1" }, style('darkgreen')), "Processed"), React.createElement("option", Object.assign({ value: "-1" }, style('darkblue')), "Archived"), React.createElement("option", Object.assign({ value: "2" }, style('purple')), "Refunded"), React.createElement("option", Object.assign({ value: "3" }, style('gray')), "Superseded"), React.createElement("option", Object.assign({ value: "4" }, style('dimgray')), "Cancelled"))), React.createElement("label", null, React.createElement("p", null, "Paid Status:"), React.createElement(select_1.SingleBox, { value: props.selectedPaidStatus, onChange: function onChange(ps) {
	            return props.setPaidStatus(data_1.isPaidStatus(ps) ? ps : 'any');
	        }, enabled: enabledGeneral }, React.createElement("option", { value: "any" }, "Any"), React.createElement("option", { value: "pending" }, "Pending Payment"), React.createElement("option", { value: "paid" }, "Paid"))), React.createElement("label", null, React.createElement("p", null, "Payment Method:"), React.createElement(select_1.SingleBox, { value: props.selectedPaymentMethod, onChange: function onChange(pm) {
	            return props.setPaymentMethod(pm);
	        }, enabled: enabledGeneral }, React.createElement("option", { value: "any" }, "Any"), utils_1.reduceObj(function (k, v, acc) {
	        acc.push(React.createElement("option", { key: "pm-" + k, value: k }, v));
	        return acc;
	    }, props.paymentMethods, []))), React.createElement("label", null, React.createElement("p", null, "Origin:"), React.createElement(select_1.SingleBox, { value: props.selectedOrigin, onChange: function onChange(o) {
	            return props.setOrigin(o);
	        }, enabled: enabledGeneral }, React.createElement("option", { value: "any" }, "Any"), utils_1.reduceObj(function (k, v, acc) {
	        acc.push(React.createElement("option", { key: "o-" + k, value: k }, v));
	        return acc;
	    }, props.origins, []))), React.createElement("label", null, React.createElement("p", null, "State:"), React.createElement(select_1.SingleBox, { value: props.selectedState, onChange: function onChange(s) {
	            return props.setState(s);
	        }, enabled: enabledGeneral }, React.createElement("option", { value: "any" }, "Any"), utils_1.reduceObj(function (k, v, acc) {
	        acc.push(React.createElement("option", { key: "s-" + k, value: k }, v));
	        return acc;
	    }, props.states, []))), React.createElement("label", null, React.createElement("p", null, "Payment Group:"), React.createElement(select_1.SingleBox, { value: props.selectedPaymentGroup, onChange: function onChange(pg) {
	            return props.setPaymentGroup(pg);
	        }, enabled: enabledGeneral }, React.createElement("option", { value: "any" }, "Any"), utils_1.reduceObj(function (k, v, acc) {
	        acc.push(React.createElement("option", { key: "pg-" + k, value: k }, v));
	        return acc;
	    }, props.paymentGroups, []))), React.createElement("p", null, "Date(s):"), React.createElement("div", { style: { marginLeft: '25px' } }, React.createElement("label", null, React.createElement("p", null, "Type:"), React.createElement(select_1.SingleBox, { value: props.selectedDateType, onChange: function onChange(dt) {
	            return props.setDateType(data_1.isDateType(dt) ? dt : 'any');
	        }, enabled: enabledGeneral }, React.createElement("option", { value: "any" }), React.createElement("option", { value: "submittedDate" }, "Submitted Date"), React.createElement("option", { value: "processedDate" }, "Processed Date"), React.createElement("option", { value: "paymentReceivedDate" }, "Payment Received Date"))), React.createElement("label", null, React.createElement("p", null, "From:"), React.createElement(datePicker_1.DatePicker, Object.assign({}, fromDateProps, { onChange: function onChange(e, d) {
	            return props.setFromDate(d);
	        }, disabled: disabledDate, readonly: false, invalid: false, hasClearButton: props.clearFromDate }))), React.createElement("label", null, React.createElement("p", null, "To:"), React.createElement(datePicker_1.DatePicker, Object.assign({}, toDateProps, { onChange: function onChange(e, d) {
	            return props.setToDate(d);
	        }, disabled: disabledDate, readonly: false, invalid: false, hasClearButton: props.clearToDate })))));
	};

/***/ },

/***/ 652:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var actions_1 = __webpack_require__(648);
	exports.reducer = function (s, a) {
	    if (actions_1.isOrdersFiltersAction(a)) {
	        return ordersFiltersReducer(s, a.action);
	    }
	    return s;
	};
	var ordersFiltersReducer = function ordersFiltersReducer(s, a) {
	    switch (a.type) {
	        case "set order status":
	            var clearFilters = a.orderStatus === 'any';
	            return Object.assign({}, s, { selectedOrderStatus: a.orderStatus, selectedPaidStatus: clearFilters ? 'any' : s.selectedPaidStatus, selectedPaymentMethod: clearFilters ? 'any' : s.selectedPaymentMethod, selectedOrigin: clearFilters ? 'any' : s.selectedOrigin, selectedState: clearFilters ? 'any' : s.selectedState, selectedPaymentGroup: clearFilters ? 'any' : s.selectedPaymentGroup, selectedDateType: clearFilters ? 'any' : s.selectedDateType, fromDate: clearFilters ? null : s.fromDate, toDate: clearFilters ? null : s.toDate });
	        case "set paid status":
	            return Object.assign({}, s, { selectedPaidStatus: a.paidStatus });
	        case "set payment method":
	            return Object.assign({}, s, { selectedPaymentMethod: a.paymentMethod });
	        case "set origin":
	            return Object.assign({}, s, { selectedOrigin: a.origin });
	        case "set state":
	            return Object.assign({}, s, { selectedState: a.state });
	        case "set payment group":
	            return Object.assign({}, s, { selectedPaymentGroup: a.paymentGroup });
	        case "set date type":
	            var clearDates = a.dateType === 'any';
	            return Object.assign({}, s, { selectedDateType: a.dateType, fromDate: clearDates ? null : s.fromDate, toDate: clearDates ? null : s.toDate });
	        case "set from date":
	            return Object.assign({}, s, { fromDate: a.fromDate });
	        case "set to date":
	            return Object.assign({}, s, { toDate: a.toDate });
	        case "clear from date":
	            return Object.assign({}, s, { fromDate: null });
	        case "clear to date":
	            return Object.assign({}, s, { toDate: null });
	    }
	    return s;
	};

/***/ },

/***/ 653:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) {
	            try {
	                step(generator.next(value));
	            } catch (e) {
	                reject(e);
	            }
	        }
	        function rejected(value) {
	            try {
	                step(generator["throw"](value));
	            } catch (e) {
	                reject(e);
	            }
	        }
	        function step(result) {
	            result.done ? resolve(result.value) : new P(function (resolve) {
	                resolve(result.value);
	            }).then(fulfilled, rejected);
	        }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var ReusablePayerSetup = __webpack_require__(656);
	var GatewaySetup = __webpack_require__(646);
	var OrdersFilters = __webpack_require__(647);
	var _reports = __webpack_require__(655);
	var commands_1 = __webpack_require__(12);
	var legacy = __webpack_require__(135);
	var admin;
	(function (admin) {
	    admin.reusablePayerSetup = ReusablePayerSetup.reusablePayerSetupCallJs;
	    admin.gatewaySetup = GatewaySetup;
	    admin.ordersFilters = OrdersFilters.ordersFiltersCallJs;
	    admin.reports = _reports;
	})(admin = exports.admin || (exports.admin = {}));
	var scheduledPayments;
	(function (scheduledPayments) {
	    var _this = this;
	
	    scheduledPayments.changeMethod = function (paymentSchedule, ajaxPage) {
	        return __awaiter(_this, void 0, void 0, regeneratorRuntime.mark(function _callee() {
	            var cc, resp;
	            return regeneratorRuntime.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            console.log(ajaxPage);
	                            cc = new commands_1.CommandCaller(ajaxPage);
	                            _context.prev = 2;
	                            _context.next = 5;
	                            return cc.runGet("scheduledPayments.changePaymentMethod", {
	                                paymentScheduleId: paymentSchedule
	                            });
	
	                        case 5:
	                            resp = _context.sent;
	
	                            console.log(resp);
	                            legacy.showDialog("ChangePaymentsDialog", resp.title, resp.content, '420px');
	                            _context.next = 13;
	                            break;
	
	                        case 10:
	                            _context.prev = 10;
	                            _context.t0 = _context["catch"](2);
	
	                            console.log("yuck", _context.t0);
	
	                        case 13:
	                        case "end":
	                            return _context.stop();
	                    }
	                }
	            }, _callee, this, [[2, 10]]);
	        }));
	    };
	})(scheduledPayments = exports.scheduledPayments || (exports.scheduledPayments = {}));
	var front;
	(function (front) {
	    var update_cc = void 0;
	    (function (update_cc) {
	        update_cc.buildLink = function (cb, params) {
	            document.getElementsByName(params.name).forEach(function (e) {
	                return e.onclick = function () {
	                    return document.location.assign(params.target);
	                };
	            });
	        };
	        update_cc.page = function (cb, params) {
	            var div = document.createElement('div');
	            div.textContent = params.reference;
	            cb(div);
	        };
	    })(update_cc = front.update_cc || (front.update_cc = {}));
	})(front = exports.front || (exports.front = {}));

/***/ },

/***/ 654:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var date_utils_1 = __webpack_require__(269);
	var credit_card_1 = __webpack_require__(268);
	var React = __webpack_require__(3);
	var PayerCreditCard = function PayerCreditCard(details) {
	    return React.createElement("ul", { className: "creditcard " + details.cardType }, React.createElement("li", null, credit_card_1.cardTypeToUserString(details.cardType)), React.createElement("li", null, details.pan), React.createElement("li", null, "Expires ", date_utils_1.monthToUserString(details.expiryMonth), " ", details.expiryYear));
	};
	var PayerDirectEntry = function PayerDirectEntry(details) {
	    return React.createElement("ul", null, React.createElement("li", null, details.bsb), React.createElement("li", null, details.accountNumber));
	};
	var PayerSelector = function PayerSelector(params) {
	    var details = params.details;
	    switch (details.type) {
	        case 'credit card':
	            return React.createElement(PayerCreditCard, Object.assign({}, details));
	        case 'direct entry':
	            return React.createElement(PayerDirectEntry, Object.assign({}, details));
	        default:
	            return React.createElement("span", null, "If you are reading us, please contact us because there is a problem");
	        //i haven't written a renderer for the Mock payer, because it should only exist in test cases.
	        //i haven't written a renderer for the FailurePayer, because it should represent only a system configuration error
	    }
	};
	exports.Payer = function (params) {
	    return React.createElement("div", { className: "IvtAoOrders2PaymentDetailsWidget" }, React.createElement(PayerSelector, Object.assign({}, params)));
	};

/***/ },

/***/ 655:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) {
	            try {
	                step(generator.next(value));
	            } catch (e) {
	                reject(e);
	            }
	        }
	        function rejected(value) {
	            try {
	                step(generator["throw"](value));
	            } catch (e) {
	                reject(e);
	            }
	        }
	        function step(result) {
	            result.done ? resolve(result.value) : new P(function (resolve) {
	                resolve(result.value);
	            }).then(fulfilled, rejected);
	        }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var commands_1 = __webpack_require__(12);
	var React = __webpack_require__(3);
	var ReactDOM = __webpack_require__(6);
	var button_1 = __webpack_require__(138);
	var fixed_data_grid_1 = __webpack_require__(94);
	var modal_1 = __webpack_require__(95);
	var form_1 = __webpack_require__(55);
	var field_1 = __webpack_require__(112);
	var input_1 = __webpack_require__(34);
	var textarea_1 = __webpack_require__(274);
	var select_1 = __webpack_require__(39);
	var radio_1 = __webpack_require__(609);
	var utils_1 = __webpack_require__(4);
	var date_utils_1 = __webpack_require__(269);
	var datePicker_1 = __webpack_require__(93);
	var checkbox_1 = __webpack_require__(92);
	var FilterType;
	(function (FilterType) {
	    FilterType[FilterType["MultiSelect"] = 1] = "MultiSelect";
	    FilterType[FilterType["DateRange"] = 2] = "DateRange";
	    FilterType[FilterType["YesNo"] = 3] = "YesNo";
	    FilterType[FilterType["Select"] = 4] = "Select";
	})(FilterType || (FilterType = {}));
	exports.run = function (cb, props) {
	    var div = document.createElement('div');
	    var cc = new commands_1.CommandCaller(props.ajaxPage);
	    ReactDOM.render(React.createElement(Reports, Object.assign({}, props, { commands: cc })), div);
	    cb(div);
	};
	var headingSingle = { 'click': '', "reportSerial": "#", "title": "Report Name", description: "Description", reportType: "Report Type", authorName: "Author" };
	
	var SingleTable = function (_fixed_data_grid_1$Fi) {
	    _inherits(SingleTable, _fixed_data_grid_1$Fi);
	
	    function SingleTable() {
	        _classCallCheck(this, SingleTable);
	
	        return _possibleConstructorReturn(this, (SingleTable.__proto__ || Object.getPrototypeOf(SingleTable)).apply(this, arguments));
	    }
	
	    return SingleTable;
	}(fixed_data_grid_1.FixedDataGrid);
	
	var toDateFrom = function toDateFrom(id) {
	    var today = new Date();
	    switch (id) {
	        case 'thisYear':
	            today.setFullYear(today.getFullYear() + 1);
	            today.setMonth(0);
	            today.setDate(0);
	            today.setHours(0, 0, 0, 0);
	            return today;
	        case 'thisMonth':
	            today.setMonth(today.getMonth() + 1);
	            today.setDate(0);
	            today.setHours(0, 0, 0, 0);
	            return today;
	        case 'today':
	            today.setDate(today.getDate() + 1);
	            today.setHours(0, 0, 0, 0);
	            return today;
	        case 'lastYear':
	            today.setMonth(0);
	            today.setDate(0);
	            today.setHours(0, 0, 0, 0);
	            return today;
	        case 'lastMonth':
	            today.setDate(0);
	            today.setHours(0, 0, 0, 0);
	            return today;
	        case 'yesterday':
	            today.setHours(0, 0, 0, 0);
	            return today;
	    }
	};
	var labelFrom = function labelFrom(id) {
	    switch (id) {
	        case 'thisYear':
	            return 'This Year';
	        case 'thisMonth':
	            return 'This Month';
	        case 'today':
	            return 'Today';
	        case 'lastYear':
	            return 'Last Year';
	        case 'lastMonth':
	            return 'Last Month';
	        case 'yesterday':
	            return 'Yesterday';
	    }
	};
	var fromDateFrom = function fromDateFrom(id) {
	    var today = new Date();
	    switch (id) {
	        case 'thisYear':
	            today.setMonth(0);
	            today.setDate(1);
	            today.setHours(0, 0, 0, 0);
	            return today;
	        case 'thisMonth':
	            today.setDate(1);
	            today.setHours(0, 0, 0, 0);
	            return today;
	        case 'today':
	            today.setHours(0, 0, 0, 0);
	            return today;
	        case 'lastYear':
	            today.setFullYear(today.getFullYear() - 1);
	            today.setMonth(0);
	            today.setDate(1);
	            today.setHours(0, 0, 0, 0);
	            return today;
	        case 'lastMonth':
	            today.setMonth(today.getMonth() - 1);
	            today.setDate(1);
	            today.setHours(0, 0, 0, 0);
	            return today;
	        case 'yesterday':
	            today.setDate(today.getDate() - 1);
	            today.setHours(0, 0, 0, 0);
	            return today;
	    }
	};
	var newFromId = function newFromId(id) {
	    var fromDate = fromDateFrom(id);
	    var toDate = toDateFrom(id);
	    return {
	        filterType: FilterType.DateRange,
	        selectedFilterItems: [{ fromDate: utils_1.dateToYYYYMMDD(fromDate), toDate: utils_1.dateToYYYYMMDD(toDate), id: id, label: labelFrom(id) }]
	    };
	};
	
	var Reports = function (_React$Component) {
	    _inherits(Reports, _React$Component);
	
	    function Reports() {
	        _classCallCheck(this, Reports);
	
	        var _this2 = _possibleConstructorReturn(this, (Reports.__proto__ || Object.getPrototypeOf(Reports)).call(this));
	
	        _this2.loadFromHash = function (reports) {
	            var hash = window.location.hash;
	            var parts = hash.split('=');
	            if (parts.length == 2 && parts[0] == '#r') {
	                _this2.loadReport(parts[1], reports)();
	            } else {
	                _this2.setState({ loadedReport: undefined });
	            }
	        };
	        //since this is a callback, we have an event to discard
	        _this2.onHashChanged = function () {
	            _this2.loadFromHash();
	        };
	        _this2.getReports = function () {
	            return __awaiter(_this2, void 0, void 0, regeneratorRuntime.mark(function _callee() {
	                var reports;
	                return regeneratorRuntime.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                _context.next = 2;
	                                return this.props.commands.runGet('get custom reports');
	
	                            case 2:
	                                reports = _context.sent;
	
	                                this.setState({ reports: reports });
	                                return _context.abrupt("return", reports);
	
	                            case 5:
	                            case "end":
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	        };
	        _this2.loadReport = function (repId, reports) {
	            return function () {
	                var report = _this2.state.reports.find(function (r) {
	                    return r.reportSerial == repId;
	                }) || reports && reports.find(function (r) {
	                    return r.reportSerial == repId;
	                });
	                if (report) {
	                    _this2.setState({ loadedReport: report });
	                } else {
	                    _this2.setState({ loadedReport: undefined });
	                }
	            };
	        };
	        _this2.openNewReport = function () {
	            _this2.setState({ newReportInfo: { info: { reportType: _this2.props.reportTypes[0].id.toString(), title: "", description: "" } } });
	        };
	        _this2.cancelNewReport = function () {
	            _this2.setState({ newReportInfo: undefined });
	        };
	        _this2.saveReportStateless = function (report) {
	            return __awaiter(_this2, void 0, void 0, regeneratorRuntime.mark(function _callee2() {
	                return regeneratorRuntime.wrap(function _callee2$(_context2) {
	                    while (1) {
	                        switch (_context2.prev = _context2.next) {
	                            case 0:
	                                _context2.next = 2;
	                                return this.props.commands.runPost('save report', report);
	
	                            case 2:
	                                return _context2.abrupt("return", _context2.sent);
	
	                            case 3:
	                            case "end":
	                                return _context2.stop();
	                        }
	                    }
	                }, _callee2, this);
	            }));
	        };
	        _this2.submitNewReport = function () {
	            return __awaiter(_this2, void 0, void 0, regeneratorRuntime.mark(function _callee3() {
	                var st, params;
	                return regeneratorRuntime.wrap(function _callee3$(_context3) {
	                    while (1) {
	                        switch (_context3.prev = _context3.next) {
	                            case 0:
	                                st = this.state.newReportInfo;
	
	                                if (!st) {
	                                    _context3.next = 8;
	                                    break;
	                                }
	
	                                this.setState({ submitting: true });
	                                params = {
	                                    description: st.info.description,
	                                    reportId: st.info.reportType,
	                                    title: st.info.title
	                                };
	                                _context3.next = 6;
	                                return this.saveReportStateless(params);
	
	                            case 6:
	                                this.getReports();
	                                this.setState({ submitting: false, newReportInfo: undefined });
	
	                            case 8:
	                            case "end":
	                                return _context3.stop();
	                        }
	                    }
	                }, _callee3, this);
	            }));
	        };
	        _this2.saveUpdateReport = function (report) {
	            return __awaiter(_this2, void 0, void 0, regeneratorRuntime.mark(function _callee4() {
	                var newReport, reports;
	                return regeneratorRuntime.wrap(function _callee4$(_context4) {
	                    while (1) {
	                        switch (_context4.prev = _context4.next) {
	                            case 0:
	                                this.setState({ submitting: true });
	                                _context4.next = 3;
	                                return this.saveReportStateless(report);
	
	                            case 3:
	                                newReport = _context4.sent;
	                                reports = this.state.reports.map(function (r) {
	                                    return r.reportSerial == newReport.reportSerial ? newReport : r;
	                                });
	
	                                this.setState({ reports: reports, loadedReport: undefined, submitting: false }); // go via a render without the report loaded
	                                this.setState({ loadedReport: newReport });
	
	                            case 7:
	                            case "end":
	                                return _context4.stop();
	                        }
	                    }
	                }, _callee4, this);
	            }));
	        };
	        _this2.closeReport = function () {
	            _this2.setState({ loadedReport: undefined });
	        };
	        _this2.state = { reports: [], loadedReport: undefined, newReportInfo: undefined, submitting: false };
	        return _this2;
	    }
	
	    _createClass(Reports, [{
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            this.getReports().then(this.loadFromHash);
	            window.addEventListener('hashchange', this.onHashChanged);
	        }
	    }, {
	        key: "componentWillUpdate",
	        value: function componentWillUpdate(nextProps, nextState, nextContext) {
	            var old = this.state.loadedReport;
	            var new_ = nextState.loadedReport;
	            if (old == undefined && new_ !== undefined || old !== undefined && new_ !== undefined && old.reportSerial !== new_.reportSerial) {
	                window.location.hash = "#r=" + new_.reportSerial;
	            } else if (old !== undefined && new_ === undefined) {
	                window.location.hash = "#";
	            }
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this3 = this;
	
	            var loadedReport = this.state.loadedReport;
	            if (loadedReport) {
	                var reportType = this.props.reportTypes.find(function (r) {
	                    return r.id == loadedReport.reportId;
	                });
	                if (!reportType) {
	                    return React.createElement("div", null, "The report you have tried to load is corrupt. ", React.createElement("button", { onClick: this.closeReport }, "Go back"));
	                } else {
	                    var filters = mergeReportFilters(loadedReport.filters, reportType.filters);
	                    var reportWithDefaultFilters = Object.assign({}, loadedReport, { defualtFilters: filters });
	                    return React.createElement(RenderReport, { commands: this.props.commands, saveReport: this.saveUpdateReport, submitting: this.state.submitting, closeReport: this.closeReport, report: reportWithDefaultFilters, reportType: reportType });
	                }
	            } else {
	                return React.createElement(RenderFrontPage, { reportTypes: this.props.reportTypes, submitting: this.state.submitting, newReportInfo: this.state.newReportInfo, reports: this.state.reports, loadReport: this.loadReport, onNewInfo: function onNewInfo(i) {
	                        return _this3.setState(function (s) {
	                            return { newReportInfo: { info: Object.assign({}, (s.newReportInfo || { info: undefined }).info, i), submitting: false } };
	                        });
	                    }, submitNewReport: this.submitNewReport, cancelNewReport: this.cancelNewReport, openNewReport: this.openNewReport });
	            }
	        }
	    }]);
	
	    return Reports;
	}(React.Component);
	
	var mergeReportFilters = function mergeReportFilters(chosen, defaults) {
	    //the filter we want to use consists of the setting from the one,
	    //but everything else from the old one.
	    var merge = function merge(def) {
	        var it = chosen && chosen.find(function (c) {
	            return c.id == def.id;
	        });
	        return it && it.filterType == def.filterType ? Object.assign({}, def, { selectedFilterItems: it.selectedFilterItems }) : def;
	    };
	    return chosen ? defaults.map(merge) : defaults;
	};
	var isSpecificPeriod = function isSpecificPeriod(t) {
	    switch (t) {
	        case "thisYear":
	        case "yesterday":
	        case "thisMonth":
	        case "lastYear":
	        case "lastMonth":
	        case "today":
	            return true;
	        case "dateRange":
	        case "monthYearRange":
	            return false;
	    }
	};
	var EditFilterModal = function EditFilterModal(props) {
	    var value = props.defaultValue;
	    switch (value.filterType) {
	        case FilterType.YesNo:
	            return React.createElement(EditFilterYesnoModal, Object.assign({}, props, { defaultValue: value }));
	        case FilterType.DateRange:
	            return React.createElement(EditFilterDateRangeModal, Object.assign({}, props, { defaultValue: value }));
	        case FilterType.Select:
	            return React.createElement(EditFilterSelectModal, Object.assign({}, props, { defaultValue: value }));
	        case FilterType.MultiSelect:
	            return React.createElement(EditFilterMultiSelectModal, Object.assign({}, props, { defaultValue: value }));
	    }
	};
	
	var EditFilterYesnoModal = function (_React$Component2) {
	    _inherits(EditFilterYesnoModal, _React$Component2);
	
	    function EditFilterYesnoModal(props) {
	        _classCallCheck(this, EditFilterYesnoModal);
	
	        var _this4 = _possibleConstructorReturn(this, (EditFilterYesnoModal.__proto__ || Object.getPrototypeOf(EditFilterYesnoModal)).call(this));
	
	        _this4.onSubmit = function () {
	            _this4.props.onChange(Object.assign({}, _this4.props.defaultValue, { selectedFilterItems: [{ selected: _this4.state.selected }] }));
	        };
	        _this4.change = function (i) {
	            _this4.setState({ selected: i == "Yes" });
	        };
	        _this4.cssProps = modal_1.centeredModalProps('600px');
	        var v = props.defaultValue.selectedFilterItems[0];
	        _this4.state = { selected: v ? v.selected : false };
	        return _this4;
	    }
	
	    _createClass(EditFilterYesnoModal, [{
	        key: "render",
	        value: function render() {
	            return React.createElement(modal_1.Modal, { style: this.cssProps, isOpen: true, title: "Edit " + this.props.defaultValue.name + " Filter", onRequestClose: this.props.onClose }, React.createElement(form_1.Form, { onSubmit: this.onSubmit }, React.createElement(field_1.Item, { label: this.props.defaultValue.name }, React.createElement(select_1.SingleBox, { onChange: this.change, value: this.state.selected ? "Yes" : "No" }, React.createElement("option", { value: "No" }, "No"), React.createElement("option", { value: "Yes" }, "Yes")))));
	        }
	    }]);
	
	    return EditFilterYesnoModal;
	}(React.Component);
	
	var EditFilterSelectModal = function (_React$Component3) {
	    _inherits(EditFilterSelectModal, _React$Component3);
	
	    function EditFilterSelectModal(props) {
	        _classCallCheck(this, EditFilterSelectModal);
	
	        var _this5 = _possibleConstructorReturn(this, (EditFilterSelectModal.__proto__ || Object.getPrototypeOf(EditFilterSelectModal)).call(this));
	
	        _this5.onSubmit = function () {
	            var i = _this5.props.defaultValue.filterItems.find(function (i) {
	                return _this5.state.value == i.id;
	            });
	            var selectedFilterItems = i ? [i] : [];
	            _this5.props.onChange(Object.assign({}, _this5.props.defaultValue, { selectedFilterItems: selectedFilterItems }));
	        };
	        _this5.change = function (i) {
	            _this5.setState({ value: i });
	        };
	        _this5.cssProps = modal_1.centeredModalProps('600px');
	        _this5.state = { value: props.defaultValue.selectedFilterItems.reduce(function (a, b) {
	                return b.id;
	            }, '') };
	        return _this5;
	    }
	
	    _createClass(EditFilterSelectModal, [{
	        key: "render",
	        value: function render() {
	            return React.createElement(modal_1.Modal, { style: this.cssProps, isOpen: true, title: "Edit " + this.props.defaultValue.name + " Filter", onRequestClose: this.props.onClose }, React.createElement(form_1.Form, { onSubmit: this.onSubmit }, React.createElement(field_1.Item, { label: this.props.defaultValue.name }, React.createElement(select_1.SingleBox, { onChange: this.change, value: this.state.value }, React.createElement("option", { value: "" }, "All"), this.props.defaultValue.filterItems.map(function (i) {
	                return React.createElement("option", { key: i.id, value: i.id }, i.label);
	            })))));
	        }
	    }]);
	
	    return EditFilterSelectModal;
	}(React.Component);
	
	var EditFilterMultiSelectModal = function (_React$Component4) {
	    _inherits(EditFilterMultiSelectModal, _React$Component4);
	
	    function EditFilterMultiSelectModal(props) {
	        _classCallCheck(this, EditFilterMultiSelectModal);
	
	        var _this6 = _possibleConstructorReturn(this, (EditFilterMultiSelectModal.__proto__ || Object.getPrototypeOf(EditFilterMultiSelectModal)).call(this));
	
	        _this6.onSubmit = function () {
	            var selectedFilterItems = _this6.state.something ? _this6.props.defaultValue.filterItems.filter(function (i) {
	                return _this6.state.values.find(function (v) {
	                    return v == i.childValue;
	                });
	            }).map(function (i) {
	                return { id: i.childValue, label: i.childName };
	            }) : [];
	            if (selectedFilterItems.length == 0 && _this6.state.something) {
	                alert("Please select some " + _this6.props.defaultValue.name + " or choose \"All\".");
	            } else {
	                _this6.props.onChange(Object.assign({}, _this6.props.defaultValue, { selectedFilterItems: selectedFilterItems }));
	            }
	        };
	        _this6.change = function (i, checked) {
	            return function () {
	                _this6.setState(function (s) {
	                    return { values: checked ? [].concat(_toConsumableArray(s.values), [i]) : s.values.filter(function (v) {
	                            return v != i;
	                        }) };
	                });
	            };
	        };
	        _this6.deselectAll = function () {
	            _this6.setState({ something: false });
	        };
	        _this6.selectSomething = function () {
	            _this6.setState({ something: true });
	        };
	        _this6.cssProps = { width: "600px" };
	        _this6.state = {
	            values: props.defaultValue.selectedFilterItems.map(function (b) {
	                return b.id;
	            }),
	            something: props.defaultValue.selectedFilterItems.length > 0
	        };
	        return _this6;
	    }
	
	    _createClass(EditFilterMultiSelectModal, [{
	        key: "render",
	        value: function render() {
	            var _this7 = this;
	
	            return React.createElement(modal_1.Modal, { style: this.cssProps, isOpen: true, title: "Edit " + this.props.defaultValue.name + " Filter", onRequestClose: this.props.onClose }, React.createElement(form_1.Form, { onSubmit: this.onSubmit }, React.createElement(field_1.Item, { label: this.props.defaultValue.name }, React.createElement("ul", { className: "sbCheckboxGroup" }, React.createElement("li", { className: "sbCheckboxItem sbCheckboxGroupVertical" }, React.createElement(radio_1.Radio, { onChange: this.deselectAll, checked: !this.state.something, name: "whichones", label: "All " + this.props.defaultValue.name })), " ", React.createElement("li", { className: "sbCheckboxItem sbCheckboxGroupVertical" }, React.createElement(radio_1.Radio, { onChange: this.selectSomething, checked: this.state.something, name: "whichones", label: "Specific " + this.props.defaultValue.name }), this.state.something && React.createElement("fieldset", null, React.createElement("ul", { className: "sbCheckboxGroup" }, this.props.defaultValue.filterItems.map(function (i) {
	                var checked = !!_this7.state.values.find(function (v) {
	                    return v == i.childValue;
	                });
	                return React.createElement("li", { key: i.childValue, className: "sbCheckboxItem sbCheckboxGroupVertical" }, React.createElement(checkbox_1.Checkbox, { key: i.childValue, label: i.childName, checked: checked, onChange: _this7.change(i.childValue, !checked) }));
	            }))))))));
	        }
	    }]);
	
	    return EditFilterMultiSelectModal;
	}(React.Component);
	
	var EditFilterDateRangeModal = function (_React$Component5) {
	    _inherits(EditFilterDateRangeModal, _React$Component5);
	
	    function EditFilterDateRangeModal(props) {
	        _classCallCheck(this, EditFilterDateRangeModal);
	
	        var _this8 = _possibleConstructorReturn(this, (EditFilterDateRangeModal.__proto__ || Object.getPrototypeOf(EditFilterDateRangeModal)).call(this, props));
	
	        _this8.onSpecificPeriod = function () {
	            _this8.onChange(_this8.state.specificPeriod);
	        };
	        _this8.onChange = function (value) {
	            _this8.setState(function (s) {
	                return {
	                    specificPeriod: isSpecificPeriod(value) ? value : s.specificPeriod,
	                    value: value
	                };
	            });
	        };
	        _this8.onSubmit = function () {
	            var value = _this8.state.value;
	            switch (value) {
	                case "dateRange":
	                    //typescript gets super confused unless i do this sideeffectively.
	                    var a = Object.assign({}, _this8.props.defaultValue);
	                    a.filterType = FilterType.DateRange;
	                    a.selectedFilterItems = [{
	                        id: value,
	                        label: _this8.state.fromDate.toLocaleDateString('en-AU') + " - " + _this8.state.toDate.toLocaleDateString('en-AU'),
	                        fromDate: utils_1.dateToYYYYMMDD(_this8.state.fromDate),
	                        toDate: utils_1.dateToYYYYMMDD(_this8.state.toDate)
	                    }];
	                    var c = _this8.props.onChange;
	                    c(a);
	                    return;
	                case "monthYearRange":
	                    var _fromDate = new Date();
	                    _fromDate.setFullYear(_this8.state.fromMonthYear[1]);
	                    _fromDate.setMonth(_this8.state.fromMonthYear[0] - 1);
	                    _fromDate.setDate(1);
	                    _fromDate.setHours(0, 0, 0, 0);
	                    var _toDate = new Date();
	                    _toDate.setFullYear(_this8.state.toMonthYear[1]);
	                    _toDate.setMonth(_this8.state.toMonthYear[0]); //yes, the zeroth of next month
	                    _toDate.setDate(0);
	                    _toDate.setHours(23, 59, 59, 999);
	                    var fromMon = date_utils_1.monthToUserString(date_utils_1.numberToMaybeMonth(_this8.state.fromMonthYear[0]));
	                    var toMon = date_utils_1.monthToUserString(date_utils_1.numberToMaybeMonth(_this8.state.toMonthYear[0]));
	                    //typescript gets confused unless i do this sideeffectly.
	                    var b = Object.assign({}, _this8.props.defaultValue);
	                    b.selectedFilterItems = [{
	                        id: value,
	                        label: fromMon + " " + _this8.state.fromMonthYear[1] + " - " + toMon + " " + _this8.state.toMonthYear[1],
	                        fromDate: utils_1.dateToYYYYMMDD(_fromDate),
	                        toDate: utils_1.dateToYYYYMMDD(_toDate)
	                    }];
	                    _this8.props.onChange(b);
	                    return;
	                case "thisYear":
	                case "thisMonth":
	                case "today":
	                case "lastYear":
	                case "lastMonth":
	                case "yesterday":
	                    var d = Object.assign({}, _this8.props.defaultValue, newFromId(value));
	                    _this8.props.onChange(d);
	                    return;
	            }
	            // noinspection JSUnusedLocalSymbols
	            var v = value;
	        };
	        _this8.onStandard = function (value) {
	            _this8.setState({ value: value });
	        };
	        _this8.setFromYear = function (d) {
	            _this8.setState({ fromMonthYear: [_this8.state.fromMonthYear[0], Number.parseInt(d)] });
	        };
	        _this8.setToYear = function (d) {
	            _this8.setState({ toMonthYear: [_this8.state.toMonthYear[0], Number.parseInt(d)] });
	        };
	        _this8.setToMonth = function (d) {
	            _this8.setState({ toMonthYear: [Number.parseInt(d), _this8.state.toMonthYear[1]] });
	        };
	        _this8.setFromMonth = function (d) {
	            _this8.setState({ fromMonthYear: [Number.parseInt(d), _this8.state.fromMonthYear[1]] });
	        };
	        _this8.setFromDate = function (_, fromDate) {
	            _this8.setState({ fromDate: fromDate });
	        };
	        _this8.setToDate = function (_, toDate) {
	            _this8.setState({ toDate: toDate });
	        };
	        var val = _this8.props.defaultValue.selectedFilterItems[0];
	        var value = val ? val.id : 'thisYear';
	        var fromDate = new Date(val ? val.fromDate : "1 January");
	        var toDate = new Date(val ? val.toDate : "31 December");
	        _this8.state = {
	            specificPeriod: isSpecificPeriod(value) ? value : 'thisYear',
	            fromDate: fromDate,
	            toDate: toDate,
	            fromMonthYear: [fromDate.getMonth() + 1, fromDate.getFullYear()],
	            toMonthYear: [toDate.getMonth() + 1, toDate.getFullYear()],
	            value: value
	        };
	        return _this8;
	    }
	
	    _createClass(EditFilterDateRangeModal, [{
	        key: "render",
	        value: function render() {
	            var _this9 = this;
	
	            var name = "edit-filter-name-thingo";
	            var specificPeriodName = "edit-filter-specific-period-name-thingo";
	            var SpecificPeriodRadio = function SpecificPeriodRadio(p) {
	                return React.createElement("p", null, React.createElement(radio_1.Radio, { label: labelFrom(p.value), name: specificPeriodName, checked: _this9.state.specificPeriod == p.value, onChange: function onChange() {
	                        return _this9.onChange(p.value);
	                    } }));
	            };
	            var isMonthYearRange = this.state.value == "monthYearRange";
	            var isDateRange = this.state.value == "dateRange";
	            var specificPeriod = isSpecificPeriod(this.state.value);
	            return React.createElement(modal_1.Modal, { style: { width: "700px" }, isOpen: true, title: "Edit Filter", onRequestClose: this.props.onClose }, React.createElement(form_1.Form, { onSubmit: this.onSubmit }, React.createElement(field_1.Item, { label: "Specific Period" }, React.createElement(radio_1.Radio, { label: "Specific Period", name: name, checked: specificPeriod, onChange: this.onSpecificPeriod }), React.createElement("fieldset", { disabled: !specificPeriod, style: { marginLeft: "2em" } }, React.createElement("div", { style: { float: "left", width: "50%" } }, React.createElement(SpecificPeriodRadio, { value: "thisYear" }), React.createElement(SpecificPeriodRadio, { value: "thisMonth" }), React.createElement(SpecificPeriodRadio, { value: "today" })), React.createElement("div", { style: { float: "right", width: "50%" } }, React.createElement(SpecificPeriodRadio, { value: "lastYear" }), React.createElement(SpecificPeriodRadio, { value: "lastMonth" }), React.createElement(SpecificPeriodRadio, { value: "yesterday" })))), React.createElement(field_1.Item, { label: "Date Range" }, React.createElement(radio_1.Radio, { label: "Date Range", name: name, checked: isDateRange, onChange: function onChange() {
	                    return _this9.onStandard('dateRange');
	                } }), React.createElement("fieldset", { disabled: !isDateRange, style: { marginLeft: "2em" } }, React.createElement(field_1.Item, { label: "From" }, React.createElement(datePicker_1.DatePicker, { date: this.state.fromDate, onChange: this.setFromDate, readonly: !isDateRange, invalid: false })), React.createElement(field_1.Item, { label: "To" }, React.createElement(datePicker_1.DatePicker, { date: this.state.toDate, onChange: this.setToDate, readonly: !isDateRange, invalid: false })))), React.createElement(field_1.Item, { label: "Month Year Range" }, React.createElement(radio_1.Radio, { label: "Month Year Range", name: name, checked: isMonthYearRange, onChange: function onChange() {
	                    return _this9.onStandard('monthYearRange');
	                } }), React.createElement("fieldset", { disabled: !isMonthYearRange, style: { marginLeft: "2em" } }, React.createElement(field_1.Item, { label: "From" }, React.createElement(select_1.SingleBox, { onChange: this.setFromMonth, value: this.state.fromMonthYear[0].toString() }, React.createElement("option", { value: "1" }, "January"), React.createElement("option", { value: "2" }, "February"), React.createElement("option", { value: "3" }, "March"), React.createElement("option", { value: "4" }, "April"), React.createElement("option", { value: "5" }, "May"), React.createElement("option", { value: "6" }, "June"), React.createElement("option", { value: "7" }, "July"), React.createElement("option", { value: "8" }, "August"), React.createElement("option", { value: "9" }, "September"), React.createElement("option", { value: "10" }, "October"), React.createElement("option", { value: "11" }, "November"), React.createElement("option", { value: "12" }, "December")), React.createElement(input_1.Input, { onChange: this.setFromYear, value: this.state.fromMonthYear[1].toString(), numeric: { min: 1950 } })), React.createElement(field_1.Item, { label: "To" }, React.createElement(select_1.SingleBox, { onChange: this.setToMonth, value: this.state.toMonthYear[0].toString() }, React.createElement("option", { value: "1" }, "January"), React.createElement("option", { value: "2" }, "February"), React.createElement("option", { value: "3" }, "March"), React.createElement("option", { value: "4" }, "April"), React.createElement("option", { value: "5" }, "May"), React.createElement("option", { value: "6" }, "June"), React.createElement("option", { value: "7" }, "July"), React.createElement("option", { value: "8" }, "August"), React.createElement("option", { value: "9" }, "September"), React.createElement("option", { value: "10" }, "October"), React.createElement("option", { value: "11" }, "November"), React.createElement("option", { value: "12" }, "December")), React.createElement(input_1.Input, { onChange: this.setToYear, value: this.state.toMonthYear[1].toString(), numeric: { min: 1950 } }))))));
	        }
	    }]);
	
	    return EditFilterDateRangeModal;
	}(React.Component);
	
	var RenderReport = function (_React$Component6) {
	    _inherits(RenderReport, _React$Component6);
	
	    function RenderReport(props) {
	        _classCallCheck(this, RenderReport);
	
	        var _this10 = _possibleConstructorReturn(this, (RenderReport.__proto__ || Object.getPrototypeOf(RenderReport)).call(this, props));
	
	        _this10.closeFilter = function () {
	            _this10.setState({ showFilterModal: undefined });
	        };
	        _this10.cancelSaveReport = function () {
	            _this10.setState({ updatingReportProps: undefined });
	        };
	        _this10.openFilter = function (id) {
	            if (_this10.state.filters[id] !== undefined) {
	                _this10.setState({ showFilterModal: id });
	            }
	        };
	        _this10.openSaveReportModal = function () {
	            var report = _this10.props.report;
	            _this10.setState({
	                updatingReportProps: {
	                    description: report.description,
	                    title: report.title
	                }
	            });
	        };
	        _this10.saveCsv = function () {
	            var results = _this10.state.results;
	            if (!results) return;
	            var fields = results.columns.map(function (m) {
	                return m.dataField;
	            });
	            var header = [results.columns.map(function (m) {
	                return m.headerText;
	            })];
	            var dataRows = results.data.map(function (m) {
	                return fields.map(function (f) {
	                    return m[f];
	                });
	            });
	            var rows = header.concat(dataRows);
	            var csvContent = "data:text/csv;charset=utf-8,";
	            var out = csvContent + rows.map(function (r) {
	                return r.join(',');
	            }).join("\n");
	            var a = document.createElement('a');
	            a.setAttribute('href', encodeURI(out));
	            a.setAttribute('download', _this10.props.report.title + ".csv");
	            document.body.appendChild(a);
	            a.click();
	            document.body.removeChild(a);
	        };
	        _this10.onNewInfo = function (n) {
	            _this10.setState({ updatingReportProps: n });
	        };
	        _this10.setFilter = function (id, v) {
	            var filters = _this10.state.filters;
	            if (filters[id] !== undefined) {
	                var new_filters = [].concat(_toConsumableArray(filters));
	                new_filters[id] = v;
	                _this10.setState({ filters: new_filters });
	                var rep = Object.assign({}, _this10.props.report, { filters: new_filters }); //hack around typescripts extraordinary and misplaced punctiliousness with a redundant const
	                _this10.runReportWithReport(rep);
	            }
	        };
	        _this10.submitSaveReport = function () {
	            return __awaiter(_this10, void 0, void 0, regeneratorRuntime.mark(function _callee5() {
	                var updatingProps, oldReport;
	                return regeneratorRuntime.wrap(function _callee5$(_context5) {
	                    while (1) {
	                        switch (_context5.prev = _context5.next) {
	                            case 0:
	                                updatingProps = this.state.updatingReportProps;
	
	                                if (updatingProps) {
	                                    _context5.next = 3;
	                                    break;
	                                }
	
	                                return _context5.abrupt("return");
	
	                            case 3:
	                                oldReport = Object.assign({}, this.props.report, { title: updatingProps.title, description: updatingProps.description, filters: this.state.filters });
	                                _context5.next = 6;
	                                return this.props.saveReport(oldReport);
	
	                            case 6:
	                                this.setState({ updatingReportProps: undefined });
	
	                            case 7:
	                            case "end":
	                                return _context5.stop();
	                        }
	                    }
	                }, _callee5, this);
	            }));
	        };
	        _this10.initialize = function (props) {
	            //i want to ensure we blank out the state here.
	            _this10.setState(RenderReport.getBlankState(props.report));
	            _this10.runReport();
	        };
	        _this10.runReport = function () {
	            return __awaiter(_this10, void 0, void 0, regeneratorRuntime.mark(function _callee6() {
	                var r;
	                return regeneratorRuntime.wrap(function _callee6$(_context6) {
	                    while (1) {
	                        switch (_context6.prev = _context6.next) {
	                            case 0:
	                                r = Object.assign({}, this.props.report, { filters: this.state.filters }); //i haven't literally written the prohibited props name, it just comes for the ride
	
	                                _context6.next = 3;
	                                return this.runReportWithReport(r);
	
	                            case 3:
	                            case "end":
	                                return _context6.stop();
	                        }
	                    }
	                }, _callee6, this);
	            }));
	        };
	        _this10.runReportWithReport = function (report) {
	            return __awaiter(_this10, void 0, void 0, regeneratorRuntime.mark(function _callee7() {
	                var res;
	                return regeneratorRuntime.wrap(function _callee7$(_context7) {
	                    while (1) {
	                        switch (_context7.prev = _context7.next) {
	                            case 0:
	                                this.setState({ running: true });
	                                _context7.prev = 1;
	                                _context7.next = 4;
	                                return this.props.commands.runGet('run report', {
	                                    id: report.reportId,
	                                    filters: report.filters && report.filters.map(function (m) {
	                                        return Object.assign({}, m, { filterItems: undefined });
	                                    })
	                                });
	
	                            case 4:
	                                res = _context7.sent;
	
	                                this.setState({ results: res[0], running: false });
	                                _context7.next = 11;
	                                break;
	
	                            case 8:
	                                _context7.prev = 8;
	                                _context7.t0 = _context7["catch"](1);
	
	                                this.setState({ running: false });
	
	                            case 11:
	                            case "end":
	                                return _context7.stop();
	                        }
	                    }
	                }, _callee7, this, [[1, 8]]);
	            }));
	        };
	        _this10.state = RenderReport.getBlankState(props.report);
	        return _this10;
	    }
	
	    _createClass(RenderReport, [{
	        key: "componentDidUpdate",
	        value: function componentDidUpdate(prevProps, prevState, prevContext) {
	            if (this.props.report.reportSerial != prevProps.report.reportSerial) {
	                this.initialize(this.props);
	            }
	        }
	    }, {
	        key: "componentWillMount",
	        value: function componentWillMount() {
	            this.initialize(this.props);
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this11 = this;
	
	            var props = this.props;
	            var showingFilterModal = this.state.showFilterModal;
	            var modal = showingFilterModal !== undefined && React.createElement(EditFilterModal, { defaultValue: this.state.filters[showingFilterModal], onChange: function onChange(v) {
	                    _this11.setFilter(showingFilterModal, v);
	                    _this11.closeFilter();
	                }, onClose: this.closeFilter });
	            var saveReportModal = this.state.updatingReportProps && React.createElement(NewReportModal, { type: "save", reportType: this.props.reportType.title, info: this.state.updatingReportProps, submitting: this.props.submitting, onNewInfo: this.onNewInfo, onSave: this.submitSaveReport, onRequestClose: this.cancelSaveReport });
	            return React.createElement("div", null, modal, saveReportModal, React.createElement("h1", null, props.report.title, " \xB7 ", props.reportType.title), React.createElement("p", null, props.report.description), React.createElement(Toolbar, null, React.createElement(button_1.Button, { onClick: props.closeReport, icon: "/sb/static/images/icons/arrow_left.png" }, "Back"), React.createElement(button_1.Button, { onClick: this.openSaveReportModal, emoji: "\uD83D\uDCBE" }, "Save"), React.createElement(button_1.Button, { disabled: this.state.running, onClick: this.runReport, emoji: "\uD83C\uDFC3" }, "Run"), this.state.results && React.createElement(button_1.Button, { onClick: this.saveCsv, emoji: "\uD83D\uDCC8" }, "Export Spreadsheet"), (this.props.submitting || this.state.running) && React.createElement("img", { className: "loadingImage", src: "/sb/static/images/loadergif.gif" })), React.createElement("div", { style: { position: "relative" } }, React.createElement("div", { style: {
	                    position: "absolute",
	                    paddingRight: "10px",
	                    borderRight: "1px solid black",
	                    width: "20%"
	                } }, this.state.filters.map(function (r, n) {
	                return React.createElement(RenderFilter, { key: n, openFilter: function openFilter() {
	                        return _this11.openFilter(n);
	                    }, r: r });
	            })), React.createElement("div", { style: {
	                    position: "absolute",
	                    paddingLeft: "10px",
	                    marginLeft: "10px",
	                    borderLeft: "1px solid black",
	                    left: "20%",
	                    width: "80%"
	                } }, this.state.results && React.createElement(RenderResults, { results: this.state.results }))));
	        }
	    }]);
	
	    return RenderReport;
	}(React.Component);
	
	RenderReport.getBlankState = function (rep) {
	    return {
	        running: false,
	        results: undefined,
	        showFilterModal: undefined,
	        updatingReportProps: undefined,
	        filters: rep.defualtFilters
	    };
	};
	var makeLabel = function makeLabel(r) {
	    switch (r.filterType) {
	        case FilterType.YesNo:
	            var k = r.selectedFilterItems[0];
	            return k ? k.selected ? 'Yes' : 'No' : 'Default';
	        case FilterType.DateRange:
	            var i = r.selectedFilterItems[0];
	            return i ? i.label : "Unspecified, unclear time period";
	        case FilterType.Select:
	        case FilterType.MultiSelect:
	            var l = r.selectedFilterItems.map(function (i) {
	                return i.label;
	            }).join(", ");
	            return l || "All";
	    }
	};
	var RenderFilter = function RenderFilter(props) {
	    var r = props.r;
	    var label = makeLabel(props.r);
	    return React.createElement("div", { key: r.id, onClick: props.openFilter, style: {
	            border: "1px solid rgb(0, 169, 224)",
	            cursor: "pointer",
	            position: "relative"
	        } }, React.createElement("p", { style: { margin: "0px", fontWeight: "bold" } }, r.name), React.createElement("p", null, label), React.createElement("button", { style: {
	            position: "absolute",
	            top: "0px",
	            right: "0px",
	            margin: "5px",
	            fontSize: "200%",
	            color: "#00a9e0",
	            padding: "0px",
	            border: "0px none",
	            backgroundColor: "transparent"
	        } }, "\u2699\uFE0F"));
	};
	var money = { minimumFractionDigits: 2 };
	var RenderResults = function RenderResults(props) {
	    var heading = props.results.columns.reduce(function (old, cur) {
	        return Object.assign({}, old, _defineProperty({}, cur.dataField, cur.headerText));
	    }, {});
	    var typeMap = props.results.columns.reduce(function (old, cur) {
	        return Object.assign({}, old, _defineProperty({}, cur.dataField, cur.type));
	    }, {});
	    var formatColumn = function formatColumn(a, cur) {
	        var type = typeMap[cur];
	        switch (type) {
	            case "number":
	                var num = Number.parseFloat(a[cur]);
	                return {
	                    alignment: 'right',
	                    node: isNaN(num) ? a[cur] : num.toLocaleString('en-AU', money)
	                };
	            case "numeric":
	                return {
	                    alignment: 'right',
	                    node: a[cur]
	                };
	            case "text":
	                return {
	                    node: a[cur]
	                };
	        }
	        throw "oh noes, i know nothing of " + type + " for column " + cur;
	    };
	    var headingAlignments = props.results.columns.reduce(function (old, cur) {
	        return Object.assign({}, old, _defineProperty({}, cur.dataField, toHeadingAlignment(cur.type)));
	    }, {});
	    var toDatagridRow = function toDatagridRow(a) {
	        return props.results.columns.map(function (k) {
	            return k.dataField;
	        }).reduce(function (old, cur) {
	            return Object.assign({}, old, _defineProperty({}, cur, formatColumn(a, cur)));
	        }, {});
	    };
	    var data = props.results.data.map(toDatagridRow);
	    return React.createElement("div", null, React.createElement(fixed_data_grid_1.FixedDataGrid, { headingAlignments: headingAlignments, heading: heading, data: data }), React.createElement("div", { style: { width: "100%", textAlign: "right" } }));
	};
	var toHeadingAlignment = function toHeadingAlignment(v) {
	    switch (v) {
	        case "number":
	            return "right";
	        case "numeric":
	            return "right";
	        case "text":
	            return "center";
	    }
	};
	var RenderFrontPage = function RenderFrontPage(props) {
	    var v = props.reports.map(function (r) {
	        return {
	            click: props.loadReport(r.reportSerial),
	            reportSerial: { node: r.reportSerial, alignment: fixed_data_grid_1.Alignment.left },
	            title: { node: r.title, alignment: fixed_data_grid_1.Alignment.left },
	            description: { node: r.description, alignment: fixed_data_grid_1.Alignment.left },
	            reportType: { node: r.reportType, alignment: fixed_data_grid_1.Alignment.left },
	            authorName: { node: r.authorName, alignment: fixed_data_grid_1.Alignment.left }
	        };
	    });
	    var newReportInfo = props.newReportInfo;
	    var modal = newReportInfo && React.createElement(NewReportModal, { type: "new", reportTypes: props.reportTypes.map(function (r) {
	            return { value: r.id.toString(), label: r.title };
	        }), info: newReportInfo.info, submitting: props.submitting, onNewInfo: props.onNewInfo, onSave: props.submitNewReport, onRequestClose: props.cancelNewReport });
	    return React.createElement("div", null, modal, React.createElement("h1", null, "Reports"), React.createElement(Toolbar, null, React.createElement(button_1.Button, { onClick: props.openNewReport, icon: "/sb/static/images/icons/addIcon.png" })), React.createElement(SingleTable, { rowClick: 'click', widths: "leave undefined", heading: headingSingle, data: v }));
	};
	var Toolbar = function Toolbar(props) {
	    return React.createElement("div", null, props.children);
	};
	var NewReportModal = function NewReportModal(props) {
	    var cssProps = modal_1.centeredModalProps('600px');
	    cssProps.overflow = undefined;
	    var reportType = React.createElement(field_1.Item, { label: "Report Type" }, props.type == 'new' ? React.createElement(select_1.SingleBox, { enabled: !props.submitting, onChange: function onChange(v) {
	            return props.onNewInfo(Object.assign({}, props.info, { reportType: v }));
	        }, value: props.info.reportType }, props.reportTypes.map(function (t) {
	        return React.createElement("option", { key: t.value, value: t.value }, t.label);
	    })) : props.reportType);
	    return React.createElement(modal_1.Modal, { style: cssProps, isOpen: true, title: props.type == 'new' ? "New Report" : "Save Report", onRequestClose: props.onRequestClose }, React.createElement(form_1.Form, { isSubmitting: props.submitting, hasCancel: true, onCancel: props.onRequestClose, onSubmit: props.onSave }, reportType, React.createElement(field_1.Item, { label: "Title" }, React.createElement(input_1.Input, { disabled: props.submitting, value: props.info.title, onChange: function onChange(v) {
	            return props.onNewInfo(Object.assign({}, props.info, { title: v }));
	        } })), React.createElement(field_1.Item, { label: "Description" }, React.createElement(textarea_1.Textarea, { disabled: props.submitting, value: props.info.description, onChange: function onChange(v) {
	            return props.onNewInfo(Object.assign({}, props.info, { description: v }));
	        } }))));
	};

/***/ },

/***/ 656:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(3);
	var ReactDOM = __webpack_require__(6);
	var Field = __webpack_require__(112);
	var form_1 = __webpack_require__(55);
	var select_1 = __webpack_require__(39);
	var commands_1 = __webpack_require__(12);
	
	var ReusablePayerSetup = function (_React$Component) {
	    _inherits(ReusablePayerSetup, _React$Component);
	
	    function ReusablePayerSetup(props, context) {
	        _classCallCheck(this, ReusablePayerSetup);
	
	        var _this = _possibleConstructorReturn(this, (ReusablePayerSetup.__proto__ || Object.getPrototypeOf(ReusablePayerSetup)).call(this, props, context));
	
	        _this.state = {
	            currentAccountId: props ? props.currentAccountId : 0
	        };
	        return _this;
	    }
	
	    _createClass(ReusablePayerSetup, [{
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var updateCurrentAccount = function updateCurrentAccount(value) {
	                return _this2.setState({
	                    currentAccountId: Number.parseInt(value)
	                });
	            };
	            return React.createElement(form_1.ManagedForm, { hasSave: true, hasCancel: true, onCancel: function onCancel() {
	                    return _this2.cancel();
	                }, onSubmit: function onSubmit() {
	                    // TODO Port to async/await
	                    if (!_this2.isValid()) {
	                        alert("Please select an account");
	                        return Promise.resolve();
	                    }
	                    return _this2.save();
	                } }, React.createElement(ReusablePayerSetupForm, { accounts: this.props.accounts, currentAccountId: this.state.currentAccountId, updateCurrentAccount: updateCurrentAccount }));
	        }
	    }, {
	        key: "isValid",
	        value: function isValid() {
	            return this.state.currentAccountId !== 0 && this.props.accounts.map(function (a) {
	                return a.id;
	            }).indexOf(this.state.currentAccountId) != -1;
	        }
	    }, {
	        key: "cancel",
	        value: function cancel() {
	            window.location.assign(this.props.paymentMethodListPage);
	        }
	    }, {
	        key: "save",
	        value: function save() {
	            return new commands_1.CommandCaller(this.props.ajaxPageUrl).runPost('save reusable payer settings', {
	                id: this.props.reusablePayerId,
	                accountId: this.state.currentAccountId
	            });
	        }
	    }]);
	
	    return ReusablePayerSetup;
	}(React.Component);
	
	var ReusablePayerSetupForm = function (_React$Component2) {
	    _inherits(ReusablePayerSetupForm, _React$Component2);
	
	    function ReusablePayerSetupForm() {
	        _classCallCheck(this, ReusablePayerSetupForm);
	
	        return _possibleConstructorReturn(this, (ReusablePayerSetupForm.__proto__ || Object.getPrototypeOf(ReusablePayerSetupForm)).apply(this, arguments));
	    }
	
	    _createClass(ReusablePayerSetupForm, [{
	        key: "render",
	        value: function render() {
	            var optionFromAccount = function optionFromAccount(account) {
	                return React.createElement("option", { key: account.id, value: "" + account.id }, account.name, " (", ReusablePayerSetupForm.type(account), ")");
	            };
	            var zerothOption = this.props.currentAccountId == 0 ? [React.createElement("option", { key: "0", value: "0" })] : [];
	            var otherOptions = this.props.accounts.map(optionFromAccount);
	            var options = zerothOption.concat(otherOptions);
	            return React.createElement("div", null, React.createElement(form_1.Heading, null, "Reusable Payer Method Setup"), React.createElement(Field.Group, { heading: "Settings" }, React.createElement(Field.Item, { label: "Account Settings", isRequired: true }, React.createElement(select_1.SingleBox, { value: "" + this.props.currentAccountId, onChange: this.props.updateCurrentAccount }, options))));
	        }
	    }], [{
	        key: "type",
	        value: function type(acc) {
	            switch (acc.configuration) {
	                case "securepay":
	                    return "SecurePay";
	                case "eway rapid":
	                    return "eWay Rapid";
	                default:
	                    return acc.configuration;
	            }
	        }
	    }]);
	
	    return ReusablePayerSetupForm;
	}(React.Component);
	
	exports.reusablePayerSetupCallJs = function (callback, props) {
	    var div = document.createElement('div');
	    callback(div);
	    ReactDOM.render(React.createElement(ReusablePayerSetup, { ajaxPageUrl: props.ajaxPageUrl, currentAccountId: props.currentAccountId, accounts: props.accounts, reusablePayerId: props.reusablePayerId, paymentMethodListPage: props.paymentMethodListPage }), div);
	};

/***/ },

/***/ 657:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var $ = __webpack_require__(10);
	var Immutable = __webpack_require__(103);
	
	var EwayError = function (_Error) {
	    _inherits(EwayError, _Error);
	
	    //noinspection JSUnusedLocalSymbols
	    function EwayError(ewayResult, message) {
	        _classCallCheck(this, EwayError);
	
	        var _this = _possibleConstructorReturn(this, (EwayError.__proto__ || Object.getPrototypeOf(EwayError)).call(this, message));
	
	        _this.ewayResult = ewayResult;
	        return _this;
	    }
	
	    return EwayError;
	}(Error);
	
	exports.EwayError = EwayError;
	/**
	 * The eWay library needs to be downloaded directly from ewaypayments.com, so instead of holding the library directly,
	 * we hold a promise of it.
	 */
	var eWay = new Promise(function (resolve, reject) {
	    $.getScript("https://api.ewaypayments.com/JSONP/v3/js").done(function () {
	        // The loaded script attaches itself to the global variable "eWAY".
	        // Grab it, delete it (so the global state is unchanged), and return it.
	        var global = window.eWAY;
	        delete window.eWAY;
	        resolve(global);
	    }).fail(function (jqxhr, settings, exception) {
	        reject(exception);
	    });
	});
	function convertParamsToForm(paymentDetails) {
	    var form = document.createElement("form");
	    form.style.display = 'none';
	    form.method = 'POST';
	    form.action = paymentDetails.FormActionURL;
	    function addField(name, value) {
	        var input = document.createElement('input');
	        input.type = "hidden";
	        input.name = name;
	        input.value = value;
	        form.appendChild(input);
	    }
	    addField("EWAY_ACCESSCODE", paymentDetails.AccessCode);
	    addField("EWAY_PAYMENTTYPE", "Credit Card");
	    addField("EWAY_CARDNAME", paymentDetails.Name);
	    addField("EWAY_CARDNUMBER", paymentDetails.Number);
	    addField("EWAY_CARDEXPIRYMONTH", paymentDetails.Month);
	    addField("EWAY_CARDEXPIRYYEAR", paymentDetails.Year);
	    addField("EWAY_CARDCVN", paymentDetails.CVV);
	    return form;
	}
	var ErrorCodes = Immutable.Map({
	    'V6100': 'Invalid cardholder name',
	    'V6101': 'Invalid card expiry month',
	    'V6102': 'Invalid card expiry year',
	    'V6103': 'Invalid card start month',
	    'V6104': 'Invalid card start year',
	    'V6105': 'Invalid card issue number',
	    'V6106': 'Invalid card CCV/CVN',
	    'V6110': 'Invalid card number'
	});
	function processEway(params) {
	    return new Promise(function (resolve, reject) {
	        eWay.then(function (eWAY) {
	            var form = convertParamsToForm(params);
	            eWAY.process(form, {
	                autoRedirect: false,
	                onComplete: function onComplete(result) {
	                    if (result.Errors !== null && ErrorCodes.has(result.Errors)) {
	                        reject(ErrorCodes.get(result.Errors));
	                    } else {
	                        resolve(result);
	                    }
	                },
	                onError: function onError(e) {
	                    return resolve({
	                        Errors: e.hasOwnProperty('Errors') ? e.Errors : "Some error",
	                        RedirectUrl: params.FormActionURL,
	                        Is3DSecure: false,
	                        AccessCode: params.AccessCode
	                    });
	                },
	                onTimeout: function onTimeout() {
	                    return resolve({
	                        Errors: "Timeout",
	                        RedirectUrl: params.FormActionURL,
	                        Is3DSecure: false,
	                        AccessCode: params.AccessCode
	                    });
	                }
	            });
	        });
	    });
	}
	exports.processEway = processEway;

/***/ },

/***/ 658:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var $ = __webpack_require__(10);
	var paymentgateway_1 = __webpack_require__(285);
	var creditCard = __webpack_require__(140);
	var commands_1 = __webpack_require__(12);
	var submitAo = function submitAo(div, ajaxPageUrl) {
	    var params = Object.assign({}, creditCard.getCreditCardParams(), { savePayment: document.getElementById('savePayment').checked });
	    div.block({ message: "Please wait while your payment is set up..." });
	    new commands_1.CommandCaller(ajaxPageUrl).runPost('submit payment', params).then(function (result) {
	        return location.assign(result);
	    }, function () {
	        div.unblock();
	    });
	};
	exports.submit = function (method) {
	    return method === 'eway rapid' ? paymentgateway_1.submitEwayPayment : submitAo;
	};
	exports.updateCreditCardType = function (orderId, cardType, ajaxPageUrl) {
	    ;
	    new commands_1.CommandCaller(ajaxPageUrl).runPost('update credit card type', { orderId: orderId, cardType: cardType.code }).then(function (response) {
	        var cvv = $("input[name='CreditCardNumberCVV']");
	        cvv.prop('maxLength', response.cvvDigits);
	        cvv.val(cvv.val().substr(0, response.cvvDigits));
	        $("#reusablePayerInvoice").html(response.invoice);
	    });
	};

/***/ },

/***/ 659:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) {
	            try {
	                step(generator.next(value));
	            } catch (e) {
	                reject(e);
	            }
	        }
	        function rejected(value) {
	            try {
	                step(generator["throw"](value));
	            } catch (e) {
	                reject(e);
	            }
	        }
	        function step(result) {
	            result.done ? resolve(result.value) : new P(function (resolve) {
	                resolve(result.value);
	            }).then(fulfilled, rejected);
	        }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var payment_methods_tabs_1 = __webpack_require__(284);
	var $ = __webpack_require__(10);
	var commands_1 = __webpack_require__(12);
	var modal_1 = __webpack_require__(135);
	var creditCard = __webpack_require__(140);
	var showError = function showError(tryParams /*under TS2, "tryParams: PaymentMethodTabError". the if check around usages will effect a safe downcast */) {
	    var error = tryParams; //delete this cast
	    window.alert(error.title + "\n\n" + error.error);
	};
	exports.submit = function (div, ajaxPageUrl) {
	    var tryParams = payment_methods_tabs_1.getFormValues(div.find('form'));
	    if (tryParams.method == 'error') {
	        showError(tryParams);
	        return false;
	    }
	    var params = Object.assign({}, tryParams, { preferredPaymentDay: $("[name='PreferredPaymentDay']").val(), frequency: $("[name='PaymentFrequency']").val() });
	    div.block({ message: "Please wait while your payment is set up..." });
	    new commands_1.CommandCaller(ajaxPageUrl).runPost('submit recurring payment', params).then(function (l) {
	        return location.assign(l);
	    }, function () {
	        return div.unblock();
	    });
	    return true;
	};
	exports.changeDetails = function (form, paymentSchedule, ajaxPageUrl) {
	    return __awaiter(undefined, void 0, void 0, regeneratorRuntime.mark(function _callee() {
	        var params, body;
	        return regeneratorRuntime.wrap(function _callee$(_context) {
	            while (1) {
	                switch (_context.prev = _context.next) {
	                    case 0:
	                        params = Object.assign({}, payment_methods_tabs_1.getFormValues(form), { paymentSchedule: paymentSchedule });
	
	                        if (!(params.method == 'error')) {
	                            _context.next = 4;
	                            break;
	                        }
	
	                        showError(params);
	                        return _context.abrupt("return");
	
	                    case 4:
	                        body = $(document.body);
	
	                        body.block({ message: "Please wait while we update the payment details" });
	                        _context.prev = 6;
	                        _context.next = 9;
	                        return new commands_1.CommandCaller(ajaxPageUrl).runPost('change payment method', params);
	
	                    case 9:
	                        modal_1.hideDialog('ChangePaymentsDialog');
	                        location.reload();
	                        _context.next = 15;
	                        break;
	
	                    case 13:
	                        _context.prev = 13;
	                        _context.t0 = _context["catch"](6);
	
	                    case 15:
	                        body.unblock();
	
	                    case 16:
	                    case "end":
	                        return _context.stop();
	                }
	            }
	        }, _callee, this, [[6, 13]]);
	    }));
	};
	exports.updateMethod = function (ajaxPage, orderId, paymentMethod, preferredPaymentDay, frequency /* a narrower type is possible*/, callback) {
	    var type = creditCard.creditCardType().new_;
	    var params = {
	        orderId: orderId,
	        paymentMethod: paymentMethod,
	        preferredPaymentDay: preferredPaymentDay,
	        frequency: frequency,
	        cardType: paymentMethod == "CreditCard" && type != null ? type.code : undefined
	    };
	    var p = new commands_1.CommandCaller(ajaxPage).runPost('update payment method', params);
	    if (callback) p.then(callback);
	    return p;
	};
	exports.updateCreditCardType = function (ajaxPage, orderId, cardType, preferredPaymentDay, frequency, callback) {
	    var p = new commands_1.CommandCaller(ajaxPage).runPost('update credit card type', { orderId: orderId, cardType: cardType.code, preferredPaymentDay: preferredPaymentDay, frequency: frequency });
	    if (callback) p.then(callback);
	    return p;
	};

/***/ },

/***/ 660:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(3);
	var utils_1 = __webpack_require__(4);
	exports.Loading = function (props) {
	    return React.createElement("div", { className: utils_1.joinStrings(props.className ? ['loading', props.className] : ['loading']) }, React.createElement("div", { className: "icon" }, React.createElement("img", { src: "/sb/static/images/loadergif.gif" })), React.createElement("div", { className: "message" }, props.message == null ? "Loading…" : props.message));
	};

/***/ },

/***/ 661:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(3);
	/**
	 * Paginator that shows previous/next buttons, as well as a series of buttons with specific page numbers.
	 * These buttons are prefixed/suffixed appropriately with "..." when there are more props.padding pages to
	 * either side of the current page.
	 *
	 * The component is given the following CSS classes:
	 *  * .paginator for the outer div
	 *  * .page-button for the specific page buttons, and also for the "..."
	 *  * .enabled / .disabled depending on whether the button can be pressed (e.g. can't press the "left" button when already on page 1).
	 *  * .active for the current .page-button
	 *  * .filler for the "..."
	 */
	
	var Paginator = function (_React$Component) {
	    _inherits(Paginator, _React$Component);
	
	    function Paginator() {
	        _classCallCheck(this, Paginator);
	
	        return _possibleConstructorReturn(this, (Paginator.__proto__ || Object.getPrototypeOf(Paginator)).apply(this, arguments));
	    }
	
	    _createClass(Paginator, [{
	        key: "getPadding",
	        value: function getPadding() {
	            return typeof this.props.padding !== 'undefined' && this.props.padding != null ? this.props.padding : Paginator.DEFAULT_PADDING;
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            return React.createElement("div", { className: "paginator" }, this.createButton(this.props.currentPage - 1, "Previous", this.props.currentPage > 0), this.leftFiller(), this.centreButtons(), this.rightFiller(), this.createButton(this.props.currentPage + 1, "Next", this.props.currentPage < this.props.numPages - 1));
	        }
	    }, {
	        key: "centreButtons",
	        value: function centreButtons() {
	            var min = Math.max(0, this.props.currentPage - this.getPadding());
	            var max = Math.min(this.props.numPages, this.props.currentPage + this.getPadding());
	            var buttons = [];
	            for (var i = min; i < max; i++) {
	                buttons.push(this.createButton(i, (i + 1).toString(), true));
	            }
	            return buttons;
	        }
	    }, {
	        key: "leftFiller",
	        value: function leftFiller() {
	            return this.props.currentPage - this.getPadding() > 0 ? this.createFiller() : null;
	        }
	    }, {
	        key: "rightFiller",
	        value: function rightFiller() {
	            return this.props.currentPage + this.getPadding() < this.props.numPages - 1 ? this.createFiller() : null;
	        }
	    }, {
	        key: "createButton",
	        value: function createButton(page, label, isEnabled) {
	            var _this2 = this;
	
	            var onClick = function onClick(event) {
	                if (isEnabled) {
	                    _this2.props.onSelectPage(page);
	                }
	                event.preventDefault();
	            };
	            var enabledClass = isEnabled ? 'enabled' : 'disabled';
	            var activeClass = this.props.currentPage == page ? 'current' : '';
	            var className = "page-button " + enabledClass + " " + activeClass;
	            var key = "button-" + page;
	            return this.props.currentPage == page || !isEnabled ? React.createElement("span", { key: key, className: className }, label) : React.createElement("a", { key: key, href: "#", onClick: onClick, className: className }, label);
	        }
	    }, {
	        key: "createFiller",
	        value: function createFiller() {
	            return React.createElement("span", { className: "page-button filler" }, "...");
	        }
	    }]);
	
	    return Paginator;
	}(React.Component);
	
	Paginator.DEFAULT_PADDING = 3;
	exports.Paginator = Paginator;

/***/ },

/***/ 662:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(3);
	/**
	 * A StyleableCheckbox has an empty span with classname "to-style" directly next to the checkbox <input>, and within the
	 * same <label> element. This means that you are able to:
	 *  * Hide the checkbox
	 *  * Style the "input + .to-style" and "input:checked + .to-style" span to look like whatever you want (e.g. using
	 *    background images).
	 *  * Clicking the .to-style span will trigger the underlying checkbox to get checked or unchecked. This is due to it
	 *    being within the same <label> element.
	 *
	 * Alternatively, if you don't do any of these things, it will still work as per a normal checkbox with a label that
	 * can be clicked.
	 */
	
	var StyleableCheckbox = function (_React$Component) {
	    _inherits(StyleableCheckbox, _React$Component);
	
	    function StyleableCheckbox() {
	        _classCallCheck(this, StyleableCheckbox);
	
	        return _possibleConstructorReturn(this, (StyleableCheckbox.__proto__ || Object.getPrototypeOf(StyleableCheckbox)).apply(this, arguments));
	    }
	
	    _createClass(StyleableCheckbox, [{
	        key: "render",
	        value: function render() {
	            return React.createElement("div", { className: this.props.className + ' style-checkbox' }, React.createElement("label", null, React.createElement("input", { type: "checkbox", checked: this.props.defaultChecked, onChange: this.props.onChange, className: this.props.className }), React.createElement("span", { className: "to-style" }), React.createElement("span", { className: "label" }, this.props.label)));
	        }
	    }]);
	
	    return StyleableCheckbox;
	}(React.Component);
	
	exports.StyleableCheckbox = StyleableCheckbox;

/***/ },

/***/ 663:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) {
	            try {
	                step(generator.next(value));
	            } catch (e) {
	                reject(e);
	            }
	        }
	        function rejected(value) {
	            try {
	                step(generator["throw"](value));
	            } catch (e) {
	                reject(e);
	            }
	        }
	        function step(result) {
	            result.done ? resolve(result.value) : new P(function (resolve) {
	                resolve(result.value);
	            }).then(fulfilled, rejected);
	        }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(3);
	var ReactDOM = __webpack_require__(6);
	var redux_1 = __webpack_require__(22);
	var redux_thunk_1 = __webpack_require__(33);
	var graph_renderer_1 = __webpack_require__(137);
	var lib_1 = __webpack_require__(181);
	var lib2_1 = __webpack_require__(271);
	var report_builder_1 = __webpack_require__(179);
	var utils_1 = __webpack_require__(4);
	var commands_1 = __webpack_require__(12);
	var chart_data_1 = __webpack_require__(180);
	var yyyymmddFromDateFilter = redux_1.compose(utils_1.dateToYYYYMMDD, lib2_1.dateFromFilter);
	var reportRunDates = function reportRunDates(filter) {
	    return {
	        startDate: yyyymmddFromDateFilter(filter, 'fromDate'),
	        endDate: yyyymmddFromDateFilter(filter, 'toDate')
	    };
	};
	var runSearchReport = function runSearchReport(command, dateRangeFilter, typeFilter, ajaxPageUrl) {
	    return __awaiter(undefined, void 0, void 0, regeneratorRuntime.mark(function _callee() {
	        var typeSerials, params;
	        return regeneratorRuntime.wrap(function _callee$(_context) {
	            while (1) {
	                switch (_context.prev = _context.next) {
	                    case 0:
	                        typeSerials = typeFilter.type == "checkbox" ? typeFilter.checked : [];
	                        params = Object.assign({}, reportRunDates(dateRangeFilter), { typeSerials: typeSerials && typeSerials.length ? typeSerials : undefined });
	                        _context.next = 4;
	                        return new commands_1.CommandCaller(ajaxPageUrl).runGet(command, params);
	
	                    case 4:
	                        return _context.abrupt("return", _context.sent);
	
	                    case 5:
	                    case "end":
	                        return _context.stop();
	                }
	            }
	        }, _callee, this);
	    }));
	};
	function runProfileReport(command, dateRangeFilter, ajaxPageUrl) {
	    return __awaiter(this, void 0, void 0, regeneratorRuntime.mark(function _callee2() {
	        var params;
	        return regeneratorRuntime.wrap(function _callee2$(_context2) {
	            while (1) {
	                switch (_context2.prev = _context2.next) {
	                    case 0:
	                        params = reportRunDates(dateRangeFilter);
	                        _context2.next = 3;
	                        return new commands_1.CommandCaller(ajaxPageUrl).runGet(command, params);
	
	                    case 3:
	                        return _context2.abrupt("return", _context2.sent);
	
	                    case 4:
	                    case "end":
	                        return _context2.stop();
	                }
	            }
	        }, _callee2, this);
	    }));
	}
	exports.runReports = function (callback, params) {
	    var div = document.createElement("div");
	    var content = document.getElementById('content');
	    if (content) {
	        content.getElementsByTagName('table')[0].style.width = '100%';
	    }
	    var types = params.types.map(function (t) {
	        return { value: "" + t.serial, label: t.title };
	    });
	    var axes = {
	        searches: [{ value: "0", label: "Total Search Count" }],
	        searchResults: [{ value: "0", label: "Total Search Result Count" }].concat(_toConsumableArray(types)),
	        profileViews: [{ value: "0", label: "Total Profile Views" }],
	        profileEnquiries: [{ value: "0", label: "Total Profile Enquiries" }],
	        profileStats: [{ value: "StatsSearch", label: "Search Total" }, { value: "StatsView", label: "View Total" }, { value: "StatsEnquiry", label: "Enquiry Total" }]
	    };
	    var reducer = report_builder_1.reducer;
	    var filters = {
	        dateRange: { type: "date range", isHidden: false },
	        types: {
	            type: "checkbox",
	            isHidden: false,
	            label: "Membership Types",
	            group: types
	        }
	    };
	    var valueKeys = [{ id: "Date", label: "Date" }];
	    var displayModes = ["Graph", "Table"];
	    var reportTypes = {
	        searchCount: {
	            axis: "searches",
	            filters: ["dateRange", "types"],
	            label: "Search Count",
	            renderAs: "line",
	            removeEmptyAxes: true,
	            keys: valueKeys,
	            defaultDisplayMode: "Graph",
	            displayModes: displayModes
	        },
	        searchResultsCount: {
	            axis: "searchResults",
	            filters: ["dateRange", "types"],
	            label: "Search Results Count",
	            renderAs: "line",
	            removeEmptyAxes: true,
	            keys: valueKeys,
	            defaultDisplayMode: "Graph",
	            displayModes: displayModes
	        },
	        numProfileView: {
	            axis: "profileViews",
	            filters: ["dateRange"],
	            label: "Number of Profile View",
	            renderAs: "line",
	            removeEmptyAxes: true,
	            keys: valueKeys,
	            defaultDisplayMode: "Graph",
	            displayModes: displayModes
	        },
	        numProfileEnquiry: {
	            axis: "profileEnquiries",
	            filters: ["dateRange"],
	            label: "Number of Profile Enquiry",
	            renderAs: "line",
	            removeEmptyAxes: true,
	            keys: valueKeys,
	            defaultDisplayMode: "Graph",
	            displayModes: displayModes
	        },
	        overallProfileStats: {
	            axis: "profileStats",
	            filters: ["dateRange"],
	            label: "Overall Profile Stats",
	            renderAs: "bar",
	            removeEmptyAxes: false,
	            keys: [{ id: "EntityName", label: "Entity Name" }],
	            defaultDisplayMode: "Table",
	            displayModes: ["Table"]
	        }
	    };
	    var mapReportTypeToCommand = function mapReportTypeToCommand(reportType) {
	        switch (reportType) {
	            case "searchCount":
	                return "get search count";
	            case "searchResultsCount":
	                return "get search results count";
	            case "numProfileView":
	                return "get profile view count";
	            case "numProfileEnquiry":
	                return "get profile enquiry count";
	            case "overallProfileStats":
	                return "get profile stats count";
	        }
	    };
	    var runSomeReport = function runSomeReport(ajaxPageUrl, state, dispatchWrapped) {
	        return __awaiter(undefined, void 0, void 0, regeneratorRuntime.mark(function _callee3() {
	            var reportType, command, axis, a, c, e;
	            return regeneratorRuntime.wrap(function _callee3$(_context3) {
	                while (1) {
	                    switch (_context3.prev = _context3.next) {
	                        case 0:
	                            reportType = state.reportType;
	                            command = mapReportTypeToCommand(reportType);
	                            axis = reportTypes[reportType].axis;
	                            _context3.t0 = command;
	                            _context3.next = _context3.t0 === "get search count" ? 6 : _context3.t0 === "get search results count" ? 6 : _context3.t0 === "get profile view count" ? 11 : _context3.t0 === "get profile enquiry count" ? 11 : _context3.t0 === "get profile stats count" ? 16 : 21;
	                            break;
	
	                        case 6:
	                            _context3.next = 8;
	                            return runSearchReport(command, state.filters.dateRange, state.filters.types, ajaxPageUrl);
	
	                        case 8:
	                            a = _context3.sent;
	
	                            dispatchWrapped({
	                                type: "set new report data",
	                                data: { data: chart_data_1.flattenReportChartData(a), renderAs: "line", axis: axis }
	                            });
	                            return _context3.abrupt("break", 21);
	
	                        case 11:
	                            _context3.next = 13;
	                            return runProfileReport(command, state.filters.dateRange, ajaxPageUrl);
	
	                        case 13:
	                            c = _context3.sent;
	
	                            dispatchWrapped({
	                                type: "set new report data",
	                                data: { data: chart_data_1.flattenReportChartData(c), renderAs: "line", axis: axis }
	                            });
	                            return _context3.abrupt("break", 21);
	
	                        case 16:
	                            _context3.next = 18;
	                            return runProfileReport("get profile stats count", state.filters.dateRange, ajaxPageUrl);
	
	                        case 18:
	                            e = _context3.sent;
	
	                            dispatchWrapped({
	                                type: "set new report data",
	                                data: {
	                                    renderAs: "bar",
	                                    axis: axis,
	                                    data: utils_1.flatten(e.map(function (item) {
	                                        return [{ id: 'StatsSearch', key: item.EntityName, value: item.StatsSearch }, { id: 'StatsView', key: item.EntityName, value: item.StatsView }, { id: 'StatsEnquiry', key: item.EntityName, value: item.StatsEnquiry }];
	                                    }))
	                                }
	                            });
	                            return _context3.abrupt("break", 21);
	
	                        case 21:
	                        case "end":
	                            return _context3.stop();
	                    }
	                }
	            }, _callee3, this);
	        }));
	    };
	    var ownProps = function ownProps(store, ajaxPageUrl) {
	        return {
	            title: "Search Directory Reports",
	            store: store,
	            modes: graph_renderer_1.standardModes,
	            reportTypes: reportTypes,
	            filters: filters,
	            axes: axes,
	            runReport: function runReport(dispatchWrapped) {
	                return function (dispatchedUnwrapped, getState) {
	                    return __awaiter(undefined, void 0, void 0, regeneratorRuntime.mark(function _callee4() {
	                        var state;
	                        return regeneratorRuntime.wrap(function _callee4$(_context4) {
	                            while (1) {
	                                switch (_context4.prev = _context4.next) {
	                                    case 0:
	                                        state = getState();
	                                        _context4.prev = 1;
	                                        return _context4.abrupt("return", runSomeReport(ajaxPageUrl, state, dispatchWrapped));
	
	                                    case 5:
	                                        _context4.prev = 5;
	                                        _context4.t0 = _context4["catch"](1);
	
	                                        window.alert("There was an unexpected error. Ensure you're logged in, your internet connection is working, and try reloading the page");
	
	                                    case 8:
	                                    case "end":
	                                        return _context4.stop();
	                                }
	                            }
	                        }, _callee4, this, [[1, 5]]);
	                    }));
	                };
	            }
	        };
	    };
	    var initialState = {
	        reportType: "searchCount",
	        displayMode: "Graph",
	        filters: {
	            "dateRange": { type: "date range", fromDate: new Date(), toDate: new Date() },
	            "types": { type: "checkbox", checked: [] }
	        }
	    };
	    callback(div);
	    var store = redux_1.createStore(utils_1.withDefault(reducer, initialState), initialState, redux_1.applyMiddleware(redux_thunk_1.default));
	    var ReportApp = lib_1.makeReportApp();
	    ReactDOM.render(React.createElement(ReportApp, Object.assign({}, ownProps(store, params.ajaxPageUrl))), div);
	    // 😛
	};

/***/ },

/***/ 664:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var Widgets = __webpack_require__(665);
	var Reports_ = __webpack_require__(663);
	exports.widgets = Widgets;
	exports.Reports = Reports_;

/***/ },

/***/ 665:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(3);
	var ReactDOM = __webpack_require__(6);
	var react_redux_1 = __webpack_require__(23);
	var redux_1 = __webpack_require__(22);
	var Select = function Select(params) {
	    return React.createElement("select", { value: params.selected, onChange: function onChange(e) {
	            return params.onChange(e.currentTarget.value);
	        }, name: params.name }, React.createElement("option", { value: "0" }, "All"), Object.keys(params.options).map(function (key) {
	        return React.createElement("option", { key: key, value: key + "" }, params.options[key]);
	    }));
	};
	var mapStateToProps = function mapStateToProps(state, props) {
	    return Object.assign({}, state, props);
	};
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        onChange: function onChange(a) {
	            return dispatch({ type: "change selection", selected: a });
	        }
	    };
	};
	var reducer = function reducer(state, a) {
	    if (!a) return state;
	    switch (a.type) {
	        case "change selection":
	            return { selected: a.selected };
	    }
	    return state;
	};
	exports.selectOne = function (render, props) {
	    var div = document.createElement('div');
	    render(div);
	    var W = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(Select);
	    var store = redux_1.createStore(reducer, { selected: props.selected });
	    var modal = ReactDOM.render(React.createElement(W, { store: store, name: props.name, options: props.options }), div);
	};

/***/ },

/***/ 666:
/***/ function(module, exports) {

	"use strict";
	
	var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) {
	            try {
	                step(generator.next(value));
	            } catch (e) {
	                reject(e);
	            }
	        }
	        function rejected(value) {
	            try {
	                step(generator["throw"](value));
	            } catch (e) {
	                reject(e);
	            }
	        }
	        function step(result) {
	            result.done ? resolve(result.value) : new P(function (resolve) {
	                resolve(result.value);
	            }).then(fulfilled, rejected);
	        }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var wrapFieldAction = function wrapFieldAction(action) {
	    return {
	        type: 'field action',
	        action: action
	    };
	};
	var wrapSaveAction = function wrapSaveAction(action) {
	    return {
	        type: 'save action',
	        action: action
	    };
	};
	exports.actionCreators = {
	    state: {
	        changeToSaveStateAction: function changeToSaveStateAction() {
	            return { type: 'change to save state' };
	        }
	    },
	    field: {
	        changeNameAction: function changeNameAction(newName) {
	            return wrapFieldAction({ type: 'change name', name: newName });
	        },
	        changeOptionalAction: function changeOptionalAction(newOptional) {
	            return wrapFieldAction({ type: 'change optional', optional: newOptional });
	        },
	        changeReasonAction: function changeReasonAction(newReason) {
	            return wrapFieldAction({ type: 'change reason', reason: newReason });
	        }
	    },
	    save: {
	        saveSuccessAddAction: function saveSuccessAddAction(id) {
	            return wrapSaveAction({ type: 'save add success', id: id });
	        },
	        saveSuccessEditAction: function saveSuccessEditAction() {
	            return wrapSaveAction({ type: 'save edit success' });
	        },
	        saveFailureAction: function saveFailureAction(errorFields) {
	            return wrapSaveAction({ type: 'save failure', errorFields: errorFields });
	        }
	    }
	};
	exports.onSave = function (commandCaller, onClose) {
	    return function (dispatch, getState) {
	        return __awaiter(undefined, void 0, void 0, regeneratorRuntime.mark(function _callee() {
	            var state, r;
	            return regeneratorRuntime.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            dispatch(exports.actionCreators.state.changeToSaveStateAction());
	                            state = getState();
	                            _context.prev = 2;
	                            _context.next = 5;
	                            return commandCaller.runPost('subscriptionmanager.saveSubscription', {
	                                id: state.subscriptionId,
	                                name: state.name,
	                                optional: state.optional,
	                                reason: state.reason
	                            });
	
	                        case 5:
	                            r = _context.sent;
	
	                            if (r.errorFields.length > 0) {
	                                dispatch(exports.actionCreators.save.saveFailureAction(r.errorFields));
	                            } else {
	                                state.subscriptionId == undefined ? dispatch(exports.actionCreators.save.saveSuccessAddAction(r.id)) : dispatch(exports.actionCreators.save.saveSuccessEditAction());
	                                onClose();
	                            }
	                            _context.next = 11;
	                            break;
	
	                        case 9:
	                            _context.prev = 9;
	                            _context.t0 = _context["catch"](2);
	
	                        case 11:
	                        case "end":
	                            return _context.stop();
	                    }
	                }
	            }, _callee, this, [[2, 9]]);
	        }));
	    };
	};

/***/ },

/***/ 667:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(3);
	var modal_1 = __webpack_require__(95);
	var form_1 = __webpack_require__(55);
	var input_1 = __webpack_require__(34);
	var checkbox_1 = __webpack_require__(92);
	var textarea_1 = __webpack_require__(274);
	var SubscriptionForm = function SubscriptionForm(props) {
	    var nameErrors = props.errorFields !== undefined ? props.errorFields.filter(function (e) {
	        return e.fieldType == 'name';
	    }) : [];
	    return React.createElement("div", null, React.createElement(form_1.Form, { hasSave: true, hasCancel: true, onCancel: props.onClose, onSubmit: props.onSave, isSubmitting: props.isSaving }, React.createElement("label", null, React.createElement("p", null, "Name: "), React.createElement(input_1.Input, { style: { width: "95%" }, value: props.name, onChange: function onChange(value) {
	            return props.nameOnChange(value);
	        }, invalid: nameErrors.length > 0 })), nameErrors.length > 0 && React.createElement("ul", null, nameErrors.map(function (e) {
	        return React.createElement("li", { style: { color: "red" } }, React.createElement("p", { style: { color: "red" } }, e.errorMessage));
	    })), React.createElement("label", null, React.createElement("p", null, "Optional: "), React.createElement(checkbox_1.Checkbox, { checked: props.optional, value: '1', onChange: function onChange(value) {
	            return props.optionalOnChange(value);
	        } })), !props.optional && React.createElement("label", null, React.createElement("p", null, "Unsubscribe Reason: "), React.createElement(textarea_1.Textarea, { style: { width: "95%" }, value: props.reason, onChange: function onChange(value) {
	            return props.reasonOnChange(value);
	        } }))));
	};
	exports.SubscriptionApp = function (props) {
	    return React.createElement("div", null, React.createElement(modal_1.Modal, { style: { width: "40em" }, isOpen: true, title: "Add Subscription", onRequestClose: props.onClose }, React.createElement(SubscriptionForm, Object.assign({}, props))));
	};

/***/ },

/***/ 668:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var app_1 = __webpack_require__(286);
	exports.SubscriptionAppReducer = function () {
	    var store = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : app_1.subscriptionAppInitialState;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case 'change to save state':
	            return {
	                subscriptionId: store.subscriptionId,
	                name: store.name,
	                optional: store.optional,
	                reason: store.reason,
	                isSaving: true,
	                errorFields: store.errorFields
	            };
	        case 'field action':
	            return fieldReducer(store, action.action);
	        case 'save action':
	            return saveReducer(store, action.action);
	    }
	    return store;
	};
	var fieldReducer = function fieldReducer() {
	    var store = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : app_1.subscriptionAppInitialState;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case 'change name':
	            return {
	                subscriptionId: store.subscriptionId,
	                name: action.name,
	                optional: store.optional,
	                reason: store.reason,
	                isSaving: store.isSaving,
	                errorFields: store.errorFields
	            };
	        case 'change optional':
	            var optional = action.optional;
	            return {
	                subscriptionId: store.subscriptionId,
	                name: store.name,
	                optional: optional,
	                reason: store.reason,
	                isSaving: store.isSaving,
	                errorFields: store.errorFields
	            };
	        case 'change reason':
	            return {
	                subscriptionId: store.subscriptionId,
	                name: store.name,
	                optional: store.optional,
	                reason: action.reason,
	                isSaving: store.isSaving,
	                errorFields: store.errorFields
	            };
	    }
	    return store;
	};
	var saveReducer = function saveReducer() {
	    var store = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : app_1.subscriptionAppInitialState;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case 'save add success':
	            return {
	                subscriptionId: action.id,
	                name: store.name,
	                optional: store.optional,
	                reason: store.reason,
	                isSaving: false,
	                errorFields: []
	            };
	        case 'save edit success':
	            return {
	                subscriptionId: store.subscriptionId,
	                name: store.name,
	                optional: store.optional,
	                reason: store.reason,
	                isSaving: false,
	                errorFields: []
	            };
	        case 'save failure':
	            return {
	                subscriptionId: store.subscriptionId,
	                name: store.name,
	                optional: store.optional,
	                reason: store.reason,
	                isSaving: false,
	                errorFields: action.errorFields
	            };
	    }
	    return store;
	};

/***/ },

/***/ 669:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(3);
	var Redux = __webpack_require__(22);
	var ReactDOM = __webpack_require__(6);
	var redux_thunk_1 = __webpack_require__(33);
	var commands_1 = __webpack_require__(12);
	var app_1 = __webpack_require__(286);
	var reducers_1 = __webpack_require__(668);
	var admin;
	(function (admin) {
	    admin.getSubscriptionGridData = function (props) {
	        return function (callback) {
	            var cc = new commands_1.CommandCaller(props.ajaxPageUrl);
	            cc.runGet('subscriptionmanager.subscriptions', {}).then(function (response) {
	                callback(response.content);
	            });
	        };
	    };
	    admin.deleteSubscription = function (props, ids) {
	        var cc = new commands_1.CommandCaller(props.ajaxPageUrl);
	        cc.runPost('subscriptionmanager.deleteSubscription', { ids: ids }).then(function () {
	            refreshSubscriptionList();
	        });
	    };
	    admin.addSubscriptionModal = function (props) {
	        var div = document.createElement('div');
	        var body = document.getElementsByTagName('body')[0];
	        body.appendChild(div);
	        var initialState = {
	            name: '',
	            optional: true,
	            reason: '',
	            isSaving: false
	        };
	        var store = Redux.createStore(reducers_1.SubscriptionAppReducer, initialState, Redux.applyMiddleware(redux_thunk_1.default));
	        ReactDOM.render(React.createElement(app_1.SubscriptionAppContainer, { store: store, ajaxPageUrl: props.ajaxPageUrl, onClose: function onClose() {
	                ReactDOM.unmountComponentAtNode(div);
	                refreshSubscriptionList();
	            } }), div);
	    };
	    admin.editSubscriptionModal = function (props) {
	        var div = document.createElement('div');
	        var body = document.getElementsByTagName('body')[0];
	        body.appendChild(div);
	        var initialState = {
	            subscriptionId: props.subscriptionId,
	            name: props.name,
	            optional: props.optional,
	            reason: props.reason,
	            isSaving: false
	        };
	        var store = Redux.createStore(reducers_1.SubscriptionAppReducer, initialState, Redux.applyMiddleware(redux_thunk_1.default));
	        ReactDOM.render(React.createElement(app_1.SubscriptionAppContainer, { store: store, ajaxPageUrl: props.ajaxPageUrl, onClose: function onClose() {
	                ReactDOM.unmountComponentAtNode(div);
	                refreshSubscriptionList();
	            } }), div);
	    };
	    var refreshSubscriptionList = function refreshSubscriptionList() {
	        new HtmlDataGrid('subscriptionsList').refresh();
	    };
	})(admin = exports.admin || (exports.admin = {}));

/***/ },

/***/ 670:
/***/ function(module, exports) {

	'use strict';
	
	/***********************************************************************
	 * FILE: jquery.ptTimeSelect.js
	 * 
	 * 		jquery plug in for displaying a popup that allows a user
	 * 		to define a time and set that time back to a form's input
	 * 		field.
	 * 
	 * 
	 * AUTHOR:
	 * 
	 * 		*Paul T.*
	 * 
	 * 		- <http://www.purtuga.com>
	 * 		- <http://pttimeselect.sourceforge.net>
	 * 
	 * 
	 * DEPENDECIES:
	 * 
	 * 		-	jquery.js
	 * 			<http://docs.jquery.com/Downloading_jquery>
	 * 
	 * 
	 * LICENSE:
	 * 
	 * 		Copyright (c) 2007 Paul T. (purtuga.com)
	 *		Dual licensed under the:
	 *
	 * 		-	MIT
	 * 			<http://www.opensource.org/licenses/mit-license.php>
	 * 
	 * 		-	GPL
	 * 			<http://www.opensource.org/licenses/gpl-license.php>
	 * 
	 * INSTALLATION:
	 * 
	 * There are two files (.css and .js) delivered with this plugin and
	 * that must be incluced in your html page after the jquery.js library,
	 * and prior to making any attempts at using it. Both of these are to
	 * be included inside of the 'head' element of the document.
	 * |
	 * |	<link rel="stylesheet" type="text/css" href="jquery.ptTimeSelect.css" />
	 * |	<script type="text/javascript" src="jquery.ptTimeSelect.js"></script>
	 * |
	 * 
	 * USAGE:
	 * 
	 * 	-	See <$(ele).ptTimeSelect()>
	 * 
	 * 
	 * 
	 * LAST UPDATED:
	 * 
	 * 		- $Date: 2009/06/08 22:26:53 $
	 * 		- $Author: paulinho4u $
	 * 		- $Revision: 1.4 $
	 * 
	 * 
	 **********************************************************************/
	
	(function () {
		var target = jQuery;
		var ptTimeSelect = {};
	
		/***********************************************************************
	  * PROPERTY: jQuery.ptTimeSelect.options
	  * 		The default options for all timeselect attached elements. Can be
	  * 		overwriten wiht <jQuery.fn.ptTimeSelect()>
	  *
	  * 	containerClass	-
	  *
	  *
	  */
		ptTimeSelect.options = {
			containerClass: undefined,
			containerWidth: undefined,
			hoursLabel: 'Hour',
			minutesLabel: 'Minutes',
			setButtonLabel: 'Set',
			popupImage: undefined,
			onFocusDisplay: true,
			zIndex: 10,
			onBeforeShow: undefined,
			onClose: undefined
		};
	
		/***********************************************************************
	  * METHOD: jQuery.ptTimeSelect._ptTimeSelectInit()
	  * 		Internal method. Called when page is initalized to add the time
	  * 		selection area to the DOM.
	  *
	  * PARAMS:
	  *
	  * 		none.
	  *
	  * RETURNS:
	  *
	  * 		nothing.
	  *
	  *
	  */
		ptTimeSelect._ptTimeSelectInit = function () {
			target(document).ready(function () {
				var uniqueid = "pt-id-" + Math.floor(Math.random() * 1000);
				//if the html is not yet created in the document, then do it now
				if (!target('#ptTimeSelectCntr').length) {
					target("body").append('<div id="ptTimeSelectCntr" class="" style="display:none">' + '		<div class="ui-widget ui-widget-content ui-corner-all">' + '		<div class="ui-widget-header ui-corner-all">' + '			<div id="ptTimeSelectCloseCntr" style="float: right;">' + '				<a href="javascript: void(0);" data-pt-closer="' + uniqueid + '"' + '						class="ui-corner-all ui-state-default">' + '					<span class="ui-icon ui-icon-circle-close">X</span>' + '				</a>' + '			</div>' + '			<div id="ptTimeSelectUserTime" style="float: left;">' + '				<span id="ptTimeSelectUserSelHr">1</span> : ' + '				<span id="ptTimeSelectUserSelMin">00</span> ' + '				<span id="ptTimeSelectUserSelAmPm">AM</span>' + '			</div>' + '			<br style="clear: both;" /><div></div>' + '		</div>' + '		<div class="ui-widget-content ui-corner-all">' + '			<div>' + '				<div class="ptTimeSelectTimeLabelsCntr">' + '					<div class="ptTimeSelectLeftPane" style="width: 50%; text-align: center; float: left;" class="">Hour</div>' + '					<div class="ptTimeSelectRightPane" style="width: 50%; text-align: center; float: left;">Minutes</div>' + '				</div>' + '				<div>' + '					<div style="float: left; width: 50%;">' + '						<div class="ui-widget-content ptTimeSelectLeftPane">' + '							<div class="ptTimeSelectHrAmPmCntr">' + '								<a class="ptTimeSelectHr ui-state-default" href="javascript: void(0);" ' + '										style="display: block; width: 45%; float: left;">AM</a>' + '								<a class="ptTimeSelectHr ui-state-default" href="javascript: void(0);" ' + '										style="display: block; width: 45%; float: left;">PM</a>' + '								<br style="clear: left;" /><div></div>' + '							</div>' + '							<div class="ptTimeSelectHrCntr">' + '								<a class="ptTimeSelectHr ui-state-default" href="javascript: void(0);">1</a>' + '								<a class="ptTimeSelectHr ui-state-default" href="javascript: void(0);">2</a>' + '								<a class="ptTimeSelectHr ui-state-default" href="javascript: void(0);">3</a>' + '								<a class="ptTimeSelectHr ui-state-default" href="javascript: void(0);">4</a>' + '								<a class="ptTimeSelectHr ui-state-default" href="javascript: void(0);">5</a>' + '								<a class="ptTimeSelectHr ui-state-default" href="javascript: void(0);">6</a>' + '								<a class="ptTimeSelectHr ui-state-default" href="javascript: void(0);">7</a>' + '								<a class="ptTimeSelectHr ui-state-default" href="javascript: void(0);">8</a>' + '								<a class="ptTimeSelectHr ui-state-default" href="javascript: void(0);">9</a>' + '								<a class="ptTimeSelectHr ui-state-default" href="javascript: void(0);">10</a>' + '								<a class="ptTimeSelectHr ui-state-default" href="javascript: void(0);">11</a>' + '								<a class="ptTimeSelectHr ui-state-default" href="javascript: void(0);">12</a>' + '								<br style="clear: left;" /><div></div>' + '							</div>' + '						</div>' + '					</div>' + '					<div style="width: 50%; float: left;">' + '						<div class="ui-widget-content ptTimeSelectRightPane">' + '							<div class="ptTimeSelectMinCntr">' + '								<a class="ptTimeSelectMin ui-state-default" href="javascript: void(0);">00</a>' + '								<a class="ptTimeSelectMin ui-state-default" href="javascript: void(0);">05</a>' + '								<a class="ptTimeSelectMin ui-state-default" href="javascript: void(0);">10</a>' + '								<a class="ptTimeSelectMin ui-state-default" href="javascript: void(0);">15</a>' + '								<a class="ptTimeSelectMin ui-state-default" href="javascript: void(0);">20</a>' + '								<a class="ptTimeSelectMin ui-state-default" href="javascript: void(0);">25</a>' + '								<a class="ptTimeSelectMin ui-state-default" href="javascript: void(0);">30</a>' + '								<a class="ptTimeSelectMin ui-state-default" href="javascript: void(0);">35</a>' + '								<a class="ptTimeSelectMin ui-state-default" href="javascript: void(0);">40</a>' + '								<a class="ptTimeSelectMin ui-state-default" href="javascript: void(0);">45</a>' + '								<a class="ptTimeSelectMin ui-state-default" href="javascript: void(0);">50</a>' + '								<a class="ptTimeSelectMin ui-state-default" href="javascript: void(0);">55</a>' + '								<br style="clear: left;" /><div></div>' + '							</div>' + '						</div>' + '					</div>' + '				</div>' + '			</div>' + '			<div style="clear: left;"></div>' + '		</div>' + '		<div id="ptTimeSelectSetButton">' + '			<a href="javascript: void(0);" data-pt-opener="' + uniqueid + '" ' + '						class="ui-corner-all ui-state-default">' + '				SET' + '			</a>' + '			<br style="clear: both;" /><div></div>' + '		</div>' + '		<!--[if lte IE 6.5]>' + '			<iframe style="display:block; position:absolute;top: 0;left:0;z-index:-1;' + '				filter:Alpha(Opacity=\'0\');width:3000px;height:3000px"></iframe>' + '		<![endif]-->' + '	</div></div>');
	
					document.querySelectorAll("[data-pt-closer]").forEach(function (e) {
						if (e.getAttribute("data-pt-closer") != uniqueid) return;
						e.onclick = function () {
							ptTimeSelect.closeCntr();
						};
						e.onmouseover = function () {
							target(this).removeClass('ui-state-default').addClass('ui-state-hover');
						};
						e.onmouseout = function () {
							target(this).removeClass('ui-state-hover').addClass('ui-state-default');
						};
					});
					document.querySelectorAll("[data-pt-opener]").forEach(function (e) {
						if (e.getAttribute("data-pt-opener") != uniqueid) return;
						e.onclick = function () {
							ptTimeSelect.setTime();
						};
						e.onmouseover = function () {
							target(this).removeClass('ui-state-default').addClass('ui-state-hover');
						};
						e.onmouseout = function () {
							target(this).removeClass('ui-state-hover').addClass('ui-state-default');
						};
					});
	
					var e = target('#ptTimeSelectCntr');
	
					// Add the events to the functions
					e.find('.ptTimeSelectMin').bind("click", function () {
						ptTimeSelect.setMin(target(this).text());
					});
	
					e.find('.ptTimeSelectHr').bind("click", function () {
						ptTimeSelect.setHr(target(this).text());
					});
	
					target(document).mousedown(ptTimeSelect._doCheckMouseClick);
				} //end if
			});
		}(); /* jQuery.ptTimeSelectInit() */
	
		/***********************************************************************
	  * METHOD: jQuery.ptTimeSelect.setHr(h)
	  * 		Sets the hour selected by the user on the popup.
	  *
	  *
	  * PARAMS:
	  *
	  * 		h -	[int] interger indicating the hour. This value is the same
	  * 			as the text value displayed on the popup under the hour.
	  * 			This value can also be the words AM or PM.
	  *
	  *
	  * RETURN:
	  *
	  * 		none
	  */
		ptTimeSelect.setHr = function (h) {
			if (h.toLowerCase() == "am" || h.toLowerCase() == "pm") {
				target('#ptTimeSelectUserSelAmPm').empty().append(h);
			} else {
				target('#ptTimeSelectUserSelHr').empty().append(h);
			}
		}; /* END setHr() function */
	
		/***********************************************************************
	  * METHOD: jQuery.ptTimeSelect.setMin(m)
	  * 		Sets the minutes selected by the user on the popup.
	  *
	  *
	  * PARAMS:
	  *
	  * 		m -	[int] interger indicating the minutes. This value is the same
	  * 			as the text value displayed on the popup under the minutes.
	  *
	  *
	  * RETURN:
	  *
	  * 		none
	  */
		ptTimeSelect.setMin = function (m) {
			target('#ptTimeSelectUserSelMin').empty().append(m);
		}; /* END setMin() function */
	
		/***********************************************************************
	  * METHOD: ptTimeSelect.setTime()
	  * 		Takes the time defined by the user and sets it to the input
	  * 		element that the popup is currently opened for.
	  *
	  *
	  * PARAMS:
	  *
	  * 		none.
	  *
	  *
	  * RETURN:
	  *
	  * 		none
	  */
		ptTimeSelect.setTime = function () {
			var tSel = target('#ptTimeSelectUserSelHr').text() + ":" + target('#ptTimeSelectUserSelMin').text() + " " + target('#ptTimeSelectUserSelAmPm').text();
			target(".isPtTimeSelectActive").val(tSel);
			this.closeCntr();
		}; /* END setTime() function */
	
		/***********************************************************************
	  * METHOD: jQuery.ptTimeSelect.openCntr()
	  * 		Displays the time definition area on the page, right below
	  * 		the input field.  Also sets the custom colors/css on the
	  * 		displayed area to what ever the input element options were
	  * 		set with.
	  *
	  * PARAMS:
	  *
	  * 		uId	-	STRING. Id of the element for whom the area will
	  * 				be displayed. This ID was created when the
	  * 				ptTimeSelect() method was called.
	  *
	  * RETURN:
	  *
	  * 		nothing.
	  *
	  */
		ptTimeSelect.openCntr = function (ele) {
			ptTimeSelect.closeCntr();
			target(".isPtTimeSelectActive").removeClass("isPtTimeSelectActive");
			var cntr = target("#ptTimeSelectCntr");
			var i = target(ele).eq(0).addClass("isPtTimeSelectActive");
			var opt = i.data("ptTimeSelectOptions");
			var style = i.offset();
			style['z-index'] = opt.zIndex;
			style.top = style.top + i.outerHeight();
			if (opt.containerWidth) {
				style.width = opt.containerWidth;
			}
			if (opt.containerClass) {
				cntr.addClass(opt.containerClass);
			}
			cntr.css(style);
			var hr = 1;
			var min = '00';
			var tm = 'AM';
			if (i.val()) {
				var re = /([0-9]{1,2}).*:.*([0-9]{2}).*(PM|AM)/i;
				var match = re.exec(i.val());
				if (match) {
					hr = match[1] || 1;
					min = match[2] || '00';
					tm = match[3] || 'AM';
				}
			}
			cntr.find("#ptTimeSelectUserSelHr").empty().append(hr);
			cntr.find("#ptTimeSelectUserSelMin").empty().append(min);
			cntr.find("#ptTimeSelectUserSelAmPm").empty().append(tm);
			cntr.find(".ptTimeSelectTimeLabelsCntr .ptTimeSelectLeftPane").empty().append(opt.hoursLabel);
			cntr.find(".ptTimeSelectTimeLabelsCntr .ptTimeSelectRightPane").empty().append(opt.minutesLabel);
			cntr.find("#ptTimeSelectSetButton a").empty().append(opt.setButtonLabel);
			if (opt.onBeforeShow) {
				opt.onBeforeShow(i, cntr);
			}
			cntr.slideDown("fast");
		}; /* END openCntr() function */
	
		/***********************************************************************
	  * METHOD: ptTimeSelect.closeCntr()
	  * 		Closes (hides it) the popup container.
	  *
	  * PARAMS:
	  *
	  * 		@param {Object} i	-	Optional. The input field for which the
	  * 								container is being closed.
	  *
	  * RETURN:
	  *
	  * 		none
	  *
	  */
		ptTimeSelect.closeCntr = function (i) {
			if (target("#ptTimeSelectCntr:visible").length) {
				target('#ptTimeSelectCntr').slideUp("fast", function () {
					target('#ptTimeSelectCntr').removeClass().css("width", "");
					if (!i) {
						i = target(".isPtTimeSelectActive");
					}
					if (i) {
						var opt = i.removeClass("isPtTimeSelectActive").data("ptTimeSelectOptions");
						if (opt && opt.onClose) {
							opt.onClose(i);
						}
					}
				});
			}
			return;
		}; /* END setTime() function */
	
		ptTimeSelect._doCheckMouseClick = function (ev) {
			if (!target("#ptTimeSelectCntr:visible").length) {
				return;
			}
			if (!target(ev.target).closest("#ptTimeSelectCntr").length) {
				ptTimeSelect.closeCntr();
			}
		}; /* ptTimeSelect._doCheckMouseClick */
	
		/***********************************************************************
	  * METHOD: ptTimeSelect()
	  * 	Attaches a ptTimeSelect widget to each matched element. Matched
	  * 	elements must be input fields that accept a values (input field).
	  * 	Each element, when focused upon, will display a time selection
	  * 	popoup where the user can define a time.
	  *
	  * PARAMS:
	  *
	  * 	@param {OBJECT}	opt -	(Optional) An object with the options for
	  * 							the time selection widget.
	  *
	  * OPTIONS:
	  *
	  * 	containerClass	-	String. A class to be assocated with the popup widget.
	  * 						(default: none)
	  * 	containerWidth	-	String. Css width for the container. (default: none)
	  * 	hoursLabel		-	String. Label for the Hours. (default: Hours)
	  * 	minutesLabel	-	String. Label for the Mintues. (default: Minutes)
	  * 	setButtonLabel	-	String. Label for the Set button. (default: SET)
	  * 	popupImage		-	String. The html element (ex. img or text) to be
	  * 						appended next to each input field and that will display
	  * 						the time select widget upon click.
	  * 	zindex			-	Int. Interger for the popup widget z-index.
	  * 	onBeforeShow	-	Function. Function to be called before the widget is
	  * 						made visible to the user. Function is passed 2 arguments:
	  * 						(1) the input field as a jquery object and (2) the popup
	  * 						widget as a jquery object.
	  * 	onClose			-	Function. Function to be called after closing the
	  * 						popup widget. Function is passed 1 argument: the input
	  * 						field as a jquery object.
	  * 	onFocusDisplay	-	Boolean. True or False indicating if popup is auto
	  * 						displayed upon focus of the input field. (default:true)
	  *
	  *
	  * RETURNS:
	  *
	  * 		- @return {object} jQuery
	  *
	  *
	  * EXAMPLE:
	  *
	  * 	|		$('#fooTime').ptTimeSelect();
	  *
	  */
		jQuery.fn.ptTimeSelect = function (opt) {
			this.each(function () {
				if (this.nodeName.toLowerCase() != 'input') return;
				var e = target(this);
				if (e.hasClass('hasPtTimeSelect')) {
					return this;
				}
				var thisOpt = {};
				thisOpt = target.extend(thisOpt, target.ptTimeSelect.options, opt);
				e.addClass('hasPtTimeSelect').data("ptTimeSelectOptions", thisOpt);
	
				var uniqueid = "pt-id-" + Math.floor(Math.random() * 1000);
	
				//Wrap the input field in a <div> element with
				// a unique id for later referencing.
				if (thisOpt.popupImage || !thisOpt.onFocusDisplay) {
					var img = target('<span>&nbsp;</span><a href="javascript:" data-pt-other-opener="' + uniqueid + '" >' + thisOpt.popupImage + '</a>').data("ptTimeSelectEle", e);
					e.after(img);
					document.querySelectorAll("[data-pt-other-opener]").forEach(function (e) {
						if (e.getAttribute("data-pt-other-opener") !== uniqueid) return;
						e.onclick = function () {
							ptTimeSelect.openCntr(target(this).data('ptTimeSelectEle'));
						};
					});
				}
				if (thisOpt.onFocusDisplay) {
					e.focus(function () {
						ptTimeSelect.openCntr(this);
					});
				}
				return this;
			});
		}; /* End of jQuery.fn.timeSelect */
	
		/***********************************************************************
	  * SECTION: HTML INSETED INTO DOM
	  * 	The only html created on the page is the popup window widget. For
	  * 	details on the structure of this element see
	  * 	<jQuery.ptTimeSelect._ptTimeSelectInit()>
	  *
	  */
	
		target.ptTimeSelect = ptTimeSelect;
	})();

/***/ },

/***/ 674:
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./af": 349,
		"./af.js": 349,
		"./ar": 356,
		"./ar-dz": 350,
		"./ar-dz.js": 350,
		"./ar-kw": 351,
		"./ar-kw.js": 351,
		"./ar-ly": 352,
		"./ar-ly.js": 352,
		"./ar-ma": 353,
		"./ar-ma.js": 353,
		"./ar-sa": 354,
		"./ar-sa.js": 354,
		"./ar-tn": 355,
		"./ar-tn.js": 355,
		"./ar.js": 356,
		"./az": 357,
		"./az.js": 357,
		"./be": 358,
		"./be.js": 358,
		"./bg": 359,
		"./bg.js": 359,
		"./bn": 360,
		"./bn.js": 360,
		"./bo": 361,
		"./bo.js": 361,
		"./br": 362,
		"./br.js": 362,
		"./bs": 363,
		"./bs.js": 363,
		"./ca": 364,
		"./ca.js": 364,
		"./cs": 365,
		"./cs.js": 365,
		"./cv": 366,
		"./cv.js": 366,
		"./cy": 367,
		"./cy.js": 367,
		"./da": 368,
		"./da.js": 368,
		"./de": 371,
		"./de-at": 369,
		"./de-at.js": 369,
		"./de-ch": 370,
		"./de-ch.js": 370,
		"./de.js": 371,
		"./dv": 372,
		"./dv.js": 372,
		"./el": 373,
		"./el.js": 373,
		"./en-au": 374,
		"./en-au.js": 374,
		"./en-ca": 375,
		"./en-ca.js": 375,
		"./en-gb": 376,
		"./en-gb.js": 376,
		"./en-ie": 377,
		"./en-ie.js": 377,
		"./en-nz": 378,
		"./en-nz.js": 378,
		"./eo": 379,
		"./eo.js": 379,
		"./es": 381,
		"./es-do": 380,
		"./es-do.js": 380,
		"./es.js": 381,
		"./et": 382,
		"./et.js": 382,
		"./eu": 383,
		"./eu.js": 383,
		"./fa": 384,
		"./fa.js": 384,
		"./fi": 385,
		"./fi.js": 385,
		"./fo": 386,
		"./fo.js": 386,
		"./fr": 389,
		"./fr-ca": 387,
		"./fr-ca.js": 387,
		"./fr-ch": 388,
		"./fr-ch.js": 388,
		"./fr.js": 389,
		"./fy": 390,
		"./fy.js": 390,
		"./gd": 391,
		"./gd.js": 391,
		"./gl": 392,
		"./gl.js": 392,
		"./gom-latn": 393,
		"./gom-latn.js": 393,
		"./he": 394,
		"./he.js": 394,
		"./hi": 395,
		"./hi.js": 395,
		"./hr": 396,
		"./hr.js": 396,
		"./hu": 397,
		"./hu.js": 397,
		"./hy-am": 398,
		"./hy-am.js": 398,
		"./id": 399,
		"./id.js": 399,
		"./is": 400,
		"./is.js": 400,
		"./it": 401,
		"./it.js": 401,
		"./ja": 402,
		"./ja.js": 402,
		"./jv": 403,
		"./jv.js": 403,
		"./ka": 404,
		"./ka.js": 404,
		"./kk": 405,
		"./kk.js": 405,
		"./km": 406,
		"./km.js": 406,
		"./kn": 407,
		"./kn.js": 407,
		"./ko": 408,
		"./ko.js": 408,
		"./ky": 409,
		"./ky.js": 409,
		"./lb": 410,
		"./lb.js": 410,
		"./lo": 411,
		"./lo.js": 411,
		"./lt": 412,
		"./lt.js": 412,
		"./lv": 413,
		"./lv.js": 413,
		"./me": 414,
		"./me.js": 414,
		"./mi": 415,
		"./mi.js": 415,
		"./mk": 416,
		"./mk.js": 416,
		"./ml": 417,
		"./ml.js": 417,
		"./mr": 418,
		"./mr.js": 418,
		"./ms": 420,
		"./ms-my": 419,
		"./ms-my.js": 419,
		"./ms.js": 420,
		"./my": 421,
		"./my.js": 421,
		"./nb": 422,
		"./nb.js": 422,
		"./ne": 423,
		"./ne.js": 423,
		"./nl": 425,
		"./nl-be": 424,
		"./nl-be.js": 424,
		"./nl.js": 425,
		"./nn": 426,
		"./nn.js": 426,
		"./pa-in": 427,
		"./pa-in.js": 427,
		"./pl": 428,
		"./pl.js": 428,
		"./pt": 430,
		"./pt-br": 429,
		"./pt-br.js": 429,
		"./pt.js": 430,
		"./ro": 431,
		"./ro.js": 431,
		"./ru": 432,
		"./ru.js": 432,
		"./sd": 433,
		"./sd.js": 433,
		"./se": 434,
		"./se.js": 434,
		"./si": 435,
		"./si.js": 435,
		"./sk": 436,
		"./sk.js": 436,
		"./sl": 437,
		"./sl.js": 437,
		"./sq": 438,
		"./sq.js": 438,
		"./sr": 440,
		"./sr-cyrl": 439,
		"./sr-cyrl.js": 439,
		"./sr.js": 440,
		"./ss": 441,
		"./ss.js": 441,
		"./sv": 442,
		"./sv.js": 442,
		"./sw": 443,
		"./sw.js": 443,
		"./ta": 444,
		"./ta.js": 444,
		"./te": 445,
		"./te.js": 445,
		"./tet": 446,
		"./tet.js": 446,
		"./th": 447,
		"./th.js": 447,
		"./tl-ph": 448,
		"./tl-ph.js": 448,
		"./tlh": 449,
		"./tlh.js": 449,
		"./tr": 450,
		"./tr.js": 450,
		"./tzl": 451,
		"./tzl.js": 451,
		"./tzm": 453,
		"./tzm-latn": 452,
		"./tzm-latn.js": 452,
		"./tzm.js": 453,
		"./uk": 454,
		"./uk.js": 454,
		"./ur": 455,
		"./ur.js": 455,
		"./uz": 457,
		"./uz-latn": 456,
		"./uz-latn.js": 456,
		"./uz.js": 457,
		"./vi": 458,
		"./vi.js": 458,
		"./x-pseudo": 459,
		"./x-pseudo.js": 459,
		"./yo": 460,
		"./yo.js": 460,
		"./zh-cn": 461,
		"./zh-cn.js": 461,
		"./zh-hk": 462,
		"./zh-hk.js": 462,
		"./zh-tw": 463,
		"./zh-tw.js": 463
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 674;


/***/ },

/***/ 1215:
/***/ function(module, exports) {

	/* (ignored) */

/***/ }

});


// WEBPACK FOOTER //
// bundle.js